webpackJsonp([1],{

/***/ "./node_modules/algoliasearch/src/AlgoliaSearch.js":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = AlgoliaSearch;
	
	var Index = __webpack_require__("./node_modules/algoliasearch/src/Index.js");
	var deprecate = __webpack_require__("./node_modules/algoliasearch/src/deprecate.js");
	var deprecatedMessage = __webpack_require__("./node_modules/algoliasearch/src/deprecatedMessage.js");
	var AlgoliaSearchCore = __webpack_require__("./node_modules/algoliasearch/src/AlgoliaSearchCore.js");
	var inherits = __webpack_require__("./node_modules/inherits/inherits_browser.js");
	var errors = __webpack_require__("./node_modules/algoliasearch/src/errors.js");
	
	function AlgoliaSearch() {
	  AlgoliaSearchCore.apply(this, arguments);
	}
	
	inherits(AlgoliaSearch, AlgoliaSearchCore);
	
	/*
	 * Delete an index
	 *
	 * @param indexName the name of index to delete
	 * @param callback the result callback called with two arguments
	 *  error: null or Error('message')
	 *  content: the server answer that contains the task ID
	 */
	AlgoliaSearch.prototype.deleteIndex = function(indexName, callback) {
	  return this._jsonRequest({
	    method: 'DELETE',
	    url: '/1/indexes/' + encodeURIComponent(indexName),
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/**
	 * Move an existing index.
	 * @param srcIndexName the name of index to copy.
	 * @param dstIndexName the new index name that will contains a copy of
	 * srcIndexName (destination will be overriten if it already exist).
	 * @param callback the result callback called with two arguments
	 *  error: null or Error('message')
	 *  content: the server answer that contains the task ID
	 */
	AlgoliaSearch.prototype.moveIndex = function(srcIndexName, dstIndexName, callback) {
	  var postObj = {
	    operation: 'move', destination: dstIndexName
	  };
	  return this._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(srcIndexName) + '/operation',
	    body: postObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/**
	 * Copy an existing index.
	 * @param srcIndexName the name of index to copy.
	 * @param dstIndexName the new index name that will contains a copy
	 * of srcIndexName (destination will be overriten if it already exist).
	 * @param callback the result callback called with two arguments
	 *  error: null or Error('message')
	 *  content: the server answer that contains the task ID
	 */
	AlgoliaSearch.prototype.copyIndex = function(srcIndexName, dstIndexName, callback) {
	  var postObj = {
	    operation: 'copy', destination: dstIndexName
	  };
	  return this._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(srcIndexName) + '/operation',
	    body: postObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/**
	 * Return last log entries.
	 * @param offset Specify the first entry to retrieve (0-based, 0 is the most recent log entry).
	 * @param length Specify the maximum number of entries to retrieve starting
	 * at offset. Maximum allowed value: 1000.
	 * @param type Specify the maximum number of entries to retrieve starting
	 * at offset. Maximum allowed value: 1000.
	 * @param callback the result callback called with two arguments
	 *  error: null or Error('message')
	 *  content: the server answer that contains the task ID
	 */
	AlgoliaSearch.prototype.getLogs = function(offset, length, callback) {
	  var clone = __webpack_require__("./node_modules/algoliasearch/src/clone.js");
	  var params = {};
	  if (typeof offset === 'object') {
	    // getLogs(params)
	    params = clone(offset);
	    callback = length;
	  } else if (arguments.length === 0 || typeof offset === 'function') {
	    // getLogs([cb])
	    callback = offset;
	  } else if (arguments.length === 1 || typeof length === 'function') {
	    // getLogs(1, [cb)]
	    callback = length;
	    params.offset = offset;
	  } else {
	    // getLogs(1, 2, [cb])
	    params.offset = offset;
	    params.length = length;
	  }
	
	  if (params.offset === undefined) params.offset = 0;
	  if (params.length === undefined) params.length = 10;
	
	  return this._jsonRequest({
	    method: 'GET',
	    url: '/1/logs?' + this._getSearchParams(params, ''),
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	 * List all existing indexes (paginated)
	 *
	 * @param page The page to retrieve, starting at 0.
	 * @param callback the result callback called with two arguments
	 *  error: null or Error('message')
	 *  content: the server answer with index list
	 */
	AlgoliaSearch.prototype.listIndexes = function(page, callback) {
	  var params = '';
	
	  if (page === undefined || typeof page === 'function') {
	    callback = page;
	  } else {
	    params = '?page=' + page;
	  }
	
	  return this._jsonRequest({
	    method: 'GET',
	    url: '/1/indexes' + params,
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	 * Get the index object initialized
	 *
	 * @param indexName the name of index
	 * @param callback the result callback with one argument (the Index instance)
	 */
	AlgoliaSearch.prototype.initIndex = function(indexName) {
	  return new Index(this, indexName);
	};
	
	/*
	 * @deprecated use client.listApiKeys
	 */
	AlgoliaSearch.prototype.listUserKeys = deprecate(function(callback) {
	  return this.listApiKeys(callback);
	}, deprecatedMessage('client.listUserKeys()', 'client.listApiKeys()'));
	
	/*
	 * List all existing api keys with their associated ACLs
	 *
	 * @param callback the result callback called with two arguments
	 *  error: null or Error('message')
	 *  content: the server answer with api keys list
	 */
	AlgoliaSearch.prototype.listApiKeys = function(callback) {
	  return this._jsonRequest({
	    method: 'GET',
	    url: '/1/keys',
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	 * @deprecated see client.getApiKey
	 */
	AlgoliaSearch.prototype.getUserKeyACL = deprecate(function(key, callback) {
	  return this.getApiKey(key, callback);
	}, deprecatedMessage('client.getUserKeyACL()', 'client.getApiKey()'));
	
	/*
	 * Get an API key
	 *
	 * @param key
	 * @param callback the result callback called with two arguments
	 *  error: null or Error('message')
	 *  content: the server answer with the right API key
	 */
	AlgoliaSearch.prototype.getApiKey = function(key, callback) {
	  return this._jsonRequest({
	    method: 'GET',
	    url: '/1/keys/' + key,
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	 * @deprecated see client.deleteApiKey
	 */
	AlgoliaSearch.prototype.deleteUserKey = deprecate(function(key, callback) {
	  return this.deleteApiKey(key, callback);
	}, deprecatedMessage('client.deleteUserKey()', 'client.deleteApiKey()'));
	
	/*
	 * Delete an existing API key
	 * @param key
	 * @param callback the result callback called with two arguments
	 *  error: null or Error('message')
	 *  content: the server answer with the date of deletion
	 */
	AlgoliaSearch.prototype.deleteApiKey = function(key, callback) {
	  return this._jsonRequest({
	    method: 'DELETE',
	    url: '/1/keys/' + key,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	 @deprecated see client.addApiKey
	 */
	AlgoliaSearch.prototype.addUserKey = deprecate(function(acls, params, callback) {
	  return this.addApiKey(acls, params, callback);
	}, deprecatedMessage('client.addUserKey()', 'client.addApiKey()'));
	
	/*
	 * Add a new global API key
	 *
	 * @param {string[]} acls - The list of ACL for this key. Defined by an array of strings that
	 *   can contains the following values:
	 *     - search: allow to search (https and http)
	 *     - addObject: allows to add/update an object in the index (https only)
	 *     - deleteObject : allows to delete an existing object (https only)
	 *     - deleteIndex : allows to delete index content (https only)
	 *     - settings : allows to get index settings (https only)
	 *     - editSettings : allows to change index settings (https only)
	 * @param {Object} [params] - Optionnal parameters to set for the key
	 * @param {number} params.validity - Number of seconds after which the key will be automatically removed (0 means no time limit for this key)
	 * @param {number} params.maxQueriesPerIPPerHour - Number of API calls allowed from an IP address per hour
	 * @param {number} params.maxHitsPerQuery - Number of hits this API key can retrieve in one call
	 * @param {string[]} params.indexes - Allowed targeted indexes for this key
	 * @param {string} params.description - A description for your key
	 * @param {string[]} params.referers - A list of authorized referers
	 * @param {Object} params.queryParameters - Force the key to use specific query parameters
	 * @param {Function} callback - The result callback called with two arguments
	 *   error: null or Error('message')
	 *   content: the server answer with the added API key
	 * @return {Promise|undefined} Returns a promise if no callback given
	 * @example
	 * client.addUserKey(['search'], {
	 *   validity: 300,
	 *   maxQueriesPerIPPerHour: 2000,
	 *   maxHitsPerQuery: 3,
	 *   indexes: ['fruits'],
	 *   description: 'Eat three fruits',
	 *   referers: ['*.algolia.com'],
	 *   queryParameters: {
	 *     tagFilters: ['public'],
	 *   }
	 * })
	 * @see {@link https://www.algolia.com/doc/rest_api#AddKey|Algolia REST API Documentation}
	 */
	AlgoliaSearch.prototype.addApiKey = function(acls, params, callback) {
	  var isArray = __webpack_require__("./node_modules/isarray/index.js");
	  var usage = 'Usage: client.addApiKey(arrayOfAcls[, params, callback])';
	
	  if (!isArray(acls)) {
	    throw new Error(usage);
	  }
	
	  if (arguments.length === 1 || typeof params === 'function') {
	    callback = params;
	    params = null;
	  }
	
	  var postObj = {
	    acl: acls
	  };
	
	  if (params) {
	    postObj.validity = params.validity;
	    postObj.maxQueriesPerIPPerHour = params.maxQueriesPerIPPerHour;
	    postObj.maxHitsPerQuery = params.maxHitsPerQuery;
	    postObj.indexes = params.indexes;
	    postObj.description = params.description;
	
	    if (params.queryParameters) {
	      postObj.queryParameters = this._getSearchParams(params.queryParameters, '');
	    }
	
	    postObj.referers = params.referers;
	  }
	
	  return this._jsonRequest({
	    method: 'POST',
	    url: '/1/keys',
	    body: postObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/**
	 * @deprecated Please use client.addApiKey()
	 */
	AlgoliaSearch.prototype.addUserKeyWithValidity = deprecate(function(acls, params, callback) {
	  return this.addApiKey(acls, params, callback);
	}, deprecatedMessage('client.addUserKeyWithValidity()', 'client.addApiKey()'));
	
	/**
	 * @deprecated Please use client.updateApiKey()
	 */
	AlgoliaSearch.prototype.updateUserKey = deprecate(function(key, acls, params, callback) {
	  return this.updateApiKey(key, acls, params, callback);
	}, deprecatedMessage('client.updateUserKey()', 'client.updateApiKey()'));
	
	/**
	 * Update an existing API key
	 * @param {string} key - The key to update
	 * @param {string[]} acls - The list of ACL for this key. Defined by an array of strings that
	 *   can contains the following values:
	 *     - search: allow to search (https and http)
	 *     - addObject: allows to add/update an object in the index (https only)
	 *     - deleteObject : allows to delete an existing object (https only)
	 *     - deleteIndex : allows to delete index content (https only)
	 *     - settings : allows to get index settings (https only)
	 *     - editSettings : allows to change index settings (https only)
	 * @param {Object} [params] - Optionnal parameters to set for the key
	 * @param {number} params.validity - Number of seconds after which the key will be automatically removed (0 means no time limit for this key)
	 * @param {number} params.maxQueriesPerIPPerHour - Number of API calls allowed from an IP address per hour
	 * @param {number} params.maxHitsPerQuery - Number of hits this API key can retrieve in one call
	 * @param {string[]} params.indexes - Allowed targeted indexes for this key
	 * @param {string} params.description - A description for your key
	 * @param {string[]} params.referers - A list of authorized referers
	 * @param {Object} params.queryParameters - Force the key to use specific query parameters
	 * @param {Function} callback - The result callback called with two arguments
	 *   error: null or Error('message')
	 *   content: the server answer with the modified API key
	 * @return {Promise|undefined} Returns a promise if no callback given
	 * @example
	 * client.updateApiKey('APIKEY', ['search'], {
	 *   validity: 300,
	 *   maxQueriesPerIPPerHour: 2000,
	 *   maxHitsPerQuery: 3,
	 *   indexes: ['fruits'],
	 *   description: 'Eat three fruits',
	 *   referers: ['*.algolia.com'],
	 *   queryParameters: {
	 *     tagFilters: ['public'],
	 *   }
	 * })
	 * @see {@link https://www.algolia.com/doc/rest_api#UpdateIndexKey|Algolia REST API Documentation}
	 */
	AlgoliaSearch.prototype.updateApiKey = function(key, acls, params, callback) {
	  var isArray = __webpack_require__("./node_modules/isarray/index.js");
	  var usage = 'Usage: client.updateApiKey(key, arrayOfAcls[, params, callback])';
	
	  if (!isArray(acls)) {
	    throw new Error(usage);
	  }
	
	  if (arguments.length === 2 || typeof params === 'function') {
	    callback = params;
	    params = null;
	  }
	
	  var putObj = {
	    acl: acls
	  };
	
	  if (params) {
	    putObj.validity = params.validity;
	    putObj.maxQueriesPerIPPerHour = params.maxQueriesPerIPPerHour;
	    putObj.maxHitsPerQuery = params.maxHitsPerQuery;
	    putObj.indexes = params.indexes;
	    putObj.description = params.description;
	
	    if (params.queryParameters) {
	      putObj.queryParameters = this._getSearchParams(params.queryParameters, '');
	    }
	
	    putObj.referers = params.referers;
	  }
	
	  return this._jsonRequest({
	    method: 'PUT',
	    url: '/1/keys/' + key,
	    body: putObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/**
	 * Initialize a new batch of search queries
	 * @deprecated use client.search()
	 */
	AlgoliaSearch.prototype.startQueriesBatch = deprecate(function startQueriesBatchDeprecated() {
	  this._batch = [];
	}, deprecatedMessage('client.startQueriesBatch()', 'client.search()'));
	
	/**
	 * Add a search query in the batch
	 * @deprecated use client.search()
	 */
	AlgoliaSearch.prototype.addQueryInBatch = deprecate(function addQueryInBatchDeprecated(indexName, query, args) {
	  this._batch.push({
	    indexName: indexName,
	    query: query,
	    params: args
	  });
	}, deprecatedMessage('client.addQueryInBatch()', 'client.search()'));
	
	/**
	 * Launch the batch of queries using XMLHttpRequest.
	 * @deprecated use client.search()
	 */
	AlgoliaSearch.prototype.sendQueriesBatch = deprecate(function sendQueriesBatchDeprecated(callback) {
	  return this.search(this._batch, callback);
	}, deprecatedMessage('client.sendQueriesBatch()', 'client.search()'));
	
	/**
	 * Perform write operations accross multiple indexes.
	 *
	 * To reduce the amount of time spent on network round trips,
	 * you can create, update, or delete several objects in one call,
	 * using the batch endpoint (all operations are done in the given order).
	 *
	 * Available actions:
	 *   - addObject
	 *   - updateObject
	 *   - partialUpdateObject
	 *   - partialUpdateObjectNoCreate
	 *   - deleteObject
	 *
	 * https://www.algolia.com/doc/rest_api#Indexes
	 * @param  {Object[]} operations An array of operations to perform
	 * @return {Promise|undefined} Returns a promise if no callback given
	 * @example
	 * client.batch([{
	 *   action: 'addObject',
	 *   indexName: 'clients',
	 *   body: {
	 *     name: 'Bill'
	 *   }
	 * }, {
	 *   action: 'udpateObject',
	 *   indexName: 'fruits',
	 *   body: {
	 *     objectID: '29138',
	 *     name: 'banana'
	 *   }
	 * }], cb)
	 */
	AlgoliaSearch.prototype.batch = function(operations, callback) {
	  var isArray = __webpack_require__("./node_modules/isarray/index.js");
	  var usage = 'Usage: client.batch(operations[, callback])';
	
	  if (!isArray(operations)) {
	    throw new Error(usage);
	  }
	
	  return this._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/*/batch',
	    body: {
	      requests: operations
	    },
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	// environment specific methods
	AlgoliaSearch.prototype.destroy = notImplemented;
	AlgoliaSearch.prototype.enableRateLimitForward = notImplemented;
	AlgoliaSearch.prototype.disableRateLimitForward = notImplemented;
	AlgoliaSearch.prototype.useSecuredAPIKey = notImplemented;
	AlgoliaSearch.prototype.disableSecuredAPIKey = notImplemented;
	AlgoliaSearch.prototype.generateSecuredApiKey = notImplemented;
	
	function notImplemented() {
	  var message = 'Not implemented in this environment.\n' +
	    'If you feel this is a mistake, write to support@algolia.com';
	
	  throw new errors.AlgoliaSearchError(message);
	}


/***/ }),

/***/ "./node_modules/algoliasearch/src/AlgoliaSearchCore.js":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = AlgoliaSearchCore;
	
	var errors = __webpack_require__("./node_modules/algoliasearch/src/errors.js");
	var exitPromise = __webpack_require__("./node_modules/algoliasearch/src/exitPromise.js");
	var IndexCore = __webpack_require__("./node_modules/algoliasearch/src/IndexCore.js");
	var store = __webpack_require__("./node_modules/algoliasearch/src/store.js");
	
	// We will always put the API KEY in the JSON body in case of too long API KEY,
	// to avoid query string being too long and failing in various conditions (our server limit, browser limit,
	// proxies limit)
	var MAX_API_KEY_LENGTH = 500;
	var RESET_APP_DATA_TIMER =
	  ({"NODE_ENV":"production","PUBLIC_DIR":"/Users/todd/src/howtohypermedia/public"}).RESET_APP_DATA_TIMER && parseInt(({"NODE_ENV":"production","PUBLIC_DIR":"/Users/todd/src/howtohypermedia/public"}).RESET_APP_DATA_TIMER, 10) ||
	  60 * 2 * 1000; // after 2 minutes reset to first host
	
	/*
	 * Algolia Search library initialization
	 * https://www.algolia.com/
	 *
	 * @param {string} applicationID - Your applicationID, found in your dashboard
	 * @param {string} apiKey - Your API key, found in your dashboard
	 * @param {Object} [opts]
	 * @param {number} [opts.timeout=2000] - The request timeout set in milliseconds,
	 * another request will be issued after this timeout
	 * @param {string} [opts.protocol='http:'] - The protocol used to query Algolia Search API.
	 *                                        Set to 'https:' to force using https.
	 *                                        Default to document.location.protocol in browsers
	 * @param {Object|Array} [opts.hosts={
	 *           read: [this.applicationID + '-dsn.algolia.net'].concat([
	 *             this.applicationID + '-1.algolianet.com',
	 *             this.applicationID + '-2.algolianet.com',
	 *             this.applicationID + '-3.algolianet.com']
	 *           ]),
	 *           write: [this.applicationID + '.algolia.net'].concat([
	 *             this.applicationID + '-1.algolianet.com',
	 *             this.applicationID + '-2.algolianet.com',
	 *             this.applicationID + '-3.algolianet.com']
	 *           ]) - The hosts to use for Algolia Search API.
	 *           If you provide them, you will less benefit from our HA implementation
	 */
	function AlgoliaSearchCore(applicationID, apiKey, opts) {
	  var debug = __webpack_require__("./node_modules/debug/src/browser.js")('algoliasearch');
	
	  var clone = __webpack_require__("./node_modules/algoliasearch/src/clone.js");
	  var isArray = __webpack_require__("./node_modules/isarray/index.js");
	  var map = __webpack_require__("./node_modules/algoliasearch/src/map.js");
	
	  var usage = 'Usage: algoliasearch(applicationID, apiKey, opts)';
	
	  if (opts._allowEmptyCredentials !== true && !applicationID) {
	    throw new errors.AlgoliaSearchError('Please provide an application ID. ' + usage);
	  }
	
	  if (opts._allowEmptyCredentials !== true && !apiKey) {
	    throw new errors.AlgoliaSearchError('Please provide an API key. ' + usage);
	  }
	
	  this.applicationID = applicationID;
	  this.apiKey = apiKey;
	
	  this.hosts = {
	    read: [],
	    write: []
	  };
	
	  opts = opts || {};
	
	  var protocol = opts.protocol || 'https:';
	  this._timeouts = opts.timeouts || {
	    connect: 1 * 1000, // 500ms connect is GPRS latency
	    read: 2 * 1000,
	    write: 30 * 1000
	  };
	
	  // backward compat, if opts.timeout is passed, we use it to configure all timeouts like before
	  if (opts.timeout) {
	    this._timeouts.connect = this._timeouts.read = this._timeouts.write = opts.timeout;
	  }
	
	  // while we advocate for colon-at-the-end values: 'http:' for `opts.protocol`
	  // we also accept `http` and `https`. It's a common error.
	  if (!/:$/.test(protocol)) {
	    protocol = protocol + ':';
	  }
	
	  if (opts.protocol !== 'http:' && opts.protocol !== 'https:') {
	    throw new errors.AlgoliaSearchError('protocol must be `http:` or `https:` (was `' + opts.protocol + '`)');
	  }
	
	  this._checkAppIdData();
	
	  if (!opts.hosts) {
	    var defaultHosts = map(this._shuffleResult, function(hostNumber) {
	      return applicationID + '-' + hostNumber + '.algolianet.com';
	    });
	
	    // no hosts given, compute defaults
	    this.hosts.read = [this.applicationID + '-dsn.algolia.net'].concat(defaultHosts);
	    this.hosts.write = [this.applicationID + '.algolia.net'].concat(defaultHosts);
	  } else if (isArray(opts.hosts)) {
	    // when passing custom hosts, we need to have a different host index if the number
	    // of write/read hosts are different.
	    this.hosts.read = clone(opts.hosts);
	    this.hosts.write = clone(opts.hosts);
	  } else {
	    this.hosts.read = clone(opts.hosts.read);
	    this.hosts.write = clone(opts.hosts.write);
	  }
	
	  // add protocol and lowercase hosts
	  this.hosts.read = map(this.hosts.read, prepareHost(protocol));
	  this.hosts.write = map(this.hosts.write, prepareHost(protocol));
	
	  this.extraHeaders = [];
	
	  // In some situations you might want to warm the cache
	  this.cache = opts._cache || {};
	
	  this._ua = opts._ua;
	  this._useCache = opts._useCache === undefined || opts._cache ? true : opts._useCache;
	  this._useFallback = opts.useFallback === undefined ? true : opts.useFallback;
	
	  this._setTimeout = opts._setTimeout;
	
	  debug('init done, %j', this);
	}
	
	/*
	 * Get the index object initialized
	 *
	 * @param indexName the name of index
	 * @param callback the result callback with one argument (the Index instance)
	 */
	AlgoliaSearchCore.prototype.initIndex = function(indexName) {
	  return new IndexCore(this, indexName);
	};
	
	/**
	* Add an extra field to the HTTP request
	*
	* @param name the header field name
	* @param value the header field value
	*/
	AlgoliaSearchCore.prototype.setExtraHeader = function(name, value) {
	  this.extraHeaders.push({
	    name: name.toLowerCase(), value: value
	  });
	};
	
	/**
	* Augment sent x-algolia-agent with more data, each agent part
	* is automatically separated from the others by a semicolon;
	*
	* @param algoliaAgent the agent to add
	*/
	AlgoliaSearchCore.prototype.addAlgoliaAgent = function(algoliaAgent) {
	  if (this._ua.indexOf(';' + algoliaAgent) === -1) {
	    this._ua += ';' + algoliaAgent;
	  }
	};
	
	/*
	 * Wrapper that try all hosts to maximize the quality of service
	 */
	AlgoliaSearchCore.prototype._jsonRequest = function(initialOpts) {
	  this._checkAppIdData();
	
	  var requestDebug = __webpack_require__("./node_modules/debug/src/browser.js")('algoliasearch:' + initialOpts.url);
	
	  var body;
	  var additionalUA = initialOpts.additionalUA || '';
	  var cache = initialOpts.cache;
	  var client = this;
	  var tries = 0;
	  var usingFallback = false;
	  var hasFallback = client._useFallback && client._request.fallback && initialOpts.fallback;
	  var headers;
	
	  if (
	    this.apiKey.length > MAX_API_KEY_LENGTH &&
	    initialOpts.body !== undefined &&
	    (initialOpts.body.params !== undefined || // index.search()
	    initialOpts.body.requests !== undefined) // client.search()
	  ) {
	    initialOpts.body.apiKey = this.apiKey;
	    headers = this._computeRequestHeaders(additionalUA, false);
	  } else {
	    headers = this._computeRequestHeaders(additionalUA);
	  }
	
	  if (initialOpts.body !== undefined) {
	    body = safeJSONStringify(initialOpts.body);
	  }
	
	  requestDebug('request start');
	  var debugData = [];
	
	  function doRequest(requester, reqOpts) {
	    client._checkAppIdData();
	
	    var startTime = new Date();
	    var cacheID;
	
	    if (client._useCache) {
	      cacheID = initialOpts.url;
	    }
	
	    // as we sometime use POST requests to pass parameters (like query='aa'),
	    // the cacheID must also include the body to be different between calls
	    if (client._useCache && body) {
	      cacheID += '_body_' + reqOpts.body;
	    }
	
	    // handle cache existence
	    if (client._useCache && cache && cache[cacheID] !== undefined) {
	      requestDebug('serving response from cache');
	      return client._promise.resolve(JSON.parse(cache[cacheID]));
	    }
	
	    // if we reached max tries
	    if (tries >= client.hosts[initialOpts.hostType].length) {
	      if (!hasFallback || usingFallback) {
	        requestDebug('could not get any response');
	        // then stop
	        return client._promise.reject(new errors.AlgoliaSearchError(
	          'Cannot connect to the AlgoliaSearch API.' +
	          ' Send an email to support@algolia.com to report and resolve the issue.' +
	          ' Application id was: ' + client.applicationID, {debugData: debugData}
	        ));
	      }
	
	      requestDebug('switching to fallback');
	
	      // let's try the fallback starting from here
	      tries = 0;
	
	      // method, url and body are fallback dependent
	      reqOpts.method = initialOpts.fallback.method;
	      reqOpts.url = initialOpts.fallback.url;
	      reqOpts.jsonBody = initialOpts.fallback.body;
	      if (reqOpts.jsonBody) {
	        reqOpts.body = safeJSONStringify(reqOpts.jsonBody);
	      }
	      // re-compute headers, they could be omitting the API KEY
	      headers = client._computeRequestHeaders(additionalUA);
	
	      reqOpts.timeouts = client._getTimeoutsForRequest(initialOpts.hostType);
	      client._setHostIndexByType(0, initialOpts.hostType);
	      usingFallback = true; // the current request is now using fallback
	      return doRequest(client._request.fallback, reqOpts);
	    }
	
	    var currentHost = client._getHostByType(initialOpts.hostType);
	
	    var url = currentHost + reqOpts.url;
	    var options = {
	      body: reqOpts.body,
	      jsonBody: reqOpts.jsonBody,
	      method: reqOpts.method,
	      headers: headers,
	      timeouts: reqOpts.timeouts,
	      debug: requestDebug
	    };
	
	    requestDebug('method: %s, url: %s, headers: %j, timeouts: %d',
	      options.method, url, options.headers, options.timeouts);
	
	    if (requester === client._request.fallback) {
	      requestDebug('using fallback');
	    }
	
	    // `requester` is any of this._request or this._request.fallback
	    // thus it needs to be called using the client as context
	    return requester.call(client, url, options).then(success, tryFallback);
	
	    function success(httpResponse) {
	      // compute the status of the response,
	      //
	      // When in browser mode, using XDR or JSONP, we have no statusCode available
	      // So we rely on our API response `status` property.
	      // But `waitTask` can set a `status` property which is not the statusCode (it's the task status)
	      // So we check if there's a `message` along `status` and it means it's an error
	      //
	      // That's the only case where we have a response.status that's not the http statusCode
	      var status = httpResponse && httpResponse.body && httpResponse.body.message && httpResponse.body.status ||
	
	        // this is important to check the request statusCode AFTER the body eventual
	        // statusCode because some implementations (jQuery XDomainRequest transport) may
	        // send statusCode 200 while we had an error
	        httpResponse.statusCode ||
	
	        // When in browser mode, using XDR or JSONP
	        // we default to success when no error (no response.status && response.message)
	        // If there was a JSON.parse() error then body is null and it fails
	        httpResponse && httpResponse.body && 200;
	
	      requestDebug('received response: statusCode: %s, computed statusCode: %d, headers: %j',
	        httpResponse.statusCode, status, httpResponse.headers);
	
	      var httpResponseOk = Math.floor(status / 100) === 2;
	
	      var endTime = new Date();
	      debugData.push({
	        currentHost: currentHost,
	        headers: removeCredentials(headers),
	        content: body || null,
	        contentLength: body !== undefined ? body.length : null,
	        method: reqOpts.method,
	        timeouts: reqOpts.timeouts,
	        url: reqOpts.url,
	        startTime: startTime,
	        endTime: endTime,
	        duration: endTime - startTime,
	        statusCode: status
	      });
	
	      if (httpResponseOk) {
	        if (client._useCache && cache) {
	          cache[cacheID] = httpResponse.responseText;
	        }
	
	        return httpResponse.body;
	      }
	
	      var shouldRetry = Math.floor(status / 100) !== 4;
	
	      if (shouldRetry) {
	        tries += 1;
	        return retryRequest();
	      }
	
	      requestDebug('unrecoverable error');
	
	      // no success and no retry => fail
	      var unrecoverableError = new errors.AlgoliaSearchError(
	        httpResponse.body && httpResponse.body.message, {debugData: debugData, statusCode: status}
	      );
	
	      return client._promise.reject(unrecoverableError);
	    }
	
	    function tryFallback(err) {
	      // error cases:
	      //  While not in fallback mode:
	      //    - CORS not supported
	      //    - network error
	      //  While in fallback mode:
	      //    - timeout
	      //    - network error
	      //    - badly formatted JSONP (script loaded, did not call our callback)
	      //  In both cases:
	      //    - uncaught exception occurs (TypeError)
	      requestDebug('error: %s, stack: %s', err.message, err.stack);
	
	      var endTime = new Date();
	      debugData.push({
	        currentHost: currentHost,
	        headers: removeCredentials(headers),
	        content: body || null,
	        contentLength: body !== undefined ? body.length : null,
	        method: reqOpts.method,
	        timeouts: reqOpts.timeouts,
	        url: reqOpts.url,
	        startTime: startTime,
	        endTime: endTime,
	        duration: endTime - startTime
	      });
	
	      if (!(err instanceof errors.AlgoliaSearchError)) {
	        err = new errors.Unknown(err && err.message, err);
	      }
	
	      tries += 1;
	
	      // stop the request implementation when:
	      if (
	        // we did not generate this error,
	        // it comes from a throw in some other piece of code
	        err instanceof errors.Unknown ||
	
	        // server sent unparsable JSON
	        err instanceof errors.UnparsableJSON ||
	
	        // max tries and already using fallback or no fallback
	        tries >= client.hosts[initialOpts.hostType].length &&
	        (usingFallback || !hasFallback)) {
	        // stop request implementation for this command
	        err.debugData = debugData;
	        return client._promise.reject(err);
	      }
	
	      // When a timeout occured, retry by raising timeout
	      if (err instanceof errors.RequestTimeout) {
	        return retryRequestWithHigherTimeout();
	      }
	
	      return retryRequest();
	    }
	
	    function retryRequest() {
	      requestDebug('retrying request');
	      client._incrementHostIndex(initialOpts.hostType);
	      return doRequest(requester, reqOpts);
	    }
	
	    function retryRequestWithHigherTimeout() {
	      requestDebug('retrying request with higher timeout');
	      client._incrementHostIndex(initialOpts.hostType);
	      client._incrementTimeoutMultipler();
	      reqOpts.timeouts = client._getTimeoutsForRequest(initialOpts.hostType);
	      return doRequest(requester, reqOpts);
	    }
	  }
	
	  var promise = doRequest(
	    client._request, {
	      url: initialOpts.url,
	      method: initialOpts.method,
	      body: body,
	      jsonBody: initialOpts.body,
	      timeouts: client._getTimeoutsForRequest(initialOpts.hostType)
	    }
	  );
	
	  // either we have a callback
	  // either we are using promises
	  if (typeof initialOpts.callback === 'function') {
	    promise.then(function okCb(content) {
	      exitPromise(function() {
	        initialOpts.callback(null, content);
	      }, client._setTimeout || setTimeout);
	    }, function nookCb(err) {
	      exitPromise(function() {
	        initialOpts.callback(err);
	      }, client._setTimeout || setTimeout);
	    });
	  } else {
	    return promise;
	  }
	};
	
	/*
	* Transform search param object in query string
	* @param {object} args arguments to add to the current query string
	* @param {string} params current query string
	* @return {string} the final query string
	*/
	AlgoliaSearchCore.prototype._getSearchParams = function(args, params) {
	  if (args === undefined || args === null) {
	    return params;
	  }
	  for (var key in args) {
	    if (key !== null && args[key] !== undefined && args.hasOwnProperty(key)) {
	      params += params === '' ? '' : '&';
	      params += key + '=' + encodeURIComponent(Object.prototype.toString.call(args[key]) === '[object Array]' ? safeJSONStringify(args[key]) : args[key]);
	    }
	  }
	  return params;
	};
	
	AlgoliaSearchCore.prototype._computeRequestHeaders = function(additionalUA, withAPIKey) {
	  var forEach = __webpack_require__("./node_modules/foreach/index.js");
	
	  var ua = additionalUA ?
	    this._ua + ';' + additionalUA :
	    this._ua;
	
	  var requestHeaders = {
	    'x-algolia-agent': ua,
	    'x-algolia-application-id': this.applicationID
	  };
	
	  // browser will inline headers in the url, node.js will use http headers
	  // but in some situations, the API KEY will be too long (big secured API keys)
	  // so if the request is a POST and the KEY is very long, we will be asked to not put
	  // it into headers but in the JSON body
	  if (withAPIKey !== false) {
	    requestHeaders['x-algolia-api-key'] = this.apiKey;
	  }
	
	  if (this.userToken) {
	    requestHeaders['x-algolia-usertoken'] = this.userToken;
	  }
	
	  if (this.securityTags) {
	    requestHeaders['x-algolia-tagfilters'] = this.securityTags;
	  }
	
	  if (this.extraHeaders) {
	    forEach(this.extraHeaders, function addToRequestHeaders(header) {
	      requestHeaders[header.name] = header.value;
	    });
	  }
	
	  return requestHeaders;
	};
	
	/**
	 * Search through multiple indices at the same time
	 * @param  {Object[]}   queries  An array of queries you want to run.
	 * @param {string} queries[].indexName The index name you want to target
	 * @param {string} [queries[].query] The query to issue on this index. Can also be passed into `params`
	 * @param {Object} queries[].params Any search param like hitsPerPage, ..
	 * @param  {Function} callback Callback to be called
	 * @return {Promise|undefined} Returns a promise if no callback given
	 */
	AlgoliaSearchCore.prototype.search = function(queries, opts, callback) {
	  var isArray = __webpack_require__("./node_modules/isarray/index.js");
	  var map = __webpack_require__("./node_modules/algoliasearch/src/map.js");
	
	  var usage = 'Usage: client.search(arrayOfQueries[, callback])';
	
	  if (!isArray(queries)) {
	    throw new Error(usage);
	  }
	
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  } else if (opts === undefined) {
	    opts = {};
	  }
	
	  var client = this;
	
	  var postObj = {
	    requests: map(queries, function prepareRequest(query) {
	      var params = '';
	
	      // allow query.query
	      // so we are mimicing the index.search(query, params) method
	      // {indexName:, query:, params:}
	      if (query.query !== undefined) {
	        params += 'query=' + encodeURIComponent(query.query);
	      }
	
	      return {
	        indexName: query.indexName,
	        params: client._getSearchParams(query.params, params)
	      };
	    })
	  };
	
	  var JSONPParams = map(postObj.requests, function prepareJSONPParams(request, requestId) {
	    return requestId + '=' +
	      encodeURIComponent(
	        '/1/indexes/' + encodeURIComponent(request.indexName) + '?' +
	        request.params
	      );
	  }).join('&');
	
	  var url = '/1/indexes/*/queries';
	
	  if (opts.strategy !== undefined) {
	    url += '?strategy=' + opts.strategy;
	  }
	
	  return this._jsonRequest({
	    cache: this.cache,
	    method: 'POST',
	    url: url,
	    body: postObj,
	    hostType: 'read',
	    fallback: {
	      method: 'GET',
	      url: '/1/indexes/*',
	      body: {
	        params: JSONPParams
	      }
	    },
	    callback: callback
	  });
	};
	
	/**
	 * Set the extra security tagFilters header
	 * @param {string|array} tags The list of tags defining the current security filters
	 */
	AlgoliaSearchCore.prototype.setSecurityTags = function(tags) {
	  if (Object.prototype.toString.call(tags) === '[object Array]') {
	    var strTags = [];
	    for (var i = 0; i < tags.length; ++i) {
	      if (Object.prototype.toString.call(tags[i]) === '[object Array]') {
	        var oredTags = [];
	        for (var j = 0; j < tags[i].length; ++j) {
	          oredTags.push(tags[i][j]);
	        }
	        strTags.push('(' + oredTags.join(',') + ')');
	      } else {
	        strTags.push(tags[i]);
	      }
	    }
	    tags = strTags.join(',');
	  }
	
	  this.securityTags = tags;
	};
	
	/**
	 * Set the extra user token header
	 * @param {string} userToken The token identifying a uniq user (used to apply rate limits)
	 */
	AlgoliaSearchCore.prototype.setUserToken = function(userToken) {
	  this.userToken = userToken;
	};
	
	/**
	 * Clear all queries in client's cache
	 * @return undefined
	 */
	AlgoliaSearchCore.prototype.clearCache = function() {
	  this.cache = {};
	};
	
	/**
	* Set the number of milliseconds a request can take before automatically being terminated.
	* @deprecated
	* @param {Number} milliseconds
	*/
	AlgoliaSearchCore.prototype.setRequestTimeout = function(milliseconds) {
	  if (milliseconds) {
	    this._timeouts.connect = this._timeouts.read = this._timeouts.write = milliseconds;
	  }
	};
	
	/**
	* Set the three different (connect, read, write) timeouts to be used when requesting
	* @param {Object} timeouts
	*/
	AlgoliaSearchCore.prototype.setTimeouts = function(timeouts) {
	  this._timeouts = timeouts;
	};
	
	/**
	* Get the three different (connect, read, write) timeouts to be used when requesting
	* @param {Object} timeouts
	*/
	AlgoliaSearchCore.prototype.getTimeouts = function() {
	  return this._timeouts;
	};
	
	AlgoliaSearchCore.prototype._getAppIdData = function() {
	  var data = store.get(this.applicationID);
	  if (data !== null) this._cacheAppIdData(data);
	  return data;
	};
	
	AlgoliaSearchCore.prototype._setAppIdData = function(data) {
	  data.lastChange = (new Date()).getTime();
	  this._cacheAppIdData(data);
	  return store.set(this.applicationID, data);
	};
	
	AlgoliaSearchCore.prototype._checkAppIdData = function() {
	  var data = this._getAppIdData();
	  var now = (new Date()).getTime();
	  if (data === null || now - data.lastChange > RESET_APP_DATA_TIMER) {
	    return this._resetInitialAppIdData(data);
	  }
	
	  return data;
	};
	
	AlgoliaSearchCore.prototype._resetInitialAppIdData = function(data) {
	  var newData = data || {};
	  newData.hostIndexes = {read: 0, write: 0};
	  newData.timeoutMultiplier = 1;
	  newData.shuffleResult = newData.shuffleResult || shuffle([1, 2, 3]);
	  return this._setAppIdData(newData);
	};
	
	AlgoliaSearchCore.prototype._cacheAppIdData = function(data) {
	  this._hostIndexes = data.hostIndexes;
	  this._timeoutMultiplier = data.timeoutMultiplier;
	  this._shuffleResult = data.shuffleResult;
	};
	
	AlgoliaSearchCore.prototype._partialAppIdDataUpdate = function(newData) {
	  var foreach = __webpack_require__("./node_modules/foreach/index.js");
	  var currentData = this._getAppIdData();
	  foreach(newData, function(value, key) {
	    currentData[key] = value;
	  });
	
	  return this._setAppIdData(currentData);
	};
	
	AlgoliaSearchCore.prototype._getHostByType = function(hostType) {
	  return this.hosts[hostType][this._getHostIndexByType(hostType)];
	};
	
	AlgoliaSearchCore.prototype._getTimeoutMultiplier = function() {
	  return this._timeoutMultiplier;
	};
	
	AlgoliaSearchCore.prototype._getHostIndexByType = function(hostType) {
	  return this._hostIndexes[hostType];
	};
	
	AlgoliaSearchCore.prototype._setHostIndexByType = function(hostIndex, hostType) {
	  var clone = __webpack_require__("./node_modules/algoliasearch/src/clone.js");
	  var newHostIndexes = clone(this._hostIndexes);
	  newHostIndexes[hostType] = hostIndex;
	  this._partialAppIdDataUpdate({hostIndexes: newHostIndexes});
	  return hostIndex;
	};
	
	AlgoliaSearchCore.prototype._incrementHostIndex = function(hostType) {
	  return this._setHostIndexByType(
	    (this._getHostIndexByType(hostType) + 1) % this.hosts[hostType].length, hostType
	  );
	};
	
	AlgoliaSearchCore.prototype._incrementTimeoutMultipler = function() {
	  var timeoutMultiplier = Math.max(this._timeoutMultiplier + 1, 4);
	  return this._partialAppIdDataUpdate({timeoutMultiplier: timeoutMultiplier});
	};
	
	AlgoliaSearchCore.prototype._getTimeoutsForRequest = function(hostType) {
	  return {
	    connect: this._timeouts.connect * this._timeoutMultiplier,
	    complete: this._timeouts[hostType] * this._timeoutMultiplier
	  };
	};
	
	function prepareHost(protocol) {
	  return function prepare(host) {
	    return protocol + '//' + host.toLowerCase();
	  };
	}
	
	// Prototype.js < 1.7, a widely used library, defines a weird
	// Array.prototype.toJSON function that will fail to stringify our content
	// appropriately
	// refs:
	//   - https://groups.google.com/forum/#!topic/prototype-core/E-SAVvV_V9Q
	//   - https://github.com/sstephenson/prototype/commit/038a2985a70593c1a86c230fadbdfe2e4898a48c
	//   - http://stackoverflow.com/a/3148441/147079
	function safeJSONStringify(obj) {
	  /* eslint no-extend-native:0 */
	
	  if (Array.prototype.toJSON === undefined) {
	    return JSON.stringify(obj);
	  }
	
	  var toJSON = Array.prototype.toJSON;
	  delete Array.prototype.toJSON;
	  var out = JSON.stringify(obj);
	  Array.prototype.toJSON = toJSON;
	
	  return out;
	}
	
	function shuffle(array) {
	  var currentIndex = array.length;
	  var temporaryValue;
	  var randomIndex;
	
	  // While there remain elements to shuffle...
	  while (currentIndex !== 0) {
	    // Pick a remaining element...
	    randomIndex = Math.floor(Math.random() * currentIndex);
	    currentIndex -= 1;
	
	    // And swap it with the current element.
	    temporaryValue = array[currentIndex];
	    array[currentIndex] = array[randomIndex];
	    array[randomIndex] = temporaryValue;
	  }
	
	  return array;
	}
	
	function removeCredentials(headers) {
	  var newHeaders = {};
	
	  for (var headerName in headers) {
	    if (Object.prototype.hasOwnProperty.call(headers, headerName)) {
	      var value;
	
	      if (headerName === 'x-algolia-api-key' || headerName === 'x-algolia-application-id') {
	        value = '**hidden for security purposes**';
	      } else {
	        value = headers[headerName];
	      }
	
	      newHeaders[headerName] = value;
	    }
	  }
	
	  return newHeaders;
	}


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),

/***/ "./node_modules/algoliasearch/src/Index.js":
/***/ (function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__("./node_modules/inherits/inherits_browser.js");
	var IndexCore = __webpack_require__("./node_modules/algoliasearch/src/IndexCore.js");
	var deprecate = __webpack_require__("./node_modules/algoliasearch/src/deprecate.js");
	var deprecatedMessage = __webpack_require__("./node_modules/algoliasearch/src/deprecatedMessage.js");
	var exitPromise = __webpack_require__("./node_modules/algoliasearch/src/exitPromise.js");
	var errors = __webpack_require__("./node_modules/algoliasearch/src/errors.js");
	
	var deprecateForwardToSlaves = deprecate(
	  function() {},
	  deprecatedMessage('forwardToSlaves', 'forwardToReplicas')
	);
	
	module.exports = Index;
	
	function Index() {
	  IndexCore.apply(this, arguments);
	}
	
	inherits(Index, IndexCore);
	
	/*
	* Add an object in this index
	*
	* @param content contains the javascript object to add inside the index
	* @param objectID (optional) an objectID you want to attribute to this object
	* (if the attribute already exist the old object will be overwrite)
	* @param callback (optional) the result callback called with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that contains 3 elements: createAt, taskId and objectID
	*/
	Index.prototype.addObject = function(content, objectID, callback) {
	  var indexObj = this;
	
	  if (arguments.length === 1 || typeof objectID === 'function') {
	    callback = objectID;
	    objectID = undefined;
	  }
	
	  return this.as._jsonRequest({
	    method: objectID !== undefined ?
	    'PUT' : // update or create
	    'POST', // create (API generates an objectID)
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + // create
	    (objectID !== undefined ? '/' + encodeURIComponent(objectID) : ''), // update or create
	    body: content,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Add several objects
	*
	* @param objects contains an array of objects to add
	* @param callback (optional) the result callback called with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that updateAt and taskID
	*/
	Index.prototype.addObjects = function(objects, callback) {
	  var isArray = __webpack_require__("./node_modules/isarray/index.js");
	  var usage = 'Usage: index.addObjects(arrayOfObjects[, callback])';
	
	  if (!isArray(objects)) {
	    throw new Error(usage);
	  }
	
	  var indexObj = this;
	  var postObj = {
	    requests: []
	  };
	  for (var i = 0; i < objects.length; ++i) {
	    var request = {
	      action: 'addObject',
	      body: objects[i]
	    };
	    postObj.requests.push(request);
	  }
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/batch',
	    body: postObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Update partially an object (only update attributes passed in argument)
	*
	* @param partialObject contains the javascript attributes to override, the
	*  object must contains an objectID attribute
	* @param createIfNotExists (optional) if false, avoid an automatic creation of the object
	* @param callback (optional) the result callback called with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that contains 3 elements: createAt, taskId and objectID
	*/
	Index.prototype.partialUpdateObject = function(partialObject, createIfNotExists, callback) {
	  if (arguments.length === 1 || typeof createIfNotExists === 'function') {
	    callback = createIfNotExists;
	    createIfNotExists = undefined;
	  }
	
	  var indexObj = this;
	  var url = '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/' + encodeURIComponent(partialObject.objectID) + '/partial';
	  if (createIfNotExists === false) {
	    url += '?createIfNotExists=false';
	  }
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: url,
	    body: partialObject,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Partially Override the content of several objects
	*
	* @param objects contains an array of objects to update (each object must contains a objectID attribute)
	* @param callback (optional) the result callback called with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that updateAt and taskID
	*/
	Index.prototype.partialUpdateObjects = function(objects, createIfNotExists, callback) {
	  if (arguments.length === 1 || typeof createIfNotExists === 'function') {
	    callback = createIfNotExists;
	    createIfNotExists = true;
	  }
	
	  var isArray = __webpack_require__("./node_modules/isarray/index.js");
	  var usage = 'Usage: index.partialUpdateObjects(arrayOfObjects[, callback])';
	
	  if (!isArray(objects)) {
	    throw new Error(usage);
	  }
	
	  var indexObj = this;
	  var postObj = {
	    requests: []
	  };
	  for (var i = 0; i < objects.length; ++i) {
	    var request = {
	      action: createIfNotExists === true ? 'partialUpdateObject' : 'partialUpdateObjectNoCreate',
	      objectID: objects[i].objectID,
	      body: objects[i]
	    };
	    postObj.requests.push(request);
	  }
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/batch',
	    body: postObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Override the content of object
	*
	* @param object contains the javascript object to save, the object must contains an objectID attribute
	* @param callback (optional) the result callback called with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that updateAt and taskID
	*/
	Index.prototype.saveObject = function(object, callback) {
	  var indexObj = this;
	  return this.as._jsonRequest({
	    method: 'PUT',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/' + encodeURIComponent(object.objectID),
	    body: object,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Override the content of several objects
	*
	* @param objects contains an array of objects to update (each object must contains a objectID attribute)
	* @param callback (optional) the result callback called with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that updateAt and taskID
	*/
	Index.prototype.saveObjects = function(objects, callback) {
	  var isArray = __webpack_require__("./node_modules/isarray/index.js");
	  var usage = 'Usage: index.saveObjects(arrayOfObjects[, callback])';
	
	  if (!isArray(objects)) {
	    throw new Error(usage);
	  }
	
	  var indexObj = this;
	  var postObj = {
	    requests: []
	  };
	  for (var i = 0; i < objects.length; ++i) {
	    var request = {
	      action: 'updateObject',
	      objectID: objects[i].objectID,
	      body: objects[i]
	    };
	    postObj.requests.push(request);
	  }
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/batch',
	    body: postObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Delete an object from the index
	*
	* @param objectID the unique identifier of object to delete
	* @param callback (optional) the result callback called with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that contains 3 elements: createAt, taskId and objectID
	*/
	Index.prototype.deleteObject = function(objectID, callback) {
	  if (typeof objectID === 'function' || typeof objectID !== 'string' && typeof objectID !== 'number') {
	    var err = new errors.AlgoliaSearchError('Cannot delete an object without an objectID');
	    callback = objectID;
	    if (typeof callback === 'function') {
	      return callback(err);
	    }
	
	    return this.as._promise.reject(err);
	  }
	
	  var indexObj = this;
	  return this.as._jsonRequest({
	    method: 'DELETE',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/' + encodeURIComponent(objectID),
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Delete several objects from an index
	*
	* @param objectIDs contains an array of objectID to delete
	* @param callback (optional) the result callback called with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that contains 3 elements: createAt, taskId and objectID
	*/
	Index.prototype.deleteObjects = function(objectIDs, callback) {
	  var isArray = __webpack_require__("./node_modules/isarray/index.js");
	  var map = __webpack_require__("./node_modules/algoliasearch/src/map.js");
	
	  var usage = 'Usage: index.deleteObjects(arrayOfObjectIDs[, callback])';
	
	  if (!isArray(objectIDs)) {
	    throw new Error(usage);
	  }
	
	  var indexObj = this;
	  var postObj = {
	    requests: map(objectIDs, function prepareRequest(objectID) {
	      return {
	        action: 'deleteObject',
	        objectID: objectID,
	        body: {
	          objectID: objectID
	        }
	      };
	    })
	  };
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/batch',
	    body: postObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Delete all objects matching a query
	*
	* @param query the query string
	* @param params the optional query parameters
	* @param callback (optional) the result callback called with one argument
	*  error: null or Error('message')
	*/
	Index.prototype.deleteByQuery = function(query, params, callback) {
	  var clone = __webpack_require__("./node_modules/algoliasearch/src/clone.js");
	  var map = __webpack_require__("./node_modules/algoliasearch/src/map.js");
	
	  var indexObj = this;
	  var client = indexObj.as;
	
	  if (arguments.length === 1 || typeof params === 'function') {
	    callback = params;
	    params = {};
	  } else {
	    params = clone(params);
	  }
	
	  params.attributesToRetrieve = 'objectID';
	  params.hitsPerPage = 1000;
	  params.distinct = false;
	
	  // when deleting, we should never use cache to get the
	  // search results
	  this.clearCache();
	
	  // there's a problem in how we use the promise chain,
	  // see how waitTask is done
	  var promise = this
	  .search(query, params)
	  .then(stopOrDelete);
	
	  function stopOrDelete(searchContent) {
	    // stop here
	    if (searchContent.nbHits === 0) {
	      // return indexObj.as._request.resolve();
	      return searchContent;
	    }
	
	    // continue and do a recursive call
	    var objectIDs = map(searchContent.hits, function getObjectID(object) {
	      return object.objectID;
	    });
	
	    return indexObj
	    .deleteObjects(objectIDs)
	    .then(waitTask)
	    .then(doDeleteByQuery);
	  }
	
	  function waitTask(deleteObjectsContent) {
	    return indexObj.waitTask(deleteObjectsContent.taskID);
	  }
	
	  function doDeleteByQuery() {
	    return indexObj.deleteByQuery(query, params);
	  }
	
	  if (!callback) {
	    return promise;
	  }
	
	  promise.then(success, failure);
	
	  function success() {
	    exitPromise(function exit() {
	      callback(null);
	    }, client._setTimeout || setTimeout);
	  }
	
	  function failure(err) {
	    exitPromise(function exit() {
	      callback(err);
	    }, client._setTimeout || setTimeout);
	  }
	};
	
	/*
	* Browse all content from an index using events. Basically this will do
	* .browse() -> .browseFrom -> .browseFrom -> .. until all the results are returned
	*
	* @param {string} query - The full text query
	* @param {Object} [queryParameters] - Any search query parameter
	* @return {EventEmitter}
	* @example
	* var browser = index.browseAll('cool songs', {
	*   tagFilters: 'public,comments',
	*   hitsPerPage: 500
	* });
	*
	* browser.on('result', function resultCallback(content) {
	*   console.log(content.hits);
	* });
	*
	* // if any error occurs, you get it
	* browser.on('error', function(err) {
	*   throw err;
	* });
	*
	* // when you have browsed the whole index, you get this event
	* browser.on('end', function() {
	*   console.log('finished');
	* });
	*
	* // at any point if you want to stop the browsing process, you can stop it manually
	* // otherwise it will go on and on
	* browser.stop();
	*
	* @see {@link https://www.algolia.com/doc/rest_api#Browse|Algolia REST API Documentation}
	*/
	Index.prototype.browseAll = function(query, queryParameters) {
	  if (typeof query === 'object') {
	    queryParameters = query;
	    query = undefined;
	  }
	
	  var merge = __webpack_require__("./node_modules/algoliasearch/src/merge.js");
	
	  var IndexBrowser = __webpack_require__("./node_modules/algoliasearch/src/IndexBrowser.js");
	
	  var browser = new IndexBrowser();
	  var client = this.as;
	  var index = this;
	  var params = client._getSearchParams(
	    merge({}, queryParameters || {}, {
	      query: query
	    }), ''
	  );
	
	  // start browsing
	  browseLoop();
	
	  function browseLoop(cursor) {
	    if (browser._stopped) {
	      return;
	    }
	
	    var body;
	
	    if (cursor !== undefined) {
	      body = {
	        cursor: cursor
	      };
	    } else {
	      body = {
	        params: params
	      };
	    }
	
	    client._jsonRequest({
	      method: 'POST',
	      url: '/1/indexes/' + encodeURIComponent(index.indexName) + '/browse',
	      hostType: 'read',
	      body: body,
	      callback: browseCallback
	    });
	  }
	
	  function browseCallback(err, content) {
	    if (browser._stopped) {
	      return;
	    }
	
	    if (err) {
	      browser._error(err);
	      return;
	    }
	
	    browser._result(content);
	
	    // no cursor means we are finished browsing
	    if (content.cursor === undefined) {
	      browser._end();
	      return;
	    }
	
	    browseLoop(content.cursor);
	  }
	
	  return browser;
	};
	
	/*
	* Get a Typeahead.js adapter
	* @param searchParams contains an object with query parameters (see search for details)
	*/
	Index.prototype.ttAdapter = function(params) {
	  var self = this;
	  return function ttAdapter(query, syncCb, asyncCb) {
	    var cb;
	
	    if (typeof asyncCb === 'function') {
	      // typeahead 0.11
	      cb = asyncCb;
	    } else {
	      // pre typeahead 0.11
	      cb = syncCb;
	    }
	
	    self.search(query, params, function searchDone(err, content) {
	      if (err) {
	        cb(err);
	        return;
	      }
	
	      cb(content.hits);
	    });
	  };
	};
	
	/*
	* Wait the publication of a task on the server.
	* All server task are asynchronous and you can check with this method that the task is published.
	*
	* @param taskID the id of the task returned by server
	* @param callback the result callback with with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that contains the list of results
	*/
	Index.prototype.waitTask = function(taskID, callback) {
	  // wait minimum 100ms before retrying
	  var baseDelay = 100;
	  // wait maximum 5s before retrying
	  var maxDelay = 5000;
	  var loop = 0;
	
	  // waitTask() must be handled differently from other methods,
	  // it's a recursive method using a timeout
	  var indexObj = this;
	  var client = indexObj.as;
	
	  var promise = retryLoop();
	
	  function retryLoop() {
	    return client._jsonRequest({
	      method: 'GET',
	      hostType: 'read',
	      url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/task/' + taskID
	    }).then(function success(content) {
	      loop++;
	      var delay = baseDelay * loop * loop;
	      if (delay > maxDelay) {
	        delay = maxDelay;
	      }
	
	      if (content.status !== 'published') {
	        return client._promise.delay(delay).then(retryLoop);
	      }
	
	      return content;
	    });
	  }
	
	  if (!callback) {
	    return promise;
	  }
	
	  promise.then(successCb, failureCb);
	
	  function successCb(content) {
	    exitPromise(function exit() {
	      callback(null, content);
	    }, client._setTimeout || setTimeout);
	  }
	
	  function failureCb(err) {
	    exitPromise(function exit() {
	      callback(err);
	    }, client._setTimeout || setTimeout);
	  }
	};
	
	/*
	* This function deletes the index content. Settings and index specific API keys are kept untouched.
	*
	* @param callback (optional) the result callback called with two arguments
	*  error: null or Error('message')
	*  content: the settings object or the error message if a failure occured
	*/
	Index.prototype.clearIndex = function(callback) {
	  var indexObj = this;
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/clear',
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Get settings of this index
	*
	* @param callback (optional) the result callback called with two arguments
	*  error: null or Error('message')
	*  content: the settings object or the error message if a failure occured
	*/
	Index.prototype.getSettings = function(callback) {
	  var indexObj = this;
	  return this.as._jsonRequest({
	    method: 'GET',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/settings?getVersion=2',
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	Index.prototype.searchSynonyms = function(params, callback) {
	  if (typeof params === 'function') {
	    callback = params;
	    params = {};
	  } else if (params === undefined) {
	    params = {};
	  }
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/search',
	    body: params,
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	Index.prototype.saveSynonym = function(synonym, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  } else if (opts === undefined) {
	    opts = {};
	  }
	
	  if (opts.forwardToSlaves !== undefined) deprecateForwardToSlaves();
	  var forwardToReplicas = (opts.forwardToSlaves || opts.forwardToReplicas) ? 'true' : 'false';
	
	  return this.as._jsonRequest({
	    method: 'PUT',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/' + encodeURIComponent(synonym.objectID) +
	      '?forwardToReplicas=' + forwardToReplicas,
	    body: synonym,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	Index.prototype.getSynonym = function(objectID, callback) {
	  return this.as._jsonRequest({
	    method: 'GET',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/' + encodeURIComponent(objectID),
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	Index.prototype.deleteSynonym = function(objectID, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  } else if (opts === undefined) {
	    opts = {};
	  }
	
	  if (opts.forwardToSlaves !== undefined) deprecateForwardToSlaves();
	  var forwardToReplicas = (opts.forwardToSlaves || opts.forwardToReplicas) ? 'true' : 'false';
	
	  return this.as._jsonRequest({
	    method: 'DELETE',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/' + encodeURIComponent(objectID) +
	      '?forwardToReplicas=' + forwardToReplicas,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	Index.prototype.clearSynonyms = function(opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  } else if (opts === undefined) {
	    opts = {};
	  }
	
	  if (opts.forwardToSlaves !== undefined) deprecateForwardToSlaves();
	  var forwardToReplicas = (opts.forwardToSlaves || opts.forwardToReplicas) ? 'true' : 'false';
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/clear' +
	      '?forwardToReplicas=' + forwardToReplicas,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	Index.prototype.batchSynonyms = function(synonyms, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  } else if (opts === undefined) {
	    opts = {};
	  }
	
	  if (opts.forwardToSlaves !== undefined) deprecateForwardToSlaves();
	  var forwardToReplicas = (opts.forwardToSlaves || opts.forwardToReplicas) ? 'true' : 'false';
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/batch' +
	      '?forwardToReplicas=' + forwardToReplicas +
	      '&replaceExistingSynonyms=' + (opts.replaceExistingSynonyms ? 'true' : 'false'),
	    hostType: 'write',
	    body: synonyms,
	    callback: callback
	  });
	};
	
	Index.prototype.searchRules = function(params, callback) {
	  if (typeof params === 'function') {
	    callback = params;
	    params = {};
	  } else if (params === undefined) {
	    params = {};
	  }
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/rules/search',
	    body: params,
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	Index.prototype.saveRule = function(rule, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  } else if (opts === undefined) {
	    opts = {};
	  }
	
	  var forwardToReplicas = opts.forwardToReplicas === true ? 'true' : 'false';
	
	  return this.as._jsonRequest({
	    method: 'PUT',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/rules/' + encodeURIComponent(rule.objectID) +
	      '?forwardToReplicas=' + forwardToReplicas,
	    body: rule,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	Index.prototype.getRule = function(objectID, callback) {
	  return this.as._jsonRequest({
	    method: 'GET',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/rules/' + encodeURIComponent(objectID),
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	Index.prototype.deleteRule = function(objectID, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  } else if (opts === undefined) {
	    opts = {};
	  }
	
	  var forwardToReplicas = opts.forwardToReplicas === true ? 'true' : 'false';
	
	  return this.as._jsonRequest({
	    method: 'DELETE',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/rules/' + encodeURIComponent(objectID) +
	      '?forwardToReplicas=' + forwardToReplicas,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	Index.prototype.clearRules = function(opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  } else if (opts === undefined) {
	    opts = {};
	  }
	
	  var forwardToReplicas = opts.forwardToReplicas === true ? 'true' : 'false';
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/rules/clear' +
	      '?forwardToReplicas=' + forwardToReplicas,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	Index.prototype.batchRules = function(rules, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  } else if (opts === undefined) {
	    opts = {};
	  }
	
	  var forwardToReplicas = opts.forwardToReplicas === true ? 'true' : 'false';
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/rules/batch' +
	      '?forwardToReplicas=' + forwardToReplicas +
	      '&clearExistingRules=' + (opts.clearExistingRules === true ? 'true' : 'false'),
	    hostType: 'write',
	    body: rules,
	    callback: callback
	  });
	};
	
	/*
	* Set settings for this index
	*
	* @param settigns the settings object that can contains :
	* - minWordSizefor1Typo: (integer) the minimum number of characters to accept one typo (default = 3).
	* - minWordSizefor2Typos: (integer) the minimum number of characters to accept two typos (default = 7).
	* - hitsPerPage: (integer) the number of hits per page (default = 10).
	* - attributesToRetrieve: (array of strings) default list of attributes to retrieve in objects.
	*   If set to null, all attributes are retrieved.
	* - attributesToHighlight: (array of strings) default list of attributes to highlight.
	*   If set to null, all indexed attributes are highlighted.
	* - attributesToSnippet**: (array of strings) default list of attributes to snippet alongside the number
	* of words to return (syntax is attributeName:nbWords).
	*   By default no snippet is computed. If set to null, no snippet is computed.
	* - attributesToIndex: (array of strings) the list of fields you want to index.
	*   If set to null, all textual and numerical attributes of your objects are indexed,
	*   but you should update it to get optimal results.
	*   This parameter has two important uses:
	*     - Limit the attributes to index: For example if you store a binary image in base64,
	*     you want to store it and be able to
	*       retrieve it but you don't want to search in the base64 string.
	*     - Control part of the ranking*: (see the ranking parameter for full explanation)
	*     Matches in attributes at the beginning of
	*       the list will be considered more important than matches in attributes further down the list.
	*       In one attribute, matching text at the beginning of the attribute will be
	*       considered more important than text after, you can disable
	*       this behavior if you add your attribute inside `unordered(AttributeName)`,
	*       for example attributesToIndex: ["title", "unordered(text)"].
	* - attributesForFaceting: (array of strings) The list of fields you want to use for faceting.
	*   All strings in the attribute selected for faceting are extracted and added as a facet.
	*   If set to null, no attribute is used for faceting.
	* - attributeForDistinct: (string) The attribute name used for the Distinct feature.
	* This feature is similar to the SQL "distinct" keyword: when enabled
	*   in query with the distinct=1 parameter, all hits containing a duplicate
	*   value for this attribute are removed from results.
	*   For example, if the chosen attribute is show_name and several hits have
	*   the same value for show_name, then only the best one is kept and others are removed.
	* - ranking: (array of strings) controls the way results are sorted.
	*   We have six available criteria:
	*    - typo: sort according to number of typos,
	*    - geo: sort according to decreassing distance when performing a geo-location based search,
	*    - proximity: sort according to the proximity of query words in hits,
	*    - attribute: sort according to the order of attributes defined by attributesToIndex,
	*    - exact:
	*        - if the user query contains one word: sort objects having an attribute
	*        that is exactly the query word before others.
	*          For example if you search for the "V" TV show, you want to find it
	*          with the "V" query and avoid to have all popular TV
	*          show starting by the v letter before it.
	*        - if the user query contains multiple words: sort according to the
	*        number of words that matched exactly (and not as a prefix).
	*    - custom: sort according to a user defined formula set in **customRanking** attribute.
	*   The standard order is ["typo", "geo", "proximity", "attribute", "exact", "custom"]
	* - customRanking: (array of strings) lets you specify part of the ranking.
	*   The syntax of this condition is an array of strings containing attributes
	*   prefixed by asc (ascending order) or desc (descending order) operator.
	*   For example `"customRanking" => ["desc(population)", "asc(name)"]`
	* - queryType: Select how the query words are interpreted, it can be one of the following value:
	*   - prefixAll: all query words are interpreted as prefixes,
	*   - prefixLast: only the last word is interpreted as a prefix (default behavior),
	*   - prefixNone: no query word is interpreted as a prefix. This option is not recommended.
	* - highlightPreTag: (string) Specify the string that is inserted before
	* the highlighted parts in the query result (default to "<em>").
	* - highlightPostTag: (string) Specify the string that is inserted after
	* the highlighted parts in the query result (default to "</em>").
	* - optionalWords: (array of strings) Specify a list of words that should
	* be considered as optional when found in the query.
	* @param callback (optional) the result callback called with two arguments
	*  error: null or Error('message')
	*  content: the server answer or the error message if a failure occured
	*/
	Index.prototype.setSettings = function(settings, opts, callback) {
	  if (arguments.length === 1 || typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	
	  if (opts.forwardToSlaves !== undefined) deprecateForwardToSlaves();
	  var forwardToReplicas = (opts.forwardToSlaves || opts.forwardToReplicas) ? 'true' : 'false';
	
	  var indexObj = this;
	  return this.as._jsonRequest({
	    method: 'PUT',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/settings?forwardToReplicas='
	      + forwardToReplicas,
	    hostType: 'write',
	    body: settings,
	    callback: callback
	  });
	};
	
	/*
	 @deprecated see index.listApiKeys
	 */
	Index.prototype.listUserKeys = deprecate(function(callback) {
	  return this.listApiKeys(callback);
	}, deprecatedMessage('index.listUserKeys()', 'index.listApiKeys()'));
	
	/*
	* List all existing API keys to this index
	*
	* @param callback the result callback called with two arguments
	*  error: null or Error('message')
	*  content: the server answer with API keys belonging to the index
	*/
	Index.prototype.listApiKeys = function(callback) {
	  var indexObj = this;
	  return this.as._jsonRequest({
	    method: 'GET',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/keys',
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	 @deprecated see index.getApiKey
	 */
	Index.prototype.getUserKeyACL = deprecate(function(key, callback) {
	  return this.getApiKey(key, callback);
	}, deprecatedMessage('index.getUserKeyACL()', 'index.getApiKey()'));
	
	
	/*
	* Get an API key from this index
	*
	* @param key
	* @param callback the result callback called with two arguments
	*  error: null or Error('message')
	*  content: the server answer with the right API key
	*/
	Index.prototype.getApiKey = function(key, callback) {
	  var indexObj = this;
	  return this.as._jsonRequest({
	    method: 'GET',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/keys/' + key,
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	 @deprecated see index.deleteApiKey
	 */
	Index.prototype.deleteUserKey = deprecate(function(key, callback) {
	  return this.deleteApiKey(key, callback);
	}, deprecatedMessage('index.deleteUserKey()', 'index.deleteApiKey()'));
	
	/*
	* Delete an existing API key associated to this index
	*
	* @param key
	* @param callback the result callback called with two arguments
	*  error: null or Error('message')
	*  content: the server answer with the deletion date
	*/
	Index.prototype.deleteApiKey = function(key, callback) {
	  var indexObj = this;
	  return this.as._jsonRequest({
	    method: 'DELETE',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/keys/' + key,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	 @deprecated see index.addApiKey
	 */
	Index.prototype.addUserKey = deprecate(function(acls, params, callback) {
	  return this.addApiKey(acls, params, callback);
	}, deprecatedMessage('index.addUserKey()', 'index.addApiKey()'));
	
	/*
	* Add a new API key to this index
	*
	* @param {string[]} acls - The list of ACL for this key. Defined by an array of strings that
	*   can contains the following values:
	*     - search: allow to search (https and http)
	*     - addObject: allows to add/update an object in the index (https only)
	*     - deleteObject : allows to delete an existing object (https only)
	*     - deleteIndex : allows to delete index content (https only)
	*     - settings : allows to get index settings (https only)
	*     - editSettings : allows to change index settings (https only)
	* @param {Object} [params] - Optionnal parameters to set for the key
	* @param {number} params.validity - Number of seconds after which the key will
	* be automatically removed (0 means no time limit for this key)
	* @param {number} params.maxQueriesPerIPPerHour - Number of API calls allowed from an IP address per hour
	* @param {number} params.maxHitsPerQuery - Number of hits this API key can retrieve in one call
	* @param {string} params.description - A description for your key
	* @param {string[]} params.referers - A list of authorized referers
	* @param {Object} params.queryParameters - Force the key to use specific query parameters
	* @param {Function} callback - The result callback called with two arguments
	*   error: null or Error('message')
	*   content: the server answer with the added API key
	* @return {Promise|undefined} Returns a promise if no callback given
	* @example
	* index.addUserKey(['search'], {
	*   validity: 300,
	*   maxQueriesPerIPPerHour: 2000,
	*   maxHitsPerQuery: 3,
	*   description: 'Eat three fruits',
	*   referers: ['*.algolia.com'],
	*   queryParameters: {
	*     tagFilters: ['public'],
	*   }
	* })
	* @see {@link https://www.algolia.com/doc/rest_api#AddIndexKey|Algolia REST API Documentation}
	*/
	Index.prototype.addApiKey = function(acls, params, callback) {
	  var isArray = __webpack_require__("./node_modules/isarray/index.js");
	  var usage = 'Usage: index.addApiKey(arrayOfAcls[, params, callback])';
	
	  if (!isArray(acls)) {
	    throw new Error(usage);
	  }
	
	  if (arguments.length === 1 || typeof params === 'function') {
	    callback = params;
	    params = null;
	  }
	
	  var postObj = {
	    acl: acls
	  };
	
	  if (params) {
	    postObj.validity = params.validity;
	    postObj.maxQueriesPerIPPerHour = params.maxQueriesPerIPPerHour;
	    postObj.maxHitsPerQuery = params.maxHitsPerQuery;
	    postObj.description = params.description;
	
	    if (params.queryParameters) {
	      postObj.queryParameters = this.as._getSearchParams(params.queryParameters, '');
	    }
	
	    postObj.referers = params.referers;
	  }
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/keys',
	    body: postObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/**
	* @deprecated use index.addApiKey()
	*/
	Index.prototype.addUserKeyWithValidity = deprecate(function deprecatedAddUserKeyWithValidity(acls, params, callback) {
	  return this.addApiKey(acls, params, callback);
	}, deprecatedMessage('index.addUserKeyWithValidity()', 'index.addApiKey()'));
	
	/*
	 @deprecated see index.updateApiKey
	 */
	Index.prototype.updateUserKey = deprecate(function(key, acls, params, callback) {
	  return this.updateApiKey(key, acls, params, callback);
	}, deprecatedMessage('index.updateUserKey()', 'index.updateApiKey()'));
	
	/**
	* Update an existing API key of this index
	* @param {string} key - The key to update
	* @param {string[]} acls - The list of ACL for this key. Defined by an array of strings that
	*   can contains the following values:
	*     - search: allow to search (https and http)
	*     - addObject: allows to add/update an object in the index (https only)
	*     - deleteObject : allows to delete an existing object (https only)
	*     - deleteIndex : allows to delete index content (https only)
	*     - settings : allows to get index settings (https only)
	*     - editSettings : allows to change index settings (https only)
	* @param {Object} [params] - Optionnal parameters to set for the key
	* @param {number} params.validity - Number of seconds after which the key will
	* be automatically removed (0 means no time limit for this key)
	* @param {number} params.maxQueriesPerIPPerHour - Number of API calls allowed from an IP address per hour
	* @param {number} params.maxHitsPerQuery - Number of hits this API key can retrieve in one call
	* @param {string} params.description - A description for your key
	* @param {string[]} params.referers - A list of authorized referers
	* @param {Object} params.queryParameters - Force the key to use specific query parameters
	* @param {Function} callback - The result callback called with two arguments
	*   error: null or Error('message')
	*   content: the server answer with user keys list
	* @return {Promise|undefined} Returns a promise if no callback given
	* @example
	* index.updateApiKey('APIKEY', ['search'], {
	*   validity: 300,
	*   maxQueriesPerIPPerHour: 2000,
	*   maxHitsPerQuery: 3,
	*   description: 'Eat three fruits',
	*   referers: ['*.algolia.com'],
	*   queryParameters: {
	*     tagFilters: ['public'],
	*   }
	* })
	* @see {@link https://www.algolia.com/doc/rest_api#UpdateIndexKey|Algolia REST API Documentation}
	*/
	Index.prototype.updateApiKey = function(key, acls, params, callback) {
	  var isArray = __webpack_require__("./node_modules/isarray/index.js");
	  var usage = 'Usage: index.updateApiKey(key, arrayOfAcls[, params, callback])';
	
	  if (!isArray(acls)) {
	    throw new Error(usage);
	  }
	
	  if (arguments.length === 2 || typeof params === 'function') {
	    callback = params;
	    params = null;
	  }
	
	  var putObj = {
	    acl: acls
	  };
	
	  if (params) {
	    putObj.validity = params.validity;
	    putObj.maxQueriesPerIPPerHour = params.maxQueriesPerIPPerHour;
	    putObj.maxHitsPerQuery = params.maxHitsPerQuery;
	    putObj.description = params.description;
	
	    if (params.queryParameters) {
	      putObj.queryParameters = this.as._getSearchParams(params.queryParameters, '');
	    }
	
	    putObj.referers = params.referers;
	  }
	
	  return this.as._jsonRequest({
	    method: 'PUT',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/keys/' + key,
	    body: putObj,
	    hostType: 'write',
	    callback: callback
	  });
	};


/***/ }),

/***/ "./node_modules/algoliasearch/src/IndexBrowser.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// This is the object returned by the `index.browseAll()` method
	
	module.exports = IndexBrowser;
	
	var inherits = __webpack_require__("./node_modules/inherits/inherits_browser.js");
	var EventEmitter = __webpack_require__("./node_modules/events/events.js").EventEmitter;
	
	function IndexBrowser() {
	}
	
	inherits(IndexBrowser, EventEmitter);
	
	IndexBrowser.prototype.stop = function() {
	  this._stopped = true;
	  this._clean();
	};
	
	IndexBrowser.prototype._end = function() {
	  this.emit('end');
	  this._clean();
	};
	
	IndexBrowser.prototype._error = function(err) {
	  this.emit('error', err);
	  this._clean();
	};
	
	IndexBrowser.prototype._result = function(content) {
	  this.emit('result', content);
	};
	
	IndexBrowser.prototype._clean = function() {
	  this.removeAllListeners('stop');
	  this.removeAllListeners('end');
	  this.removeAllListeners('error');
	  this.removeAllListeners('result');
	};


/***/ }),

/***/ "./node_modules/algoliasearch/src/IndexCore.js":
/***/ (function(module, exports, __webpack_require__) {

	var buildSearchMethod = __webpack_require__("./node_modules/algoliasearch/src/buildSearchMethod.js");
	var deprecate = __webpack_require__("./node_modules/algoliasearch/src/deprecate.js");
	var deprecatedMessage = __webpack_require__("./node_modules/algoliasearch/src/deprecatedMessage.js");
	
	module.exports = IndexCore;
	
	/*
	* Index class constructor.
	* You should not use this method directly but use initIndex() function
	*/
	function IndexCore(algoliasearch, indexName) {
	  this.indexName = indexName;
	  this.as = algoliasearch;
	  this.typeAheadArgs = null;
	  this.typeAheadValueOption = null;
	
	  // make sure every index instance has it's own cache
	  this.cache = {};
	}
	
	/*
	* Clear all queries in cache
	*/
	IndexCore.prototype.clearCache = function() {
	  this.cache = {};
	};
	
	/*
	* Search inside the index using XMLHttpRequest request (Using a POST query to
	* minimize number of OPTIONS queries: Cross-Origin Resource Sharing).
	*
	* @param {string} [query] the full text query
	* @param {object} [args] (optional) if set, contains an object with query parameters:
	* - page: (integer) Pagination parameter used to select the page to retrieve.
	*                   Page is zero-based and defaults to 0. Thus,
	*                   to retrieve the 10th page you need to set page=9
	* - hitsPerPage: (integer) Pagination parameter used to select the number of hits per page. Defaults to 20.
	* - attributesToRetrieve: a string that contains the list of object attributes
	* you want to retrieve (let you minimize the answer size).
	*   Attributes are separated with a comma (for example "name,address").
	*   You can also use an array (for example ["name","address"]).
	*   By default, all attributes are retrieved. You can also use '*' to retrieve all
	*   values when an attributesToRetrieve setting is specified for your index.
	* - attributesToHighlight: a string that contains the list of attributes you
	*   want to highlight according to the query.
	*   Attributes are separated by a comma. You can also use an array (for example ["name","address"]).
	*   If an attribute has no match for the query, the raw value is returned.
	*   By default all indexed text attributes are highlighted.
	*   You can use `*` if you want to highlight all textual attributes.
	*   Numerical attributes are not highlighted.
	*   A matchLevel is returned for each highlighted attribute and can contain:
	*      - full: if all the query terms were found in the attribute,
	*      - partial: if only some of the query terms were found,
	*      - none: if none of the query terms were found.
	* - attributesToSnippet: a string that contains the list of attributes to snippet alongside
	* the number of words to return (syntax is `attributeName:nbWords`).
	*    Attributes are separated by a comma (Example: attributesToSnippet=name:10,content:10).
	*    You can also use an array (Example: attributesToSnippet: ['name:10','content:10']).
	*    By default no snippet is computed.
	* - minWordSizefor1Typo: the minimum number of characters in a query word to accept one typo in this word.
	* Defaults to 3.
	* - minWordSizefor2Typos: the minimum number of characters in a query word
	* to accept two typos in this word. Defaults to 7.
	* - getRankingInfo: if set to 1, the result hits will contain ranking
	* information in _rankingInfo attribute.
	* - aroundLatLng: search for entries around a given
	* latitude/longitude (specified as two floats separated by a comma).
	*   For example aroundLatLng=47.316669,5.016670).
	*   You can specify the maximum distance in meters with the aroundRadius parameter (in meters)
	*   and the precision for ranking with aroundPrecision
	*   (for example if you set aroundPrecision=100, two objects that are distant of
	*   less than 100m will be considered as identical for "geo" ranking parameter).
	*   At indexing, you should specify geoloc of an object with the _geoloc attribute
	*   (in the form {"_geoloc":{"lat":48.853409, "lng":2.348800}})
	* - insideBoundingBox: search entries inside a given area defined by the two extreme points
	* of a rectangle (defined by 4 floats: p1Lat,p1Lng,p2Lat,p2Lng).
	*   For example insideBoundingBox=47.3165,4.9665,47.3424,5.0201).
	*   At indexing, you should specify geoloc of an object with the _geoloc attribute
	*   (in the form {"_geoloc":{"lat":48.853409, "lng":2.348800}})
	* - numericFilters: a string that contains the list of numeric filters you want to
	* apply separated by a comma.
	*   The syntax of one filter is `attributeName` followed by `operand` followed by `value`.
	*   Supported operands are `<`, `<=`, `=`, `>` and `>=`.
	*   You can have multiple conditions on one attribute like for example numericFilters=price>100,price<1000.
	*   You can also use an array (for example numericFilters: ["price>100","price<1000"]).
	* - tagFilters: filter the query by a set of tags. You can AND tags by separating them by commas.
	*   To OR tags, you must add parentheses. For example, tags=tag1,(tag2,tag3) means tag1 AND (tag2 OR tag3).
	*   You can also use an array, for example tagFilters: ["tag1",["tag2","tag3"]]
	*   means tag1 AND (tag2 OR tag3).
	*   At indexing, tags should be added in the _tags** attribute
	*   of objects (for example {"_tags":["tag1","tag2"]}).
	* - facetFilters: filter the query by a list of facets.
	*   Facets are separated by commas and each facet is encoded as `attributeName:value`.
	*   For example: `facetFilters=category:Book,author:John%20Doe`.
	*   You can also use an array (for example `["category:Book","author:John%20Doe"]`).
	* - facets: List of object attributes that you want to use for faceting.
	*   Comma separated list: `"category,author"` or array `['category','author']`
	*   Only attributes that have been added in **attributesForFaceting** index setting
	*   can be used in this parameter.
	*   You can also use `*` to perform faceting on all attributes specified in **attributesForFaceting**.
	* - queryType: select how the query words are interpreted, it can be one of the following value:
	*    - prefixAll: all query words are interpreted as prefixes,
	*    - prefixLast: only the last word is interpreted as a prefix (default behavior),
	*    - prefixNone: no query word is interpreted as a prefix. This option is not recommended.
	* - optionalWords: a string that contains the list of words that should
	* be considered as optional when found in the query.
	*   Comma separated and array are accepted.
	* - distinct: If set to 1, enable the distinct feature (disabled by default)
	* if the attributeForDistinct index setting is set.
	*   This feature is similar to the SQL "distinct" keyword: when enabled
	*   in a query with the distinct=1 parameter,
	*   all hits containing a duplicate value for the attributeForDistinct attribute are removed from results.
	*   For example, if the chosen attribute is show_name and several hits have
	*   the same value for show_name, then only the best
	*   one is kept and others are removed.
	* - restrictSearchableAttributes: List of attributes you want to use for
	* textual search (must be a subset of the attributesToIndex index setting)
	* either comma separated or as an array
	* @param {function} [callback] the result callback called with two arguments:
	*  error: null or Error('message'). If false, the content contains the error.
	*  content: the server answer that contains the list of results.
	*/
	IndexCore.prototype.search = buildSearchMethod('query');
	
	/*
	* -- BETA --
	* Search a record similar to the query inside the index using XMLHttpRequest request (Using a POST query to
	* minimize number of OPTIONS queries: Cross-Origin Resource Sharing).
	*
	* @param {string} [query] the similar query
	* @param {object} [args] (optional) if set, contains an object with query parameters.
	*   All search parameters are supported (see search function), restrictSearchableAttributes and facetFilters
	*   are the two most useful to restrict the similar results and get more relevant content
	*/
	IndexCore.prototype.similarSearch = buildSearchMethod('similarQuery');
	
	/*
	* Browse index content. The response content will have a `cursor` property that you can use
	* to browse subsequent pages for this query. Use `index.browseFrom(cursor)` when you want.
	*
	* @param {string} query - The full text query
	* @param {Object} [queryParameters] - Any search query parameter
	* @param {Function} [callback] - The result callback called with two arguments
	*   error: null or Error('message')
	*   content: the server answer with the browse result
	* @return {Promise|undefined} Returns a promise if no callback given
	* @example
	* index.browse('cool songs', {
	*   tagFilters: 'public,comments',
	*   hitsPerPage: 500
	* }, callback);
	* @see {@link https://www.algolia.com/doc/rest_api#Browse|Algolia REST API Documentation}
	*/
	IndexCore.prototype.browse = function(query, queryParameters, callback) {
	  var merge = __webpack_require__("./node_modules/algoliasearch/src/merge.js");
	
	  var indexObj = this;
	
	  var page;
	  var hitsPerPage;
	
	  // we check variadic calls that are not the one defined
	  // .browse()/.browse(fn)
	  // => page = 0
	  if (arguments.length === 0 || arguments.length === 1 && typeof arguments[0] === 'function') {
	    page = 0;
	    callback = arguments[0];
	    query = undefined;
	  } else if (typeof arguments[0] === 'number') {
	    // .browse(2)/.browse(2, 10)/.browse(2, fn)/.browse(2, 10, fn)
	    page = arguments[0];
	    if (typeof arguments[1] === 'number') {
	      hitsPerPage = arguments[1];
	    } else if (typeof arguments[1] === 'function') {
	      callback = arguments[1];
	      hitsPerPage = undefined;
	    }
	    query = undefined;
	    queryParameters = undefined;
	  } else if (typeof arguments[0] === 'object') {
	    // .browse(queryParameters)/.browse(queryParameters, cb)
	    if (typeof arguments[1] === 'function') {
	      callback = arguments[1];
	    }
	    queryParameters = arguments[0];
	    query = undefined;
	  } else if (typeof arguments[0] === 'string' && typeof arguments[1] === 'function') {
	    // .browse(query, cb)
	    callback = arguments[1];
	    queryParameters = undefined;
	  }
	
	  // otherwise it's a .browse(query)/.browse(query, queryParameters)/.browse(query, queryParameters, cb)
	
	  // get search query parameters combining various possible calls
	  // to .browse();
	  queryParameters = merge({}, queryParameters || {}, {
	    page: page,
	    hitsPerPage: hitsPerPage,
	    query: query
	  });
	
	  var params = this.as._getSearchParams(queryParameters, '');
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/browse',
	    body: {params: params},
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	* Continue browsing from a previous position (cursor), obtained via a call to `.browse()`.
	*
	* @param {string} query - The full text query
	* @param {Object} [queryParameters] - Any search query parameter
	* @param {Function} [callback] - The result callback called with two arguments
	*   error: null or Error('message')
	*   content: the server answer with the browse result
	* @return {Promise|undefined} Returns a promise if no callback given
	* @example
	* index.browseFrom('14lkfsakl32', callback);
	* @see {@link https://www.algolia.com/doc/rest_api#Browse|Algolia REST API Documentation}
	*/
	IndexCore.prototype.browseFrom = function(cursor, callback) {
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/browse',
	    body: {cursor: cursor},
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	* Search for facet values
	* https://www.algolia.com/doc/rest-api/search#search-for-facet-values
	*
	* @param {string} params.facetName Facet name, name of the attribute to search for values in.
	* Must be declared as a facet
	* @param {string} params.facetQuery Query for the facet search
	* @param {string} [params.*] Any search parameter of Algolia,
	* see https://www.algolia.com/doc/api-client/javascript/search#search-parameters
	* Pagination is not supported. The page and hitsPerPage parameters will be ignored.
	* @param callback (optional)
	*/
	IndexCore.prototype.searchForFacetValues = function(params, callback) {
	  var clone = __webpack_require__("./node_modules/algoliasearch/src/clone.js");
	  var omit = __webpack_require__("./node_modules/algoliasearch/src/omit.js");
	  var usage = 'Usage: index.searchForFacetValues({facetName, facetQuery, ...params}[, callback])';
	
	  if (params.facetName === undefined || params.facetQuery === undefined) {
	    throw new Error(usage);
	  }
	
	  var facetName = params.facetName;
	  var filteredParams = omit(clone(params), function(keyName) {
	    return keyName === 'facetName';
	  });
	  var searchParameters = this.as._getSearchParams(filteredParams, '');
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' +
	      encodeURIComponent(this.indexName) + '/facets/' + encodeURIComponent(facetName) + '/query',
	    hostType: 'read',
	    body: {params: searchParameters},
	    callback: callback
	  });
	};
	
	IndexCore.prototype.searchFacet = deprecate(function(params, callback) {
	  return this.searchForFacetValues(params, callback);
	}, deprecatedMessage(
	  'index.searchFacet(params[, callback])',
	  'index.searchForFacetValues(params[, callback])'
	));
	
	IndexCore.prototype._search = function(params, url, callback, additionalUA) {
	  return this.as._jsonRequest({
	    cache: this.cache,
	    method: 'POST',
	    url: url || '/1/indexes/' + encodeURIComponent(this.indexName) + '/query',
	    body: {params: params},
	    hostType: 'read',
	    fallback: {
	      method: 'GET',
	      url: '/1/indexes/' + encodeURIComponent(this.indexName),
	      body: {params: params}
	    },
	    callback: callback,
	    additionalUA: additionalUA
	  });
	};
	
	/*
	* Get an object from this index
	*
	* @param objectID the unique identifier of the object to retrieve
	* @param attrs (optional) if set, contains the array of attribute names to retrieve
	* @param callback (optional) the result callback called with two arguments
	*  error: null or Error('message')
	*  content: the object to retrieve or the error message if a failure occured
	*/
	IndexCore.prototype.getObject = function(objectID, attrs, callback) {
	  var indexObj = this;
	
	  if (arguments.length === 1 || typeof attrs === 'function') {
	    callback = attrs;
	    attrs = undefined;
	  }
	
	  var params = '';
	  if (attrs !== undefined) {
	    params = '?attributes=';
	    for (var i = 0; i < attrs.length; ++i) {
	      if (i !== 0) {
	        params += ',';
	      }
	      params += attrs[i];
	    }
	  }
	
	  return this.as._jsonRequest({
	    method: 'GET',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/' + encodeURIComponent(objectID) + params,
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	* Get several objects from this index
	*
	* @param objectIDs the array of unique identifier of objects to retrieve
	*/
	IndexCore.prototype.getObjects = function(objectIDs, attributesToRetrieve, callback) {
	  var isArray = __webpack_require__("./node_modules/isarray/index.js");
	  var map = __webpack_require__("./node_modules/algoliasearch/src/map.js");
	
	  var usage = 'Usage: index.getObjects(arrayOfObjectIDs[, callback])';
	
	  if (!isArray(objectIDs)) {
	    throw new Error(usage);
	  }
	
	  var indexObj = this;
	
	  if (arguments.length === 1 || typeof attributesToRetrieve === 'function') {
	    callback = attributesToRetrieve;
	    attributesToRetrieve = undefined;
	  }
	
	  var body = {
	    requests: map(objectIDs, function prepareRequest(objectID) {
	      var request = {
	        indexName: indexObj.indexName,
	        objectID: objectID
	      };
	
	      if (attributesToRetrieve) {
	        request.attributesToRetrieve = attributesToRetrieve.join(',');
	      }
	
	      return request;
	    })
	  };
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/*/objects',
	    hostType: 'read',
	    body: body,
	    callback: callback
	  });
	};
	
	IndexCore.prototype.as = null;
	IndexCore.prototype.indexName = null;
	IndexCore.prototype.typeAheadArgs = null;
	IndexCore.prototype.typeAheadValueOption = null;


/***/ }),

/***/ "./node_modules/algoliasearch/src/browser/builds/algoliasearch.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var AlgoliaSearch = __webpack_require__("./node_modules/algoliasearch/src/AlgoliaSearch.js");
	var createAlgoliasearch = __webpack_require__("./node_modules/algoliasearch/src/browser/createAlgoliasearch.js");
	
	module.exports = createAlgoliasearch(AlgoliaSearch);


/***/ }),

/***/ "./node_modules/algoliasearch/src/browser/createAlgoliasearch.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__("./node_modules/global/window.js");
	var Promise = global.Promise || __webpack_require__("./node_modules/es6-promise/dist/es6-promise.js").Promise;
	
	// This is the standalone browser build entry point
	// Browser implementation of the Algolia Search JavaScript client,
	// using XMLHttpRequest, XDomainRequest and JSONP as fallback
	module.exports = function createAlgoliasearch(AlgoliaSearch, uaSuffix) {
	  var inherits = __webpack_require__("./node_modules/inherits/inherits_browser.js");
	  var errors = __webpack_require__("./node_modules/algoliasearch/src/errors.js");
	  var inlineHeaders = __webpack_require__("./node_modules/algoliasearch/src/browser/inline-headers.js");
	  var jsonpRequest = __webpack_require__("./node_modules/algoliasearch/src/browser/jsonp-request.js");
	  var places = __webpack_require__("./node_modules/algoliasearch/src/places.js");
	  uaSuffix = uaSuffix || '';
	
	  if (false) {
	    require('debug').enable('algoliasearch*');
	  }
	
	  function algoliasearch(applicationID, apiKey, opts) {
	    var cloneDeep = __webpack_require__("./node_modules/algoliasearch/src/clone.js");
	
	    var getDocumentProtocol = __webpack_require__("./node_modules/algoliasearch/src/browser/get-document-protocol.js");
	
	    opts = cloneDeep(opts || {});
	
	    if (opts.protocol === undefined) {
	      opts.protocol = getDocumentProtocol();
	    }
	
	    opts._ua = opts._ua || algoliasearch.ua;
	
	    return new AlgoliaSearchBrowser(applicationID, apiKey, opts);
	  }
	
	  algoliasearch.version = __webpack_require__("./node_modules/algoliasearch/src/version.js");
	  algoliasearch.ua = 'Algolia for vanilla JavaScript ' + uaSuffix + algoliasearch.version;
	  algoliasearch.initPlaces = places(algoliasearch);
	
	  // we expose into window no matter how we are used, this will allow
	  // us to easily debug any website running algolia
	  global.__algolia = {
	    debug: __webpack_require__("./node_modules/debug/src/browser.js"),
	    algoliasearch: algoliasearch
	  };
	
	  var support = {
	    hasXMLHttpRequest: 'XMLHttpRequest' in global,
	    hasXDomainRequest: 'XDomainRequest' in global
	  };
	
	  if (support.hasXMLHttpRequest) {
	    support.cors = 'withCredentials' in new XMLHttpRequest();
	  }
	
	  function AlgoliaSearchBrowser() {
	    // call AlgoliaSearch constructor
	    AlgoliaSearch.apply(this, arguments);
	  }
	
	  inherits(AlgoliaSearchBrowser, AlgoliaSearch);
	
	  AlgoliaSearchBrowser.prototype._request = function request(url, opts) {
	    return new Promise(function wrapRequest(resolve, reject) {
	      // no cors or XDomainRequest, no request
	      if (!support.cors && !support.hasXDomainRequest) {
	        // very old browser, not supported
	        reject(new errors.Network('CORS not supported'));
	        return;
	      }
	
	      url = inlineHeaders(url, opts.headers);
	
	      var body = opts.body;
	      var req = support.cors ? new XMLHttpRequest() : new XDomainRequest();
	      var reqTimeout;
	      var timedOut;
	      var connected = false;
	
	      reqTimeout = setTimeout(onTimeout, opts.timeouts.connect);
	      // we set an empty onprogress listener
	      // so that XDomainRequest on IE9 is not aborted
	      // refs:
	      //  - https://github.com/algolia/algoliasearch-client-js/issues/76
	      //  - https://social.msdn.microsoft.com/Forums/ie/en-US/30ef3add-767c-4436-b8a9-f1ca19b4812e/ie9-rtm-xdomainrequest-issued-requests-may-abort-if-all-event-handlers-not-specified?forum=iewebdevelopment
	      req.onprogress = onProgress;
	      if ('onreadystatechange' in req) req.onreadystatechange = onReadyStateChange;
	      req.onload = onLoad;
	      req.onerror = onError;
	
	      // do not rely on default XHR async flag, as some analytics code like hotjar
	      // breaks it and set it to false by default
	      if (req instanceof XMLHttpRequest) {
	        req.open(opts.method, url, true);
	      } else {
	        req.open(opts.method, url);
	      }
	
	      // headers are meant to be sent after open
	      if (support.cors) {
	        if (body) {
	          if (opts.method === 'POST') {
	            // https://developer.mozilla.org/en-US/docs/Web/HTTP/Access_control_CORS#Simple_requests
	            req.setRequestHeader('content-type', 'application/x-www-form-urlencoded');
	          } else {
	            req.setRequestHeader('content-type', 'application/json');
	          }
	        }
	        req.setRequestHeader('accept', 'application/json');
	      }
	
	      req.send(body);
	
	      // event object not received in IE8, at least
	      // but we do not use it, still important to note
	      function onLoad(/* event */) {
	        // When browser does not supports req.timeout, we can
	        // have both a load and timeout event, since handled by a dumb setTimeout
	        if (timedOut) {
	          return;
	        }
	
	        clearTimeout(reqTimeout);
	
	        var out;
	
	        try {
	          out = {
	            body: JSON.parse(req.responseText),
	            responseText: req.responseText,
	            statusCode: req.status,
	            // XDomainRequest does not have any response headers
	            headers: req.getAllResponseHeaders && req.getAllResponseHeaders() || {}
	          };
	        } catch (e) {
	          out = new errors.UnparsableJSON({
	            more: req.responseText
	          });
	        }
	
	        if (out instanceof errors.UnparsableJSON) {
	          reject(out);
	        } else {
	          resolve(out);
	        }
	      }
	
	      function onError(event) {
	        if (timedOut) {
	          return;
	        }
	
	        clearTimeout(reqTimeout);
	
	        // error event is trigerred both with XDR/XHR on:
	        //   - DNS error
	        //   - unallowed cross domain request
	        reject(
	          new errors.Network({
	            more: event
	          })
	        );
	      }
	
	      function onTimeout() {
	        timedOut = true;
	        req.abort();
	
	        reject(new errors.RequestTimeout());
	      }
	
	      function onConnect() {
	        connected = true;
	        clearTimeout(reqTimeout);
	        reqTimeout = setTimeout(onTimeout, opts.timeouts.complete);
	      }
	
	      function onProgress() {
	        if (!connected) onConnect();
	      }
	
	      function onReadyStateChange() {
	        if (!connected && req.readyState > 1) onConnect();
	      }
	    });
	  };
	
	  AlgoliaSearchBrowser.prototype._request.fallback = function requestFallback(url, opts) {
	    url = inlineHeaders(url, opts.headers);
	
	    return new Promise(function wrapJsonpRequest(resolve, reject) {
	      jsonpRequest(url, opts, function jsonpRequestDone(err, content) {
	        if (err) {
	          reject(err);
	          return;
	        }
	
	        resolve(content);
	      });
	    });
	  };
	
	  AlgoliaSearchBrowser.prototype._promise = {
	    reject: function rejectPromise(val) {
	      return Promise.reject(val);
	    },
	    resolve: function resolvePromise(val) {
	      return Promise.resolve(val);
	    },
	    delay: function delayPromise(ms) {
	      return new Promise(function resolveOnTimeout(resolve/* , reject*/) {
	        setTimeout(resolve, ms);
	      });
	    }
	  };
	
	  return algoliasearch;
	};


/***/ }),

/***/ "./node_modules/algoliasearch/src/browser/get-document-protocol.js":
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = getDocumentProtocol;
	
	function getDocumentProtocol() {
	  var protocol = window.document.location.protocol;
	
	  // when in `file:` mode (local html file), default to `http:`
	  if (protocol !== 'http:' && protocol !== 'https:') {
	    protocol = 'http:';
	  }
	
	  return protocol;
	}


/***/ }),

/***/ "./node_modules/algoliasearch/src/browser/inline-headers.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = inlineHeaders;
	
	var encode = __webpack_require__("./node_modules/querystring-es3/encode.js");
	
	function inlineHeaders(url, headers) {
	  if (/\?/.test(url)) {
	    url += '&';
	  } else {
	    url += '?';
	  }
	
	  return url + encode(headers);
	}


/***/ }),

/***/ "./node_modules/algoliasearch/src/browser/jsonp-request.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = jsonpRequest;
	
	var errors = __webpack_require__("./node_modules/algoliasearch/src/errors.js");
	
	var JSONPCounter = 0;
	
	function jsonpRequest(url, opts, cb) {
	  if (opts.method !== 'GET') {
	    cb(new Error('Method ' + opts.method + ' ' + url + ' is not supported by JSONP.'));
	    return;
	  }
	
	  opts.debug('JSONP: start');
	
	  var cbCalled = false;
	  var timedOut = false;
	
	  JSONPCounter += 1;
	  var head = document.getElementsByTagName('head')[0];
	  var script = document.createElement('script');
	  var cbName = 'algoliaJSONP_' + JSONPCounter;
	  var done = false;
	
	  window[cbName] = function(data) {
	    removeGlobals();
	
	    if (timedOut) {
	      opts.debug('JSONP: Late answer, ignoring');
	      return;
	    }
	
	    cbCalled = true;
	
	    clean();
	
	    cb(null, {
	      body: data/* ,
	      // We do not send the statusCode, there's no statusCode in JSONP, it will be
	      // computed using data.status && data.message like with XDR
	      statusCode*/
	    });
	  };
	
	  // add callback by hand
	  url += '&callback=' + cbName;
	
	  // add body params manually
	  if (opts.jsonBody && opts.jsonBody.params) {
	    url += '&' + opts.jsonBody.params;
	  }
	
	  var ontimeout = setTimeout(timeout, opts.timeouts.complete);
	
	  // script onreadystatechange needed only for
	  // <= IE8
	  // https://github.com/angular/angular.js/issues/4523
	  script.onreadystatechange = readystatechange;
	  script.onload = success;
	  script.onerror = error;
	
	  script.async = true;
	  script.defer = true;
	  script.src = url;
	  head.appendChild(script);
	
	  function success() {
	    opts.debug('JSONP: success');
	
	    if (done || timedOut) {
	      return;
	    }
	
	    done = true;
	
	    // script loaded but did not call the fn => script loading error
	    if (!cbCalled) {
	      opts.debug('JSONP: Fail. Script loaded but did not call the callback');
	      clean();
	      cb(new errors.JSONPScriptFail());
	    }
	  }
	
	  function readystatechange() {
	    if (this.readyState === 'loaded' || this.readyState === 'complete') {
	      success();
	    }
	  }
	
	  function clean() {
	    clearTimeout(ontimeout);
	    script.onload = null;
	    script.onreadystatechange = null;
	    script.onerror = null;
	    head.removeChild(script);
	  }
	
	  function removeGlobals() {
	    try {
	      delete window[cbName];
	      delete window[cbName + '_loaded'];
	    } catch (e) {
	      window[cbName] = window[cbName + '_loaded'] = undefined;
	    }
	  }
	
	  function timeout() {
	    opts.debug('JSONP: Script timeout');
	    timedOut = true;
	    clean();
	    cb(new errors.RequestTimeout());
	  }
	
	  function error() {
	    opts.debug('JSONP: Script error');
	
	    if (done || timedOut) {
	      return;
	    }
	
	    clean();
	    cb(new errors.JSONPScriptError());
	  }
	}


/***/ }),

/***/ "./node_modules/algoliasearch/src/buildSearchMethod.js":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = buildSearchMethod;
	
	var errors = __webpack_require__("./node_modules/algoliasearch/src/errors.js");
	
	/**
	 * Creates a search method to be used in clients
	 * @param {string} queryParam the name of the attribute used for the query
	 * @param {string} url the url
	 * @return {function} the search method
	 */
	function buildSearchMethod(queryParam, url) {
	  /**
	   * The search method. Prepares the data and send the query to Algolia.
	   * @param {string} query the string used for query search
	   * @param {object} args additional parameters to send with the search
	   * @param {function} [callback] the callback to be called with the client gets the answer
	   * @return {undefined|Promise} If the callback is not provided then this methods returns a Promise
	   */
	  return function search(query, args, callback) {
	    // warn V2 users on how to search
	    if (typeof query === 'function' && typeof args === 'object' ||
	      typeof callback === 'object') {
	      // .search(query, params, cb)
	      // .search(cb, params)
	      throw new errors.AlgoliaSearchError('index.search usage is index.search(query, params, cb)');
	    }
	
	    // Normalizing the function signature
	    if (arguments.length === 0 || typeof query === 'function') {
	      // Usage : .search(), .search(cb)
	      callback = query;
	      query = '';
	    } else if (arguments.length === 1 || typeof args === 'function') {
	      // Usage : .search(query/args), .search(query, cb)
	      callback = args;
	      args = undefined;
	    }
	    // At this point we have 3 arguments with values
	
	    // Usage : .search(args) // careful: typeof null === 'object'
	    if (typeof query === 'object' && query !== null) {
	      args = query;
	      query = undefined;
	    } else if (query === undefined || query === null) { // .search(undefined/null)
	      query = '';
	    }
	
	    var params = '';
	
	    if (query !== undefined) {
	      params += queryParam + '=' + encodeURIComponent(query);
	    }
	
	    var additionalUA;
	    if (args !== undefined) {
	      if (args.additionalUA) {
	        additionalUA = args.additionalUA;
	        delete args.additionalUA;
	      }
	      // `_getSearchParams` will augment params, do not be fooled by the = versus += from previous if
	      params = this.as._getSearchParams(args, params);
	    }
	
	
	    return this._search(params, url, callback, additionalUA);
	  };
	}


/***/ }),

/***/ "./node_modules/algoliasearch/src/clone.js":
/***/ (function(module, exports) {

	module.exports = function clone(obj) {
	  return JSON.parse(JSON.stringify(obj));
	};


/***/ }),

/***/ "./node_modules/algoliasearch/src/deprecate.js":
/***/ (function(module, exports) {

	module.exports = function deprecate(fn, message) {
	  var warned = false;
	
	  function deprecated() {
	    if (!warned) {
	      /* eslint no-console:0 */
	      console.log(message);
	      warned = true;
	    }
	
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};


/***/ }),

/***/ "./node_modules/algoliasearch/src/deprecatedMessage.js":
/***/ (function(module, exports) {

	module.exports = function deprecatedMessage(previousUsage, newUsage) {
	  var githubAnchorLink = previousUsage.toLowerCase()
	    .replace('.', '')
	    .replace('()', '');
	
	  return 'algoliasearch: `' + previousUsage + '` was replaced by `' + newUsage +
	    '`. Please see https://github.com/algolia/algoliasearch-client-js/wiki/Deprecated#' + githubAnchorLink;
	};


/***/ }),

/***/ "./node_modules/algoliasearch/src/errors.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// This file hosts our error definitions
	// We use custom error "types" so that we can act on them when we need it
	// e.g.: if error instanceof errors.UnparsableJSON then..
	
	var inherits = __webpack_require__("./node_modules/inherits/inherits_browser.js");
	
	function AlgoliaSearchError(message, extraProperties) {
	  var forEach = __webpack_require__("./node_modules/foreach/index.js");
	
	  var error = this;
	
	  // try to get a stacktrace
	  if (typeof Error.captureStackTrace === 'function') {
	    Error.captureStackTrace(this, this.constructor);
	  } else {
	    error.stack = (new Error()).stack || 'Cannot get a stacktrace, browser is too old';
	  }
	
	  this.name = 'AlgoliaSearchError';
	  this.message = message || 'Unknown error';
	
	  if (extraProperties) {
	    forEach(extraProperties, function addToErrorObject(value, key) {
	      error[key] = value;
	    });
	  }
	}
	
	inherits(AlgoliaSearchError, Error);
	
	function createCustomError(name, message) {
	  function AlgoliaSearchCustomError() {
	    var args = Array.prototype.slice.call(arguments, 0);
	
	    // custom message not set, use default
	    if (typeof args[0] !== 'string') {
	      args.unshift(message);
	    }
	
	    AlgoliaSearchError.apply(this, args);
	    this.name = 'AlgoliaSearch' + name + 'Error';
	  }
	
	  inherits(AlgoliaSearchCustomError, AlgoliaSearchError);
	
	  return AlgoliaSearchCustomError;
	}
	
	// late exports to let various fn defs and inherits take place
	module.exports = {
	  AlgoliaSearchError: AlgoliaSearchError,
	  UnparsableJSON: createCustomError(
	    'UnparsableJSON',
	    'Could not parse the incoming response as JSON, see err.more for details'
	  ),
	  RequestTimeout: createCustomError(
	    'RequestTimeout',
	    'Request timedout before getting a response'
	  ),
	  Network: createCustomError(
	    'Network',
	    'Network issue, see err.more for details'
	  ),
	  JSONPScriptFail: createCustomError(
	    'JSONPScriptFail',
	    '<script> was loaded but did not call our provided callback'
	  ),
	  JSONPScriptError: createCustomError(
	    'JSONPScriptError',
	    '<script> unable to load due to an `error` event on it'
	  ),
	  Unknown: createCustomError(
	    'Unknown',
	    'Unknown error occured'
	  )
	};


/***/ }),

/***/ "./node_modules/algoliasearch/src/exitPromise.js":
/***/ (function(module, exports) {

	// Parse cloud does not supports setTimeout
	// We do not store a setTimeout reference in the client everytime
	// We only fallback to a fake setTimeout when not available
	// setTimeout cannot be override globally sadly
	module.exports = function exitPromise(fn, _setTimeout) {
	  _setTimeout(fn, 0);
	};


/***/ }),

/***/ "./node_modules/algoliasearch/src/map.js":
/***/ (function(module, exports, __webpack_require__) {

	var foreach = __webpack_require__("./node_modules/foreach/index.js");
	
	module.exports = function map(arr, fn) {
	  var newArr = [];
	  foreach(arr, function(item, itemIndex) {
	    newArr.push(fn(item, itemIndex, arr));
	  });
	  return newArr;
	};


/***/ }),

/***/ "./node_modules/algoliasearch/src/merge.js":
/***/ (function(module, exports, __webpack_require__) {

	var foreach = __webpack_require__("./node_modules/foreach/index.js");
	
	module.exports = function merge(destination/* , sources */) {
	  var sources = Array.prototype.slice.call(arguments);
	
	  foreach(sources, function(source) {
	    for (var keyName in source) {
	      if (source.hasOwnProperty(keyName)) {
	        if (typeof destination[keyName] === 'object' && typeof source[keyName] === 'object') {
	          destination[keyName] = merge({}, destination[keyName], source[keyName]);
	        } else if (source[keyName] !== undefined) {
	          destination[keyName] = source[keyName];
	        }
	      }
	    }
	  });
	
	  return destination;
	};


/***/ }),

/***/ "./node_modules/algoliasearch/src/omit.js":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function omit(obj, test) {
	  var keys = __webpack_require__("./node_modules/object-keys/index.js");
	  var foreach = __webpack_require__("./node_modules/foreach/index.js");
	
	  var filtered = {};
	
	  foreach(keys(obj), function doFilter(keyName) {
	    if (test(keyName) !== true) {
	      filtered[keyName] = obj[keyName];
	    }
	  });
	
	  return filtered;
	};


/***/ }),

/***/ "./node_modules/algoliasearch/src/places.js":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = createPlacesClient;
	
	var buildSearchMethod = __webpack_require__("./node_modules/algoliasearch/src/buildSearchMethod.js");
	
	function createPlacesClient(algoliasearch) {
	  return function places(appID, apiKey, opts) {
	    var cloneDeep = __webpack_require__("./node_modules/algoliasearch/src/clone.js");
	
	    opts = opts && cloneDeep(opts) || {};
	    opts.hosts = opts.hosts || [
	      'places-dsn.algolia.net',
	      'places-1.algolianet.com',
	      'places-2.algolianet.com',
	      'places-3.algolianet.com'
	    ];
	
	    // allow initPlaces() no arguments => community rate limited
	    if (arguments.length === 0 || typeof appID === 'object' || appID === undefined) {
	      appID = '';
	      apiKey = '';
	      opts._allowEmptyCredentials = true;
	    }
	
	    var client = algoliasearch(appID, apiKey, opts);
	    var index = client.initIndex('places');
	    index.search = buildSearchMethod('query', '/1/places/query');
	    index.getObject = function(objectID, callback) {
	      return this.as._jsonRequest({
	        method: 'GET',
	        url: '/1/places/' + encodeURIComponent(objectID),
	        hostType: 'read',
	        callback: callback
	      });
	    };
	    return index;
	  };
	}


/***/ }),

/***/ "./node_modules/algoliasearch/src/store.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var debug = __webpack_require__("./node_modules/debug/src/browser.js")('algoliasearch:src/hostIndexState.js');
	var localStorageNamespace = 'algoliasearch-client-js';
	
	var store;
	var moduleStore = {
	  state: {},
	  set: function(key, data) {
	    this.state[key] = data;
	    return this.state[key];
	  },
	  get: function(key) {
	    return this.state[key] || null;
	  }
	};
	
	var localStorageStore = {
	  set: function(key, data) {
	    moduleStore.set(key, data); // always replicate localStorageStore to moduleStore in case of failure
	
	    try {
	      var namespace = JSON.parse(global.localStorage[localStorageNamespace]);
	      namespace[key] = data;
	      global.localStorage[localStorageNamespace] = JSON.stringify(namespace);
	      return namespace[key];
	    } catch (e) {
	      return localStorageFailure(key, e);
	    }
	  },
	  get: function(key) {
	    try {
	      return JSON.parse(global.localStorage[localStorageNamespace])[key] || null;
	    } catch (e) {
	      return localStorageFailure(key, e);
	    }
	  }
	};
	
	function localStorageFailure(key, e) {
	  debug('localStorage failed with', e);
	  cleanup();
	  store = moduleStore;
	  return store.get(key);
	}
	
	store = supportsLocalStorage() ? localStorageStore : moduleStore;
	
	module.exports = {
	  get: getOrSet,
	  set: getOrSet,
	  supportsLocalStorage: supportsLocalStorage
	};
	
	function getOrSet(key, data) {
	  if (arguments.length === 1) {
	    return store.get(key);
	  }
	
	  return store.set(key, data);
	}
	
	function supportsLocalStorage() {
	  try {
	    if ('localStorage' in global &&
	      global.localStorage !== null) {
	      if (!global.localStorage[localStorageNamespace]) {
	        // actual creation of the namespace
	        global.localStorage.setItem(localStorageNamespace, JSON.stringify({}));
	      }
	      return true;
	    }
	
	    return false;
	  } catch (_) {
	    return false;
	  }
	}
	
	// In case of any error on localStorage, we clean our own namespace, this should handle
	// quota errors when a lot of keys + data are used
	function cleanup() {
	  try {
	    global.localStorage.removeItem(localStorageNamespace);
	  } catch (_) {
	    // nothing to do
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ "./node_modules/algoliasearch/src/version.js":
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = '3.24.0';


/***/ }),

/***/ "./node_modules/chain-function/index.js":
/***/ (function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ }),

/***/ "./node_modules/classnames/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ "./node_modules/debug/src/browser.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__("./node_modules/debug/src/debug.js");
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"NODE_ENV":"production","PUBLIC_DIR":"/Users/todd/src/howtohypermedia/public"}).DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/debug/src/debug.js":
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__("./node_modules/ms/index.js");
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),

/***/ "./node_modules/deep-equal/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__("./node_modules/deep-equal/lib/keys.js");
	var isArguments = __webpack_require__("./node_modules/deep-equal/lib/is_arguments.js");
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ "./node_modules/deep-equal/lib/is_arguments.js":
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ "./node_modules/deep-equal/lib/keys.js":
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ "./node_modules/define-properties/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__("./node_modules/object-keys/index.js");
	var foreach = __webpack_require__("./node_modules/foreach/index.js");
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';
	
	var toStr = Object.prototype.toString;
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var arePropertyDescriptorsSupported = function () {
		var obj = {};
		try {
			Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
	        /* eslint-disable no-unused-vars, no-restricted-syntax */
	        for (var _ in obj) { return false; }
	        /* eslint-enable no-unused-vars, no-restricted-syntax */
			return obj.x === obj;
		} catch (e) { /* this is IE 8. */
			return false;
		}
	};
	var supportsDescriptors = Object.defineProperty && arePropertyDescriptorsSupported();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object && (!isFunction(predicate) || !predicate())) {
			return;
		}
		if (supportsDescriptors) {
			Object.defineProperty(object, name, {
				configurable: true,
				enumerable: false,
				value: value,
				writable: true
			});
		} else {
			object[name] = value;
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = props.concat(Object.getOwnPropertySymbols(map));
		}
		foreach(props, function (name) {
			defineProperty(object, name, map[name], predicates[name]);
		});
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ }),

/***/ "./node_modules/es-abstract/es5.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $isNaN = __webpack_require__("./node_modules/es-abstract/helpers/isNaN.js");
	var $isFinite = __webpack_require__("./node_modules/es-abstract/helpers/isFinite.js");
	
	var sign = __webpack_require__("./node_modules/es-abstract/helpers/sign.js");
	var mod = __webpack_require__("./node_modules/es-abstract/helpers/mod.js");
	
	var IsCallable = __webpack_require__("./node_modules/is-callable/index.js");
	var toPrimitive = __webpack_require__("./node_modules/es-to-primitive/es5.js");
	
	// https://es5.github.io/#x9
	var ES5 = {
		ToPrimitive: toPrimitive,
	
		ToBoolean: function ToBoolean(value) {
			return Boolean(value);
		},
		ToNumber: function ToNumber(value) {
			return Number(value);
		},
		ToInteger: function ToInteger(value) {
			var number = this.ToNumber(value);
			if ($isNaN(number)) { return 0; }
			if (number === 0 || !$isFinite(number)) { return number; }
			return sign(number) * Math.floor(Math.abs(number));
		},
		ToInt32: function ToInt32(x) {
			return this.ToNumber(x) >> 0;
		},
		ToUint32: function ToUint32(x) {
			return this.ToNumber(x) >>> 0;
		},
		ToUint16: function ToUint16(value) {
			var number = this.ToNumber(value);
			if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
			var posInt = sign(number) * Math.floor(Math.abs(number));
			return mod(posInt, 0x10000);
		},
		ToString: function ToString(value) {
			return String(value);
		},
		ToObject: function ToObject(value) {
			this.CheckObjectCoercible(value);
			return Object(value);
		},
		CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
			/* jshint eqnull:true */
			if (value == null) {
				throw new TypeError(optMessage || 'Cannot call method on ' + value);
			}
			return value;
		},
		IsCallable: IsCallable,
		SameValue: function SameValue(x, y) {
			if (x === y) { // 0 === -0, but they are not identical.
				if (x === 0) { return 1 / x === 1 / y; }
				return true;
			}
			return $isNaN(x) && $isNaN(y);
		},
	
		// http://www.ecma-international.org/ecma-262/5.1/#sec-8
		Type: function Type(x) {
			if (x === null) {
				return 'Null';
			}
			if (typeof x === 'undefined') {
				return 'Undefined';
			}
			if (typeof x === 'function' || typeof x === 'object') {
				return 'Object';
			}
			if (typeof x === 'number') {
				return 'Number';
			}
			if (typeof x === 'boolean') {
				return 'Boolean';
			}
			if (typeof x === 'string') {
				return 'String';
			}
		}
	};
	
	module.exports = ES5;


/***/ }),

/***/ "./node_modules/es-abstract/es6.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
	var symbolToStr = hasSymbols ? Symbol.prototype.toString : toStr;
	
	var $isNaN = __webpack_require__("./node_modules/es-abstract/helpers/isNaN.js");
	var $isFinite = __webpack_require__("./node_modules/es-abstract/helpers/isFinite.js");
	var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
	
	var assign = __webpack_require__("./node_modules/es-abstract/helpers/assign.js");
	var sign = __webpack_require__("./node_modules/es-abstract/helpers/sign.js");
	var mod = __webpack_require__("./node_modules/es-abstract/helpers/mod.js");
	var isPrimitive = __webpack_require__("./node_modules/es-abstract/helpers/isPrimitive.js");
	var toPrimitive = __webpack_require__("./node_modules/es-to-primitive/es6.js");
	var parseInteger = parseInt;
	var bind = __webpack_require__("./node_modules/function-bind/index.js");
	var strSlice = bind.call(Function.call, String.prototype.slice);
	var isBinary = bind.call(Function.call, RegExp.prototype.test, /^0b[01]+$/i);
	var isOctal = bind.call(Function.call, RegExp.prototype.test, /^0o[0-7]+$/i);
	var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
	var nonWSregex = new RegExp('[' + nonWS + ']', 'g');
	var hasNonWS = bind.call(Function.call, RegExp.prototype.test, nonWSregex);
	var invalidHexLiteral = /^[-+]0x[0-9a-f]+$/i;
	var isInvalidHexLiteral = bind.call(Function.call, RegExp.prototype.test, invalidHexLiteral);
	
	// whitespace from: http://es5.github.io/#x15.5.4.20
	// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
	var ws = [
		'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
		'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
		'\u2029\uFEFF'
	].join('');
	var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
	var replace = bind.call(Function.call, String.prototype.replace);
	var trim = function (value) {
		return replace(value, trimRegex, '');
	};
	
	var ES5 = __webpack_require__("./node_modules/es-abstract/es5.js");
	
	var hasRegExpMatcher = __webpack_require__("./node_modules/is-regex/index.js");
	
	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-abstract-operations
	var ES6 = assign(assign({}, ES5), {
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-call-f-v-args
		Call: function Call(F, V) {
			var args = arguments.length > 2 ? arguments[2] : [];
			if (!this.IsCallable(F)) {
				throw new TypeError(F + ' is not a function');
			}
			return F.apply(V, args);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toprimitive
		ToPrimitive: toPrimitive,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toboolean
		// ToBoolean: ES5.ToBoolean,
	
		// http://www.ecma-international.org/ecma-262/6.0/#sec-tonumber
		ToNumber: function ToNumber(argument) {
			var value = isPrimitive(argument) ? argument : toPrimitive(argument, 'number');
			if (typeof value === 'symbol') {
				throw new TypeError('Cannot convert a Symbol value to a number');
			}
			if (typeof value === 'string') {
				if (isBinary(value)) {
					return this.ToNumber(parseInteger(strSlice(value, 2), 2));
				} else if (isOctal(value)) {
					return this.ToNumber(parseInteger(strSlice(value, 2), 8));
				} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
					return NaN;
				} else {
					var trimmed = trim(value);
					if (trimmed !== value) {
						return this.ToNumber(trimmed);
					}
				}
			}
			return Number(value);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tointeger
		// ToInteger: ES5.ToNumber,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint32
		// ToInt32: ES5.ToInt32,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint32
		// ToUint32: ES5.ToUint32,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint16
		ToInt16: function ToInt16(argument) {
			var int16bit = this.ToUint16(argument);
			return int16bit >= 0x8000 ? int16bit - 0x10000 : int16bit;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint16
		// ToUint16: ES5.ToUint16,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint8
		ToInt8: function ToInt8(argument) {
			var int8bit = this.ToUint8(argument);
			return int8bit >= 0x80 ? int8bit - 0x100 : int8bit;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8
		ToUint8: function ToUint8(argument) {
			var number = this.ToNumber(argument);
			if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
			var posInt = sign(number) * Math.floor(Math.abs(number));
			return mod(posInt, 0x100);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8clamp
		ToUint8Clamp: function ToUint8Clamp(argument) {
			var number = this.ToNumber(argument);
			if ($isNaN(number) || number <= 0) { return 0; }
			if (number >= 0xFF) { return 0xFF; }
			var f = Math.floor(argument);
			if (f + 0.5 < number) { return f + 1; }
			if (number < f + 0.5) { return f; }
			if (f % 2 !== 0) { return f + 1; }
			return f;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tostring
		ToString: function ToString(argument) {
			if (typeof argument === 'symbol') {
				throw new TypeError('Cannot convert a Symbol value to a string');
			}
			return String(argument);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toobject
		ToObject: function ToObject(value) {
			this.RequireObjectCoercible(value);
			return Object(value);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-topropertykey
		ToPropertyKey: function ToPropertyKey(argument) {
			var key = this.ToPrimitive(argument, String);
			return typeof key === 'symbol' ? symbolToStr.call(key) : this.ToString(key);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
		ToLength: function ToLength(argument) {
			var len = this.ToInteger(argument);
			if (len <= 0) { return 0; } // includes converting -0 to +0
			if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
			return len;
		},
	
		// http://www.ecma-international.org/ecma-262/6.0/#sec-canonicalnumericindexstring
		CanonicalNumericIndexString: function CanonicalNumericIndexString(argument) {
			if (toStr.call(argument) !== '[object String]') {
				throw new TypeError('must be a string');
			}
			if (argument === '-0') { return -0; }
			var n = this.ToNumber(argument);
			if (this.SameValue(this.ToString(n), argument)) { return n; }
			return void 0;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-requireobjectcoercible
		RequireObjectCoercible: ES5.CheckObjectCoercible,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isarray
		IsArray: Array.isArray || function IsArray(argument) {
			return toStr.call(argument) === '[object Array]';
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-iscallable
		// IsCallable: ES5.IsCallable,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isconstructor
		IsConstructor: function IsConstructor(argument) {
			return typeof argument === 'function' && !!argument.prototype; // unfortunately there's no way to truly check this without try/catch `new argument`
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isextensible-o
		IsExtensible: function IsExtensible(obj) {
			if (!Object.preventExtensions) { return true; }
			if (isPrimitive(obj)) {
				return false;
			}
			return Object.isExtensible(obj);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isinteger
		IsInteger: function IsInteger(argument) {
			if (typeof argument !== 'number' || $isNaN(argument) || !$isFinite(argument)) {
				return false;
			}
			var abs = Math.abs(argument);
			return Math.floor(abs) === abs;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-ispropertykey
		IsPropertyKey: function IsPropertyKey(argument) {
			return typeof argument === 'string' || typeof argument === 'symbol';
		},
	
		// http://www.ecma-international.org/ecma-262/6.0/#sec-isregexp
		IsRegExp: function IsRegExp(argument) {
			if (!argument || typeof argument !== 'object') {
				return false;
			}
			if (hasSymbols) {
				var isRegExp = argument[Symbol.match];
				if (typeof isRegExp !== 'undefined') {
					return ES5.ToBoolean(isRegExp);
				}
			}
			return hasRegExpMatcher(argument);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevalue
		// SameValue: ES5.SameValue,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero
		SameValueZero: function SameValueZero(x, y) {
			return (x === y) || ($isNaN(x) && $isNaN(y));
		},
	
		/**
		 * 7.3.2 GetV (V, P)
		 * 1. Assert: IsPropertyKey(P) is true.
		 * 2. Let O be ToObject(V).
		 * 3. ReturnIfAbrupt(O).
		 * 4. Return O.[[Get]](P, V).
		 */
		GetV: function GetV(V, P) {
			// 7.3.2.1
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			// 7.3.2.2-3
			var O = this.ToObject(V);
	
			// 7.3.2.4
			return O[P];
		},
	
		/**
		 * 7.3.9 - http://www.ecma-international.org/ecma-262/6.0/#sec-getmethod
		 * 1. Assert: IsPropertyKey(P) is true.
		 * 2. Let func be GetV(O, P).
		 * 3. ReturnIfAbrupt(func).
		 * 4. If func is either undefined or null, return undefined.
		 * 5. If IsCallable(func) is false, throw a TypeError exception.
		 * 6. Return func.
		 */
		GetMethod: function GetMethod(O, P) {
			// 7.3.9.1
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			// 7.3.9.2
			var func = this.GetV(O, P);
	
			// 7.3.9.4
			if (func == null) {
				return undefined;
			}
	
			// 7.3.9.5
			if (!this.IsCallable(func)) {
				throw new TypeError(P + 'is not a function');
			}
	
			// 7.3.9.6
			return func;
		},
	
		/**
		 * 7.3.1 Get (O, P) - http://www.ecma-international.org/ecma-262/6.0/#sec-get-o-p
		 * 1. Assert: Type(O) is Object.
		 * 2. Assert: IsPropertyKey(P) is true.
		 * 3. Return O.[[Get]](P, O).
		 */
		Get: function Get(O, P) {
			// 7.3.1.1
			if (this.Type(O) !== 'Object') {
				throw new TypeError('Assertion failed: Type(O) is not Object');
			}
			// 7.3.1.2
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
			// 7.3.1.3
			return O[P];
		},
	
		Type: function Type(x) {
			if (typeof x === 'symbol') {
				return 'Symbol';
			}
			return ES5.Type(x);
		},
	
		// http://www.ecma-international.org/ecma-262/6.0/#sec-speciesconstructor
		SpeciesConstructor: function SpeciesConstructor(O, defaultConstructor) {
			if (this.Type(O) !== 'Object') {
				throw new TypeError('Assertion failed: Type(O) is not Object');
			}
			var C = O.constructor;
			if (typeof C === 'undefined') {
				return defaultConstructor;
			}
			if (this.Type(C) !== 'Object') {
				throw new TypeError('O.constructor is not an Object');
			}
			var S = hasSymbols && Symbol.species ? C[Symbol.species] : undefined;
			if (S == null) {
				return defaultConstructor;
			}
			if (this.IsConstructor(S)) {
				return S;
			}
			throw new TypeError('no constructor found');
		}
	});
	
	delete ES6.CheckObjectCoercible; // renamed in ES6 to RequireObjectCoercible
	
	module.exports = ES6;


/***/ }),

/***/ "./node_modules/es-abstract/es7.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ES6 = __webpack_require__("./node_modules/es-abstract/es6.js");
	var assign = __webpack_require__("./node_modules/es-abstract/helpers/assign.js");
	
	var ES7 = assign(ES6, {
		// https://github.com/tc39/ecma262/pull/60
		SameValueNonNumber: function SameValueNonNumber(x, y) {
			if (typeof x === 'number' || typeof x !== typeof y) {
				throw new TypeError('SameValueNonNumber requires two non-number values of the same type.');
			}
			return this.SameValue(x, y);
		}
	});
	
	module.exports = ES7;


/***/ }),

/***/ "./node_modules/es-abstract/helpers/assign.js":
/***/ (function(module, exports) {

	var has = Object.prototype.hasOwnProperty;
	module.exports = Object.assign || function assign(target, source) {
		for (var key in source) {
			if (has.call(source, key)) {
				target[key] = source[key];
			}
		}
		return target;
	};


/***/ }),

/***/ "./node_modules/es-abstract/helpers/isFinite.js":
/***/ (function(module, exports) {

	var $isNaN = Number.isNaN || function (a) { return a !== a; };
	
	module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ }),

/***/ "./node_modules/es-abstract/helpers/isNaN.js":
/***/ (function(module, exports) {

	module.exports = Number.isNaN || function isNaN(a) {
		return a !== a;
	};


/***/ }),

/***/ "./node_modules/es-abstract/helpers/isPrimitive.js":
/***/ (function(module, exports) {

	module.exports = function isPrimitive(value) {
		return value === null || (typeof value !== 'function' && typeof value !== 'object');
	};


/***/ }),

/***/ "./node_modules/es-abstract/helpers/mod.js":
/***/ (function(module, exports) {

	module.exports = function mod(number, modulo) {
		var remain = number % modulo;
		return Math.floor(remain >= 0 ? remain : remain + modulo);
	};


/***/ }),

/***/ "./node_modules/es-abstract/helpers/sign.js":
/***/ (function(module, exports) {

	module.exports = function sign(number) {
		return number >= 0 ? 1 : -1;
	};


/***/ }),

/***/ "./node_modules/es-to-primitive/es5.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	var isPrimitive = __webpack_require__("./node_modules/es-to-primitive/helpers/isPrimitive.js");
	
	var isCallable = __webpack_require__("./node_modules/is-callable/index.js");
	
	// https://es5.github.io/#x8.12
	var ES5internalSlots = {
		'[[DefaultValue]]': function (O, hint) {
			var actualHint = hint || (toStr.call(O) === '[object Date]' ? String : Number);
	
			if (actualHint === String || actualHint === Number) {
				var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
				var value, i;
				for (i = 0; i < methods.length; ++i) {
					if (isCallable(O[methods[i]])) {
						value = O[methods[i]]();
						if (isPrimitive(value)) {
							return value;
						}
					}
				}
				throw new TypeError('No default value');
			}
			throw new TypeError('invalid [[DefaultValue]] hint supplied');
		}
	};
	
	// https://es5.github.io/#x9
	module.exports = function ToPrimitive(input, PreferredType) {
		if (isPrimitive(input)) {
			return input;
		}
		return ES5internalSlots['[[DefaultValue]]'](input, PreferredType);
	};


/***/ }),

/***/ "./node_modules/es-to-primitive/es6.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
	
	var isPrimitive = __webpack_require__("./node_modules/es-to-primitive/helpers/isPrimitive.js");
	var isCallable = __webpack_require__("./node_modules/is-callable/index.js");
	var isDate = __webpack_require__("./node_modules/is-date-object/index.js");
	var isSymbol = __webpack_require__("./node_modules/is-symbol/index.js");
	
	var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
		if (typeof O === 'undefined' || O === null) {
			throw new TypeError('Cannot call method on ' + O);
		}
		if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
			throw new TypeError('hint must be "string" or "number"');
		}
		var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
		var method, result, i;
		for (i = 0; i < methodNames.length; ++i) {
			method = O[methodNames[i]];
			if (isCallable(method)) {
				result = method.call(O);
				if (isPrimitive(result)) {
					return result;
				}
			}
		}
		throw new TypeError('No default value');
	};
	
	var GetMethod = function GetMethod(O, P) {
		var func = O[P];
		if (func !== null && typeof func !== 'undefined') {
			if (!isCallable(func)) {
				throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
			}
			return func;
		}
	};
	
	// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
	module.exports = function ToPrimitive(input, PreferredType) {
		if (isPrimitive(input)) {
			return input;
		}
		var hint = 'default';
		if (arguments.length > 1) {
			if (PreferredType === String) {
				hint = 'string';
			} else if (PreferredType === Number) {
				hint = 'number';
			}
		}
	
		var exoticToPrim;
		if (hasSymbols) {
			if (Symbol.toPrimitive) {
				exoticToPrim = GetMethod(input, Symbol.toPrimitive);
			} else if (isSymbol(input)) {
				exoticToPrim = Symbol.prototype.valueOf;
			}
		}
		if (typeof exoticToPrim !== 'undefined') {
			var result = exoticToPrim.call(input, hint);
			if (isPrimitive(result)) {
				return result;
			}
			throw new TypeError('unable to convert exotic object to primitive');
		}
		if (hint === 'default' && (isDate(input) || isSymbol(input))) {
			hint = 'string';
		}
		return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
	};


/***/ }),

/***/ "./node_modules/es-to-primitive/helpers/isPrimitive.js":
/***/ (function(module, exports) {

	module.exports = function isPrimitive(value) {
		return value === null || (typeof value !== 'function' && typeof value !== 'object');
	};


/***/ }),

/***/ "./node_modules/es6-promise/dist/es6-promise.js":
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(process, global) {/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
	 * @version   4.1.0
	 */
	
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ES6Promise = factory());
	}(this, (function () { 'use strict';
	
	function objectOrFunction(x) {
	  return typeof x === 'function' || typeof x === 'object' && x !== null;
	}
	
	function isFunction(x) {
	  return typeof x === 'function';
	}
	
	var _isArray = undefined;
	if (!Array.isArray) {
	  _isArray = function (x) {
	    return Object.prototype.toString.call(x) === '[object Array]';
	  };
	} else {
	  _isArray = Array.isArray;
	}
	
	var isArray = _isArray;
	
	var len = 0;
	var vertxNext = undefined;
	var customSchedulerFn = undefined;
	
	var asap = function asap(callback, arg) {
	  queue[len] = callback;
	  queue[len + 1] = arg;
	  len += 2;
	  if (len === 2) {
	    // If len is 2, that means that we need to schedule an async flush.
	    // If additional callbacks are queued before the queue is flushed, they
	    // will be processed by this flush that we are scheduling.
	    if (customSchedulerFn) {
	      customSchedulerFn(flush);
	    } else {
	      scheduleFlush();
	    }
	  }
	};
	
	function setScheduler(scheduleFn) {
	  customSchedulerFn = scheduleFn;
	}
	
	function setAsap(asapFn) {
	  asap = asapFn;
	}
	
	var browserWindow = typeof window !== 'undefined' ? window : undefined;
	var browserGlobal = browserWindow || {};
	var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
	var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';
	
	// test for web worker but not in IE10
	var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
	
	// node
	function useNextTick() {
	  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	  // see https://github.com/cujojs/when/issues/410 for details
	  return function () {
	    return process.nextTick(flush);
	  };
	}
	
	// vertx
	function useVertxTimer() {
	  if (typeof vertxNext !== 'undefined') {
	    return function () {
	      vertxNext(flush);
	    };
	  }
	
	  return useSetTimeout();
	}
	
	function useMutationObserver() {
	  var iterations = 0;
	  var observer = new BrowserMutationObserver(flush);
	  var node = document.createTextNode('');
	  observer.observe(node, { characterData: true });
	
	  return function () {
	    node.data = iterations = ++iterations % 2;
	  };
	}
	
	// web worker
	function useMessageChannel() {
	  var channel = new MessageChannel();
	  channel.port1.onmessage = flush;
	  return function () {
	    return channel.port2.postMessage(0);
	  };
	}
	
	function useSetTimeout() {
	  // Store setTimeout reference so es6-promise will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var globalSetTimeout = setTimeout;
	  return function () {
	    return globalSetTimeout(flush, 1);
	  };
	}
	
	var queue = new Array(1000);
	function flush() {
	  for (var i = 0; i < len; i += 2) {
	    var callback = queue[i];
	    var arg = queue[i + 1];
	
	    callback(arg);
	
	    queue[i] = undefined;
	    queue[i + 1] = undefined;
	  }
	
	  len = 0;
	}
	
	function attemptVertx() {
	  try {
	    var r = require;
	    var vertx = __webpack_require__(1);
	    vertxNext = vertx.runOnLoop || vertx.runOnContext;
	    return useVertxTimer();
	  } catch (e) {
	    return useSetTimeout();
	  }
	}
	
	var scheduleFlush = undefined;
	// Decide what async method to use to triggering processing of queued callbacks:
	if (isNode) {
	  scheduleFlush = useNextTick();
	} else if (BrowserMutationObserver) {
	  scheduleFlush = useMutationObserver();
	} else if (isWorker) {
	  scheduleFlush = useMessageChannel();
	} else if (browserWindow === undefined && "function" === 'function') {
	  scheduleFlush = attemptVertx();
	} else {
	  scheduleFlush = useSetTimeout();
	}
	
	function then(onFulfillment, onRejection) {
	  var _arguments = arguments;
	
	  var parent = this;
	
	  var child = new this.constructor(noop);
	
	  if (child[PROMISE_ID] === undefined) {
	    makePromise(child);
	  }
	
	  var _state = parent._state;
	
	  if (_state) {
	    (function () {
	      var callback = _arguments[_state - 1];
	      asap(function () {
	        return invokeCallback(_state, child, callback, parent._result);
	      });
	    })();
	  } else {
	    subscribe(parent, child, onFulfillment, onRejection);
	  }
	
	  return child;
	}
	
	/**
	  `Promise.resolve` returns a promise that will become resolved with the
	  passed `value`. It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    resolve(1);
	  });
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.resolve(1);
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  @method resolve
	  @static
	  @param {Any} value value that the returned promise will be resolved with
	  Useful for tooling.
	  @return {Promise} a promise that will become fulfilled with the given
	  `value`
	*/
	function resolve(object) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (object && typeof object === 'object' && object.constructor === Constructor) {
	    return object;
	  }
	
	  var promise = new Constructor(noop);
	  _resolve(promise, object);
	  return promise;
	}
	
	var PROMISE_ID = Math.random().toString(36).substring(16);
	
	function noop() {}
	
	var PENDING = void 0;
	var FULFILLED = 1;
	var REJECTED = 2;
	
	var GET_THEN_ERROR = new ErrorObject();
	
	function selfFulfillment() {
	  return new TypeError("You cannot resolve a promise with itself");
	}
	
	function cannotReturnOwn() {
	  return new TypeError('A promises callback cannot return that same promise.');
	}
	
	function getThen(promise) {
	  try {
	    return promise.then;
	  } catch (error) {
	    GET_THEN_ERROR.error = error;
	    return GET_THEN_ERROR;
	  }
	}
	
	function tryThen(then, value, fulfillmentHandler, rejectionHandler) {
	  try {
	    then.call(value, fulfillmentHandler, rejectionHandler);
	  } catch (e) {
	    return e;
	  }
	}
	
	function handleForeignThenable(promise, thenable, then) {
	  asap(function (promise) {
	    var sealed = false;
	    var error = tryThen(then, thenable, function (value) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	      if (thenable !== value) {
	        _resolve(promise, value);
	      } else {
	        fulfill(promise, value);
	      }
	    }, function (reason) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	
	      _reject(promise, reason);
	    }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	    if (!sealed && error) {
	      sealed = true;
	      _reject(promise, error);
	    }
	  }, promise);
	}
	
	function handleOwnThenable(promise, thenable) {
	  if (thenable._state === FULFILLED) {
	    fulfill(promise, thenable._result);
	  } else if (thenable._state === REJECTED) {
	    _reject(promise, thenable._result);
	  } else {
	    subscribe(thenable, undefined, function (value) {
	      return _resolve(promise, value);
	    }, function (reason) {
	      return _reject(promise, reason);
	    });
	  }
	}
	
	function handleMaybeThenable(promise, maybeThenable, then$$) {
	  if (maybeThenable.constructor === promise.constructor && then$$ === then && maybeThenable.constructor.resolve === resolve) {
	    handleOwnThenable(promise, maybeThenable);
	  } else {
	    if (then$$ === GET_THEN_ERROR) {
	      _reject(promise, GET_THEN_ERROR.error);
	      GET_THEN_ERROR.error = null;
	    } else if (then$$ === undefined) {
	      fulfill(promise, maybeThenable);
	    } else if (isFunction(then$$)) {
	      handleForeignThenable(promise, maybeThenable, then$$);
	    } else {
	      fulfill(promise, maybeThenable);
	    }
	  }
	}
	
	function _resolve(promise, value) {
	  if (promise === value) {
	    _reject(promise, selfFulfillment());
	  } else if (objectOrFunction(value)) {
	    handleMaybeThenable(promise, value, getThen(value));
	  } else {
	    fulfill(promise, value);
	  }
	}
	
	function publishRejection(promise) {
	  if (promise._onerror) {
	    promise._onerror(promise._result);
	  }
	
	  publish(promise);
	}
	
	function fulfill(promise, value) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	
	  promise._result = value;
	  promise._state = FULFILLED;
	
	  if (promise._subscribers.length !== 0) {
	    asap(publish, promise);
	  }
	}
	
	function _reject(promise, reason) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	  promise._state = REJECTED;
	  promise._result = reason;
	
	  asap(publishRejection, promise);
	}
	
	function subscribe(parent, child, onFulfillment, onRejection) {
	  var _subscribers = parent._subscribers;
	  var length = _subscribers.length;
	
	  parent._onerror = null;
	
	  _subscribers[length] = child;
	  _subscribers[length + FULFILLED] = onFulfillment;
	  _subscribers[length + REJECTED] = onRejection;
	
	  if (length === 0 && parent._state) {
	    asap(publish, parent);
	  }
	}
	
	function publish(promise) {
	  var subscribers = promise._subscribers;
	  var settled = promise._state;
	
	  if (subscribers.length === 0) {
	    return;
	  }
	
	  var child = undefined,
	      callback = undefined,
	      detail = promise._result;
	
	  for (var i = 0; i < subscribers.length; i += 3) {
	    child = subscribers[i];
	    callback = subscribers[i + settled];
	
	    if (child) {
	      invokeCallback(settled, child, callback, detail);
	    } else {
	      callback(detail);
	    }
	  }
	
	  promise._subscribers.length = 0;
	}
	
	function ErrorObject() {
	  this.error = null;
	}
	
	var TRY_CATCH_ERROR = new ErrorObject();
	
	function tryCatch(callback, detail) {
	  try {
	    return callback(detail);
	  } catch (e) {
	    TRY_CATCH_ERROR.error = e;
	    return TRY_CATCH_ERROR;
	  }
	}
	
	function invokeCallback(settled, promise, callback, detail) {
	  var hasCallback = isFunction(callback),
	      value = undefined,
	      error = undefined,
	      succeeded = undefined,
	      failed = undefined;
	
	  if (hasCallback) {
	    value = tryCatch(callback, detail);
	
	    if (value === TRY_CATCH_ERROR) {
	      failed = true;
	      error = value.error;
	      value.error = null;
	    } else {
	      succeeded = true;
	    }
	
	    if (promise === value) {
	      _reject(promise, cannotReturnOwn());
	      return;
	    }
	  } else {
	    value = detail;
	    succeeded = true;
	  }
	
	  if (promise._state !== PENDING) {
	    // noop
	  } else if (hasCallback && succeeded) {
	      _resolve(promise, value);
	    } else if (failed) {
	      _reject(promise, error);
	    } else if (settled === FULFILLED) {
	      fulfill(promise, value);
	    } else if (settled === REJECTED) {
	      _reject(promise, value);
	    }
	}
	
	function initializePromise(promise, resolver) {
	  try {
	    resolver(function resolvePromise(value) {
	      _resolve(promise, value);
	    }, function rejectPromise(reason) {
	      _reject(promise, reason);
	    });
	  } catch (e) {
	    _reject(promise, e);
	  }
	}
	
	var id = 0;
	function nextId() {
	  return id++;
	}
	
	function makePromise(promise) {
	  promise[PROMISE_ID] = id++;
	  promise._state = undefined;
	  promise._result = undefined;
	  promise._subscribers = [];
	}
	
	function Enumerator(Constructor, input) {
	  this._instanceConstructor = Constructor;
	  this.promise = new Constructor(noop);
	
	  if (!this.promise[PROMISE_ID]) {
	    makePromise(this.promise);
	  }
	
	  if (isArray(input)) {
	    this._input = input;
	    this.length = input.length;
	    this._remaining = input.length;
	
	    this._result = new Array(this.length);
	
	    if (this.length === 0) {
	      fulfill(this.promise, this._result);
	    } else {
	      this.length = this.length || 0;
	      this._enumerate();
	      if (this._remaining === 0) {
	        fulfill(this.promise, this._result);
	      }
	    }
	  } else {
	    _reject(this.promise, validationError());
	  }
	}
	
	function validationError() {
	  return new Error('Array Methods must be provided an Array');
	};
	
	Enumerator.prototype._enumerate = function () {
	  var length = this.length;
	  var _input = this._input;
	
	  for (var i = 0; this._state === PENDING && i < length; i++) {
	    this._eachEntry(_input[i], i);
	  }
	};
	
	Enumerator.prototype._eachEntry = function (entry, i) {
	  var c = this._instanceConstructor;
	  var resolve$$ = c.resolve;
	
	  if (resolve$$ === resolve) {
	    var _then = getThen(entry);
	
	    if (_then === then && entry._state !== PENDING) {
	      this._settledAt(entry._state, i, entry._result);
	    } else if (typeof _then !== 'function') {
	      this._remaining--;
	      this._result[i] = entry;
	    } else if (c === Promise) {
	      var promise = new c(noop);
	      handleMaybeThenable(promise, entry, _then);
	      this._willSettleAt(promise, i);
	    } else {
	      this._willSettleAt(new c(function (resolve$$) {
	        return resolve$$(entry);
	      }), i);
	    }
	  } else {
	    this._willSettleAt(resolve$$(entry), i);
	  }
	};
	
	Enumerator.prototype._settledAt = function (state, i, value) {
	  var promise = this.promise;
	
	  if (promise._state === PENDING) {
	    this._remaining--;
	
	    if (state === REJECTED) {
	      _reject(promise, value);
	    } else {
	      this._result[i] = value;
	    }
	  }
	
	  if (this._remaining === 0) {
	    fulfill(promise, this._result);
	  }
	};
	
	Enumerator.prototype._willSettleAt = function (promise, i) {
	  var enumerator = this;
	
	  subscribe(promise, undefined, function (value) {
	    return enumerator._settledAt(FULFILLED, i, value);
	  }, function (reason) {
	    return enumerator._settledAt(REJECTED, i, reason);
	  });
	};
	
	/**
	  `Promise.all` accepts an array of promises, and returns a new promise which
	  is fulfilled with an array of fulfillment values for the passed promises, or
	  rejected with the reason of the first passed promise to be rejected. It casts all
	  elements of the passed iterable to promises as it runs this algorithm.
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = resolve(2);
	  let promise3 = resolve(3);
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // The array here would be [ 1, 2, 3 ];
	  });
	  ```
	
	  If any of the `promises` given to `all` are rejected, the first promise
	  that is rejected will be given as an argument to the returned promises's
	  rejection handler. For example:
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = reject(new Error("2"));
	  let promise3 = reject(new Error("3"));
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // Code here never runs because there are rejected promises!
	  }, function(error) {
	    // error.message === "2"
	  });
	  ```
	
	  @method all
	  @static
	  @param {Array} entries array of promises
	  @param {String} label optional string for labeling the promise.
	  Useful for tooling.
	  @return {Promise} promise that is fulfilled when all `promises` have been
	  fulfilled, or rejected if any of them become rejected.
	  @static
	*/
	function all(entries) {
	  return new Enumerator(this, entries).promise;
	}
	
	/**
	  `Promise.race` returns a new promise which is settled in the same way as the
	  first passed promise to settle.
	
	  Example:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 2');
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // result === 'promise 2' because it was resolved before promise1
	    // was resolved.
	  });
	  ```
	
	  `Promise.race` is deterministic in that only the state of the first
	  settled promise matters. For example, even if other promises given to the
	  `promises` array argument are resolved, but the first settled promise has
	  become rejected before the other promises became fulfilled, the returned
	  promise will become rejected:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      reject(new Error('promise 2'));
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // Code here never runs
	  }, function(reason){
	    // reason.message === 'promise 2' because promise 2 became rejected before
	    // promise 1 became fulfilled
	  });
	  ```
	
	  An example real-world use case is implementing timeouts:
	
	  ```javascript
	  Promise.race([ajax('foo.json'), timeout(5000)])
	  ```
	
	  @method race
	  @static
	  @param {Array} promises array of promises to observe
	  Useful for tooling.
	  @return {Promise} a promise which settles in the same way as the first passed
	  promise to settle.
	*/
	function race(entries) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (!isArray(entries)) {
	    return new Constructor(function (_, reject) {
	      return reject(new TypeError('You must pass an array to race.'));
	    });
	  } else {
	    return new Constructor(function (resolve, reject) {
	      var length = entries.length;
	      for (var i = 0; i < length; i++) {
	        Constructor.resolve(entries[i]).then(resolve, reject);
	      }
	    });
	  }
	}
	
	/**
	  `Promise.reject` returns a promise rejected with the passed `reason`.
	  It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    reject(new Error('WHOOPS'));
	  });
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.reject(new Error('WHOOPS'));
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  @method reject
	  @static
	  @param {Any} reason value that the returned promise will be rejected with.
	  Useful for tooling.
	  @return {Promise} a promise rejected with the given `reason`.
	*/
	function reject(reason) {
	  /*jshint validthis:true */
	  var Constructor = this;
	  var promise = new Constructor(noop);
	  _reject(promise, reason);
	  return promise;
	}
	
	function needsResolver() {
	  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	}
	
	function needsNew() {
	  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	}
	
	/**
	  Promise objects represent the eventual result of an asynchronous operation. The
	  primary way of interacting with a promise is through its `then` method, which
	  registers callbacks to receive either a promise's eventual value or the reason
	  why the promise cannot be fulfilled.
	
	  Terminology
	  -----------
	
	  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	  - `thenable` is an object or function that defines a `then` method.
	  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	  - `exception` is a value that is thrown using the throw statement.
	  - `reason` is a value that indicates why a promise was rejected.
	  - `settled` the final resting state of a promise, fulfilled or rejected.
	
	  A promise can be in one of three states: pending, fulfilled, or rejected.
	
	  Promises that are fulfilled have a fulfillment value and are in the fulfilled
	  state.  Promises that are rejected have a rejection reason and are in the
	  rejected state.  A fulfillment value is never a thenable.
	
	  Promises can also be said to *resolve* a value.  If this value is also a
	  promise, then the original promise's settled state will match the value's
	  settled state.  So a promise that *resolves* a promise that rejects will
	  itself reject, and a promise that *resolves* a promise that fulfills will
	  itself fulfill.
	
	
	  Basic Usage:
	  ------------
	
	  ```js
	  let promise = new Promise(function(resolve, reject) {
	    // on success
	    resolve(value);
	
	    // on failure
	    reject(reason);
	  });
	
	  promise.then(function(value) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Advanced Usage:
	  ---------------
	
	  Promises shine when abstracting away asynchronous interactions such as
	  `XMLHttpRequest`s.
	
	  ```js
	  function getJSON(url) {
	    return new Promise(function(resolve, reject){
	      let xhr = new XMLHttpRequest();
	
	      xhr.open('GET', url);
	      xhr.onreadystatechange = handler;
	      xhr.responseType = 'json';
	      xhr.setRequestHeader('Accept', 'application/json');
	      xhr.send();
	
	      function handler() {
	        if (this.readyState === this.DONE) {
	          if (this.status === 200) {
	            resolve(this.response);
	          } else {
	            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	          }
	        }
	      };
	    });
	  }
	
	  getJSON('/posts.json').then(function(json) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Unlike callbacks, promises are great composable primitives.
	
	  ```js
	  Promise.all([
	    getJSON('/posts'),
	    getJSON('/comments')
	  ]).then(function(values){
	    values[0] // => postsJSON
	    values[1] // => commentsJSON
	
	    return values;
	  });
	  ```
	
	  @class Promise
	  @param {function} resolver
	  Useful for tooling.
	  @constructor
	*/
	function Promise(resolver) {
	  this[PROMISE_ID] = nextId();
	  this._result = this._state = undefined;
	  this._subscribers = [];
	
	  if (noop !== resolver) {
	    typeof resolver !== 'function' && needsResolver();
	    this instanceof Promise ? initializePromise(this, resolver) : needsNew();
	  }
	}
	
	Promise.all = all;
	Promise.race = race;
	Promise.resolve = resolve;
	Promise.reject = reject;
	Promise._setScheduler = setScheduler;
	Promise._setAsap = setAsap;
	Promise._asap = asap;
	
	Promise.prototype = {
	  constructor: Promise,
	
	  /**
	    The primary way of interacting with a promise is through its `then` method,
	    which registers callbacks to receive either a promise's eventual value or the
	    reason why the promise cannot be fulfilled.
	  
	    ```js
	    findUser().then(function(user){
	      // user is available
	    }, function(reason){
	      // user is unavailable, and you are given the reason why
	    });
	    ```
	  
	    Chaining
	    --------
	  
	    The return value of `then` is itself a promise.  This second, 'downstream'
	    promise is resolved with the return value of the first promise's fulfillment
	    or rejection handler, or rejected if the handler throws an exception.
	  
	    ```js
	    findUser().then(function (user) {
	      return user.name;
	    }, function (reason) {
	      return 'default name';
	    }).then(function (userName) {
	      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	      // will be `'default name'`
	    });
	  
	    findUser().then(function (user) {
	      throw new Error('Found user, but still unhappy');
	    }, function (reason) {
	      throw new Error('`findUser` rejected and we're unhappy');
	    }).then(function (value) {
	      // never reached
	    }, function (reason) {
	      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	    });
	    ```
	    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	  
	    ```js
	    findUser().then(function (user) {
	      throw new PedagogicalException('Upstream error');
	    }).then(function (value) {
	      // never reached
	    }).then(function (value) {
	      // never reached
	    }, function (reason) {
	      // The `PedgagocialException` is propagated all the way down to here
	    });
	    ```
	  
	    Assimilation
	    ------------
	  
	    Sometimes the value you want to propagate to a downstream promise can only be
	    retrieved asynchronously. This can be achieved by returning a promise in the
	    fulfillment or rejection handler. The downstream promise will then be pending
	    until the returned promise is settled. This is called *assimilation*.
	  
	    ```js
	    findUser().then(function (user) {
	      return findCommentsByAuthor(user);
	    }).then(function (comments) {
	      // The user's comments are now available
	    });
	    ```
	  
	    If the assimliated promise rejects, then the downstream promise will also reject.
	  
	    ```js
	    findUser().then(function (user) {
	      return findCommentsByAuthor(user);
	    }).then(function (comments) {
	      // If `findCommentsByAuthor` fulfills, we'll have the value here
	    }, function (reason) {
	      // If `findCommentsByAuthor` rejects, we'll have the reason here
	    });
	    ```
	  
	    Simple Example
	    --------------
	  
	    Synchronous Example
	  
	    ```javascript
	    let result;
	  
	    try {
	      result = findResult();
	      // success
	    } catch(reason) {
	      // failure
	    }
	    ```
	  
	    Errback Example
	  
	    ```js
	    findResult(function(result, err){
	      if (err) {
	        // failure
	      } else {
	        // success
	      }
	    });
	    ```
	  
	    Promise Example;
	  
	    ```javascript
	    findResult().then(function(result){
	      // success
	    }, function(reason){
	      // failure
	    });
	    ```
	  
	    Advanced Example
	    --------------
	  
	    Synchronous Example
	  
	    ```javascript
	    let author, books;
	  
	    try {
	      author = findAuthor();
	      books  = findBooksByAuthor(author);
	      // success
	    } catch(reason) {
	      // failure
	    }
	    ```
	  
	    Errback Example
	  
	    ```js
	  
	    function foundBooks(books) {
	  
	    }
	  
	    function failure(reason) {
	  
	    }
	  
	    findAuthor(function(author, err){
	      if (err) {
	        failure(err);
	        // failure
	      } else {
	        try {
	          findBoooksByAuthor(author, function(books, err) {
	            if (err) {
	              failure(err);
	            } else {
	              try {
	                foundBooks(books);
	              } catch(reason) {
	                failure(reason);
	              }
	            }
	          });
	        } catch(error) {
	          failure(err);
	        }
	        // success
	      }
	    });
	    ```
	  
	    Promise Example;
	  
	    ```javascript
	    findAuthor().
	      then(findBooksByAuthor).
	      then(function(books){
	        // found books
	    }).catch(function(reason){
	      // something went wrong
	    });
	    ```
	  
	    @method then
	    @param {Function} onFulfilled
	    @param {Function} onRejected
	    Useful for tooling.
	    @return {Promise}
	  */
	  then: then,
	
	  /**
	    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	    as the catch block of a try/catch statement.
	  
	    ```js
	    function findAuthor(){
	      throw new Error('couldn't find that author');
	    }
	  
	    // synchronous
	    try {
	      findAuthor();
	    } catch(reason) {
	      // something went wrong
	    }
	  
	    // async with promises
	    findAuthor().catch(function(reason){
	      // something went wrong
	    });
	    ```
	  
	    @method catch
	    @param {Function} onRejection
	    Useful for tooling.
	    @return {Promise}
	  */
	  'catch': function _catch(onRejection) {
	    return this.then(null, onRejection);
	  }
	};
	
	function polyfill() {
	    var local = undefined;
	
	    if (typeof global !== 'undefined') {
	        local = global;
	    } else if (typeof self !== 'undefined') {
	        local = self;
	    } else {
	        try {
	            local = Function('return this')();
	        } catch (e) {
	            throw new Error('polyfill failed because global object is unavailable in this environment');
	        }
	    }
	
	    var P = local.Promise;
	
	    if (P) {
	        var promiseToString = null;
	        try {
	            promiseToString = Object.prototype.toString.call(P.resolve());
	        } catch (e) {
	            // silently ignored
	        }
	
	        if (promiseToString === '[object Promise]' && !P.cast) {
	            return;
	        }
	    }
	
	    local.Promise = Promise;
	}
	
	// Strange compat..
	Promise.polyfill = polyfill;
	Promise.Promise = Promise;
	
	return Promise;
	
	})));
	//# sourceMappingURL=es6-promise.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js"), (function() { return this; }())))

/***/ }),

/***/ "./node_modules/events/events.js":
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),

/***/ "./node_modules/exenv/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ "./node_modules/foreach/index.js":
/***/ (function(module, exports) {

	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	module.exports = function forEach (obj, fn, ctx) {
	    if (toString.call(fn) !== '[object Function]') {
	        throw new TypeError('iterator must be a function');
	    }
	    var l = obj.length;
	    if (l === +l) {
	        for (var i = 0; i < l; i++) {
	            fn.call(ctx, obj[i], i, obj);
	        }
	    } else {
	        for (var k in obj) {
	            if (hasOwn.call(obj, k)) {
	                fn.call(ctx, obj[k], k, obj);
	            }
	        }
	    }
	};
	


/***/ }),

/***/ "./node_modules/function-bind/implementation.js":
/***/ (function(module, exports) {

	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ }),

/***/ "./node_modules/function-bind/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var implementation = __webpack_require__("./node_modules/function-bind/implementation.js");
	
	module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ "./node_modules/global/window.js":
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var win;
	
	if (typeof window !== "undefined") {
	    win = window;
	} else if (typeof global !== "undefined") {
	    win = global;
	} else if (typeof self !== "undefined"){
	    win = self;
	} else {
	    win = {};
	}
	
	module.exports = win;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ "./node_modules/graphcool-styles/dist/build.js":
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__("./node_modules/react/react.js"));
		else if(typeof define === 'function' && define.amd)
			define(["React"], factory);
		else if(typeof exports === 'object')
			exports["graphcool-styles"] = factory(require("react"));
		else
			root["graphcool-styles"] = factory(root["React"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_6__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// identity function for calling harmory imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	
	/******/ 	// define getter function for harmory exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		Object.defineProperty(exports, name, {
	/******/ 			configurable: false,
	/******/ 			enumerable: true,
	/******/ 			get: getter
	/******/ 		});
	/******/ 	};
	
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 7);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var React = __webpack_require__(6);
	var objectAssign = __webpack_require__(5);
	var Icon = (function (_super) {
	    __extends(Icon, _super);
	    function Icon() {
	        return _super.apply(this, arguments) || this;
	    }
	    Icon.prototype.render = function () {
	        var width = this.props.width || 16;
	        var height = this.props.height || 16;
	        var color = this.props.color || '#000';
	        var stroke = this.props.stroke || false;
	        var strokeWidth = this.props.strokeWidth || 1;
	        var rotate = this.props.rotate || 0;
	        var fillCode = !stroke ? "fill=\"" + color + "\"" : 'fill="none"';
	        var strokeCode = stroke ? "stroke=\"" + color + "\" stroke-width=\"" + strokeWidth + "px\"" : 'stroke="none"';
	        var styleCode = "style=\"width: " + width + "px; height: " + height + "px;\"";
	        var src = this.props.src;
	        var match = src.match(/data:image\/svg[^,]*?(;base64)?,(.*)/);
	        if (match && match[1] && match[2]) {
	            src = atob(match[2]);
	        }
	        var html = src.replace(/<svg/, "<svg " + strokeCode + " " + fillCode + " " + styleCode);
	        var restProps = objectAssign({}, this.props);
	        delete restProps.width;
	        delete restProps.height;
	        delete restProps.stroke;
	        delete restProps.strokeWidth;
	        delete restProps.color;
	        delete restProps.src;
	        delete restProps.className;
	        return (React.createElement("i", __assign({}, restProps, { className: this.props.className, style: {
	                transform: "rotate(" + rotate + "deg)",
	                WebkitTransform: "rotate(" + rotate + "deg)",
	                display: 'flex',
	            }, dangerouslySetInnerHTML: { __html: html } })));
	    };
	    return Icon;
	}(React.Component));
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = Icon;
	
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
	"use strict";
	"use strict";
	exports.black = '#000';
	exports.white = '#fff';
	exports.green = 'rgba(39,174,96,1)';
	exports.blue = 'rgba(42,126,210,1)';
	exports.darkBlue = 'rgba(23,42,58,1)';
	exports.darkerBlue = 'rgba(15,32,46,1)';
	exports.darkestBlue = 'rgb(11,20,28)';
	exports.orange = 'rgba(207,92,54,1)';
	exports.red = 'rgba(242,92,84,1)';
	exports.accent = '#00b861';
	exports.lightGreen = 'rgba(42,189,60,1)';
	exports.lightBlue = 'rgba(74,183,255,1)';
	exports.pink = 'rgb(224,0,130)';
	exports.pink10 = 'rgba(224,0,130,0.1)';
	exports.pink20 = 'rgba(224,0,130,0.2)';
	exports.pink30 = 'rgba(224,0,130,0.3)';
	exports.pink40 = 'rgba(224,0,130,0.4)';
	exports.pink50 = 'rgba(224,0,130,0.5)';
	exports.pink60 = 'rgba(224,0,130,0.6)';
	exports.pink70 = 'rgba(224,0,130,0.7)';
	exports.pink80 = 'rgba(224,0,130,0.8)';
	exports.pink90 = 'rgba(224,0,130,0.9)';
	exports.lightYellow = 'rgba(252,246,169,1)';
	exports.lightYellow20 = 'rgba(252,246,169,0.2)';
	exports.lightBrown = 'rgba(209,167,0,1)';
	exports.toggleGreen = 'rgba(126, 211, 33, 1)';
	exports.green0 = 'rgba(39,174,96,0)';
	exports.green50 = 'rgba(39,174,96,.5)';
	exports.lighterGreen = 'rgb(210, 242, 214)';
	exports.lightGreen05 = 'rgba(42,189,60,.05)';
	exports.lightGreen10 = 'rgba(42,189,60,.1)';
	exports.lightGreen20 = 'rgba(42,189,60,.2)';
	exports.lightGreen30 = 'rgba(42,189,60,.3)';
	exports.lightGreen50 = 'rgba(42,189,60,.5)';
	exports.blue0 = 'rgba(42,126,210,0)';
	exports.blue10 = 'rgba(42,126,210,.1)';
	exports.blue20 = 'rgba(42,126,210,.2)';
	exports.blue50 = 'rgba(42,126,210,.5)';
	exports.blue80 = 'rgba(42,126,210,.8)';
	exports.darkBlue0 = 'rgba(23,42,58,0)';
	exports.darkBlue02 = 'rgba(23,42,58,.02)';
	exports.darkBlue04 = 'rgba(23,42,58,.04)';
	exports.darkBlue05 = 'rgba(23,42,58,.05)';
	exports.darkBlue06 = 'rgba(23,42,58,.06)';
	exports.darkBlue07 = 'rgba(23,42,58,.07)';
	exports.darkBlue10 = 'rgba(23,42,58,.10)';
	exports.darkBlue20 = 'rgba(23,42,58,.20)';
	exports.darkBlue30 = 'rgba(23,42,58,.30)';
	exports.darkBlue40 = 'rgba(23,42,58,.40)';
	exports.darkBlue50 = 'rgba(23,42,58,.5)';
	exports.darkBlue60 = 'rgba(23,42,58,.6)';
	exports.darkBlue70 = 'rgba(23,42,58,.7)';
	exports.darkBlue80 = 'rgba(23,42,58,.8)';
	exports.darkBlue90 = 'rgba(23,42,58,.9)';
	exports.darkerBlue0 = 'rgba(15,32,46,0)';
	exports.darkerBlue50 = 'rgba(15,32,46,.5)';
	exports.orange0 = 'rgba(207,92,54,0)';
	exports.orange50 = 'rgba(207,92,54,.5)';
	exports.red0 = 'rgba(242,92,84,0)';
	exports.red10 = 'rgba(242,92,84,.1)';
	exports.red20 = 'rgba(242,92,84,.2)';
	exports.red30 = 'rgba(242,92,84,.3)';
	exports.red40 = 'rgba(242,92,84,.4)';
	exports.red50 = 'rgba(242,92,84,.5)';
	exports.darkBlueGray = 'rgba(9,20,28,1)';
	exports.gray02 = 'rgba(0,0,0,0.02)';
	exports.gray04 = 'rgba(0,0,0,0.04)';
	exports.gray07 = 'rgba(0,0,0,0.07)';
	exports.gray10 = 'rgba(0,0,0,0.1)';
	exports.gray20 = 'rgba(0,0,0,0.2)';
	exports.gray30 = 'rgba(0,0,0,0.3)';
	exports.gray40 = 'rgba(0,0,0,0.4)';
	exports.gray50 = 'rgba(0,0,0,0.5)';
	exports.gray60 = 'rgba(0,0,0,0.6)';
	exports.gray70 = 'rgba(0,0,0,0.7)';
	exports.gray80 = 'rgba(0,0,0,0.8)';
	exports.gray90 = 'rgba(0,0,0,0.9)';
	exports.white04 = 'rgba(255,255,255,0.04)';
	exports.white07 = 'rgba(255,255,255,0.07)';
	exports.white10 = 'rgba(255,255,255,0.1)';
	exports.white20 = 'rgba(255,255,255,0.2)';
	exports.white30 = 'rgba(255,255,255,0.3)';
	exports.white40 = 'rgba(255,255,255,0.4)';
	exports.white50 = 'rgba(255,255,255,0.5)';
	exports.white60 = 'rgba(255,255,255,0.6)';
	exports.white70 = 'rgba(255,255,255,0.7)';
	exports.white80 = 'rgba(255,255,255,0.8)';
	exports.white90 = 'rgba(255,255,255,0.9)';
	exports.purple = 'rgba(164,3,111,1)';
	exports.purple20 = 'rgba(164,3,111,.2)';
	exports.lightOrange = 'rgba(241,143,1,1)';
	exports.lightOrange10 = 'rgba(241,143,1,.1)';
	exports.lightOrange20 = 'rgba(241,143,1,.2)';
	exports.lightOrange30 = 'rgba(241,143,1,.3)';
	exports.lightGray = 'rgba(195,191,196)';
	exports.pblue = 'rgba(74,144,226,1)';
	exports.pblue20 = 'rgba(74,144,226,0.2)';
	exports.pred = 'rgba(208,2,27,1)';
	exports.pred20 = 'rgba(208,2,27,0.2)';
	exports.pbrown = 'rgba(174,145,0,1)';
	exports.pyellow40 = 'rgba(248,231,28,0.4)';
	exports.pgreen = 'rgba(39,174,96,1)';
	exports.plightgreen50 = 'rgba(184,233,134,0.5)';
	exports.size04 = '4px';
	exports.size06 = '6px';
	exports.size10 = '10px';
	exports.size16 = '16px';
	exports.size25 = '25px';
	exports.size38 = '38px';
	exports.size60 = '60px';
	exports.size96 = '96px';
	exports.size12 = '12px';
	exports.size14 = '14px';
	exports.copyLineheight = '1.5';
	exports.titleLineheight = '1.3';
	exports.duration = '.1s';
	exports.size32 = '32px';
	exports.size30 = '30px';
	exports.size20 = '20px';
	
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	module.exports = {"cover":"_10FW4QcCx4hka4m0qKKeK5","contain":"_1LuPjFJhHsh_9VzEsByA9x","bbox":"_1r_MN90NHKKHQpyvVfC54j","cbox":"cuuFrKRDWD35Pnb5EbBeC","bgCenter":"_3YeaAMWQHF1tuwhAm1seW2","bgTop":"_3YLbBlahtqRnwMLOwiCAyK","bgRight":"_28sjOE__HNAreQ6wWD6A0u","bgBottom":"_1FXbTMQ0eVDqjhd5C6MLtO","bgLeft":"y9VsMdsk53iF1rYcBmBXY","outline0":"_2Ejg1pjGXZAAKDo_-okvzh","ba":"_1kdAhj1hbgBk_qQd2PG51r","bt":"_1a-o6MR9N_5wNXbBxMXU4T","br":"_3ASZ_8V44fhhZ0WhqC2bTL","bb":"_3q-lFMNQ7rOI9otwjX994K","bl":"_3ZPIFTryWchKG0qIxUo4K7","bn":"_3mG4xjhvBYRe54t10v3ffx","bWhite":"_1DFjBqMTVlhZmYpGYxWSeV","bWhite90":"wNxU4Msdf7AxqMd66TX5-","bWhite80":"_28zdkubue7Wzv_mqPiBK0k","bWhite70":"_1LybuyoQQws7Rf2XDJA5vY","bWhite60":"_3BvPxROpgUlpmN3S-cDDNd","bWhite50":"_2I9auJAV7Tot7RR5WHWn1x","bWhite40":"PH8Nd2rkhvRhc9oy59KIq","bWhite30":"_1JjOor62ETpUWDJ_HjRkIZ","bWhite20":"_2JeJ2fIBzC6M2xmDsYRJnE","bWhite10":"_2rS7DTem_uGNzWIZRTIeku","bWhite05":"_1D2lAuS38XdOAfqs7GQXKa","bBlack":"_3JMbbNtAzJX7UJ4tsCpUkt","bBlack90":"_2x_HWjzYpmrF695In0TYJd","bBlack80":"_2dw6_f5aZ_RrUzSPZAzGAH","bBlack70":"_1wP0Vs0S5rjTrkfssZtrYr","bBlack60":"_3EokjGlLZlS9kZRNydbvLN","bBlack50":"_1bCU6egGJOxAM35wDoHE40","bBlack40":"BeK9KhwqDP-ArkQoOIQcE","bBlack30":"_1-4DteDNUKS8qkg2ntdU1E","bBlack20":"_1AMPsL8puPDey4kJe3HQkw","bBlack10":"_1Zy3gYduWwo-7QWxoAvA4x","bBlack05":"_2FIeoXv1IcPTw_hfbcr-KL","bGreen":"_1hxEIvBQQmvclIOo8GXcev","bGreen50":"_3H5xfG2DoAyU8QoCJVhnEt","bBlue":"dKsmkXqeMmLQNHD0zBzp4","bDarkBlue":"_2-1OjUvIanwzGhUrBxSp-U","bDarkBlue90":"_1IJyHdt-X8ZLN5b7_lqymW","bDarkBlue80":"_2cHXWprz9LiukPGnTbWb9M","bDarkBlue70":"_1CNjc8bmxZOfTc0bO6z43J","bDarkBlue60":"_24KkcSQwjH6OilmwdPTlNP","bDarkBlue50":"_2I9IYYFiX7pKqwNpbWwYM-","bDarkBlue40":"_27DnNuLsvX2Xz1aFTm4A_R","bDarkBlue30":"cWrPkV_1XpW6EOpSyQQVN","bDarkBlue20":"_25jXXtOZQiNO5bpWJ_pAEh","bDarkBlue10":"_135sACcML-9iC6ZCZmqgNx","bDarkBlue06":"_3pEyLMmR5ysIV0v8_iTulA","bDarkBlue05":"_2BVKOjxz0mLfKBjDtQMT9k","bDarkerBlue":"_3XZjiemKD7JyShfJFmaBaU","bRed":"_1gEHLYB0kmT3eAzO2zJNME","bRed10":"_2GAtAs6kNpG1wCUXkmzrlv","bRed20":"_2SzczH-3GZWGcJMt_wdGzX","bRed30":"_1YR-Ow91ILIacqOgx83cum","bLightOrange":"_2MF-DU_9bF0D_xOfctrTMp","bLightOrange10":"_39PS2adXciPOnphqnYkkc8","bLightOrange20":"_30_FzqB1GpkN_M3dTwhwE5","bLightOrange30":"_3t-fW640WSz78o9SXlHdx6","br0":"zKHLpV-Lbn8HQFbwOVYuL","br1":"_3VfU_TXAvGQwLPrXT7FWkH","br2":"_27Qzs-o0QwC0Aq3H2-qs_7","overlay":"vISW1aTdstPXK90JlKDbk","uppercaseButton":"_2Px2VcxEZte7Cdw3imZ_O6","br100":"_1FtHSMBJ6K-KJ2yq6HMoa3","brPill":"_1xW-awe-94xoLkM3EvaNOq","brBottom":"_2JmjCanTJAXGALD5y4wJic","brTop":"_3tcuZjDOSBIxuUEFJFtB0q","brRight":"_3Ud4hTA_mb2AEOTLcKJ15w","brLeft":"_30FfN3JecOglXB08Sx6tLh","bDotted":"_3OE5SuGRebKAf6DExo3Kmx","bDashed":"_27vJz3rWfl7N06M-zDeuiu","bSolid":"_1TDzvTWajZi1IcO6NM7nAn","bNone":"_31shiPUCV_iB4S5aXY_IXz","bw0":"_3WdvQYmaCpCvtUV8wyKLDj","bw1":"_3JTR6VC5_0d2caXkPRu12j","bw2":"_2scIzgAJ6gFn9JGGbi2v9s","bt0":"_2_mn-Q043iL3J23rKkoPPO","bb0":"_1GSC5aIY5Ic83oHiUKaPZH","bl0":"VKiNA_kwScqRnW0OGenkE","buttonShadow":"_35wBjEjU02ZagLblAg72x","overlayShadow":"_3M1p4nTGLlXx3Fygd2qEoY","pre":"_1Z8BjDxlEdjf0Qx4C2C2yY","top0":"_1JMSrpyWcsrF0YTuLngw8","top4":"BWHz4FQxWJTyu4jOH9FmY","top6":"U4QtS8PQTbj9XfwGQBDgr","top10":"_13znEvZMzG-txhoha5MVLk","top16":"zs1L52G3bNNp8l2IhEdfs","top25":"_8aIUDytXkHXBl2cwaiijg","top38":"LOzS2NuMbhBxFUIPgBspY","top60":"_1Pv6tA88lgbneHzHTkSTP6","top96":"_1MJwmOBCBVyBWfYuG2LX2o","top50":"_2CVMYteoFRhMy-bmhWSZ90","top100":"aDK1HodgK9EKieeoycBhW","right0":"wrts3hfzxzV_UIEmpZyuN","right4":"_3NGOJcU9ZdkGBnpQ6Ec5ez","right6":"jeBUVNYOkrPNwoxddDHJF","right10":"_2cmkpUIDxFa8rNUozB5uwx","right16":"_2OWWYsf78zwpkW-TTZPXEf","right25":"DGal8xBiAPXyI5OxyipMs","right38":"_1SDiWNIG8HiSK-SXauRxmW","right60":"_1kMc5NxEH1-DBOjwv5TD4K","right96":"_2V-aARNXJdKNZzAQdNVwQf","right50":"_3koFoMXCEHR9snEGdOAQYK","right100":"_2m6j75LO8SUDTBhqBqD8OW","bottom0":"VsXyP77qSgAjiIBGPHXxb","bottom4":"_2e3RmtPd5cw3utrg0SXEeH","bottom6":"_19zBYXg1vyvcKi--v6BsVc","bottom10":"_1ETV6toHwBnzcRttty39K2","bottom16":"L0JkbyD4xchtSxL4OS_wq","bottom25":"_3qgj8ymVeuZwB5sxzj7Rum","bottom38":"_3PUr-0DoB5DFJ6FV8WkmfR","bottom60":"_1Ek7pAG8ABKTtdz-8I3jcz","bottom96":"_1Fushh54fHr5j3qJDv-Xlm","bottom50":"_2eDT8z6CJ0DEA-3izSQbSu","bottom100":"_3j5gQ7-4KKcWAFZPoijSjF","left0":"_2doYfrjcP0xGrYFa_CvITH","left4":"_1gh9Zi6rexLxgo2jcJvtBd","left6":"_3_CJY_qoCuWY1VE8n9qid3","left10":"_1d11OYszcXat8IiKJyY8_E","left16":"qtiQV0ytQvC4815ss8QD1","left25":"_38iOjKGWH453C6Z3c-_l6e","left38":"viWOtbc97nweE_sJLBRaR","left60":"_2eJT4Y1QrzF0D66xT06AOh","left96":"_2omNC3p9k9dyosOn2tpQuC","left50":"_3I853d9j2Rl799G50vtqxW","left100":"_25i4hOJ82FgJ0v54Ew5VDW","absoluteFill":"_15YGwY3qYoi360D2Ih5zKo","tlCenter":"_2vAAhhjpQLJL21_MCEG_kV","tlHCenter":"_3ZFILtFhGSsdHtc0geZ8-z","tlVCenter":"QdA9UWwdQMbwjMKxLIPY4","dn":"_17j995rfWsmQIFGDJQ6XdS","di":"EaROI91t1vPRMOIRfTiEk","db":"_25p8vinkYbRFafxLtWtjU8","dib":"pTuotAhPR3-f0-LVOqBlx","dit":"_3yjp4v6UisybPRTPAcFl_E","dt":"_25-DUscSuAz8KpFy44cOf-","dtc":"_2_iDea9XRJL4Go1PZKSUP6","dtRow":"_2hX0udmOextLQZPbQSXzCC","dtRowGroup":"_3yR0vOFlHTPhqdWbNYJMRv","dtColumn":"_3QODXfcn_JSDVrk2wIt0DY","dtColumnGroup":"X0Tqg8wSjibKtegQr-rLW","dtFixed":"_3blXNR94uBOcBjLfm5y1QT","flex":"_3GuTSrHKwjo6PCyBxYcCcH","inlineFlex":"KwBvZoOjlxgnPOvm9KQzj","flex1":"_3rbVNh-XyLw5nfqfVDnJx_","flexAuto":"_27fVgoi0x7Ye5YsXvxnnID","flexFixed":"_1A5NwlFKNpx74hgHN3jnL7","flexSlide":"_1hOVN7CIQLQdgRwtuxSu4p","flexNone":"_23aJRTTsjVbymXj3EIO_NS","flexColumn":"YHeFsjXY5Bc7hHDVK_drA","flexRow":"_1dvw4W3Pi8mH6OELHUrpj2","flexWrap":"_3md39j-0qcoL921KWobGT2","itemsStart":"ehvqV-ccyehRrgy85DJr7","itemsEnd":"E_ZwMZo3FgBYywy4dUbGb","itemsCenter":"_3ydaqxSyN2UbWoMv-UPSZM","itemsBaseline":"_3AYnfQEFbB2wWZIT6bKSTb","itemsStretch":"_10oQTMBE1xjOCeuEdSg6pp","selfStart":"_8uTvBRUvyxrknbLjsrNnh","selfEnd":"_31hDWl_QUP1CCXTT6as4d6","selfCenter":"_2ctKOLoNC5vEnj66k984SZ","selfBaseline":"_2s7nf9JLmnh-TgGMlss1yI","selfStretch":"_3Z-UQq_4cQnyJixX14wE7k","justifyStart":"_2b1wuzOYM_Qqxd4Bk-up2K","justifyEnd":"M05wVZrYpSfNbf4X3f_AQ","justifyCenter":"ZFjflJkQFo7_PealgUwo2","justifyBetween":"_3Jnm8XUq9GBgVmd4tcjMJP","justifyAround":"_1dK4AMXg3LRH5yNA384Xio","contentStart":"KI_DJ4-f2HrNHlfmL-iJd","contentEnd":"_3AaPhUvxjAo-_FgMLb_6A-","contentCenter":"_2YOt4zSUZL6dPovM0jALrK","contentBetween":"_13Asmx5fg4ZJOu5vvja49G","contentAround":"_2t6PEs1PZBB4jaxS_z03Al","contentStretch":"_2Wc-JcrRXzN0PVNOW_uyVy","order0":"Y42gC5SSDvAobJTQDv4XR","order1":"_3w2h02nn_ywPMrkr4wR9iv","order2":"_2CGlAwKY8i6h-jEBbKSGSU","order3":"_1cRE2wAKtVlIazunFyDOLz","order4":"_2O7kU-2r2YXXJVEb5cjCYZ","order5":"puwwCU_Xka2fcap_IHizl","order6":"_3jGhMspAENAXT0Me-_YZrC","order7":"_1ofEMZRlL2h9j9PaIDVdEh","order8":"_3CAbOvcqJ7TGXQFf3yP0KR","orderLast":"_23pdtJhQLCoCFImkt-R4jH","sansSerif":"_2N9l-k94VywJzM5RlH655","code":"_24dmIHzYCMNRbWVT5TsREj","i":"_1N2u6z1vTBt3LLRcmYa__P","fsNormal":"_2AA-GJIDsP4Iy62dIx59wp","normal":"gogg7bXBqKjzN6FS6JzG-","b":"_1nWu1dmDBwenl9S06y31u3","fw3":"_3xcNz6tSpi-OCTkR3f68pg","fw4":"_2gwpv-keeAS7XidqsHeplu","fw5":"_3v4HErAltpbSn15dBRFDSK","fw6":"_3qeKFHcrvc1gagJ4SdQMCN","uppercaseLabel":"_3xzqYqZb7Rqt6q6z5aM2RI","fw7":"_2mpBymPixd6__-dGMPQ3k6","inputReset":"IQ-Tx8cW3tr9yGDmcRMKW","buttonReset":"rPkH_NAQ7_a1KT9Ve_xsb","h100":"OylKyb9EtT_7WunfrjSao","minH100":"Mx6ayEva5foz0chjrk4SH","vh100":"_2UXkfnaAszhDFkWlXT5rq3","minVh100":"_1gWvEQwpFpSQfiPQKNaJ8-","hAuto":"_1EGbcgSqMuqi0Kw_b1NqzP","hInherit":"_2iAJs6-0mvSlUaXTw5UB2S","mono":"_3sGwyiRyN-hoDVe0Jy1p_8","tracked":"Ic7Sg0exE6bblMV9Ab_0e","lhSolid":"_2W5LXL6YRlTKjYODYnGT6k","lhTitle":"_1p6gKnYvQMNfbIr4TNaiKv","lhCopy":"_3SrpRseGYxRM_cLzX4g90o","link":"_3jckzILLbynTzZMq0uJ_Z_","list":"_287zrnHjtdLjlnK5_Ohsn","mw100":"_2VZBdt53SFy4ToRYmn8QKv","mwNone":"_1sOKa7AXZnvuGpjk55bodj","w10":"Ta_ugO36ARSqJNQey9l18","w20":"_3i5fn6KtJcGDzsTNyOYYHd","w25":"_2jHUsMSkuHzhHd9U1bUKKX","w30":"WTn5lD4CNnAkw6EMEonZi","w40":"K5TCrZCgc9d0CNafLLLm9","w50":"_1xuGsp_FQxBVLO3bPu99GC","w60":"Ia2Au5_R3tJCIxxjAz6dC","w70":"_2lPoDwprfCuML3rQTa1J4y","w75":"_3Nit-T0_Ti1u-igY_iQsUu","w80":"_1vsG0Kd5kGi3aSFDaiix89","w90":"_3rmbBG6WLRdo76O9PjmpbY","w100":"DCxtikbu074qee0UxmgBt","wThird":"egsRFyovoMblOKRZdVd2J","wTwoThirds":"_3UscRmyqaGcl0IQLRvGGJz","wAuto":"_2LDYjQDBJxzWLP6XbXO_wN","hS04":"_2-4CPqwCMJLu-CtNJGrQOE","hS06":"_2Dk7wIWtO7MEUz-4Z3auqD","hS10":"_28vh-KvCFQABPMjenvxFMF","hS12":"_2r-49NIu4NSHS1MYm3EE_X","hS16":"_1c4VMf5feOrnpuEhMWfk7d","hS20":"_2muzpfMdIloyw1AwkP_bqG","hS25":"aJmWctWALQK7yo6H9bNju","hS38":"_2In7Eeril1DlE9jzbNXYp8","hS60":"_2MGeu79E8UdvLi8RQK6FAI","hS96":"uhXCr4YbF83lFmKk4FVDr","wS04":"t_UQMFmO8A5ANEqg8cByH","wS06":"Ll4aMh1kGQ2MLyaqf8aQs","wS10":"_1FMS5bxCeTMWqLDOOhTbF0","wS12":"fLnBWAs_3QCCxKQqolpSQ","wS16":"_6YqlmCoMwSRRp1KpNstgs","wS20":"_2Re784g9DnyJwSu2DrDH7o","wS25":"oLJ136x8Dmr9GTRGbXUjT","wS38":"_36yVs7pMpYZ_SYpu4Igclx","wS60":"_1OForozThDw5EZzfLk0RFx","wS96":"_2R8EnF4xiu5g5EM0xICCIK","overflowVisible":"_26F2Q4DzFNQwIKg3066fpm","overflowHidden":"_195lXLpg18c4zSuVCW0vDN","overflowScroll":"JZwdPEkwR0dHEvlNHogtg","overflowAuto":"_1LIqbZdID-W4ntlHyv_PTL","overflowXVisible":"_1Mn-wlUX9lOr8mijgD4IbM","overflowXHidden":"_2lXofOg-rWdlmxF6drjdlJ","overflowXScroll":"_32mT8XYVnXn7Nh8UX7IHhd","overflowXAuto":"_3Ovu-NEXTWPnxbXfQ5EFmM","overflowYVisible":"_1vAHuwctYKTKljBfN4_Lht","overflowYHidden":"TGdZP2lp9uDChfVWlCTp9","overflowYScroll":"_35zi7_Metv44As_0M2O3RY","overflowYAuto":"iYozZREcEOKb8IV1P43uL","nosb":"_2JjtCckqjucWePpnADbRDR","static":"_3p3DS_VU4jYCdKHvpU1DN5","relative":"_2MPmtfV72o10JZ9ZtlFNC","absolute":"_3AiuHjB7WkaPBh-VbuGEBO","fixed":"RSM_D_U_lsqdd9YyTXmfn","o100":"_2zTFbHvMT8inFjPTugKzOM","o90":"_1OycbEZkbuKVAI54KAh1rx","o80":"_1tPVxp8_94hPbwxyVW6-XN","o70":"_3ptu5RbIkJmseVACTooAwA","o60":"_3Mc97sXRWY2FxZjhmakUsn","o50":"_30h8RdgKnf8SviW0aDlol5","o40":"_2EjpFjF_5zO-8ZsJYVhO3z","o30":"_2qV-LtbNj4f7l9gsoJ0rzt","o20":"_3n6dzou8kwGzEwg3LUTpLg","o10":"_37LmpZ6Y64ABkI9OWHx0GT","o05":"_2fFyryUEsClKmkSaH3YGMP","o025":"_1f2TEHOIgxGVib4ZC-9FRa","o0":"_3hgvzZQ-7T_rPGWqh3ybtJ","black90":"_1cC1H4_Vpx35tV9kF1HQuy","black80":"IdIDBwPvp8Y5Xfx3w2iFx","black70":"_1fGbE3lUWz5Nnv5_CV1CSf","black60":"BbwUmC5EQGgVzTVSffWra","black50":"_3mo0LV4yY0WFRcTp4592T","black40":"_3UTJORqKFNcvsvKfax5N7D","black30":"_3T4eEsqQ5Yi7mFvTFNHkFa","black20":"_2z7CAPUunvizkgW9ra0V7l","black10":"_3vVSOkTEWMUSR8g9Yo7KvJ","lightOrange":"_1RqT4-1sHu28zLTqegnWmU","lightOrange20":"_1srcIva_GDs-ud0sZlRufy","white90":"_9wvkkGW2gz6KceqMGPdD","white80":"vVYH9vB4Pc7I05DTUDQSh","white70":"_24hO5Lk23jVl4AsGYLyByn","white60":"_3vrEDl_yv6I_427bxSCSQ9","white50":"_1tmPhG4vuMMToJ3LiYLfYD","white40":"_3qDncVwGrNHYj6gjSNYusy","white30":"_2Lyea5wAZCju8yPkZgfNXV","white20":"_2rajtQH24rII3oHgpCXCAu","white10":"MkAe9a1ek5Z0k-QSZWlX2","white":"_2RAbAmlD34SzkA4T_IL1Cz","black":"_3KuhvM99A3svAL-DLJRmFU","blue":"_1QcnP4H2rX7dfY6oldZygq","blue20":"_3DgeDVe-mKYWkdv1liNruw","blue50":"_3jEelmilt6iMl6o5zlUgsR","purple":"shJV-hLY33NEK6bCbwflD","lightBlue":"_15FMuV2ijarE0S4MIBnHeq","darkBlue":"_3k_eiwG_vmNf9VIRLDtAL6","darkBlue90":"_2_wfYlhyXZItHiKwa4uiGB","darkBlue80":"_3IJBnFlRDLQrvL9ezYj4b3","darkBlue70":"_1fleMeZ-x8zKiocrC9LRgQ","darkBlue60":"_1g8iGfDT28_m7UOacTy2uD","darkBlue50":"_2PzUkrZ7r2uIfq-IShlvVd","darkBlue40":"YRmEmv0KT3RxWe1ckTzCM","darkBlue30":"_37MmawOGiojiUTo9GehCB5","darkBlue20":"_1z6ScVl6BTOk2dRgwhj6aJ","darkBlue10":"_2o_WhyUaiQJ2Q1Jm1gNWJ2","pink":"_1E5V9K7RKqLqXsJpLR89IK","pink90":"zdaaJVl0KlmmBTgI_ADwE","pink80":"_1hkX1LShnugZTJ-05c5ufa","pink70":"_324uVhha7lXfmnSbWP8M_F","pink60":"_17obkhVjelEFP_1jvNCDDS","pink50":"_1LxdLs78khHt9uALDVEtxh","pink40":"_3fuMAuswxwyDUgpwgnBCga","pink30":"_1hkclN1Pm6oRtiS0c1ccq_","pink20":"_28tPMGbqWWxVLiwtFsepGH","pink10":"-EIyd-gdF7GGpIW7iauR9","darkerBlue":"_3XCxks2tocccGJCwft9FyI","darkerBlue50":"_19sBTQeR30Q1dbbhOxjOPr","orange":"_2EXaTsruJEyXCmQRi3oKEV","red":"_3Oy5w5DIgniXBLrTPYxtVg","green":"_1nWVMizzjfLgBKTaZJDlOW","green30":"_3vCFrFEvtBLK_mMd2uKuNQ","green50":"_2EPoE_GOK3MVrd-_KJPs4Z","lightgreen05":"_32YxtMdQspz0CvIjLC6slt","lightgreen10":"jf6PLcfzAf5DocaP5lHnY","lightgreen20":"_1NEvXlXeRFru5PDuIJ14cf","lightgreen30":"_18UTrg2DgZ94N_bm7wTysa","lightgreen50":"_1d8r-5X2GMc3ksb65Xv6Z_","bgTransparent":"_2_8k6-_OX4CgJ1PXbkj8JU","bgNone":"_2OmdhsT7rSBzjKH_ZZicYW","bgBlack90":"_1iIr8aZgdLh_VrdG9udiuj","bgBlack80":"_2A-ps7Q3vgnmG0u23LHbqP","bgBlack70":"_1qx_eYuXMSPs1BoDZDzjsO","bgBlack60":"_3lgIGnAohPSMelCYGZ2L-E","bgBlack50":"_2DvgSo20cvFKmS3K1DW7Ty","bgBlack40":"_3gcNm1AKvbTeA8iAnnO-vW","bgBlack30":"_3OxIQjtKpHFO9-7Xt1ro4b","bgBlack20":"_11v6cG3UEMqSC5TCTWJEho","bgBlack10":"_1XqsFqsWtIAMACv7AjPSQV","bgBlack07":"_2c1JGswLy0HZSX-DYiq1TL","bgBlack04":"_3htb7-LNONfROwm4aLqe_p","bgBlack02":"_1h0KdHPNntttN21yoVTUM3","bgWhite90":"_1_-VAw4MOE8hZWO2jciQ7A","bgWhite80":"zqrS-G5U4_gNg24uJoht8","bgWhite70":"_81gHVI9gbqtnlhfD34d7x","bgWhite60":"_2bYotXBCDRWN-GLFNOV5yn","bgWhite50":"_1LQ0-PwDSMN27qff3VkRLE","bgWhite40":"_2g0QcWClos0u8Lw9LCPGGD","bgWhite30":"_17NygAoRWXOKQwithS1GS","bgWhite20":"_23oMnTS5UhJfGSgFmhapxd","bgWhite10":"_38ptatkjQmJD5lf_ovEPdB","bgWhite07":"_3kX7fu4YSXDx_6YXuFSTsL","bgWhite04":"_25AI2jNylMeRE_oMFbSnXD","bgBlack":"pYxyhzdblPmnW63lW-zNv","bgWhite":"jXjgZVejWnkDu_mIskk7b","bgBlue":"_2xuOMoVxb3M7CJKyKjL82Z","bgBlue20":"_1yfSNUdpmqwDNNYJk_iDx","bgBlue10":"_7U9H1WOR2_7_qNK0q0I74","bgBlue50":"_1RSNfyMRAYViWzHxSgpt3y","bgDarkBlue":"_1ryqHUyg5xol3TJdMo6oAb","bgDarkBlue90":"_1OKl7QcR5MLrF6QVzlkeiZ","bgDarkBlue80":"HSf6HCTevbRAFaEP4_jIy","bgDarkBlue70":"_1nn8elgKMUlNbXkG0N1Jre","bgDarkBlue60":"_27ATHJ2gsudymGd-hv3QU0","bgDarkBlue50":"_3Mu3_n47hMIUbzXDidnspp","bgDarkBlue40":"_2GFqU91BulJgs7EqQB27vL","bgDarkBlue30":"_23UzPzt0c6JPVld5lnXQzm","bgDarkBlue20":"_1RCJmVnw91f9iMzKiO2Orv","bgDarkBlue10":"e2Knw789cxkmRF1Vvzobf","bgDarkBlue07":"_2yBt4B5YD8bD3f32-dFlML","bgDarkBlue04":"tSbPFPmyOGhjbiqVx3i_x","bgPink":"_1b6YniJPVm_nDgx0YO738_","bgPink90":"aMj-PWo1u1XNsaIhP5lDK","bgPink80":"_1od7uffhyqr77PfRZWgpIF","bgPink70":"O71HUSkmQ2c2xIF4UHi4I","bgPink60":"_3efVmgBvoAt_IM19mZ-OZC","bgPink50":"_3kwfsCnhTuKwrYLB7fuc5t","bgPink40":"gtFti2MtW2Ke68rf8oDJd","bgPink30":"_1x1-C_E1aey85cgZgQzlkV","bgPink20":"_16dhXDdk51ar_Vkknbkqxa","bgPink10":"_2G9M7_I7Ml1uKhUHbuFIYu","bgDarkerBlue":"JCU2gRVLDnH974D1KyPYg","bgDarkestBlue":"_2oRFVjKJLlaJLPRuPaB0t2","bgOrange":"_2mFrWqdpqCtGS5EwmFiMEz","bgRed":"_1fSImSwwq49X9WdEvt3jDY","bgRed10":"_2M8a6d52x6lf1srv_Tg1S_","bgrRed":"_2RqXND-XVHHCLDARzRfayO","bgLightOrange":"_1_H0sjHwuVadcmEAzoU0eB","bgLightOrange10":"_3QRdHS8qmvg_B-enxWcIal","bgLightOrange20":"_3J4DvkagP7p_BHWnq6dwth","bgLightOrange30":"_1K7YSYc0NrZGYeGhoEOErn","bgDarkBlueGray":"nC8Q3CpJ4tgG4FogJHcy_","bgGreen":"_33YBYNfdicj12JzO5V3M__","bgGreen10":"Goe5EQx5Ovf2JEhAcOPK4","bgGreen20":"_6lO9ivDcXQO0Fu8W7ULHl","bgGreen30":"_31V54FQcm3Ji7APEAu3GBv","bgGreen40":"_1vsQgtcmCQxfVImYOiHevD","bgGreen50":"_3wCo-HdE9_hLuFaSPALz6D","bgGreen60":"wnUcMlOcrUof2IWDHNNLq","bgGreen70":"Qp8uEvaIK3oAYyhq4H_qs","bgGreen80":"_1Pbon5GcPd3oc9JFPTpcht","bgGreen90":"U5YCVF8OYkqAd2uSY6wAP","bgLightergreen":"_30GbpK6ptCoouxDTuMKMxT","bgLightgreen05":"CUGfi9CAqI1_RiOUZVj8Y","bgLightgreen10":"-PgYKnmWt9Bmadrtphobp","bgLightgreen20":"XE9Gd8kAgdxLudnjAI1HW","bgLightgreen30":"DwZE52tUdkoiAGFoYYHu2","bgLightgreen50":"_2CiV2Mca9EfHCPsngGkC9c","brown":"_2RfjhAC8ROCsZSG_TY2Voi","bgPblue20":"_3lRjGhp2jr50-VKtP2LjnA","bgPred20":"_2q4xzL3cAp2qhf284wv8gg","bgPyellow40":"_3pA9wvWx_5-Svl4Q3vkNWH","bgPlightgreen50":"_3SR54v4Pw6fK9asY7LWNjh","bgLightGray":"_1FZViqH2Wg_4yjSN0mEV2h","bgPurple":"_1XhVTap00yOKZOGTVUIBU","bgPurple20":"_3RsN6SO2Y4b4glK8lEL4Oi","pa0":"_2KZfQJCx1Oy38jGqsT4Y3N","pa4":"_160fTBlQ4g19DmCHbzpU3S","pa6":"_1AcvKYLZN_12kFAb9SfGIH","pa10":"_1lykGxX323FWUdTrnL5gUE","pa12":"VcRICSLUYhivGHBubhoSz","pa16":"_1xJEpXETb_gBsgwtijtrpp","pa20":"_1InhotFK2UYVLEhpJZCZHE","pa25":"_1jHpNGE0pSknzcw6Dknm4b","pa38":"X8QGQuylbgbUfghZL8hli","pa60":"_3GMw5L6NHvySMQN1DtHDWR","pa96":"_12t4k36183K-00JTpOspTl","ph0":"rg6kRR6lzXP2P6U3t2SfE","ph4":"_3b9zbmUQgouoNzkjnOep8E","ph6":"_1ghU_tqdBD233Mv2kBvqg_","ph10":"_355Xh3fWTg8J69fNjrAsUz","ph12":"_7dupTi4DuxMO8dASlADQG","ph16":"eodgZyhKBhrxfPozUQOBg","ph20":"_1MgsPU58mWJMPhnCT4wDKs","ph25":"eJfVXnHy_PScngY9-U-77","ph38":"_1AIc6bIEULBNHqf8XKSpgZ","ph60":"_1k41OtONoQ-o799KrXuR5Y","ph96":"_3AOBqJX4bEHBEszGpfeGe7","pv0":"_1iHEJvnkjPusyrtvTT8C7e","pv4":"_2aZQ49KBaXL6_oQiN98B4j","pv6":"_3FO6jhB76-ABA7ALGQy6z2","pv8":"ADpMYPlNSHWadKnI2hVJk","pv10":"_1xiRngciIazZO0weMu4jmp","pv12":"_2n32P1b9gyYWK9qdEO7_CI","pv16":"HPpbzpN51W-eB8avunzB6","pv20":"_6ygES_vmwJESLUjS_uAtw","pv25":"_2YY8GCkQYyHvlAqARVTxMH","pv38":"_27Z40BqvBihLkLj3Lb-88M","pv60":"_3Wks68yhXtYyG0-X_SXFiJ","pv96":"_1dh4NijCa943zgpt5hf8eA","pl0":"_14qLJw-4-N5wQpCAy1U0qF","pl4":"_1uQRbV3IlDXo_umie5z0b-","pl6":"_95va4-tHwIlUgXxZNvLew","pl10":"_3q9ouFL8-2aOeu09rIMLPe","pl12":"L4A7UK7mYq5Y1HowUv5Y4","pl16":"_1rvKxjz5Z7su4t1gLt91cU","pl25":"_25Usf6OgQars-HhiwH6p-l","pl38":"_XqHhjpA6VV9Tj8j9oywI","pl60":"_2TUa2Mv87v778MtYIGDBD7","pl96":"_2OThI_iDUXxKxF2QAxigmi","pr0":"nJLoW1tI-_3zWndW1gOV-","pr4":"_--WGP7zYyTXioy73z1dCg","pr6":"_3mgWknTer1yWklkYiGWjh5","pr10":"_6ioXSzid5U46myOWACV6U","pr12":"_3CrTrDKVlLKvUnr0-Toosp","pr16":"_2VzxDHXWsHByZ39IvbtP8m","pr20":"POmqgGP7ylMs0hRXLtRSe","pr25":"_3Xt1l7v76hIoTve8PBkDIF","pr38":"_1lnJMlA75hJXw-jQjEfG0Z","pr60":"eXQ99XyPrPxRD0Fq36xnX","pr96":"_37gK5eWqpYZR5ZJ573B1Un","pt0":"_9g7bUKJOWsbYSEt2dlLyd","pt4":"_3YQb9Oc-j3e_aJxsakGTrA","pt6":"_31-KXui9v6V31W-uZH7xV4","pt10":"_3ARWB_ZV2fpRnFPlYWCCQJ","pt12":"_2vq6kdsymJ6ye-DaLWUV2O","pt16":"_22wEqO5V-BXXuEl6PmRd7V","pt20":"_135tO8hQEgb8S6-BHPJd_8","pt25":"_3QvvSWc_20mXZiKHEZUc7j","pt38":"_23ThnGFgoT7g4-02lNtclH","pt60":"_2Ee369uKrPw1yVsXzwSbyM","pt96":"_2lRgKHOgcw5mWmFxhwxI3n","pb0":"N__g8FDrdykNbox71EhTa","pb4":"_39vN1j2p5Baq_JXVRQvKoe","pb6":"_3s3H_dkrl4hIvStpX9F9KM","pb10":"_2sz0sMFMFPvCEOz1-VJq5Y","pb12":"_3lSd5hu5XLekSZS3ZhGS_1","pb16":"_12DAHmrDHqQ0Im-k_ETwqw","pb20":"_13JU4cXUJUrvN-aBuD1zAI","pb25":"_3sZiNUSlWx4b9oPBA7tHcW","pb38":"_1CnMa2Cp48Toy03pIy9gPw","pb60":"_32Kux4qKW_8c7lcsHbx3qT","pb96":"_3SVVQ_uV-DN9usguh3D2Of","ma0":"_7VmKzs0FhXzCyvHd3-QeS","ma4":"WAnc8DhAW_--P87J0vs-j","ma6":"_71U-FZ0OVRr4G2zgDX24O","ma10":"_3KgKmJXEc6gNt1_AYpwf7h","ma12":"_3iAmpsYXLEC3CzlmerlbtO","ma16":"_1Z1958DegXFvWjsO6LE1SA","ma20":"S7BqMiJfKwSf69DkpX5tn","ma25":"_31sI2n0ChHUZcOHhC13y5W","ma38":"_3wsLmXr1AgY4SERSJeSukJ","ma60":"Y17vMljujVZOKuGvNY6XF","ma96":"D0Eow3uhie_aAkfZBybdZ","maAuto":"_1mYge8FU1Fh1ls3ZN5_E6e","mh0":"_12nR5sAapNbgvzf1u53ma5","mh4":"O14pQb32SQXc1j96SPHB3","mh6":"_1lgC6fOaMm6waQdHxF_bsC","mh10":"_2wtpKXArT76HLNIWYe-5vq","mh12":"_27muAXTa-wVPyZA6w8uwDc","mh16":"_3GH6ob27JQ9RJu0s-K1DF3","mh20":"_19GHm3n4VoV9j5q0fyg7jx","mh25":"_1Jkw0bRUU6XanlqA-b2xht","mh38":"_3GJnFIrccFegkEUJhfDEZQ","mh60":"R-WelXMzyC9bKlRZTfdd-","mh96":"_2BAkJ-3_dW36pglpqgWKlg","mhAuto":"_3rrCrTpyUSbOnKmiqOgfH7","mv0":"YXcPCVNmP3kvvbzVpeCBC","mv4":"_3zNKc2FFoBz6l1girFFKL_","mv6":"_1ZZN2q5ejbTH2m6CKwfa3W","mv10":"_3e6uyEIA57JZE2mNoMH2at","mv12":"_1DsJjMSOUeOdaydkktHww_","mv16":"_1AJurG9zYXP0Vy1apYtEOK","mv20":"_3-Fyb4f2rAjBHDgUWzYpJc","mv25":"_2d2yK4mC4RBOHMref3nGPe","mv38":"_22o23SlOvaat1aHZCCtHes","mv60":"PbjZPvifQf0dX_Xw2Uhcz","mv96":"_3dxes1JMSzP7urlxGn0iKA","mvAuto":"_1H-lNEozTha4B1ezQiWkVz","mla":"_1l1Ukd3LB1GBAEHr3HHLxz","ml0":"_3UOf69eJEFA4bmgW0wuE5-","ml4":"_2r3PQjwufvHzcBVHK5Uv0u","ml6":"HZiGwEyROIzLYG2bCRd7u","ml10":"_2cJax2du0xR51Djr3vJazW","ml12":"_16JQez-7BdJ6EqxFmobyT","ml16":"_2lStyLB4sanpsAIulEM77X","ml20":"_1hCpxzNFKOR7vbY-QsJpKy","ml25":"_3Q4tR99B4yc76O3qj5aXQ1","ml38":"_3j4c4awh7JeWr-FjwgmNxn","ml60":"_3Phv7uVCUrN4aj8j1_v0IB","ml96":"R-1CkynyrOldUfVfsM3CS","mlAuto":"_2VyGMpClTUwH8u-up_LOMW","mra":"_2E4w1Z5DgDSbq4qhiL2B6j","mr0":"_20doAWxOwyNXf-rbIT6pUb","mr4":"_1GSC8Swyes_9uZ_Iw0Sv91","mr6":"_3mMi3YoF5_ieM6PbrSVhia","mr10":"_1ExomcTiXRhI2LBQLtmyt9","mr12":"_1ObnQqkVxoTa3PQONL2Gn","mr16":"_3Ca_IsiXTXZ6MrpYrfBjDc","mr20":"_3FRBJs0_FJmZ0rKOVwvaAL","mr25":"_2mtdW5smdD8n9HKUwnOal9","mr38":"_3GcWBw3XSjlucaSAxuEj6H","mr60":"_3HQeghaYFc9HLFcNOyIWn7","mr96":"o8aI72dqdAFBedOhpy3dP","mrAuto":"_3CKlTpxZgBFK_8VJvHJoJV","mt0":"_1-YeVRe7bdPLY3l2j6R2J3","mt4":"_18AxGSUvuPwlsH6ZzhI0Gj","mt6":"_3i6WR0RjHRSJYA_3bIpmBL","mt10":"GWuIrh52uKgYAZuNs3nNl","mt12":"_2qWM8HwBtOgRSvM-R4C9Sl","mt16":"_1gPVz5Eodnj9s6mP0dLF2x","mt20":"CY2oB6GXdHK3U7gw7NQEz","mt25":"_1KOJb7VROwdD7EWnGH6QA4","mt38":"QaSO8O1mCCtDVmFRRHX01","mt60":"_62CwOFd0yLIMqNPPWeR92","mt96":"_2IDnu9G426xulZoeBQnX-N","mtAuto":"_13relwbukBRl3OV5LqFDec","mb0":"_3KUhzXaENgo0OCO6FcM9A","mb4":"_3MAA_Ou3XwOdWEppEGIQ2y","mb6":"uUoB9fQYQKyHFAGGY16d-","mb10":"_1vf6x8FS4EV_L5fB-o3gbz","mb12":"_340djYt9WGHRi_UWIr_p9a","mb16":"_20fgfDStauKxLk4W9OentS","mb20":"_1Rbp_VfhLlmZIttTmc3KoB","mb25":"_6LvySfBVvQxZ1_wMarRRh","mb38":"_2vfeNTvBi3o9N35aDACw91","mb60":"hevD7SrN2aLTc9SRdpFeS","mb96":"qUVbEqs6MbY-IMeFe1shz","mbAuto":"_14BLbbS9URQhMnKUT7XqvE","f12":"iB1ZWL5j1eebbLlbcyk74","f14":"_1Pmgu6zLdFnW_74uAElK-J","f10":"_1Nr3H3soG1OP-fHX7xrG4y","f16":"_14ZM9JMdcBdFPrCxPDFwfV","f20":"_4FSi4SNPVf2IIrzcQMA1y","f25":"_26mOMITWugXXrMZsA6v99Y","f32":"KCpdCRxNrPknA8sf_qnwE","f38":"_1f-eZYmUEem6rQKUH1j2k9","f60":"_32ucsH7zJL3S3PBg6QGlrg","f96":"_1-GL_hfp99ZancD2UvHHed","fInherit":"_3_UTpYe-psvWug_8xfCIM5","hf32":"_2zhphYn4gPEfx0hbqpNCTZ","hf30":"_3xmTZQGc-Z9sjVE-lCE0F5","hf20":"_2zVlpRORV7g5vwpTMxezYR","strike":"BRjhTl5yCcX55j8KAfJvm","underline":"l5sMEcypSs-rKW8EJfsA_","noUnderline":"_2THEsNrmDDuGaVfNPMSarg","tl":"_3JlVhLfsVaQjFfzR4wOe9n","tr":"_1QdsG6OKLiBTPyi9ycQn3P","tc":"_1jC0RpjdtCvk4Is2IpaMh4","toe":"s8EkHPoDKt-sP320Z_kQA","ttc":"esCoD43zOovplrskfzsIa","ttl":"_9kabcoRPfLOJHXzaGObvJ","ttu":"_2ITS4bK2-ZTGdrOaT4N-io","ttn":"m4bG4tQuRIjDikm_fGhDA","center":"_20spl01gdmozXB9-nX025","clip":"ToVcG9-VrF-A6mi_66hCt","wsNormal":"Xz3ZJvON_2TDoxKGygOyt","nowrap":"_3VZZw63ewT5CxG4NVE83Wx","vBase":"_236aVAjCQ2qJdYZt8FGHFd","vMid":"_1CVaXnkHiqBgIU6pA_dzOK","vTop":"_1ZA5CHMldnXZJKue18oJDl","vBtm":"RC_yARy2cIyGKeHyICwaW","dim":"_1A1j0GNaPlZdaCMd36HlhE","noEvents":"sRfRA42nFRJbmvfbfJoov","pointer":"_3cNa21YDMaaqifnbPN8el9","cursorDefault":"_1hrmg-n8ITDUTFj--WxY8U","z0":"_5m-YHSoE5XdwbOPu_bpSs","z1":"sbXGwEFx0CJRMjW-vUVRR","z2":"_3ngljXlEGD6QK6qZnoCYgO","z3":"_31CAQeRL_mJpKdzHmpSjQ5","z4":"_2D_p-FIhTQL1SVW7ipb3CQ","z5":"qOa8jLrksAlQdrSQPN11j","z999":"_21Hz-Zro7PQ2S6V7REbk5G","z9999":"_33NXQTV3AtgCkVNDypDFRi","zMax":"_3rb7j06Kw8TrFw1dklM8zV","zInherit":"_3daj5cFjnJMCxc__MRowzc","zInitial":"D6naKn339rCH8RL3izHag","zUnset":"_2QpM2rV9luOmaWzQ_tE3lG","debug":"_3IUyoJh6ZDGNgwVGXZuxHn","debugWhite":"_28d_GhanlFQnjeGd1JLSjb","debugBlack":"_3JosabSPe0bQPrsiBv_OBo"};
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	module.exports = {"cover":"cover","contain":"contain","bbox":"bbox","cbox":"cbox","bgCenter":"bgCenter","bgTop":"bgTop","bgRight":"bgRight","bgBottom":"bgBottom","bgLeft":"bgLeft","outline0":"outline0","ba":"ba","bt":"bt","br":"br","bb":"bb","bl":"bl","bn":"bn","bWhite":"bWhite","bWhite90":"bWhite90","bWhite80":"bWhite80","bWhite70":"bWhite70","bWhite60":"bWhite60","bWhite50":"bWhite50","bWhite40":"bWhite40","bWhite30":"bWhite30","bWhite20":"bWhite20","bWhite10":"bWhite10","bWhite05":"bWhite05","bBlack":"bBlack","bBlack90":"bBlack90","bBlack80":"bBlack80","bBlack70":"bBlack70","bBlack60":"bBlack60","bBlack50":"bBlack50","bBlack40":"bBlack40","bBlack30":"bBlack30","bBlack20":"bBlack20","bBlack10":"bBlack10","bBlack05":"bBlack05","bGreen":"bGreen","bGreen50":"bGreen50","bBlue":"bBlue","bDarkBlue":"bDarkBlue","bDarkBlue90":"bDarkBlue90","bDarkBlue80":"bDarkBlue80","bDarkBlue70":"bDarkBlue70","bDarkBlue60":"bDarkBlue60","bDarkBlue50":"bDarkBlue50","bDarkBlue40":"bDarkBlue40","bDarkBlue30":"bDarkBlue30","bDarkBlue20":"bDarkBlue20","bDarkBlue10":"bDarkBlue10","bDarkBlue06":"bDarkBlue06","bDarkBlue05":"bDarkBlue05","bDarkerBlue":"bDarkerBlue","bRed":"bRed","bRed10":"bRed10","bRed20":"bRed20","bRed30":"bRed30","bLightOrange":"bLightOrange","bLightOrange10":"bLightOrange10","bLightOrange20":"bLightOrange20","bLightOrange30":"bLightOrange30","br0":"br0","br1":"br1","br2":"br2","br100":"br100","brPill":"brPill","brBottom":"brBottom","brTop":"brTop","brRight":"brRight","brLeft":"brLeft","bDotted":"bDotted","bDashed":"bDashed","bSolid":"bSolid","bNone":"bNone","bw0":"bw0","bw1":"bw1","bw2":"bw2","bt0":"bt0","bb0":"bb0","bl0":"bl0","buttonShadow":"buttonShadow","overlayShadow":"overlayShadow","pre":"pre","top0":"top0","top4":"top4","top6":"top6","top10":"top10","top16":"top16","top25":"top25","top38":"top38","top60":"top60","top96":"top96","top50":"top50","top100":"top100","right0":"right0","right4":"right4","right6":"right6","right10":"right10","right16":"right16","right25":"right25","right38":"right38","right60":"right60","right96":"right96","right50":"right50","right100":"right100","bottom0":"bottom0","bottom4":"bottom4","bottom6":"bottom6","bottom10":"bottom10","bottom16":"bottom16","bottom25":"bottom25","bottom38":"bottom38","bottom60":"bottom60","bottom96":"bottom96","bottom50":"bottom50","bottom100":"bottom100","left0":"left0","left4":"left4","left6":"left6","left10":"left10","left16":"left16","left25":"left25","left38":"left38","left60":"left60","left96":"left96","left50":"left50","left100":"left100","absoluteFill":"absoluteFill","tlCenter":"tlCenter","tlHCenter":"tlHCenter","tlVCenter":"tlVCenter","dn":"dn","di":"di","db":"db","dib":"dib","dit":"dit","dt":"dt","dtc":"dtc","dtRow":"dtRow","dtRowGroup":"dtRowGroup","dtColumn":"dtColumn","dtColumnGroup":"dtColumnGroup","dtFixed":"dtFixed","flex":"flex","inlineFlex":"inlineFlex","flex1":"flex1","flexAuto":"flexAuto","flexFixed":"flexFixed","flexSlide":"flexSlide","flexNone":"flexNone","flexColumn":"flexColumn","flexRow":"flexRow","flexWrap":"flexWrap","itemsStart":"itemsStart","itemsEnd":"itemsEnd","itemsCenter":"itemsCenter","itemsBaseline":"itemsBaseline","itemsStretch":"itemsStretch","selfStart":"selfStart","selfEnd":"selfEnd","selfCenter":"selfCenter","selfBaseline":"selfBaseline","selfStretch":"selfStretch","justifyStart":"justifyStart","justifyEnd":"justifyEnd","justifyCenter":"justifyCenter","justifyBetween":"justifyBetween","justifyAround":"justifyAround","contentStart":"contentStart","contentEnd":"contentEnd","contentCenter":"contentCenter","contentBetween":"contentBetween","contentAround":"contentAround","contentStretch":"contentStretch","order0":"order0","order1":"order1","order2":"order2","order3":"order3","order4":"order4","order5":"order5","order6":"order6","order7":"order7","order8":"order8","orderLast":"orderLast","sansSerif":"sansSerif","code":"code","i":"i","fsNormal":"fsNormal","normal":"normal","b":"b","fw3":"fw3","fw4":"fw4","fw5":"fw5","fw6":"fw6","fw7":"fw7","inputReset":"inputReset","buttonReset":"buttonReset","h100":"h100","minH100":"minH100","vh100":"vh100","minVh100":"minVh100","hAuto":"hAuto","hInherit":"hInherit","mono":"mono","tracked":"tracked","lhSolid":"lhSolid","lhTitle":"lhTitle","lhCopy":"lhCopy","link":"link","list":"list","mw100":"mw100","mwNone":"mwNone","w10":"w10","w20":"w20","w25":"w25","w30":"w30","w40":"w40","w50":"w50","w60":"w60","w70":"w70","w75":"w75","w80":"w80","w90":"w90","w100":"w100","wThird":"wThird","wTwoThirds":"wTwoThirds","wAuto":"wAuto","hS04":"hS04","hS06":"hS06","hS10":"hS10","hS12":"hS12","hS16":"hS16","hS20":"hS20","hS25":"hS25","hS38":"hS38","hS60":"hS60","hS96":"hS96","wS04":"wS04","wS06":"wS06","wS10":"wS10","wS12":"wS12","wS16":"wS16","wS20":"wS20","wS25":"wS25","wS38":"wS38","wS60":"wS60","wS96":"wS96","overflowVisible":"overflowVisible","overflowHidden":"overflowHidden","overflowScroll":"overflowScroll","overflowAuto":"overflowAuto","overflowXVisible":"overflowXVisible","overflowXHidden":"overflowXHidden","overflowXScroll":"overflowXScroll","overflowXAuto":"overflowXAuto","overflowYVisible":"overflowYVisible","overflowYHidden":"overflowYHidden","overflowYScroll":"overflowYScroll","overflowYAuto":"overflowYAuto","nosb":"nosb","static":"static","relative":"relative","absolute":"absolute","fixed":"fixed","o100":"o100","o90":"o90","o80":"o80","o70":"o70","o60":"o60","o50":"o50","o40":"o40","o30":"o30","o20":"o20","o10":"o10","o05":"o05","o025":"o025","o0":"o0","black90":"black90","black80":"black80","black70":"black70","black60":"black60","black50":"black50","black40":"black40","black30":"black30","black20":"black20","black10":"black10","lightOrange":"lightOrange","lightOrange20":"lightOrange20","white90":"white90","white80":"white80","white70":"white70","white60":"white60","white50":"white50","white40":"white40","white30":"white30","white20":"white20","white10":"white10","white":"white","black":"black","blue":"blue","blue20":"blue20","blue50":"blue50","purple":"purple","lightBlue":"lightBlue","darkBlue":"darkBlue","darkBlue90":"darkBlue90","darkBlue80":"darkBlue80","darkBlue70":"darkBlue70","darkBlue60":"darkBlue60","darkBlue50":"darkBlue50","darkBlue40":"darkBlue40","darkBlue30":"darkBlue30","darkBlue20":"darkBlue20","darkBlue10":"darkBlue10","pink":"pink","pink90":"pink90","pink80":"pink80","pink70":"pink70","pink60":"pink60","pink50":"pink50","pink40":"pink40","pink30":"pink30","pink20":"pink20","pink10":"pink10","darkerBlue":"darkerBlue","darkerBlue50":"darkerBlue50","orange":"orange","red":"red","green":"green","green30":"green30","green50":"green50","lightgreen05":"lightgreen05","lightgreen10":"lightgreen10","lightgreen20":"lightgreen20","lightgreen30":"lightgreen30","lightgreen50":"lightgreen50","bgTransparent":"bgTransparent","bgNone":"bgNone","bgBlack90":"bgBlack90","bgBlack80":"bgBlack80","bgBlack70":"bgBlack70","bgBlack60":"bgBlack60","bgBlack50":"bgBlack50","bgBlack40":"bgBlack40","bgBlack30":"bgBlack30","bgBlack20":"bgBlack20","bgBlack10":"bgBlack10","bgBlack07":"bgBlack07","bgBlack04":"bgBlack04","bgBlack02":"bgBlack02","bgWhite90":"bgWhite90","bgWhite80":"bgWhite80","bgWhite70":"bgWhite70","bgWhite60":"bgWhite60","bgWhite50":"bgWhite50","bgWhite40":"bgWhite40","bgWhite30":"bgWhite30","bgWhite20":"bgWhite20","bgWhite10":"bgWhite10","bgWhite07":"bgWhite07","bgWhite04":"bgWhite04","bgBlack":"bgBlack","bgWhite":"bgWhite","bgBlue":"bgBlue","bgBlue20":"bgBlue20","bgBlue10":"bgBlue10","bgBlue50":"bgBlue50","bgDarkBlue":"bgDarkBlue","bgDarkBlue90":"bgDarkBlue90","bgDarkBlue80":"bgDarkBlue80","bgDarkBlue70":"bgDarkBlue70","bgDarkBlue60":"bgDarkBlue60","bgDarkBlue50":"bgDarkBlue50","bgDarkBlue40":"bgDarkBlue40","bgDarkBlue30":"bgDarkBlue30","bgDarkBlue20":"bgDarkBlue20","bgDarkBlue10":"bgDarkBlue10","bgDarkBlue07":"bgDarkBlue07","bgDarkBlue04":"bgDarkBlue04","bgPink":"bgPink","bgPink90":"bgPink90","bgPink80":"bgPink80","bgPink70":"bgPink70","bgPink60":"bgPink60","bgPink50":"bgPink50","bgPink40":"bgPink40","bgPink30":"bgPink30","bgPink20":"bgPink20","bgPink10":"bgPink10","bgDarkerBlue":"bgDarkerBlue","bgDarkestBlue":"bgDarkestBlue","bgOrange":"bgOrange","bgRed":"bgRed","bgRed10":"bgRed10","bgrRed":"bgrRed","bgLightOrange":"bgLightOrange","bgLightOrange10":"bgLightOrange10","bgLightOrange20":"bgLightOrange20","bgLightOrange30":"bgLightOrange30","bgDarkBlueGray":"bgDarkBlueGray","bgGreen":"bgGreen","bgGreen10":"bgGreen10","bgGreen20":"bgGreen20","bgGreen30":"bgGreen30","bgGreen40":"bgGreen40","bgGreen50":"bgGreen50","bgGreen60":"bgGreen60","bgGreen70":"bgGreen70","bgGreen80":"bgGreen80","bgGreen90":"bgGreen90","bgLightergreen":"bgLightergreen","bgLightgreen05":"bgLightgreen05","bgLightgreen10":"bgLightgreen10","bgLightgreen20":"bgLightgreen20","bgLightgreen30":"bgLightgreen30","bgLightgreen50":"bgLightgreen50","brown":"brown","bgPblue20":"bgPblue20","bgPred20":"bgPred20","bgPyellow40":"bgPyellow40","bgPlightgreen50":"bgPlightgreen50","bgLightGray":"bgLightGray","bgPurple":"bgPurple","bgPurple20":"bgPurple20","pa0":"pa0","pa4":"pa4","pa6":"pa6","pa10":"pa10","pa12":"pa12","pa16":"pa16","pa20":"pa20","pa25":"pa25","pa38":"pa38","pa60":"pa60","pa96":"pa96","ph0":"ph0","ph4":"ph4","ph6":"ph6","ph10":"ph10","ph12":"ph12","ph16":"ph16","ph20":"ph20","ph25":"ph25","ph38":"ph38","ph60":"ph60","ph96":"ph96","pv0":"pv0","pv4":"pv4","pv6":"pv6","pv8":"pv8","pv10":"pv10","pv12":"pv12","pv16":"pv16","pv20":"pv20","pv25":"pv25","pv38":"pv38","pv60":"pv60","pv96":"pv96","pl0":"pl0","pl4":"pl4","pl6":"pl6","pl10":"pl10","pl12":"pl12","pl16":"pl16","pl25":"pl25","pl38":"pl38","pl60":"pl60","pl96":"pl96","pr0":"pr0","pr4":"pr4","pr6":"pr6","pr10":"pr10","pr12":"pr12","pr16":"pr16","pr20":"pr20","pr25":"pr25","pr38":"pr38","pr60":"pr60","pr96":"pr96","pt0":"pt0","pt4":"pt4","pt6":"pt6","pt10":"pt10","pt12":"pt12","pt16":"pt16","pt20":"pt20","pt25":"pt25","pt38":"pt38","pt60":"pt60","pt96":"pt96","pb0":"pb0","pb4":"pb4","pb6":"pb6","pb10":"pb10","pb12":"pb12","pb16":"pb16","pb20":"pb20","pb25":"pb25","pb38":"pb38","pb60":"pb60","pb96":"pb96","ma0":"ma0","ma4":"ma4","ma6":"ma6","ma10":"ma10","ma12":"ma12","ma16":"ma16","ma20":"ma20","ma25":"ma25","ma38":"ma38","ma60":"ma60","ma96":"ma96","maAuto":"maAuto","mh0":"mh0","mh4":"mh4","mh6":"mh6","mh10":"mh10","mh12":"mh12","mh16":"mh16","mh20":"mh20","mh25":"mh25","mh38":"mh38","mh60":"mh60","mh96":"mh96","mhAuto":"mhAuto","mv0":"mv0","mv4":"mv4","mv6":"mv6","mv10":"mv10","mv12":"mv12","mv16":"mv16","mv20":"mv20","mv25":"mv25","mv38":"mv38","mv60":"mv60","mv96":"mv96","mvAuto":"mvAuto","mla":"mla","ml0":"ml0","ml4":"ml4","ml6":"ml6","ml10":"ml10","ml12":"ml12","ml16":"ml16","ml20":"ml20","ml25":"ml25","ml38":"ml38","ml60":"ml60","ml96":"ml96","mlAuto":"mlAuto","mra":"mra","mr0":"mr0","mr4":"mr4","mr6":"mr6","mr10":"mr10","mr12":"mr12","mr16":"mr16","mr20":"mr20","mr25":"mr25","mr38":"mr38","mr60":"mr60","mr96":"mr96","mrAuto":"mrAuto","mt0":"mt0","mt4":"mt4","mt6":"mt6","mt10":"mt10","mt12":"mt12","mt16":"mt16","mt20":"mt20","mt25":"mt25","mt38":"mt38","mt60":"mt60","mt96":"mt96","mtAuto":"mtAuto","mb0":"mb0","mb4":"mb4","mb6":"mb6","mb10":"mb10","mb12":"mb12","mb16":"mb16","mb20":"mb20","mb25":"mb25","mb38":"mb38","mb60":"mb60","mb96":"mb96","mbAuto":"mbAuto","f12":"f12","f14":"f14","f10":"f10","f16":"f16","f20":"f20","f25":"f25","f32":"f32","f38":"f38","f60":"f60","f96":"f96","fInherit":"fInherit","hf32":"hf32","hf30":"hf30","hf20":"hf20","strike":"strike","underline":"underline","noUnderline":"noUnderline","tl":"tl","tr":"tr","tc":"tc","toe":"toe","ttc":"ttc","ttl":"ttl","ttu":"ttu","ttn":"ttn","center":"center","clip":"clip","wsNormal":"wsNormal","nowrap":"nowrap","vBase":"vBase","vMid":"vMid","vTop":"vTop","vBtm":"vBtm","dim":"dim","noEvents":"noEvents","pointer":"pointer","cursorDefault":"cursorDefault","z0":"z0","z1":"z1","z2":"z2","z3":"z3","z4":"z4","z5":"z5","z999":"z999","z9999":"z9999","zMax":"zMax","zInherit":"zInherit","zInitial":"zInitial","zUnset":"zUnset","debug":"debug","debugWhite":"debugWhite","debugBlack":"debugBlack"};
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
	"use strict";
	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};
	
	
	/***/ },
	/* 6 */
	/***/ function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_6__;
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	"use strict";
	var Icon_1 = __webpack_require__(0);
	exports.Icon = Icon_1.default;
	var variables = __webpack_require__(1);
	exports.variables = variables;
	exports.$v = variables;
	var groups = __webpack_require__(3);
	exports.groups = groups;
	exports.$g = groups;
	var particles = __webpack_require__(4);
	exports.particles = particles;
	exports.$p = particles;
	var base = __webpack_require__(2);
	exports.base = base;
	
	
	/***/ }
	/******/ ]);
	});

/***/ }),

/***/ "./node_modules/graphcool-styles/dist/components/Icon/Icon.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var React = __webpack_require__("./node_modules/react/react.js");
	var objectAssign = __webpack_require__("./node_modules/object-assign/index.js");
	var Icon = (function (_super) {
	    __extends(Icon, _super);
	    function Icon() {
	        return _super.apply(this, arguments) || this;
	    }
	    Icon.prototype.render = function () {
	        var width = this.props.width || 16;
	        var height = this.props.height || 16;
	        var color = this.props.color || '#000';
	        var stroke = this.props.stroke || false;
	        var strokeWidth = this.props.strokeWidth || 1;
	        var rotate = this.props.rotate || 0;
	        var fillCode = !stroke ? "fill=\"" + color + "\"" : 'fill="none"';
	        var strokeCode = stroke ? "stroke=\"" + color + "\" stroke-width=\"" + strokeWidth + "px\"" : 'stroke="none"';
	        var styleCode = "style=\"width: " + width + "px; height: " + height + "px;\"";
	        var src = this.props.src;
	        var match = src.match(/data:image\/svg[^,]*?(;base64)?,(.*)/);
	        if (match && match[1] && match[2]) {
	            src = atob(match[2]);
	        }
	        var html = src.replace(/<svg/, "<svg " + strokeCode + " " + fillCode + " " + styleCode);
	        var restProps = objectAssign({}, this.props);
	        delete restProps.width;
	        delete restProps.height;
	        delete restProps.stroke;
	        delete restProps.strokeWidth;
	        delete restProps.color;
	        delete restProps.src;
	        delete restProps.className;
	        return (React.createElement("i", __assign({}, restProps, { className: this.props.className, style: {
	                transform: "rotate(" + rotate + "deg)",
	                WebkitTransform: "rotate(" + rotate + "deg)",
	                display: 'flex'
	            }, dangerouslySetInnerHTML: { __html: html } })));
	    };
	    return Icon;
	}(React.Component));
	exports.__esModule = true;
	exports["default"] = Icon;


/***/ }),

/***/ "./node_modules/graphcool-styles/icons/fill/github.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzBweCIgaGVpZ2h0PSIyOXB4IiB2aWV3Qm94PSIyIC0yIDMwIDI5Ij4KPHBhdGggZD0iTTIuNSwxMi45YzAsNi40LDQuMiwxMS44LDkuOSwxMy43YzAuNywwLjEsMS0wLjMsMS0wLjdjMC0wLjMsMC0xLjMsMC0yLjVjLTQsMC45LTQuOS0xLjktNC45LTEuOQoJYy0wLjctMS43LTEuNi0yLjEtMS42LTIuMUM1LjYsMTguNSw3LDE4LjUsNywxOC41QzguNCwxOC42LDkuMiwyMCw5LjIsMjBjMS4zLDIuMiwzLjQsMS42LDQuMiwxLjJjMC4xLTAuOSwwLjUtMS42LDAuOS0xLjkKCWMtMy4yLTAuNC02LjYtMS42LTYuNi03LjFjMC0xLjYsMC42LTIuOSwxLjUtMy45QzkuMSw3LjksOC42LDYuNCw5LjQsNC40YzAsMCwxLjItMC40LDQsMS41YzEuMi0wLjMsMi40LTAuNSwzLjYtMC41CgljMS4yLDAsMi41LDAuMiwzLjYsMC41YzIuOC0xLjksNC0xLjUsNC0xLjVjMC44LDIsMC4zLDMuNSwwLjEsMy44YzAuOSwxLDEuNSwyLjMsMS41LDMuOWMwLDUuNS0zLjQsNi44LTYuNiw3LjEKCWMwLjUsMC40LDEsMS4zLDEsMi43YzAsMS45LDAsMy41LDAsNGMwLDAuNCwwLjMsMC44LDEsMC43YzUuOC0xLjksOS45LTcuMyw5LjktMTMuN2MwLTgtNi41LTE0LjQtMTQuNS0xNC40QzktMS42LDIuNSw0LjksMi41LDEyLjkKCXoiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "./node_modules/graphcool-styles/icons/stroke/addFull.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSI1MHB4IiBoZWlnaHQ9IjUwcHgiIHZpZXdCb3g9Ii0xIDMgNTAgNTAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgLTEgMyA1MCA1MDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGxpbmUgY2xhc3M9InN0MCIgeDE9IjI0IiB5MT0iNy4yNyIgeDI9IjI0IiB5Mj0iNDguNzMiLz4NCjxsaW5lIGNsYXNzPSJzdDAiIHgxPSI0NC43MyIgeTE9IjI4IiB4Mj0iMy4yNyIgeTI9IjI4Ii8+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ "./node_modules/graphcool-styles/icons/stroke/arrowRight.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgd2lkdGg9IjMwcHgiIGhlaWdodD0iNTBweCIgdmlld0JveD0iMCAwIDMwIDUwIj4NCgk8cG9seWxpbmUgY2xhc3M9InN0MCIgcG9pbnRzPSI1LDUgMjUsMjUgNSw0NSAiLz4NCjwvc3ZnPg=="

/***/ }),

/***/ "./node_modules/graphcool-styles/icons/stroke/cross.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgd2lkdGg9IjUwcHgiIGhlaWdodD0iNTBweCIgdmlld0JveD0iMCAwIDUwIDUwIj4NCgk8bGluZSB4MT0iNCIgeTE9IjQiIHgyPSI0NiIgeTI9IjQ2Ii8+DQoJPGxpbmUgeDE9IjQ2IiB5MT0iNCIgeDI9IjQiIHkyPSI0NiIvPg0KPC9zdmc+DQo="

/***/ }),

/***/ "./node_modules/graphcool-styles/icons/stroke/search.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgd2lkdGg9IjUwcHgiIGhlaWdodD0iNTBweCIgdmlld0JveD0iMCAwIDUwIDUwIj4NCgk8Y2lyY2xlIGN4PSIxNy44MiIgY3k9IjE4LjExIiByPSIxNi4yMSIvPg0KCTxsaW5lIHgxPSIyOS4yOCIgeTE9IjI5LjU3IiB4Mj0iNDguMjEiIHkyPSI0OC41Ii8+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ "./node_modules/has/src/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var bind = __webpack_require__("./node_modules/function-bind/index.js");
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ "./node_modules/inherits/inherits_browser.js":
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),

/***/ "./node_modules/is-callable/index.js":
/***/ (function(module, exports) {

	'use strict';
	
	var fnToStr = Function.prototype.toString;
	
	var constructorRegex = /^\s*class /;
	var isES6ClassFn = function isES6ClassFn(value) {
		try {
			var fnStr = fnToStr.call(value);
			var singleStripped = fnStr.replace(/\/\/.*\n/g, '');
			var multiStripped = singleStripped.replace(/\/\*[.\s\S]*\*\//g, '');
			var spaceStripped = multiStripped.replace(/\n/mg, ' ').replace(/ {2}/g, ' ');
			return constructorRegex.test(spaceStripped);
		} catch (e) {
			return false; // not a function
		}
	};
	
	var tryFunctionObject = function tryFunctionObject(value) {
		try {
			if (isES6ClassFn(value)) { return false; }
			fnToStr.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	var toStr = Object.prototype.toString;
	var fnClass = '[object Function]';
	var genClass = '[object GeneratorFunction]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isCallable(value) {
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		return strClass === fnClass || strClass === genClass;
	};


/***/ }),

/***/ "./node_modules/is-date-object/index.js":
/***/ (function(module, exports) {

	'use strict';
	
	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateObject(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) { return false; }
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};


/***/ }),

/***/ "./node_modules/is-regex/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = __webpack_require__("./node_modules/has/src/index.js");
	var regexExec = RegExp.prototype.exec;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var tryRegexExecCall = function tryRegexExec(value) {
		try {
			var lastIndex = value.lastIndex;
			value.lastIndex = 0;
	
			regexExec.call(value);
			return true;
		} catch (e) {
			return false;
		} finally {
			value.lastIndex = lastIndex;
		}
	};
	var toStr = Object.prototype.toString;
	var regexClass = '[object RegExp]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}
		if (!hasToStringTag) {
			return toStr.call(value) === regexClass;
		}
	
		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}
	
		return tryRegexExecCall(value);
	};


/***/ }),

/***/ "./node_modules/is-symbol/index.js":
/***/ (function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';
	
	if (hasSymbols) {
		var symToStr = Symbol.prototype.toString;
		var symStringRegex = /^Symbol\(.*\)$/;
		var isSymbolObject = function isSymbolObject(value) {
			if (typeof value.valueOf() !== 'symbol') { return false; }
			return symStringRegex.test(symToStr.call(value));
		};
		module.exports = function isSymbol(value) {
			if (typeof value === 'symbol') { return true; }
			if (toStr.call(value) !== '[object Symbol]') { return false; }
			try {
				return isSymbolObject(value);
			} catch (e) {
				return false;
			}
		};
	} else {
		module.exports = function isSymbol(value) {
			// this environment does not support Symbols.
			return false;
		};
	}


/***/ }),

/***/ "./node_modules/lodash/_DataView.js":
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
	    root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),

/***/ "./node_modules/lodash/_Hash.js":
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__("./node_modules/lodash/_hashClear.js"),
	    hashDelete = __webpack_require__("./node_modules/lodash/_hashDelete.js"),
	    hashGet = __webpack_require__("./node_modules/lodash/_hashGet.js"),
	    hashHas = __webpack_require__("./node_modules/lodash/_hashHas.js"),
	    hashSet = __webpack_require__("./node_modules/lodash/_hashSet.js");
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),

/***/ "./node_modules/lodash/_ListCache.js":
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__("./node_modules/lodash/_listCacheClear.js"),
	    listCacheDelete = __webpack_require__("./node_modules/lodash/_listCacheDelete.js"),
	    listCacheGet = __webpack_require__("./node_modules/lodash/_listCacheGet.js"),
	    listCacheHas = __webpack_require__("./node_modules/lodash/_listCacheHas.js"),
	    listCacheSet = __webpack_require__("./node_modules/lodash/_listCacheSet.js");
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),

/***/ "./node_modules/lodash/_Map.js":
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
	    root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),

/***/ "./node_modules/lodash/_MapCache.js":
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__("./node_modules/lodash/_mapCacheClear.js"),
	    mapCacheDelete = __webpack_require__("./node_modules/lodash/_mapCacheDelete.js"),
	    mapCacheGet = __webpack_require__("./node_modules/lodash/_mapCacheGet.js"),
	    mapCacheHas = __webpack_require__("./node_modules/lodash/_mapCacheHas.js"),
	    mapCacheSet = __webpack_require__("./node_modules/lodash/_mapCacheSet.js");
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),

/***/ "./node_modules/lodash/_Promise.js":
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
	    root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),

/***/ "./node_modules/lodash/_Set.js":
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
	    root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),

/***/ "./node_modules/lodash/_SetCache.js":
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__("./node_modules/lodash/_MapCache.js"),
	    setCacheAdd = __webpack_require__("./node_modules/lodash/_setCacheAdd.js"),
	    setCacheHas = __webpack_require__("./node_modules/lodash/_setCacheHas.js");
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),

/***/ "./node_modules/lodash/_Stack.js":
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__("./node_modules/lodash/_ListCache.js"),
	    stackClear = __webpack_require__("./node_modules/lodash/_stackClear.js"),
	    stackDelete = __webpack_require__("./node_modules/lodash/_stackDelete.js"),
	    stackGet = __webpack_require__("./node_modules/lodash/_stackGet.js"),
	    stackHas = __webpack_require__("./node_modules/lodash/_stackHas.js"),
	    stackSet = __webpack_require__("./node_modules/lodash/_stackSet.js");
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),

/***/ "./node_modules/lodash/_Symbol.js":
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),

/***/ "./node_modules/lodash/_Uint8Array.js":
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),

/***/ "./node_modules/lodash/_WeakMap.js":
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__("./node_modules/lodash/_getNative.js"),
	    root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),

/***/ "./node_modules/lodash/_apply.js":
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),

/***/ "./node_modules/lodash/_arrayAggregator.js":
/***/ (function(module, exports) {

	/**
	 * A specialized version of `baseAggregator` for arrays.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function arrayAggregator(array, setter, iteratee, accumulator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    setter(accumulator, value, iteratee(value), array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayAggregator;


/***/ }),

/***/ "./node_modules/lodash/_arrayFilter.js":
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),

/***/ "./node_modules/lodash/_arrayLikeKeys.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__("./node_modules/lodash/_baseTimes.js"),
	    isArguments = __webpack_require__("./node_modules/lodash/isArguments.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    isBuffer = __webpack_require__("./node_modules/lodash/isBuffer.js"),
	    isIndex = __webpack_require__("./node_modules/lodash/_isIndex.js"),
	    isTypedArray = __webpack_require__("./node_modules/lodash/isTypedArray.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),

/***/ "./node_modules/lodash/_arrayMap.js":
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),

/***/ "./node_modules/lodash/_arrayPush.js":
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),

/***/ "./node_modules/lodash/_arraySome.js":
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),

/***/ "./node_modules/lodash/_assocIndexOf.js":
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__("./node_modules/lodash/eq.js");
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),

/***/ "./node_modules/lodash/_baseAggregator.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__("./node_modules/lodash/_baseEach.js");
	
	/**
	 * Aggregates elements of `collection` on `accumulator` with keys transformed
	 * by `iteratee` and values set by `setter`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseAggregator(collection, setter, iteratee, accumulator) {
	  baseEach(collection, function(value, key, collection) {
	    setter(accumulator, value, iteratee(value), collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseAggregator;


/***/ }),

/***/ "./node_modules/lodash/_baseAssignValue.js":
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__("./node_modules/lodash/_defineProperty.js");
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),

/***/ "./node_modules/lodash/_baseEach.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__("./node_modules/lodash/_baseForOwn.js"),
	    createBaseEach = __webpack_require__("./node_modules/lodash/_createBaseEach.js");
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),

/***/ "./node_modules/lodash/_baseFlatten.js":
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__("./node_modules/lodash/_arrayPush.js"),
	    isFlattenable = __webpack_require__("./node_modules/lodash/_isFlattenable.js");
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),

/***/ "./node_modules/lodash/_baseFor.js":
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__("./node_modules/lodash/_createBaseFor.js");
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),

/***/ "./node_modules/lodash/_baseForOwn.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__("./node_modules/lodash/_baseFor.js"),
	    keys = __webpack_require__("./node_modules/lodash/keys.js");
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),

/***/ "./node_modules/lodash/_baseGet.js":
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__("./node_modules/lodash/_castPath.js"),
	    toKey = __webpack_require__("./node_modules/lodash/_toKey.js");
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),

/***/ "./node_modules/lodash/_baseGetAllKeys.js":
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__("./node_modules/lodash/_arrayPush.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js");
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),

/***/ "./node_modules/lodash/_baseGetTag.js":
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js"),
	    getRawTag = __webpack_require__("./node_modules/lodash/_getRawTag.js"),
	    objectToString = __webpack_require__("./node_modules/lodash/_objectToString.js");
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),

/***/ "./node_modules/lodash/_baseHasIn.js":
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),

/***/ "./node_modules/lodash/_baseIsArguments.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),

/***/ "./node_modules/lodash/_baseIsEqual.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__("./node_modules/lodash/_baseIsEqualDeep.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),

/***/ "./node_modules/lodash/_baseIsEqualDeep.js":
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__("./node_modules/lodash/_Stack.js"),
	    equalArrays = __webpack_require__("./node_modules/lodash/_equalArrays.js"),
	    equalByTag = __webpack_require__("./node_modules/lodash/_equalByTag.js"),
	    equalObjects = __webpack_require__("./node_modules/lodash/_equalObjects.js"),
	    getTag = __webpack_require__("./node_modules/lodash/_getTag.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    isBuffer = __webpack_require__("./node_modules/lodash/isBuffer.js"),
	    isTypedArray = __webpack_require__("./node_modules/lodash/isTypedArray.js");
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),

/***/ "./node_modules/lodash/_baseIsMatch.js":
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__("./node_modules/lodash/_Stack.js"),
	    baseIsEqual = __webpack_require__("./node_modules/lodash/_baseIsEqual.js");
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),

/***/ "./node_modules/lodash/_baseIsNative.js":
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__("./node_modules/lodash/isFunction.js"),
	    isMasked = __webpack_require__("./node_modules/lodash/_isMasked.js"),
	    isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
	    toSource = __webpack_require__("./node_modules/lodash/_toSource.js");
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),

/***/ "./node_modules/lodash/_baseIsTypedArray.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
	    isLength = __webpack_require__("./node_modules/lodash/isLength.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),

/***/ "./node_modules/lodash/_baseIteratee.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__("./node_modules/lodash/_baseMatches.js"),
	    baseMatchesProperty = __webpack_require__("./node_modules/lodash/_baseMatchesProperty.js"),
	    identity = __webpack_require__("./node_modules/lodash/identity.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    property = __webpack_require__("./node_modules/lodash/property.js");
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),

/***/ "./node_modules/lodash/_baseKeys.js":
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__("./node_modules/lodash/_isPrototype.js"),
	    nativeKeys = __webpack_require__("./node_modules/lodash/_nativeKeys.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),

/***/ "./node_modules/lodash/_baseMap.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__("./node_modules/lodash/_baseEach.js"),
	    isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js");
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ }),

/***/ "./node_modules/lodash/_baseMatches.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__("./node_modules/lodash/_baseIsMatch.js"),
	    getMatchData = __webpack_require__("./node_modules/lodash/_getMatchData.js"),
	    matchesStrictComparable = __webpack_require__("./node_modules/lodash/_matchesStrictComparable.js");
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),

/***/ "./node_modules/lodash/_baseMatchesProperty.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__("./node_modules/lodash/_baseIsEqual.js"),
	    get = __webpack_require__("./node_modules/lodash/get.js"),
	    hasIn = __webpack_require__("./node_modules/lodash/hasIn.js"),
	    isKey = __webpack_require__("./node_modules/lodash/_isKey.js"),
	    isStrictComparable = __webpack_require__("./node_modules/lodash/_isStrictComparable.js"),
	    matchesStrictComparable = __webpack_require__("./node_modules/lodash/_matchesStrictComparable.js"),
	    toKey = __webpack_require__("./node_modules/lodash/_toKey.js");
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),

/***/ "./node_modules/lodash/_baseOrderBy.js":
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__("./node_modules/lodash/_arrayMap.js"),
	    baseIteratee = __webpack_require__("./node_modules/lodash/_baseIteratee.js"),
	    baseMap = __webpack_require__("./node_modules/lodash/_baseMap.js"),
	    baseSortBy = __webpack_require__("./node_modules/lodash/_baseSortBy.js"),
	    baseUnary = __webpack_require__("./node_modules/lodash/_baseUnary.js"),
	    compareMultiple = __webpack_require__("./node_modules/lodash/_compareMultiple.js"),
	    identity = __webpack_require__("./node_modules/lodash/identity.js");
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  var index = -1;
	  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ }),

/***/ "./node_modules/lodash/_baseProperty.js":
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),

/***/ "./node_modules/lodash/_basePropertyDeep.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__("./node_modules/lodash/_baseGet.js");
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),

/***/ "./node_modules/lodash/_baseRest.js":
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__("./node_modules/lodash/identity.js"),
	    overRest = __webpack_require__("./node_modules/lodash/_overRest.js"),
	    setToString = __webpack_require__("./node_modules/lodash/_setToString.js");
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),

/***/ "./node_modules/lodash/_baseSetToString.js":
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__("./node_modules/lodash/constant.js"),
	    defineProperty = __webpack_require__("./node_modules/lodash/_defineProperty.js"),
	    identity = __webpack_require__("./node_modules/lodash/identity.js");
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),

/***/ "./node_modules/lodash/_baseSortBy.js":
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ }),

/***/ "./node_modules/lodash/_baseTimes.js":
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),

/***/ "./node_modules/lodash/_baseToString.js":
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js"),
	    arrayMap = __webpack_require__("./node_modules/lodash/_arrayMap.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    isSymbol = __webpack_require__("./node_modules/lodash/isSymbol.js");
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),

/***/ "./node_modules/lodash/_baseUnary.js":
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),

/***/ "./node_modules/lodash/_cacheHas.js":
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),

/***/ "./node_modules/lodash/_castPath.js":
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    isKey = __webpack_require__("./node_modules/lodash/_isKey.js"),
	    stringToPath = __webpack_require__("./node_modules/lodash/_stringToPath.js"),
	    toString = __webpack_require__("./node_modules/lodash/toString.js");
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),

/***/ "./node_modules/lodash/_compareAscending.js":
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__("./node_modules/lodash/isSymbol.js");
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ }),

/***/ "./node_modules/lodash/_compareMultiple.js":
/***/ (function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__("./node_modules/lodash/_compareAscending.js");
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ }),

/***/ "./node_modules/lodash/_coreJsData.js":
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),

/***/ "./node_modules/lodash/_createAggregator.js":
/***/ (function(module, exports, __webpack_require__) {

	var arrayAggregator = __webpack_require__("./node_modules/lodash/_arrayAggregator.js"),
	    baseAggregator = __webpack_require__("./node_modules/lodash/_baseAggregator.js"),
	    baseIteratee = __webpack_require__("./node_modules/lodash/_baseIteratee.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js");
	
	/**
	 * Creates a function like `_.groupBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} [initializer] The accumulator object initializer.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee) {
	    var func = isArray(collection) ? arrayAggregator : baseAggregator,
	        accumulator = initializer ? initializer() : {};
	
	    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
	  };
	}
	
	module.exports = createAggregator;


/***/ }),

/***/ "./node_modules/lodash/_createBaseEach.js":
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js");
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),

/***/ "./node_modules/lodash/_createBaseFor.js":
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),

/***/ "./node_modules/lodash/_defineProperty.js":
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__("./node_modules/lodash/_getNative.js");
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),

/***/ "./node_modules/lodash/_equalArrays.js":
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__("./node_modules/lodash/_SetCache.js"),
	    arraySome = __webpack_require__("./node_modules/lodash/_arraySome.js"),
	    cacheHas = __webpack_require__("./node_modules/lodash/_cacheHas.js");
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),

/***/ "./node_modules/lodash/_equalByTag.js":
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js"),
	    Uint8Array = __webpack_require__("./node_modules/lodash/_Uint8Array.js"),
	    eq = __webpack_require__("./node_modules/lodash/eq.js"),
	    equalArrays = __webpack_require__("./node_modules/lodash/_equalArrays.js"),
	    mapToArray = __webpack_require__("./node_modules/lodash/_mapToArray.js"),
	    setToArray = __webpack_require__("./node_modules/lodash/_setToArray.js");
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),

/***/ "./node_modules/lodash/_equalObjects.js":
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__("./node_modules/lodash/_getAllKeys.js");
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),

/***/ "./node_modules/lodash/_freeGlobal.js":
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ "./node_modules/lodash/_getAllKeys.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__("./node_modules/lodash/_baseGetAllKeys.js"),
	    getSymbols = __webpack_require__("./node_modules/lodash/_getSymbols.js"),
	    keys = __webpack_require__("./node_modules/lodash/keys.js");
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),

/***/ "./node_modules/lodash/_getMapData.js":
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__("./node_modules/lodash/_isKeyable.js");
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),

/***/ "./node_modules/lodash/_getMatchData.js":
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__("./node_modules/lodash/_isStrictComparable.js"),
	    keys = __webpack_require__("./node_modules/lodash/keys.js");
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),

/***/ "./node_modules/lodash/_getNative.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__("./node_modules/lodash/_baseIsNative.js"),
	    getValue = __webpack_require__("./node_modules/lodash/_getValue.js");
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),

/***/ "./node_modules/lodash/_getPrototype.js":
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__("./node_modules/lodash/_overArg.js");
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),

/***/ "./node_modules/lodash/_getRawTag.js":
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),

/***/ "./node_modules/lodash/_getSymbols.js":
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__("./node_modules/lodash/_arrayFilter.js"),
	    stubArray = __webpack_require__("./node_modules/lodash/stubArray.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),

/***/ "./node_modules/lodash/_getTag.js":
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__("./node_modules/lodash/_DataView.js"),
	    Map = __webpack_require__("./node_modules/lodash/_Map.js"),
	    Promise = __webpack_require__("./node_modules/lodash/_Promise.js"),
	    Set = __webpack_require__("./node_modules/lodash/_Set.js"),
	    WeakMap = __webpack_require__("./node_modules/lodash/_WeakMap.js"),
	    baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
	    toSource = __webpack_require__("./node_modules/lodash/_toSource.js");
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),

/***/ "./node_modules/lodash/_getValue.js":
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),

/***/ "./node_modules/lodash/_hasPath.js":
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__("./node_modules/lodash/_castPath.js"),
	    isArguments = __webpack_require__("./node_modules/lodash/isArguments.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    isIndex = __webpack_require__("./node_modules/lodash/_isIndex.js"),
	    isLength = __webpack_require__("./node_modules/lodash/isLength.js"),
	    toKey = __webpack_require__("./node_modules/lodash/_toKey.js");
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),

/***/ "./node_modules/lodash/_hashClear.js":
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__("./node_modules/lodash/_nativeCreate.js");
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),

/***/ "./node_modules/lodash/_hashDelete.js":
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),

/***/ "./node_modules/lodash/_hashGet.js":
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__("./node_modules/lodash/_nativeCreate.js");
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),

/***/ "./node_modules/lodash/_hashHas.js":
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__("./node_modules/lodash/_nativeCreate.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),

/***/ "./node_modules/lodash/_hashSet.js":
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__("./node_modules/lodash/_nativeCreate.js");
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),

/***/ "./node_modules/lodash/_isFlattenable.js":
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js"),
	    isArguments = __webpack_require__("./node_modules/lodash/isArguments.js"),
	    isArray = __webpack_require__("./node_modules/lodash/isArray.js");
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),

/***/ "./node_modules/lodash/_isIndex.js":
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),

/***/ "./node_modules/lodash/_isIterateeCall.js":
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__("./node_modules/lodash/eq.js"),
	    isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js"),
	    isIndex = __webpack_require__("./node_modules/lodash/_isIndex.js"),
	    isObject = __webpack_require__("./node_modules/lodash/isObject.js");
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),

/***/ "./node_modules/lodash/_isKey.js":
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__("./node_modules/lodash/isArray.js"),
	    isSymbol = __webpack_require__("./node_modules/lodash/isSymbol.js");
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),

/***/ "./node_modules/lodash/_isKeyable.js":
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),

/***/ "./node_modules/lodash/_isMasked.js":
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__("./node_modules/lodash/_coreJsData.js");
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),

/***/ "./node_modules/lodash/_isPrototype.js":
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),

/***/ "./node_modules/lodash/_isStrictComparable.js":
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("./node_modules/lodash/isObject.js");
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),

/***/ "./node_modules/lodash/_listCacheClear.js":
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),

/***/ "./node_modules/lodash/_listCacheDelete.js":
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__("./node_modules/lodash/_assocIndexOf.js");
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),

/***/ "./node_modules/lodash/_listCacheGet.js":
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__("./node_modules/lodash/_assocIndexOf.js");
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),

/***/ "./node_modules/lodash/_listCacheHas.js":
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__("./node_modules/lodash/_assocIndexOf.js");
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),

/***/ "./node_modules/lodash/_listCacheSet.js":
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__("./node_modules/lodash/_assocIndexOf.js");
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheClear.js":
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__("./node_modules/lodash/_Hash.js"),
	    ListCache = __webpack_require__("./node_modules/lodash/_ListCache.js"),
	    Map = __webpack_require__("./node_modules/lodash/_Map.js");
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheDelete.js":
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__("./node_modules/lodash/_getMapData.js");
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheGet.js":
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__("./node_modules/lodash/_getMapData.js");
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheHas.js":
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__("./node_modules/lodash/_getMapData.js");
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),

/***/ "./node_modules/lodash/_mapCacheSet.js":
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__("./node_modules/lodash/_getMapData.js");
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),

/***/ "./node_modules/lodash/_mapToArray.js":
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),

/***/ "./node_modules/lodash/_matchesStrictComparable.js":
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),

/***/ "./node_modules/lodash/_memoizeCapped.js":
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__("./node_modules/lodash/memoize.js");
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),

/***/ "./node_modules/lodash/_nativeCreate.js":
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__("./node_modules/lodash/_getNative.js");
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),

/***/ "./node_modules/lodash/_nativeKeys.js":
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__("./node_modules/lodash/_overArg.js");
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),

/***/ "./node_modules/lodash/_nodeUtil.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__("./node_modules/lodash/_freeGlobal.js");
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/lodash/_objectToString.js":
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),

/***/ "./node_modules/lodash/_overArg.js":
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),

/***/ "./node_modules/lodash/_overRest.js":
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__("./node_modules/lodash/_apply.js");
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),

/***/ "./node_modules/lodash/_root.js":
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__("./node_modules/lodash/_freeGlobal.js");
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),

/***/ "./node_modules/lodash/_setCacheAdd.js":
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),

/***/ "./node_modules/lodash/_setCacheHas.js":
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),

/***/ "./node_modules/lodash/_setToArray.js":
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),

/***/ "./node_modules/lodash/_setToString.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__("./node_modules/lodash/_baseSetToString.js"),
	    shortOut = __webpack_require__("./node_modules/lodash/_shortOut.js");
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),

/***/ "./node_modules/lodash/_shortOut.js":
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),

/***/ "./node_modules/lodash/_stackClear.js":
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__("./node_modules/lodash/_ListCache.js");
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),

/***/ "./node_modules/lodash/_stackDelete.js":
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),

/***/ "./node_modules/lodash/_stackGet.js":
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),

/***/ "./node_modules/lodash/_stackHas.js":
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),

/***/ "./node_modules/lodash/_stackSet.js":
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__("./node_modules/lodash/_ListCache.js"),
	    Map = __webpack_require__("./node_modules/lodash/_Map.js"),
	    MapCache = __webpack_require__("./node_modules/lodash/_MapCache.js");
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),

/***/ "./node_modules/lodash/_stringToPath.js":
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__("./node_modules/lodash/_memoizeCapped.js");
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),

/***/ "./node_modules/lodash/_toKey.js":
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__("./node_modules/lodash/isSymbol.js");
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),

/***/ "./node_modules/lodash/_toSource.js":
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),

/***/ "./node_modules/lodash/constant.js":
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),

/***/ "./node_modules/lodash/debounce.js":
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
	    now = __webpack_require__("./node_modules/lodash/now.js"),
	    toNumber = __webpack_require__("./node_modules/lodash/toNumber.js");
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),

/***/ "./node_modules/lodash/eq.js":
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),

/***/ "./node_modules/lodash/get.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__("./node_modules/lodash/_baseGet.js");
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),

/***/ "./node_modules/lodash/groupBy.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__("./node_modules/lodash/_baseAssignValue.js"),
	    createAggregator = __webpack_require__("./node_modules/lodash/_createAggregator.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The order of grouped values
	 * is determined by the order they occur in `collection`. The corresponding
	 * value of each key is an array of elements responsible for generating the
	 * key. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	 * // => { '4': [4.2], '6': [6.1, 6.3] }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.groupBy(['one', 'two', 'three'], 'length');
	 * // => { '3': ['one', 'two'], '5': ['three'] }
	 */
	var groupBy = createAggregator(function(result, value, key) {
	  if (hasOwnProperty.call(result, key)) {
	    result[key].push(value);
	  } else {
	    baseAssignValue(result, key, [value]);
	  }
	});
	
	module.exports = groupBy;


/***/ }),

/***/ "./node_modules/lodash/hasIn.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__("./node_modules/lodash/_baseHasIn.js"),
	    hasPath = __webpack_require__("./node_modules/lodash/_hasPath.js");
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),

/***/ "./node_modules/lodash/identity.js":
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),

/***/ "./node_modules/lodash/isArguments.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__("./node_modules/lodash/_baseIsArguments.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),

/***/ "./node_modules/lodash/isArray.js":
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),

/***/ "./node_modules/lodash/isArrayLike.js":
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__("./node_modules/lodash/isFunction.js"),
	    isLength = __webpack_require__("./node_modules/lodash/isLength.js");
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),

/***/ "./node_modules/lodash/isBuffer.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("./node_modules/lodash/_root.js"),
	    stubFalse = __webpack_require__("./node_modules/lodash/stubFalse.js");
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/lodash/isFunction.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
	    isObject = __webpack_require__("./node_modules/lodash/isObject.js");
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),

/***/ "./node_modules/lodash/isLength.js":
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),

/***/ "./node_modules/lodash/isObject.js":
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),

/***/ "./node_modules/lodash/isObjectLike.js":
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),

/***/ "./node_modules/lodash/isPlainObject.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
	    getPrototype = __webpack_require__("./node_modules/lodash/_getPrototype.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),

/***/ "./node_modules/lodash/isSymbol.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
	    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),

/***/ "./node_modules/lodash/isTypedArray.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__("./node_modules/lodash/_baseIsTypedArray.js"),
	    baseUnary = __webpack_require__("./node_modules/lodash/_baseUnary.js"),
	    nodeUtil = __webpack_require__("./node_modules/lodash/_nodeUtil.js");
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),

/***/ "./node_modules/lodash/keys.js":
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__("./node_modules/lodash/_arrayLikeKeys.js"),
	    baseKeys = __webpack_require__("./node_modules/lodash/_baseKeys.js"),
	    isArrayLike = __webpack_require__("./node_modules/lodash/isArrayLike.js");
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),

/***/ "./node_modules/lodash/memoize.js":
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__("./node_modules/lodash/_MapCache.js");
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),

/***/ "./node_modules/lodash/now.js":
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__("./node_modules/lodash/_root.js");
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),

/***/ "./node_modules/lodash/property.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__("./node_modules/lodash/_baseProperty.js"),
	    basePropertyDeep = __webpack_require__("./node_modules/lodash/_basePropertyDeep.js"),
	    isKey = __webpack_require__("./node_modules/lodash/_isKey.js"),
	    toKey = __webpack_require__("./node_modules/lodash/_toKey.js");
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),

/***/ "./node_modules/lodash/sortBy.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__("./node_modules/lodash/_baseFlatten.js"),
	    baseOrderBy = __webpack_require__("./node_modules/lodash/_baseOrderBy.js"),
	    baseRest = __webpack_require__("./node_modules/lodash/_baseRest.js"),
	    isIterateeCall = __webpack_require__("./node_modules/lodash/_isIterateeCall.js");
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ }),

/***/ "./node_modules/lodash/stubArray.js":
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),

/***/ "./node_modules/lodash/stubFalse.js":
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),

/***/ "./node_modules/lodash/throttle.js":
/***/ (function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__("./node_modules/lodash/debounce.js"),
	    isObject = __webpack_require__("./node_modules/lodash/isObject.js");
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ }),

/***/ "./node_modules/lodash/toNumber.js":
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__("./node_modules/lodash/isObject.js"),
	    isSymbol = __webpack_require__("./node_modules/lodash/isSymbol.js");
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),

/***/ "./node_modules/lodash/toString.js":
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__("./node_modules/lodash/_baseToString.js");
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),

/***/ "./node_modules/ms/index.js":
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),

/***/ "./node_modules/object-keys/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__("./node_modules/object-keys/isArguments.js");
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};
	
	var keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];
	
		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}
	
		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}
	
		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}
	
		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				return (Object.keys(arguments) || '').length === 2;
			}(1, 2));
			if (!keysWorksWithArguments) {
				var originalKeys = Object.keys;
				Object.keys = function keys(object) {
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					} else {
						return originalKeys(object);
					}
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ }),

/***/ "./node_modules/object-keys/isArguments.js":
/***/ (function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ }),

/***/ "./node_modules/object.entries/implementation.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ES = __webpack_require__("./node_modules/es-abstract/es7.js");
	var has = __webpack_require__("./node_modules/has/src/index.js");
	var bind = __webpack_require__("./node_modules/function-bind/index.js");
	var isEnumerable = bind.call(Function.call, Object.prototype.propertyIsEnumerable);
	
	module.exports = function entries(O) {
		var obj = ES.RequireObjectCoercible(O);
		var entrys = [];
		for (var key in obj) {
			if (has(obj, key) && isEnumerable(obj, key)) {
				entrys.push([key, obj[key]]);
			}
		}
		return entrys;
	};


/***/ }),

/***/ "./node_modules/object.entries/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__("./node_modules/define-properties/index.js");
	
	var implementation = __webpack_require__("./node_modules/object.entries/implementation.js");
	var getPolyfill = __webpack_require__("./node_modules/object.entries/polyfill.js");
	var shim = __webpack_require__("./node_modules/object.entries/shim.js");
	
	var polyfill = getPolyfill();
	
	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ }),

/***/ "./node_modules/object.entries/polyfill.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__("./node_modules/object.entries/implementation.js");
	
	module.exports = function getPolyfill() {
		return typeof Object.entries === 'function' ? Object.entries : implementation;
	};


/***/ }),

/***/ "./node_modules/object.entries/shim.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var getPolyfill = __webpack_require__("./node_modules/object.entries/polyfill.js");
	var define = __webpack_require__("./node_modules/define-properties/index.js");
	
	module.exports = function shimEntries() {
		var polyfill = getPolyfill();
		define(Object, { entries: polyfill }, {
			entries: function testEntries() {
				return Object.entries !== polyfill;
			}
		});
		return polyfill;
	};


/***/ }),

/***/ "./node_modules/process/browser.js":
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ "./node_modules/querystring-es3/encode.js":
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return map(objectKeys(obj), function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (isArray(obj[k])) {
	        return map(obj[k], function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};
	
	var isArray = Array.isArray || function (xs) {
	  return Object.prototype.toString.call(xs) === '[object Array]';
	};
	
	function map (xs, f) {
	  if (xs.map) return xs.map(f);
	  var res = [];
	  for (var i = 0; i < xs.length; i++) {
	    res.push(f(xs[i], i));
	  }
	  return res;
	}
	
	var objectKeys = Object.keys || function (obj) {
	  var res = [];
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
	  }
	  return res;
	};


/***/ }),

/***/ "./node_modules/react-helmet/lib/Helmet.js":
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__("./node_modules/react-side-effect/lib/index.js");
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__("./node_modules/deep-equal/index.js");
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__("./node_modules/react-helmet/lib/HelmetUtils.js");
	
	var _HelmetConstants = __webpack_require__("./node_modules/react-helmet/lib/HelmetConstants.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Object} bodyAttributes: {"className": "root"}
	             * @param {String} defaultTitle: "Default Title"
	             * @param {Boolean} encodeSpecialCharacters: true
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	             * @param {String} title: "Title"
	             * @param {Object} titleAttributes: {"itemprop": "name"}
	             * @param {String} titleTemplate: "MySite.com - %s"
	             */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ "./node_modules/react-helmet/lib/HelmetConstants.js":
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    "accesskey": "accessKey",
	    "charset": "charSet",
	    "class": "className",
	    "contenteditable": "contentEditable",
	    "contextmenu": "contextMenu",
	    "http-equiv": "httpEquiv",
	    "itemprop": "itemProp",
	    "tabindex": "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ "./node_modules/react-helmet/lib/HelmetUtils.js":
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.warn = exports.requestIdleCallback = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__("./node_modules/object-assign/index.js");
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__("./node_modules/react-helmet/lib/HelmetConstants.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var requestIdleCallback = function () {
	    if (typeof window !== "undefined" && typeof window.requestIdleCallback !== "undefined") {
	        return window.requestIdleCallback;
	    }
	
	    return function (cb) {
	        var start = Date.now();
	        return setTimeout(function () {
	            cb({
	                didTimeout: false,
	                timeRemaining: function timeRemaining() {
	                    return Math.max(0, 50 - (Date.now() - start));
	                }
	            });
	        }, 1);
	    };
	}();
	
	var cancelIdleCallback = function () {
	    if (typeof window !== "undefined" && typeof window.cancelIdleCallback !== "undefined") {
	        return window.cancelIdleCallback;
	    }
	
	    return function (id) {
	        return clearTimeout(id);
	    };
	}();
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetIdleCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	
	    if (_helmetIdleCallback) {
	        cancelIdleCallback(_helmetIdleCallback);
	    }
	
	    _helmetIdleCallback = requestIdleCallback(function () {
	        updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	        updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	        updateTitle(title, titleAttributes);
	
	        var tagUpdates = {
	            baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	            linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	            metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	            noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	            scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	            styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	        };
	
	        var addedTags = {};
	        var removedTags = {};
	
	        Object.keys(tagUpdates).forEach(function (tagType) {
	            var _tagUpdates$tagType = tagUpdates[tagType],
	                newTags = _tagUpdates$tagType.newTags,
	                oldTags = _tagUpdates$tagType.oldTags;
	
	
	            if (newTags.length) {
	                addedTags[tagType] = newTags;
	            }
	            if (oldTags.length) {
	                removedTags[tagType] = tagUpdates[tagType].oldTags;
	            }
	        });
	
	        _helmetIdleCallback = null;
	        onChangeClientState(newState, addedTags, removedTags);
	    });
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = Array.isArray(title) ? title.join("") : title;
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(title, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(title, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestIdleCallback = requestIdleCallback;
	exports.warn = warn;

/***/ }),

/***/ "./node_modules/react-particles-js/lib/particles.js":
/***/ (function(module, exports, __webpack_require__) {

	!function(e, t) {
	     true ? module.exports = t(__webpack_require__("./node_modules/react/react.js")) : "function" == typeof define && define.amd ? define([ "react" ], t) : "object" == typeof exports ? exports.Particles = t(require("react")) : e.Particles = t(e.React);
	}(this, function(e) {
	    return function(e) {
	        function t(i) {
	            if (a[i]) return a[i].exports;
	            var r = a[i] = {
	                exports: {},
	                id: i,
	                loaded: !1
	            };
	            return e[i].call(r.exports, r, r.exports, t), r.loaded = !0, r.exports;
	        }
	        var a = {};
	        return t.m = e, t.c = a, t.p = "", t(0);
	    }([ function(e, t, a) {
	        "use strict";
	        Object.defineProperty(t, "__esModule", {
	            value: !0
	        });
	        var i = a(3);
	        t.Particles = i.default, t.default = i.default;
	    }, function(e, t, a) {
	        "use strict";
	        function i(e) {
	            for (var a in e) t.hasOwnProperty(a) || (t[a] = e[a]);
	        }
	        Object.defineProperty(t, "__esModule", {
	            value: !0
	        }), i(a(11)), i(a(9));
	        var r = a(4);
	        t.Interact = r.default;
	        var s = a(5);
	        t.Modes = s.default;
	        var n = a(6);
	        t.Particle = n.default;
	        var o = a(7);
	        t.ParticleManager = o.default;
	        var c = a(8);
	        t.ParticlesLibrary = c.default;
	        var l = a(10);
	        t.Vendors = l.default;
	    }, function(t, a) {
	        t.exports = e;
	    }, function(e, t, a) {
	        "use strict";
	        function i(e, t) {
	            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
	        }
	        function r(e, t) {
	            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	            return !t || "object" != typeof t && "function" != typeof t ? e : t;
	        }
	        function s(e, t) {
	            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
	            e.prototype = Object.create(t && t.prototype, {
	                constructor: {
	                    value: e,
	                    enumerable: !1,
	                    writable: !0,
	                    configurable: !0
	                }
	            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
	        }
	        var n = function() {
	            function e(e, t) {
	                for (var a = 0; a < t.length; a++) {
	                    var i = t[a];
	                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), 
	                    Object.defineProperty(e, i.key, i);
	                }
	            }
	            return function(t, a, i) {
	                return a && e(t.prototype, a), i && e(t, i), t;
	            };
	        }();
	        Object.defineProperty(t, "__esModule", {
	            value: !0
	        });
	        var o = a(2), c = a(2), l = a(1), u = function(e) {
	            function t(e) {
	                i(this, t);
	                var a = r(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
	                return a.state = {
	                    canvas: void 0,
	                    library: void 0
	                }, a.loadCanvas = a.loadCanvas.bind(a), a;
	            }
	            return s(t, e), n(t, [ {
	                key: "destroy",
	                value: function() {
	                    this.state.library.destroy();
	                }
	            }, {
	                key: "loadCanvas",
	                value: function(e) {
	                    var t = this;
	                    e && this.setState({
	                        canvas: e
	                    }, function() {
	                        t.state.library.loadCanvas(t.state.canvas), t.state.library.start();
	                    });
	                }
	            }, {
	                key: "componentWillMount",
	                value: function() {
	                    this.setState({
	                        library: new l.ParticlesLibrary(this.props.params)
	                    });
	                }
	            }, {
	                key: "componentWillUnmount",
	                value: function() {
	                    this.state.library.destroy(), this.setState({
	                        library: void 0
	                    });
	                }
	            }, {
	                key: "render",
	                value: function() {
	                    var e = this.props, t = e.width, a = e.height;
	                    return o.createElement("div", null, o.createElement("canvas", {
	                        ref: this.loadCanvas,
	                        style: l.deepExtend(this.props.style, {
	                            width: t,
	                            height: a
	                        })
	                    }));
	                }
	            } ]), t;
	        }(c.PureComponent);
	        u.defaultProps = {
	            width: "100%",
	            height: "100%",
	            params: {},
	            style: {}
	        }, t.default = u;
	    }, function(e, t) {
	        "use strict";
	        function a(e, t) {
	            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
	        }
	        var i = function() {
	            function e(e, t) {
	                for (var a = 0; a < t.length; a++) {
	                    var i = t[a];
	                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), 
	                    Object.defineProperty(e, i.key, i);
	                }
	            }
	            return function(t, a, i) {
	                return a && e(t.prototype, a), i && e(t, i), t;
	            };
	        }();
	        Object.defineProperty(t, "__esModule", {
	            value: !0
	        });
	        var r = function() {
	            function e(t, i) {
	                a(this, e), this.params = t, this.library = i;
	            }
	            return i(e, [ {
	                key: "linkParticles",
	                value: function(e, t) {
	                    var a = e.x - t.x, i = e.y - t.y, r = Math.sqrt(a * a + i * i), s = this.library.canvas, n = this.params.particles.line_linked;
	                    if (r <= this.params.particles.line_linked.distance) {
	                        var o = this.params.particles.line_linked.opacity - r / (1 / this.params.particles.line_linked.opacity) / this.params.particles.line_linked.distance;
	                        if (o > 0) {
	                            var c = this.params.particles.line_linked.color_rgb_line, l = c.r, u = c.g, p = c.b;
	                            s.ctx.save(), s.ctx.strokeStyle = "rgba( " + l + ", " + u + ", " + p + ", " + o + " )", 
	                            s.ctx.lineWidth = this.params.particles.line_linked.width, s.ctx.beginPath(), n.shadow.enable && (s.ctx.shadowBlur = n.shadow.blur, 
	                            s.ctx.shadowColor = n.shadow.color), s.ctx.moveTo(e.x, e.y), s.ctx.lineTo(t.x, t.y), 
	                            s.ctx.stroke(), s.ctx.closePath(), s.ctx.restore();
	                        }
	                    }
	                }
	            }, {
	                key: "attractParticles",
	                value: function(e, t) {
	                    var a = e.x - t.x, i = e.y - t.y, r = Math.sqrt(a * a + i * i);
	                    if (r <= this.params.particles.line_linked.distance) {
	                        var s = a / (1e3 * this.params.particles.move.attract.rotateX), n = i / (1e3 * this.params.particles.move.attract.rotateY);
	                        e.vx -= s, e.vy -= n, t.vx += s, t.vy += n;
	                    }
	                }
	            }, {
	                key: "bounceParticles",
	                value: function(e, t) {
	                    var a = e.x - t.x, i = e.y - t.y, r = Math.sqrt(a * a + i * i), s = e.radius + t.radius;
	                    r <= s && (e.vx = -e.vx, e.vy = -e.vy, t.vx = -t.vx, t.vy = -t.vy);
	                }
	            } ]), e;
	        }();
	        t.default = r;
	    }, function(e, t, a) {
	        "use strict";
	        function i(e, t) {
	            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
	        }
	        var r = function() {
	            function e(e, t) {
	                for (var a = 0; a < t.length; a++) {
	                    var i = t[a];
	                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), 
	                    Object.defineProperty(e, i.key, i);
	                }
	            }
	            return function(t, a, i) {
	                return a && e(t.prototype, a), i && e(t, i), t;
	            };
	        }();
	        Object.defineProperty(t, "__esModule", {
	            value: !0
	        });
	        var s = a(1), n = function() {
	            function e(t, a) {
	                i(this, e), this.params = t, this.library = a;
	            }
	            return r(e, [ {
	                key: "pushParticles",
	                value: function(e, t) {
	                    var a = this.library, i = a.canvas, r = a.tmp, n = a.manager;
	                    r.pushing = !0;
	                    for (var o = 0; o < e; o++) this.params.particles.array.push(new s.Particle(this.params, this.library, this.params.particles.color, this.params.particles.opacity.value, {
	                        x: t ? t.pos_x : Math.random() * i.width,
	                        y: t ? t.pos_y : Math.random() * i.height
	                    })), o == e - 1 && (this.params.particles.move.enable || n.particlesDraw(), r.pushing = !1);
	                }
	            }, {
	                key: "removeParticles",
	                value: function(e) {
	                    var t = this.library.manager;
	                    this.params.particles.array.splice(0, e), this.params.particles.move.enable || t.particlesDraw();
	                }
	            }, {
	                key: "bubbleParticle",
	                value: function(e) {
	                    var t = this, a = this.library.tmp;
	                    if (this.params.interactivity.events.onhover.enable && s.isInArray("bubble", this.params.interactivity.events.onhover.mode)) {
	                        var i = e.x - this.params.interactivity.mouse.pos_x, r = e.y - this.params.interactivity.mouse.pos_y, n = Math.sqrt(i * i + r * r), o = 1 - n / this.params.interactivity.modes.bubble.distance, c = function() {
	                            e.opacity_bubble = e.opacity, e.radius_bubble = e.radius;
	                        };
	                        if (n <= this.params.interactivity.modes.bubble.distance) {
	                            if (o >= 0 && "mousemove" == this.params.interactivity.status) {
	                                if (this.params.interactivity.modes.bubble.size != this.params.particles.size.value) if (this.params.interactivity.modes.bubble.size > this.params.particles.size.value) {
	                                    var l = e.radius + this.params.interactivity.modes.bubble.size * o;
	                                    l >= 0 && (e.radius_bubble = l);
	                                } else {
	                                    var u = e.radius - this.params.interactivity.modes.bubble.size, p = e.radius - u * o;
	                                    p > 0 ? e.radius_bubble = p : e.radius_bubble = 0;
	                                }
	                                if (this.params.interactivity.modes.bubble.opacity != this.params.particles.opacity.value) if (this.params.interactivity.modes.bubble.opacity > this.params.particles.opacity.value) {
	                                    var h = this.params.interactivity.modes.bubble.opacity * o;
	                                    h > e.opacity && h <= this.params.interactivity.modes.bubble.opacity && (e.opacity_bubble = h);
	                                } else {
	                                    var m = e.opacity - (this.params.particles.opacity.value - this.params.interactivity.modes.bubble.opacity) * o;
	                                    m < e.opacity && m >= this.params.interactivity.modes.bubble.opacity && (e.opacity_bubble = m);
	                                }
	                            }
	                        } else c();
	                        "mouseleave" == this.params.interactivity.status && c();
	                    } else if (this.params.interactivity.events.onclick.enable && s.isInArray("bubble", this.params.interactivity.events.onclick.mode) && a.bubble_clicking) {
	                        var v = e.x - this.params.interactivity.mouse.click_pos_x, d = e.y - this.params.interactivity.mouse.click_pos_y, y = Math.sqrt(v * v + d * d), b = (new Date().getTime() - this.params.interactivity.mouse.click_time) / 1e3;
	                        b > this.params.interactivity.modes.bubble.duration && (a.bubble_duration_end = !0), 
	                        b > 2 * this.params.interactivity.modes.bubble.duration && (a.bubble_clicking = !1, 
	                        a.bubble_duration_end = !1);
	                        var f = function(i, r, s, n, o) {
	                            if (i != r) if (a.bubble_duration_end) {
	                                if (void 0 != s) {
	                                    var c = n - b * (n - i) / t.params.interactivity.modes.bubble.duration, l = i - c, u = i + l;
	                                    "size" == o && (e.radius_bubble = u), "opacity" == o && (e.opacity_bubble = u);
	                                }
	                            } else if (y <= t.params.interactivity.modes.bubble.distance) {
	                                var p = void 0;
	                                if (p = void 0 != s ? s : n, p != i) {
	                                    var h = n - b * (n - i) / t.params.interactivity.modes.bubble.duration;
	                                    "size" == o && (e.radius_bubble = h), "opacity" == o && (e.opacity_bubble = h);
	                                }
	                            } else "size" == o && (e.radius_bubble = void 0), "opacity" == o && (e.opacity_bubble = void 0);
	                        };
	                        a.bubble_clicking && (f(this.params.interactivity.modes.bubble.size, this.params.particles.size.value, e.radius_bubble, e.radius, "size"), 
	                        f(this.params.interactivity.modes.bubble.opacity, this.params.particles.opacity.value, e.opacity_bubble, e.opacity, "opacity"));
	                    }
	                }
	            }, {
	                key: "repulseParticle",
	                value: function(e) {
	                    var t = this, a = this.library, i = a.canvas, r = a.tmp;
	                    if (this.params.interactivity.events.onhover.enable && s.isInArray("repulse", this.params.interactivity.events.onhover.mode) && "mousemove" == this.params.interactivity.status) {
	                        var n = e.x - this.params.interactivity.mouse.pos_x, o = e.y - this.params.interactivity.mouse.pos_y, c = Math.sqrt(n * n + o * o), l = {
	                            x: n / c,
	                            y: o / c
	                        }, u = this.params.interactivity.modes.repulse.distance, p = 100, h = s.clamp(1 / u * (-1 * Math.pow(c / u, 2) + 1) * u * p, 0, 50), m = {
	                            x: e.x + l.x * h,
	                            y: e.y + l.y * h
	                        };
	                        "bounce" == this.params.particles.move.out_mode ? (m.x - e.radius > 0 && m.x + e.radius < i.width && (e.x = m.x), 
	                        m.y - e.radius > 0 && m.y + e.radius < i.height && (e.y = m.y)) : (e.x = m.x, e.y = m.y);
	                    } else if (this.params.interactivity.events.onclick.enable && s.isInArray("repulse", this.params.interactivity.events.onclick.mode)) if (r.repulse_finish || (r.repulse_count++, 
	                    r.repulse_count == this.params.particles.array.length && (r.repulse_finish = !0)), 
	                    r.repulse_clicking) {
	                        var v = Math.pow(this.params.interactivity.modes.repulse.distance / 6, 3), d = this.params.interactivity.mouse.click_pos_x - e.x, y = this.params.interactivity.mouse.click_pos_y - e.y, b = d * d + y * y, f = -v / b * 1, _ = function() {
	                            var a = Math.atan2(y, d);
	                            if (e.vx = f * Math.cos(a), e.vy = f * Math.sin(a), "bounce" == t.params.particles.move.out_mode) {
	                                var r = {
	                                    x: e.x + e.vx,
	                                    y: e.y + e.vy
	                                };
	                                r.x + e.radius > i.width ? e.vx = -e.vx : r.x - e.radius < 0 && (e.vx = -e.vx), 
	                                r.y + e.radius > i.height ? e.vy = -e.vy : r.y - e.radius < 0 && (e.vy = -e.vy);
	                            }
	                        };
	                        b <= v && _();
	                    } else 0 == r.repulse_clicking && (e.vx = e.vx_i, e.vy = e.vy_i);
	                }
	            }, {
	                key: "grabParticle",
	                value: function(e) {
	                    var t = this.library.canvas, a = this.params, i = a.interactivity, r = a.particles;
	                    if (i.events.onhover.enable && "mousemove" == i.status) {
	                        var s = e.x - i.mouse.pos_x, n = e.y - i.mouse.pos_y, o = Math.sqrt(s * s + n * n);
	                        if (o <= i.modes.grab.distance) {
	                            var c = i.modes.grab, l = c.line_linked.opacity - o / (1 / c.line_linked.opacity) / c.distance;
	                            if (l > 0) {
	                                var u = r.line_linked.color_rgb_line, p = u.r, h = u.g, m = u.b;
	                                t.ctx.strokeStyle = "rgba( " + p + ", " + h + ", " + m + ", " + l + " )", t.ctx.lineWidth = r.line_linked.width, 
	                                t.ctx.beginPath(), t.ctx.moveTo(e.x, e.y), t.ctx.lineTo(i.mouse.pos_x, i.mouse.pos_y), 
	                                t.ctx.stroke(), t.ctx.closePath();
	                            }
	                        }
	                    }
	                }
	            } ]), e;
	        }();
	        t.default = n;
	    }, function(e, t, a) {
	        "use strict";
	        function i(e, t) {
	            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
	        }
	        var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
	            return typeof e;
	        } : function(e) {
	            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	        }, s = function() {
	            function e(e, t) {
	                for (var a = 0; a < t.length; a++) {
	                    var i = t[a];
	                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), 
	                    Object.defineProperty(e, i.key, i);
	                }
	            }
	            return function(t, a, i) {
	                return a && e(t.prototype, a), i && e(t, i), t;
	            };
	        }();
	        Object.defineProperty(t, "__esModule", {
	            value: !0
	        });
	        var n = a(1), o = function() {
	            function e(t, a, r, s, n) {
	                i(this, e), this.params = t, this.library = a, this.setupSize(), this.setupPosition(n), 
	                this.setupColor(r), this.setupOpacity(), this.setupAnimation();
	            }
	            return s(e, [ {
	                key: "setupSize",
	                value: function() {
	                    this.radius = (this.params.particles.size.random ? Math.random() : 1) * this.params.particles.size.value, 
	                    this.params.particles.size.anim.enable && (this.size_status = !1, this.vs = this.params.particles.size.anim.speed / 100, 
	                    this.params.particles.size.anim.sync || (this.vs = this.vs * Math.random()));
	                }
	            }, {
	                key: "setupPosition",
	                value: function(e) {
	                    var t = this.library, a = t.canvas, i = t.vendors;
	                    this.x = e ? e.x : Math.random() * a.width, this.y = e ? e.y : Math.random() * a.height, 
	                    this.x > a.width - 2 * this.radius ? this.x = this.x - this.radius : this.x < 2 * this.radius && (this.x = this.x + this.radius), 
	                    this.y > a.height - 2 * this.radius ? this.y = this.y - this.radius : this.y < 2 * this.radius && (this.y = this.y + this.radius), 
	                    this.params.particles.move.bounce && i.checkOverlap(this, e);
	                }
	            }, {
	                key: "setupColor",
	                value: function(e) {
	                    this.color = n.getColor(e.value);
	                }
	            }, {
	                key: "setupOpacity",
	                value: function() {
	                    this.opacity = (this.params.particles.opacity.random ? Math.random() : 1) * this.params.particles.opacity.value, 
	                    this.params.particles.opacity.anim.enable && (this.opacity_status = !1, this.vo = this.params.particles.opacity.anim.speed / 100, 
	                    this.params.particles.opacity.anim.sync || (this.vo = this.vo * Math.random()));
	                }
	            }, {
	                key: "setupAnimation",
	                value: function() {
	                    var e = this.library, t = e.tmp, a = e.vendors, i = null;
	                    switch (this.params.particles.move.direction) {
	                      case "top":
	                        i = {
	                            x: 0,
	                            y: -1
	                        };
	                        break;
	
	                      case "top-right":
	                        i = {
	                            x: .5,
	                            y: -.5
	                        };
	                        break;
	
	                      case "right":
	                        i = {
	                            x: 1,
	                            y: 0
	                        };
	                        break;
	
	                      case "bottom-right":
	                        i = {
	                            x: .5,
	                            y: .5
	                        };
	                        break;
	
	                      case "bottom":
	                        i = {
	                            x: 0,
	                            y: 1
	                        };
	                        break;
	
	                      case "bottom-left":
	                        i = {
	                            x: -.5,
	                            y: 1
	                        };
	                        break;
	
	                      case "left":
	                        i = {
	                            x: -1,
	                            y: 0
	                        };
	                        break;
	
	                      case "top-left":
	                        i = {
	                            x: -.5,
	                            y: -.5
	                        };
	                        break;
	
	                      default:
	                        i = {
	                            x: 0,
	                            y: 0
	                        };
	                    }
	                    this.params.particles.move.straight ? (this.vx = i.x, this.vy = i.y, this.params.particles.move.random && (this.vx = this.vx * Math.random(), 
	                    this.vy = this.vy * Math.random())) : (this.vx = i.x + Math.random() - .5, this.vy = i.y + Math.random() - .5), 
	                    this.vx_i = this.vx, this.vy_i = this.vy;
	                    var s = this.params.particles.shape.type;
	                    if ("object" == ("undefined" == typeof s ? "undefined" : r(s))) {
	                        if (s instanceof Array) {
	                            var n = s[Math.floor(Math.random() * s.length)];
	                            this.shape = n;
	                        }
	                    } else this.shape = s;
	                    if ("image" == this.shape) {
	                        var o = this.params.particles.shape;
	                        this.img = {
	                            src: o.image.src,
	                            ratio: o.image.width / o.image.height
	                        }, this.img.ratio || (this.img.ratio = 1), "svg" == t.img_type && void 0 != t.source_svg && (a.createSvgImg(this), 
	                        t.pushing && (this.img.loaded = !1));
	                    }
	                }
	            }, {
	                key: "draw",
	                value: function e() {
	                    var t = this, a = this.library, i = a.canvas, r = a.tmp, s = a.vendors, n = (this.params.particles, 
	                    void 0);
	                    n = void 0 != this.radius_bubble ? this.radius_bubble : this.radius;
	                    var o = void 0;
	                    o = void 0 != this.opacity_bubble ? this.opacity_bubble : this.opacity;
	                    var c = void 0;
	                    if (this.color.rgb) {
	                        var l = this.color.rgb, u = l.r, p = l.g, h = l.b;
	                        c = "rgba( " + u + ", " + p + ", " + h + ", " + o + " )";
	                    } else {
	                        var m = this.color.hsl, v = m.h, d = m.s, y = m.l;
	                        c = "hsla( " + v + ", " + d + ", " + y + ", " + o + " )";
	                    }
	                    switch (i.ctx.fillStyle = c, i.ctx.beginPath(), this.shape) {
	                      case "circle":
	                        i.ctx.arc(this.x, this.y, n, 0, 2 * Math.PI, !1);
	                        break;
	
	                      case "edge":
	                        i.ctx.rect(this.x - n, this.y - n, 2 * n, 2 * n);
	                        break;
	
	                      case "triangle":
	                        s.drawShape(i.ctx, this.x - n, this.y + n / 1.66, 2 * n, 3, 2);
	                        break;
	
	                      case "polygon":
	                        s.drawShape(i.ctx, this.x - n / (this.params.particles.shape.polygon.nb_sides / 3.5), this.y - n / .76, 2.66 * n / (this.params.particles.shape.polygon.nb_sides / 3), this.params.particles.shape.polygon.nb_sides, 1);
	                        break;
	
	                      case "star":
	                        s.drawShape(i.ctx, this.x - 2 * n / (this.params.particles.shape.polygon.nb_sides / 4), this.y - n / 1.52, 2 * n * 2.66 / (this.params.particles.shape.polygon.nb_sides / 3), this.params.particles.shape.polygon.nb_sides, 2);
	                        break;
	
	                      case "image":
	                        var e = function(e) {
	                            i.ctx.drawImage(e, t.x - n, t.y - n, 2 * n, 2 * n / t.img.ratio);
	                        }, b = void 0;
	                        b = "svg" == r.img_type ? this.img.obj : r.img_obj, b && e(b);
	                    }
	                    i.ctx.closePath(), this.params.particles.shape.stroke.width > 0 && (i.ctx.strokeStyle = this.params.particles.shape.stroke.color, 
	                    i.ctx.lineWidth = this.params.particles.shape.stroke.width, i.ctx.stroke()), i.ctx.fill();
	                }
	            } ]), e;
	        }();
	        t.default = o;
	    }, function(e, t, a) {
	        "use strict";
	        function i(e, t) {
	            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
	        }
	        var r = function() {
	            function e(e, t) {
	                for (var a = 0; a < t.length; a++) {
	                    var i = t[a];
	                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), 
	                    Object.defineProperty(e, i.key, i);
	                }
	            }
	            return function(t, a, i) {
	                return a && e(t.prototype, a), i && e(t, i), t;
	            };
	        }();
	        Object.defineProperty(t, "__esModule", {
	            value: !0
	        });
	        var s = a(1), n = function() {
	            function e(t, a, r, s, n) {
	                i(this, e), this.params = t, this.interact = a, this.modes = r, this.vendors = s, 
	                this.library = n;
	            }
	            return r(e, [ {
	                key: "particlesCreate",
	                value: function() {
	                    for (var e = this.params.particles, t = e.color, a = e.opacity, i = 0; i < this.params.particles.number.value; i++) this.params.particles.array.push(new s.Particle(this.params, this.library, t, a.value));
	                }
	            }, {
	                key: "particlesUpdate",
	                value: function() {
	                    var e = this, t = this.library, a = t.canvas, i = t.interact, r = t.modes;
	                    this.params.particles.array.forEach(function(t, n) {
	                        if (e.params.particles.move.enable) {
	                            var o = e.params.particles.move.speed / 2;
	                            t.x += t.vx * o, t.y += t.vy * o;
	                        }
	                        e.params.particles.opacity.anim.enable && (1 == t.opacity_status ? (t.opacity >= e.params.particles.opacity.value && (t.opacity_status = !1), 
	                        t.opacity += t.vo) : (t.opacity <= e.params.particles.opacity.anim.opacity_min && (t.opacity_status = !0), 
	                        t.opacity -= t.vo), t.opacity < 0 && (t.opacity = 0)), e.params.particles.size.anim.enable && (1 == t.size_status ? (t.radius >= e.params.particles.size.value && (t.size_status = !1), 
	                        t.radius += t.vs) : (t.radius <= e.params.particles.size.anim.size_min && (t.size_status = !0), 
	                        t.radius -= t.vs), t.radius < 0 && (t.radius = 0));
	                        var c = void 0;
	                        switch (c = "bounce" == e.params.particles.move.out_mode ? {
	                            x_left: t.radius,
	                            x_right: a.width,
	                            y_top: t.radius,
	                            y_bottom: a.height
	                        } : {
	                            x_left: -t.radius,
	                            x_right: a.width + t.radius,
	                            y_top: -t.radius,
	                            y_bottom: a.height + t.radius
	                        }, t.x - t.radius > a.width ? (t.x = c.x_left, t.y = Math.random() * a.height) : t.x + t.radius < 0 && (t.x = c.x_right, 
	                        t.y = Math.random() * a.height), t.y - t.radius > a.height ? (t.y = c.y_top, t.x = Math.random() * a.width) : t.y + t.radius < 0 && (t.y = c.y_bottom, 
	                        t.x = Math.random() * a.width), e.params.particles.move.out_mode) {
	                          case "bounce":
	                            t.x + t.radius > a.width ? t.vx = -t.vx : t.x - t.radius < 0 && (t.vx = -t.vx), 
	                            t.y + t.radius > a.height ? t.vy = -t.vy : t.y - t.radius < 0 && (t.vy = -t.vy);
	                        }
	                        if (s.isInArray("grab", e.params.interactivity.events.onhover.mode) && r.grabParticle(t), 
	                        (s.isInArray("bubble", e.params.interactivity.events.onhover.mode) || s.isInArray("bubble", e.params.interactivity.events.onclick.mode)) && r.bubbleParticle(t), 
	                        (s.isInArray("repulse", e.params.interactivity.events.onhover.mode) || s.isInArray("repulse", e.params.interactivity.events.onclick.mode)) && r.repulseParticle(t), 
	                        e.params.particles.line_linked.enable || e.params.particles.move.attract.enable) for (var l = n + 1; l < e.params.particles.array.length; l++) {
	                            var u = e.params.particles.array[l];
	                            e.params.particles.line_linked.enable && i.linkParticles(t, u), e.params.particles.move.attract.enable && i.attractParticles(t, u), 
	                            e.params.particles.move.bounce && i.bounceParticles(t, u);
	                        }
	                    });
	                }
	            }, {
	                key: "particlesDraw",
	                value: function() {
	                    var e = this.library, t = e.canvas, a = e.manager;
	                    t.ctx.clearRect(0, 0, t.width, t.height), a.particlesUpdate(), this.params.particles.array.forEach(function(e) {
	                        e.draw();
	                    });
	                }
	            }, {
	                key: "particlesEmpty",
	                value: function() {
	                    this.params.particles.array = [];
	                }
	            }, {
	                key: "particlesRefresh",
	                value: function() {
	                    var e = this.library, t = e.tmp;
	                    e.vendors;
	                    cancelAnimationFrame(t.checkAnimFrame), cancelAnimationFrame(t.drawAnimFrame), t.source_svg = void 0, 
	                    t.img_obj = void 0, t.count_svg = 0, this.particlesEmpty(), this.library.canvasClear(), 
	                    this.library.start();
	                }
	            } ]), e;
	        }();
	        t.default = n;
	    }, function(e, t, a) {
	        "use strict";
	        function i(e, t) {
	            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
	        }
	        var r = function() {
	            function e(e, t) {
	                for (var a = 0; a < t.length; a++) {
	                    var i = t[a];
	                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), 
	                    Object.defineProperty(e, i.key, i);
	                }
	            }
	            return function(t, a, i) {
	                return a && e(t.prototype, a), i && e(t, i), t;
	            };
	        }();
	        Object.defineProperty(t, "__esModule", {
	            value: !0
	        });
	        var s = a(1), n = function() {
	            function e(t) {
	                i(this, e), this.tmp = {}, this.tmp = {}, this.loadParameters(t), this.extendParams(), 
	                this.interact = new s.Interact(this.params, this), this.modes = new s.Modes(this.params, this), 
	                this.vendors = new s.Vendors(this.params, this), this.manager = new s.ParticleManager(this.params, this.interact, this.modes, this.vendors, this);
	            }
	            return r(e, [ {
	                key: "loadParameters",
	                value: function(e) {
	                    var t = s.getDefaultParams(), a = s.deepExtend(t, e);
	                    this.params = a;
	                }
	            }, {
	                key: "loadCanvas",
	                value: function(e) {
	                    this.canvas = {
	                        element: e,
	                        width: e.offsetWidth,
	                        height: e.offsetHeight
	                    };
	                }
	            }, {
	                key: "start",
	                value: function() {
	                    var e = this.vendors;
	                    e.eventsListeners(), e.start();
	                }
	            }, {
	                key: "destroy",
	                value: function() {
	                    var e = this.tmp;
	                    this.detachListeners(), this.vendors.detachListeners(), cancelAnimationFrame(e.drawAnimFrame), 
	                    this.canvasClear();
	                }
	            }, {
	                key: "detachListeners",
	                value: function() {
	                    window.removeEventListener("resize", this.onWindowResize);
	                }
	            }, {
	                key: "extendParams",
	                value: function() {
	                    this.extendTmpDefinition(), this.onWindowResize = this.onWindowResize.bind(this);
	                }
	            }, {
	                key: "extendTmpDefinition",
	                value: function() {
	                    var e = this.tmp;
	                    e.obj = {
	                        size_value: this.params.particles.size.value,
	                        size_anim_speed: this.params.particles.size.anim.speed,
	                        move_speed: this.params.particles.move.speed,
	                        line_linked_distance: this.params.particles.line_linked.distance,
	                        line_linked_width: this.params.particles.line_linked.width,
	                        mode_grab_distance: this.params.interactivity.modes.grab.distance,
	                        mode_bubble_distance: this.params.interactivity.modes.bubble.distance,
	                        mode_bubble_size: this.params.interactivity.modes.bubble.size,
	                        mode_repulse_distance: this.params.interactivity.modes.repulse.distance
	                    };
	                }
	            }, {
	                key: "retinaInit",
	                value: function() {
	                    var e = this.canvas, t = this.tmp;
	                    this.params.retina_detect && window.devicePixelRatio > 1 ? (e.pxratio = window.devicePixelRatio, 
	                    t.retina = !0, e.width = e.element.offsetWidth * e.pxratio, e.height = e.element.offsetHeight * e.pxratio, 
	                    this.params.particles.size.value = t.obj.size_value * e.pxratio, this.params.particles.size.anim.speed = t.obj.size_anim_speed * e.pxratio, 
	                    this.params.particles.move.speed = t.obj.move_speed * e.pxratio, this.params.particles.line_linked.distance = t.obj.line_linked_distance * e.pxratio, 
	                    this.params.interactivity.modes.grab.distance = t.obj.mode_grab_distance * e.pxratio, 
	                    this.params.interactivity.modes.bubble.distance = t.obj.mode_bubble_distance * e.pxratio, 
	                    this.params.particles.line_linked.width = t.obj.line_linked_width * e.pxratio, this.params.interactivity.modes.bubble.size = t.obj.mode_bubble_size * e.pxratio, 
	                    this.params.interactivity.modes.repulse.distance = t.obj.mode_repulse_distance * e.pxratio) : (e.pxratio = 1, 
	                    t.retina = !1);
	                }
	            }, {
	                key: "canvasInit",
	                value: function() {
	                    var e = this.canvas;
	                    e.ctx = e.element.getContext("2d");
	                }
	            }, {
	                key: "canvasSize",
	                value: function() {
	                    var e = this.canvas;
	                    e.element.width = e.width, e.element.height = e.height, this.params && this.params.interactivity.events.resize && window.addEventListener("resize", this.onWindowResize);
	                }
	            }, {
	                key: "canvasPaint",
	                value: function() {
	                    var e = this.canvas;
	                    e.ctx.fillRect(0, 0, e.width, e.height);
	                }
	            }, {
	                key: "canvasClear",
	                value: function() {
	                    var e = this.canvas;
	                    e.ctx.clearRect(0, 0, e.width, e.height);
	                }
	            }, {
	                key: "onWindowResize",
	                value: function() {
	                    var e = this.canvas, t = this.manager, a = this.tmp, i = this.vendors;
	                    e.width = e.element.offsetWidth, e.height = e.element.offsetHeight, a.retina && (e.width *= e.pxratio, 
	                    e.height *= e.pxratio), e.element.width = e.width, e.element.height = e.height, 
	                    this.params.particles.move.enable || (t.particlesEmpty(), t.particlesCreate(), t.particlesDraw(), 
	                    i.densityAutoParticles()), i.densityAutoParticles();
	                }
	            } ]), e;
	        }();
	        t.default = n;
	    }, function(e, t) {
	        "use strict";
	        var a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
	            return typeof e;
	        } : function(e) {
	            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	        };
	        Object.defineProperty(t, "__esModule", {
	            value: !0
	        }), t.hexToRgb = function(e) {
	            var t = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
	            e = e.replace(t, function(e, t, a, i) {
	                return t + t + a + a + i + i;
	            });
	            var a = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
	            return a ? {
	                r: parseInt(a[1], 16),
	                g: parseInt(a[2], 16),
	                b: parseInt(a[3], 16)
	            } : null;
	        }, t.clamp = function(e, t, a) {
	            return Math.min(Math.max(e, t), a);
	        }, t.isInArray = function(e, t) {
	            return t.indexOf(e) > -1;
	        }, t.deepExtend = function(e, a) {
	            for (var i in a) a[i] && a[i].constructor && a[i].constructor === Object ? (e[i] = e[i] || {}, 
	            t.deepExtend(e[i], a[i])) : e[i] = a[i];
	            return e;
	        }, t.getColor = function(e) {
	            var i = {};
	            if ("object" == ("undefined" == typeof e ? "undefined" : a(e))) if (e instanceof Array) {
	                var r = e[Math.floor(Math.random() * e.length)];
	                i.rgb = t.hexToRgb(r);
	            } else {
	                var s = e.r, n = e.g, o = e.b;
	                if (void 0 !== s && void 0 !== n && void 0 !== o) i.rgb = {
	                    r: s,
	                    g: n,
	                    b: o
	                }; else {
	                    var c = e.h, l = e.s, u = e.l;
	                    void 0 !== c && void 0 !== n && void 0 !== o && (i.hsl = {
	                        h: c,
	                        s: l,
	                        l: u
	                    });
	                }
	            } else "random" == e ? i.rgb = {
	                r: Math.floor(255 * Math.random()) + 1,
	                g: Math.floor(255 * Math.random()) + 1,
	                b: Math.floor(255 * Math.random()) + 1
	            } : "string" == typeof e && (i.rgb = t.hexToRgb(e));
	            return i;
	        };
	    }, function(e, t, a) {
	        "use strict";
	        function i(e, t) {
	            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
	        }
	        var r = function() {
	            function e(e, t) {
	                for (var a = 0; a < t.length; a++) {
	                    var i = t[a];
	                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), 
	                    Object.defineProperty(e, i.key, i);
	                }
	            }
	            return function(t, a, i) {
	                return a && e(t.prototype, a), i && e(t, i), t;
	            };
	        }();
	        Object.defineProperty(t, "__esModule", {
	            value: !0
	        });
	        var s = a(1), n = function() {
	            function e(t, a) {
	                i(this, e), this.params = t, this.library = a, this.onMouseMove = this.onMouseMove.bind(this), 
	                this.onMouseLeave = this.onMouseLeave.bind(this), this.onClick = this.onClick.bind(this);
	            }
	            return r(e, [ {
	                key: "eventsListeners",
	                value: function() {
	                    var e = this.params.interactivity, t = this.library.canvas;
	                    "window" == e.detect_on ? e.el = window : e.el = t.element, (e.events.onhover.enable || e.events.onclick.enable) && (e.el.addEventListener("mousemove", this.onMouseMove), 
	                    e.el.addEventListener("mouseleave", this.onMouseLeave)), e.events.onclick.enable && e.el.addEventListener("click", this.onClick);
	                }
	            }, {
	                key: "detachListeners",
	                value: function() {
	                    var e = this.params.interactivity, t = this.library.tmp;
	                    e.el && ((e.events.onhover.enable || e.events.onclick.enable) && (e.el.removeEventListener("mousemove", this.onMouseMove), 
	                    e.el.addEventListener("mouseleave", this.onMouseLeave)), e.events.onclick.enable && e.el.addEventListener("click", this.onClick)), 
	                    window.cancelAnimationFrame(t.drawAnimFrame);
	                }
	            }, {
	                key: "onMouseMove",
	                value: function(e) {
	                    var t = this.library, a = t.canvas, i = t.tmp, r = this.params.interactivity, s = void 0;
	                    s = r.el == window ? {
	                        x: e.clientX,
	                        y: e.clientY
	                    } : {
	                        x: e.offsetX || e.clientX,
	                        y: e.offsetY || e.clientY
	                    }, r.mouse.pos_x = s.x, r.mouse.pos_y = s.y, i.retina && (r.mouse.pos_x *= a.pxratio, 
	                    r.mouse.pos_y *= a.pxratio), r.status = "mousemove";
	                }
	            }, {
	                key: "onMouseLeave",
	                value: function(e) {
	                    var t = this.params.interactivity;
	                    t.mouse.pos_x = null, t.mouse.pos_y = null, t.status = "mouseleave";
	                }
	            }, {
	                key: "onClick",
	                value: function() {
	                    var e = this.library, t = e.modes, a = e.tmp, i = this.params, r = i.interactivity, s = i.particles;
	                    if (r.mouse.click_pos_x = r.mouse.pos_x, r.mouse.click_pos_y = r.mouse.pos_y, r.mouse.click_time = new Date().getTime(), 
	                    r.events.onclick.enable) switch (r.events.onclick.mode) {
	                      case "push":
	                        s.move.enable ? t.pushParticles(r.modes.push.particles_nb, r.mouse) : 1 == r.modes.push.particles_nb ? t.pushParticles(r.modes.push.particles_nb, r.mouse) : r.modes.push.particles_nb > 1 && t.pushParticles(r.modes.push.particles_nb);
	                        break;
	
	                      case "remove":
	                        t.removeParticles(r.modes.remove.particles_nb);
	                        break;
	
	                      case "bubble":
	                        a.bubble_clicking = !0;
	                        break;
	
	                      case "repulse":
	                        a.repulse_clicking = !0, a.repulse_count = 0, a.repulse_finish = !1, setTimeout(function() {
	                            a.repulse_clicking = !1;
	                        }, 1e3 * r.modes.repulse.duration);
	                    }
	                }
	            }, {
	                key: "densityAutoParticles",
	                value: function() {
	                    var e = this.library, t = e.canvas, a = e.modes, i = e.tmp, r = this.params.particles;
	                    if (r.number.density.enable) {
	                        var s = t.element.width * t.element.height / 1e3;
	                        i.retina && (s = s / t.pxratio * 2);
	                        var n = s * r.number.value / r.number.density.value_area, o = r.array.length - n;
	                        o < 0 ? a.pushParticles(Math.abs(o)) : a.removeParticles(o);
	                    }
	                }
	            }, {
	                key: "checkOverlap",
	                value: function(e, t) {
	                    var a = this.library, i = a.canvas, r = a.vendors, s = this.params.particles;
	                    s.array.forEach(function(a) {
	                        var s = a, n = e.x - s.x, o = e.y - s.y, c = Math.sqrt(n * n + o * o);
	                        c <= e.radius + s.radius && (e.x = t ? t.x : Math.random() * i.width, e.y = t ? t.y : Math.random() * i.height, 
	                        r.checkOverlap(e));
	                    });
	                }
	            }, {
	                key: "createSvgImg",
	                value: function(e) {
	                    var t = this.library.tmp, a = t.source_svg, i = /#([0-9A-F]{3,6})/gi, r = a.replace(i, function(t, a, i, r) {
	                        var s = void 0;
	                        if (e.color.rgb) {
	                            var n = e.color.rgb, o = n.r, c = n.g, l = n.b;
	                            s = "rgba( " + o + ", " + c + ", " + l + ", " + e.opacity + " )";
	                        } else {
	                            var u = e.color.hsl, p = u.h, h = u.s, m = u.l;
	                            s = "rgba( " + p + ", " + h + ", " + m + ", " + e.opacity + " )";
	                        }
	                        return s;
	                    }), s = new Blob([ r ], {
	                        type: "image/svg+xml;charset=utf-8"
	                    }), n = window.URL || window, o = n.createObjectURL(s), c = new Image();
	                    c.addEventListener("load", function() {
	                        e.img.obj = c, e.img.loaded = !0, n.revokeObjectURL(o), t.count_svg++;
	                    }), c.src = o;
	                }
	            }, {
	                key: "destroy",
	                value: function() {
	                    var e = this.library, t = e.canvas, a = e.tmp;
	                    cancelAnimationFrame(a.drawAnimFrame), t.element.remove();
	                }
	            }, {
	                key: "drawShape",
	                value: function(e, t, a, i, r, s) {
	                    var n = r * s, o = r / s, c = 180 * (o - 2) / o, l = Math.PI - Math.PI * c / 180;
	                    e.save(), e.beginPath(), e.translate(t, a), e.moveTo(0, 0);
	                    for (var u = 0; u < n; u++) e.lineTo(i, 0), e.translate(i, 0), e.rotate(l);
	                    e.fill(), e.restore();
	                }
	            }, {
	                key: "exportImg",
	                value: function() {
	                    var e = this.library.canvas;
	                    window.open(e.element.toDataURL("image/png"), "_blank");
	                }
	            }, {
	                key: "loadImg",
	                value: function(e) {
	                    var t = this.library, a = t.tmp, i = t.vendors, r = this.params.particles;
	                    if (a.img_error = void 0, "" != r.shape.image.src) if ("svg" == e) {
	                        var s = new XMLHttpRequest();
	                        s.open("GET", r.shape.image.src), s.onreadystatechange = function(e) {
	                            4 == s.readyState && (200 == s.status ? (a.source_svg = e.currentTarget.response, 
	                            i.checkBeforeDraw()) : (console.log("Error react-particles-js - image not found"), 
	                            a.img_error = !0));
	                        }, s.send();
	                    } else {
	                        var n = new Image();
	                        n.addEventListener("load", function() {
	                            a.img_obj = n, i.checkBeforeDraw();
	                        }), n.src = r.shape.image.src;
	                    } else console.log("Error react-particles-js - no image.src"), a.img_error = !0;
	                }
	            }, {
	                key: "draw",
	                value: function() {
	                    var e = this.library, t = e.tmp, a = e.manager, i = e.vendors, r = this.params.particles;
	                    "image" == r.shape.type ? "svg" == t.img_type ? t.count_svg >= r.number.value ? (a.particlesDraw(), 
	                    r.move.enable ? t.drawAnimFrame = requestAnimationFrame(i.draw.bind(i)) : cancelAnimationFrame(t.drawAnimFrame)) : t.img_error || (t.drawAnimFrame = requestAnimationFrame(i.draw.bind(i))) : void 0 != t.img_obj ? (a.particlesDraw(), 
	                    r.move.enable ? t.drawAnimFrame = requestAnimationFrame(i.draw.bind(i)) : cancelAnimationFrame(t.drawAnimFrame)) : t.img_error || (t.drawAnimFrame = requestAnimationFrame(i.draw.bind(i))) : (a.particlesDraw(), 
	                    r.move.enable ? t.drawAnimFrame = requestAnimationFrame(i.draw.bind(i)) : cancelAnimationFrame(t.drawAnimFrame));
	                }
	            }, {
	                key: "checkBeforeDraw",
	                value: function() {
	                    var e = this.library, t = e.tmp, a = e.vendors, i = this.params.particles;
	                    if ("image" == i.shape.type) if ("svg" == t.img_type && void 0 == t.source_svg) {
	                        var r = void 0;
	                        t.checkAnimFrame = requestAnimationFrame(r);
	                    } else cancelAnimationFrame(t.checkAnimFrame), t.img_error || (a.init(), a.draw()); else a.init(), 
	                    a.draw();
	                }
	            }, {
	                key: "init",
	                value: function() {
	                    var e = this.library, t = e.manager, a = e.vendors, i = this.params.particles;
	                    e.retinaInit(), e.canvasInit(), e.canvasSize(), t.particlesCreate(), a.densityAutoParticles(), 
	                    i.line_linked.color_rgb_line = s.hexToRgb(i.line_linked.color);
	                }
	            }, {
	                key: "start",
	                value: function() {
	                    var e = this.library, t = e.tmp, a = e.vendors, i = this.params.particles;
	                    s.isInArray("image", i.shape.type) ? (t.img_type = i.shape.image.src.substr(i.shape.image.src.length - 3), 
	                    a.loadImg(t.img_type)) : a.checkBeforeDraw();
	                }
	            } ]), e;
	        }();
	        t.default = n;
	    }, function(e, t) {
	        "use strict";
	        Object.defineProperty(t, "__esModule", {
	            value: !0
	        }), t.getDefaultParams = function() {
	            return {
	                particles: {
	                    number: {
	                        value: 40,
	                        density: {
	                            enable: !1,
	                            value_area: 1200
	                        }
	                    },
	                    color: {
	                        value: "#FFF"
	                    },
	                    shape: {
	                        type: "circle",
	                        stroke: {
	                            width: 0,
	                            color: "#000000"
	                        },
	                        polygon: {
	                            nb_sides: 5
	                        },
	                        image: {
	                            src: "",
	                            width: 100,
	                            height: 100
	                        }
	                    },
	                    opacity: {
	                        value: .5,
	                        random: !1,
	                        anim: {
	                            enable: !0,
	                            speed: 1,
	                            opacity_min: .1,
	                            sync: !1
	                        }
	                    },
	                    size: {
	                        value: 1,
	                        random: !1,
	                        anim: {
	                            enable: !1,
	                            speed: 40,
	                            size_min: 0,
	                            sync: !1
	                        }
	                    },
	                    line_linked: {
	                        enable: !0,
	                        distance: 150,
	                        color: "#FFF",
	                        opacity: .6,
	                        width: 1,
	                        shadow: {
	                            enable: !1,
	                            blur: 5,
	                            color: "lime"
	                        }
	                    },
	                    move: {
	                        enable: !0,
	                        speed: 3,
	                        direction: "none",
	                        random: !1,
	                        straight: !1,
	                        out_mode: "bounce",
	                        bounce: !0,
	                        attract: {
	                            enable: !1,
	                            rotateX: 3e3,
	                            rotateY: 3e3
	                        }
	                    },
	                    array: []
	                },
	                interactivity: {
	                    detect_on: "canvas",
	                    events: {
	                        onhover: {
	                            enable: !1,
	                            mode: "grab"
	                        },
	                        onclick: {
	                            enable: !1,
	                            mode: "repulse"
	                        },
	                        resize: !0
	                    },
	                    modes: {
	                        grab: {
	                            distance: 180,
	                            line_linked: {
	                                opacity: .35
	                            }
	                        },
	                        bubble: {
	                            distance: 200,
	                            size: 80,
	                            duration: .4
	                        },
	                        repulse: {
	                            distance: 100,
	                            duration: 5
	                        },
	                        push: {
	                            particles_nb: 4
	                        },
	                        remove: {
	                            particles_nb: 2
	                        }
	                    },
	                    mouse: {}
	                },
	                retina_detect: !0
	            };
	        };
	    } ]);
	});

/***/ }),

/***/ "./node_modules/react-redux/lib/components/Provider.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__("./node_modules/react-redux/lib/utils/PropTypes.js");
	
	var _warning = __webpack_require__("./node_modules/react-redux/lib/utils/warning.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider() {
	  var _Provider$childContex;
	
	  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
	  var subKey = arguments[1];
	
	  var subscriptionKey = subKey || storeKey + 'Subscription';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    Provider.prototype.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes2.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	  Provider.displayName = 'Provider';
	
	  return Provider;
	}
	
	exports.default = createProvider();

/***/ }),

/***/ "./node_modules/react-redux/lib/components/connectAdvanced.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__("./node_modules/hoist-non-react-statics/index.js");
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__("./node_modules/invariant/browser.js");
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _Subscription = __webpack_require__("./node_modules/react-redux/lib/utils/Subscription.js");
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__("./node_modules/react-redux/lib/utils/PropTypes.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidMount` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          if (this.subscription) this.subscription.tryUnsubscribe();
	          this.initSubscription();
	          if (shouldHandleStateChanges) this.subscription.trySubscribe();
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ }),

/***/ "./node_modules/react-redux/lib/connect/connect.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__("./node_modules/react-redux/lib/components/connectAdvanced.js");
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__("./node_modules/react-redux/lib/utils/shallowEqual.js");
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__("./node_modules/react-redux/lib/connect/mapDispatchToProps.js");
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__("./node_modules/react-redux/lib/connect/mapStateToProps.js");
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__("./node_modules/react-redux/lib/connect/mergeProps.js");
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__("./node_modules/react-redux/lib/connect/selectorFactory.js");
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ }),

/***/ "./node_modules/react-redux/lib/connect/mapDispatchToProps.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__("./node_modules/redux/lib/index.js");
	
	var _wrapMapToProps = __webpack_require__("./node_modules/react-redux/lib/connect/wrapMapToProps.js");
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ }),

/***/ "./node_modules/react-redux/lib/connect/mapStateToProps.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__("./node_modules/react-redux/lib/connect/wrapMapToProps.js");
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ }),

/***/ "./node_modules/react-redux/lib/connect/mergeProps.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__("./node_modules/react-redux/lib/utils/verifyPlainObject.js");
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ }),

/***/ "./node_modules/react-redux/lib/connect/selectorFactory.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__("./node_modules/react-redux/lib/connect/verifySubselectors.js");
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ }),

/***/ "./node_modules/react-redux/lib/connect/verifySubselectors.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__("./node_modules/react-redux/lib/utils/warning.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ }),

/***/ "./node_modules/react-redux/lib/connect/wrapMapToProps.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__("./node_modules/react-redux/lib/utils/verifyPlainObject.js");
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ }),

/***/ "./node_modules/react-redux/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;
	
	var _Provider = __webpack_require__("./node_modules/react-redux/lib/components/Provider.js");
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__("./node_modules/react-redux/lib/components/connectAdvanced.js");
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__("./node_modules/react-redux/lib/connect/connect.js");
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.createProvider = _Provider.createProvider;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ }),

/***/ "./node_modules/react-redux/lib/utils/PropTypes.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ }),

/***/ "./node_modules/react-redux/lib/utils/Subscription.js":
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ }),

/***/ "./node_modules/react-redux/lib/utils/shallowEqual.js":
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),

/***/ "./node_modules/react-redux/lib/utils/verifyPlainObject.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__("./node_modules/lodash/isPlainObject.js");
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__("./node_modules/react-redux/lib/utils/warning.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ }),

/***/ "./node_modules/react-redux/lib/utils/warning.js":
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),

/***/ "./node_modules/react-side-effect/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__("./node_modules/exenv/index.js");
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__("./node_modules/shallowequal/index.js");
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ "./node_modules/react-swipeable-views-core/lib/checkIndexBounds.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable flowtype/require-valid-file-annotation */
	
	var checkIndexBounds = function checkIndexBounds(props) {
	  var index = props.index,
	      children = props.children;
	
	
	  var childrenCount = _react.Children.count(children);
	
	   false ? (0, _warning2.default)(index >= 0 && index <= childrenCount, 'react-swipeable-view: the new index: ' + index + ' is out of bounds: [0-' + childrenCount + '].') : void 0;
	};
	
	exports.default = checkIndexBounds;

/***/ }),

/***/ "./node_modules/react-swipeable-views-core/lib/computeIndex.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = computeIndex;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _constant = __webpack_require__("./node_modules/react-swipeable-views-core/lib/constant.js");
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//  weak
	
	function computeIndex(params) {
	  var children = params.children,
	      startIndex = params.startIndex,
	      startX = params.startX,
	      pageX = params.pageX,
	      viewLength = params.viewLength,
	      resistance = params.resistance;
	
	
	  var indexMax = _react.Children.count(children) - 1;
	  var index = startIndex + (startX - pageX) / viewLength;
	  var newStartX = void 0;
	
	  if (!resistance) {
	    // Reset the starting point
	    if (index < 0) {
	      index = 0;
	      newStartX = (index - startIndex) * viewLength + pageX;
	    } else if (index > indexMax) {
	      index = indexMax;
	      newStartX = (index - startIndex) * viewLength + pageX;
	    }
	  } else if (index < 0) {
	    index = Math.exp(index * _constant2.default.RESISTANCE_COEF) - 1;
	  } else if (index > indexMax) {
	    index = indexMax + 1 - Math.exp((indexMax - index) * _constant2.default.RESISTANCE_COEF);
	  }
	
	  return {
	    index: index,
	    startX: newStartX
	  };
	}

/***/ }),

/***/ "./node_modules/react-swipeable-views-core/lib/constant.js":
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//  weak
	
	exports.default = {
	  RESISTANCE_COEF: 0.6,
	
	  // This value is closed to what browsers are using internally to
	  // trigger a native scroll.
	  UNCERTAINTY_THRESHOLD: 3 };

/***/ }),

/***/ "./node_modules/react-swipeable-views-core/lib/getDisplaySameSlide.js":
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//  weak
	
	var getDisplaySameSlide = function getDisplaySameSlide(props, nextProps) {
	  var displaySameSlide = false;
	
	  if (props.children.length && nextProps.children.length) {
	    var oldChildren = props.children[props.index];
	    var oldKey = oldChildren ? oldChildren.key : 'empty';
	
	    if (oldKey !== null) {
	      var newChildren = nextProps.children[nextProps.index];
	      var newKey = newChildren ? newChildren.key : 'empty';
	
	      if (oldKey === newKey) {
	        displaySameSlide = true;
	      }
	    }
	  }
	
	  return displaySameSlide;
	};
	
	exports.default = getDisplaySameSlide;

/***/ }),

/***/ "./node_modules/react-swipeable-views-core/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _checkIndexBounds = __webpack_require__("./node_modules/react-swipeable-views-core/lib/checkIndexBounds.js");
	
	Object.defineProperty(exports, 'checkIndexBounds', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_checkIndexBounds).default;
	  }
	});
	
	var _computeIndex = __webpack_require__("./node_modules/react-swipeable-views-core/lib/computeIndex.js");
	
	Object.defineProperty(exports, 'computeIndex', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_computeIndex).default;
	  }
	});
	
	var _constant = __webpack_require__("./node_modules/react-swipeable-views-core/lib/constant.js");
	
	Object.defineProperty(exports, 'constant', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_constant).default;
	  }
	});
	
	var _getDisplaySameSlide = __webpack_require__("./node_modules/react-swipeable-views-core/lib/getDisplaySameSlide.js");
	
	Object.defineProperty(exports, 'getDisplaySameSlide', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getDisplaySameSlide).default;
	  }
	});
	
	var _mod = __webpack_require__("./node_modules/react-swipeable-views-core/lib/mod.js");
	
	Object.defineProperty(exports, 'mod', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_mod).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./node_modules/react-swipeable-views-core/lib/mod.js":
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable flowtype/require-valid-file-annotation */
	
	function mod(n, m) {
	  var q = n % m;
	  return q < 0 ? q + m : q;
	}
	
	exports.default = mod;

/***/ }),

/***/ "./node_modules/react-swipeable-views/lib/SwipeableViews.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.getDomTreeShapes = getDomTreeShapes;
	exports.findNativeHandler = findNativeHandler;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _properties = __webpack_require__("./node_modules/dom-helpers/transition/properties.js");
	
	var _properties2 = _interopRequireDefault(_properties);
	
	var _on = __webpack_require__("./node_modules/dom-helpers/events/on.js");
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__("./node_modules/dom-helpers/events/off.js");
	
	var _off2 = _interopRequireDefault(_off);
	
	var _reactSwipeableViewsCore = __webpack_require__("./node_modules/react-swipeable-views-core/lib/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addEventListenerEnhanced(node, event, handler, options) {
	  (0, _on2.default)(node, event, handler, options);
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, options);
	    }
	  };
	} //  weak
	
	var styleInjected = false;
	
	// Support old version of iOS.
	// To be deleted in 2018.
	function injectStyle() {
	  // Inject once for all the instances
	  if (!styleInjected) {
	    var style = document.createElement('style');
	    style.innerHTML = '\n      .react-swipeable-view-container {\n        display: -webkit-box;\n      }\n    ';
	
	    if (document.body) {
	      document.body.appendChild(style);
	    }
	    styleInjected = true;
	  }
	}
	
	var styles = {
	  container: {
	    direction: 'ltr',
	    display: 'flex'
	  },
	  slide: {
	    width: '100%',
	    WebkitFlexShrink: 0,
	    flexShrink: 0,
	    overflow: 'auto'
	  }
	};
	
	var axisProperties = {
	  root: {
	    x: {
	      overflowX: 'hidden'
	    },
	    'x-reverse': {
	      overflowX: 'hidden'
	    },
	    y: {
	      overflowY: 'hidden'
	    },
	    'y-reverse': {
	      overflowY: 'hidden'
	    }
	  },
	  flexDirection: {
	    x: 'row',
	    'x-reverse': 'row-reverse',
	    y: 'column',
	    'y-reverse': 'column-reverse'
	  },
	  transform: {
	    x: function x(translate) {
	      return 'translate(' + -translate + '%, 0)';
	    },
	    'x-reverse': function xReverse(translate) {
	      return 'translate(' + translate + '%, 0)';
	    },
	    y: function y(translate) {
	      return 'translate(0, ' + -translate + '%)';
	    },
	    'y-reverse': function yReverse(translate) {
	      return 'translate(0, ' + translate + '%)';
	    }
	  },
	  length: {
	    x: 'width',
	    'x-reverse': 'width',
	    y: 'height',
	    'y-reverse': 'height'
	  },
	  rotationMatrix: {
	    x: {
	      x: [1, 0],
	      y: [0, 1]
	    },
	    'x-reverse': {
	      x: [-1, 0],
	      y: [0, 1]
	    },
	    y: {
	      x: [0, 1],
	      y: [1, 0]
	    },
	    'y-reverse': {
	      x: [0, -1],
	      y: [1, 0]
	    }
	  },
	  scrollPosition: {
	    x: 'scrollLeft',
	    'x-reverse': 'scrollLeft',
	    y: 'scrollTop',
	    'y-reverse': 'scrollTop'
	  },
	  scrollLength: {
	    x: 'scrollWidth',
	    'x-reverse': 'scrollWidth',
	    y: 'scrollHeight',
	    'y-reverse': 'scrollHeight'
	  },
	  clientLength: {
	    x: 'clientWidth',
	    'x-reverse': 'clientWidth',
	    y: 'clientHeight',
	    'y-reverse': 'clientHeight'
	  }
	};
	
	function createTransition(property, options) {
	  var duration = options.duration,
	      easeFunction = options.easeFunction,
	      delay = options.delay;
	
	
	  return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
	}
	
	// We are using a 2x2 rotation matrix.
	function applyRotationMatrix(touch, axis) {
	  var rotationMatrix = axisProperties.rotationMatrix[axis];
	
	  return {
	    pageX: rotationMatrix.x[0] * touch.pageX + rotationMatrix.x[1] * touch.pageY,
	    pageY: rotationMatrix.y[0] * touch.pageX + rotationMatrix.y[1] * touch.pageY
	  };
	}
	
	function adaptMouse(event) {
	  event.touches = [{ pageX: event.pageX, pageY: event.pageY }];
	  return event;
	}
	
	function getDomTreeShapes(element, rootNode) {
	  var domTreeShapes = [];
	
	  while (element && element !== rootNode) {
	    // We reach a Swipeable View, no need to look higher in the dom tree.
	    if (element.hasAttribute('data-swipeable')) {
	      break;
	    }
	
	    var style = window.getComputedStyle(element);
	
	    if (
	    // Ignore the scroll children if the element is absolute positioned.
	    style.getPropertyValue('position') === 'absolute' ||
	    // Ignore the scroll children if the element has an overflowX hidden
	    style.getPropertyValue('overflow-x') === 'hidden') {
	      domTreeShapes = [];
	    } else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) {
	      // Ignore the nodes that have no width.
	      // Keep elements with a scroll
	      domTreeShapes.push({
	        element: element,
	        scrollWidth: element.scrollWidth,
	        scrollHeight: element.scrollHeight,
	        clientWidth: element.clientWidth,
	        clientHeight: element.clientHeight,
	        scrollLeft: element.scrollLeft,
	        scrollTop: element.scrollTop
	      });
	    }
	
	    element = element.parentNode;
	  }
	
	  return domTreeShapes;
	}
	
	// We can only have one node at the time claiming ownership for handling the swipe.
	// Otherwise, the UX would be confusing.
	// That's why we use a singleton here.
	var nodeHowClaimedTheScroll = null;
	
	function findNativeHandler(params) {
	  var domTreeShapes = params.domTreeShapes,
	      pageX = params.pageX,
	      startX = params.startX,
	      axis = params.axis;
	
	
	  return domTreeShapes.some(function (shape) {
	    // Determine if we are going backward or forward.
	    var goingForward = pageX >= startX;
	    if (axis === 'x' || axis === 'y') {
	      goingForward = !goingForward;
	    }
	
	    var scrollPosition = shape[axisProperties.scrollPosition[axis]];
	
	    var areNotAtStart = scrollPosition > 0;
	    var areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];
	
	    if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
	      nodeHowClaimedTheScroll = shape.element;
	      return true;
	    }
	
	    return false;
	  });
	}
	
	var SwipeableViews = function (_Component) {
	  (0, _inherits3.default)(SwipeableViews, _Component);
	
	  function SwipeableViews() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SwipeableViews);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SwipeableViews.__proto__ || (0, _getPrototypeOf2.default)(SwipeableViews)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.rootNode = null, _this.containerNode = null, _this.ignoreNextScrollEvents = false, _this.viewLength = 0, _this.startX = 0, _this.lastX = 0, _this.vx = 0, _this.startY = 0, _this.isSwiping = undefined, _this.started = false, _this.startIndex = 0, _this.transitionListener = null, _this.touchMoveListener = null, _this.activeSlide = null, _this.handleSwipeStart = function (event) {
	      var axis = _this.props.axis;
	
	      // Latency and rapid rerenders on some devices can leave a period where rootNode briefly equals null
	
	      if (_this.rootNode === null) {
	        return;
	      }
	
	      var touch = applyRotationMatrix(event.touches[0], axis);
	
	      _this.viewLength = _this.rootNode.getBoundingClientRect()[axisProperties.length[axis]];
	      _this.startX = touch.pageX;
	      _this.lastX = touch.pageX;
	      _this.vx = 0;
	      _this.startY = touch.pageY;
	      _this.isSwiping = undefined;
	      _this.started = true;
	
	      var computedStyle = window.getComputedStyle(_this.containerNode);
	      var transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
	
	      if (transform) {
	        var transformValues = transform.split('(')[1].split(')')[0].split(',');
	        var rootStyle = window.getComputedStyle(_this.rootNode);
	
	        var tranformNormalized = applyRotationMatrix({
	          pageX: parseInt(transformValues[4], 10),
	          pageY: parseInt(transformValues[5], 10)
	        }, axis);
	
	        _this.startIndex = -tranformNormalized.pageX / (_this.viewLength - parseInt(rootStyle.paddingLeft, 10) - parseInt(rootStyle.paddingRight, 10));
	      }
	    }, _this.handleSwipeMove = function (event) {
	      // The touch start event can be cancel.
	      // Makes sure we set a starting point.
	      if (!_this.started) {
	        _this.handleTouchStart(event);
	        return;
	      }
	
	      // Latency and rapid rerenders on some devices can leave a period where rootNode briefly equals null
	      if (_this.rootNode === null) {
	        return;
	      }
	
	      // We are not supposed to hanlde this touch move.
	      if (nodeHowClaimedTheScroll !== null && nodeHowClaimedTheScroll !== _this.rootNode) {
	        return;
	      }
	
	      var _this$props = _this.props,
	          axis = _this$props.axis,
	          children = _this$props.children,
	          ignoreNativeScroll = _this$props.ignoreNativeScroll,
	          onSwitching = _this$props.onSwitching,
	          resistance = _this$props.resistance;
	
	
	      var touch = applyRotationMatrix(event.touches[0], axis);
	
	      // We don't know yet.
	      if (_this.isSwiping === undefined) {
	        var dx = Math.abs(_this.startX - touch.pageX);
	        var dy = Math.abs(_this.startY - touch.pageY);
	
	        var isSwiping = dx > dy && dx > _reactSwipeableViewsCore.constant.UNCERTAINTY_THRESHOLD;
	
	        // We are likely to be swiping, let's prevent the scroll event.
	        if (dx > dy) {
	          event.preventDefault();
	        }
	
	        if (isSwiping === true || dy > _reactSwipeableViewsCore.constant.UNCERTAINTY_THRESHOLD) {
	          _this.isSwiping = isSwiping;
	          _this.startX = touch.pageX; // Shift the starting point.
	
	          return; // Let's wait the next touch event to move something.
	        }
	      }
	
	      if (_this.isSwiping !== true) {
	        return;
	      }
	
	      // We are swiping, let's prevent the scroll event.
	      event.preventDefault();
	
	      // Low Pass filter.
	      _this.vx = _this.vx * 0.5 + (touch.pageX - _this.lastX) * 0.5;
	      _this.lastX = touch.pageX;
	
	      var _computeIndex = (0, _reactSwipeableViewsCore.computeIndex)({
	        children: children,
	        resistance: resistance,
	        pageX: touch.pageX,
	        startIndex: _this.startIndex,
	        startX: _this.startX,
	        viewLength: _this.viewLength
	      }),
	          index = _computeIndex.index,
	          startX = _computeIndex.startX;
	
	      // Add support for native scroll elements.
	
	
	      if (nodeHowClaimedTheScroll === null && !ignoreNativeScroll) {
	        var domTreeShapes = getDomTreeShapes(event.target, _this.rootNode);
	        var hasFoundNativeHandler = findNativeHandler({
	          domTreeShapes: domTreeShapes,
	          startX: _this.startX,
	          pageX: touch.pageX,
	          axis: axis
	        });
	
	        // We abort the touch move handler.
	        if (hasFoundNativeHandler) {
	          return;
	        }
	      }
	
	      // We are moving toward the edges.
	      if (startX) {
	        _this.startX = startX;
	      } else if (nodeHowClaimedTheScroll === null) {
	        nodeHowClaimedTheScroll = _this.rootNode;
	      }
	
	      _this.setState({
	        displaySameSlide: false,
	        isDragging: true,
	        indexCurrent: index
	      }, function () {
	        if (onSwitching) {
	          onSwitching(index, 'move');
	        }
	      });
	    }, _this.handleSwipeEnd = function () {
	      nodeHowClaimedTheScroll = null;
	
	      // The touch start event can be cancel.
	      // Makes sure that a starting point is set.
	      if (!_this.started) {
	        return;
	      }
	
	      _this.started = false;
	
	      if (_this.isSwiping !== true) {
	        return;
	      }
	
	      var indexLatest = _this.state.indexLatest;
	      var indexCurrent = _this.state.indexCurrent;
	      var delta = indexLatest - indexCurrent;
	
	      var indexNew = void 0;
	
	      // Quick movement
	      if (Math.abs(_this.vx) > _this.props.threshold) {
	        if (_this.vx > 0) {
	          indexNew = Math.floor(indexCurrent);
	        } else {
	          indexNew = Math.ceil(indexCurrent);
	        }
	      } else if (Math.abs(delta) > _this.props.hysteresis) {
	        // Some hysteresis with indexLatest.
	        indexNew = delta > 0 ? Math.floor(indexCurrent) : Math.ceil(indexCurrent);
	      } else {
	        indexNew = indexLatest;
	      }
	
	      var indexMax = _react.Children.count(_this.props.children) - 1;
	
	      if (indexNew < 0) {
	        indexNew = 0;
	      } else if (indexNew > indexMax) {
	        indexNew = indexMax;
	      }
	
	      _this.setState({
	        indexCurrent: indexNew,
	        indexLatest: indexNew,
	        isDragging: false
	      }, function () {
	        if (_this.props.onSwitching) {
	          _this.props.onSwitching(indexNew, 'end');
	        }
	
	        if (_this.props.onChangeIndex && indexNew !== indexLatest) {
	          _this.props.onChangeIndex(indexNew, indexLatest);
	        }
	
	        // Manually calling handleTransitionEnd in that case as isn't otherwise.
	        if (indexCurrent === indexLatest) {
	          _this.handleTransitionEnd();
	        }
	      });
	    }, _this.handleTouchStart = function (event) {
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	      _this.handleSwipeStart(event);
	    }, _this.handleTouchEnd = function (event) {
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	      _this.handleSwipeEnd(event);
	    }, _this.handleMouseDown = function (event) {
	      if (_this.props.onMouseDown) {
	        _this.props.onMouseDown(event);
	      }
	      event.persist();
	      _this.handleSwipeStart(adaptMouse(event));
	    }, _this.handleMouseUp = function (event) {
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(event);
	      }
	      _this.handleSwipeEnd(adaptMouse(event));
	    }, _this.handleMouseLeave = function (event) {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	
	      // Filter out events
	      if (_this.started) {
	        _this.handleSwipeEnd(adaptMouse(event));
	      }
	    }, _this.handleMouseMove = function (event) {
	      if (_this.props.onMouseMove) {
	        _this.props.onMouseMove(event);
	      }
	
	      // Filter out events
	      if (_this.started) {
	        _this.handleSwipeMove(adaptMouse(event));
	      }
	    }, _this.handleScroll = function (event) {
	      if (_this.props.onScroll) {
	        _this.props.onScroll(event);
	      }
	
	      // Ignore events bubbling up.
	      if (event.target !== _this.rootNode) {
	        return;
	      }
	
	      if (_this.ignoreNextScrollEvents) {
	        _this.ignoreNextScrollEvents = false;
	        return;
	      }
	
	      var indexLatest = _this.state.indexLatest;
	      var indexNew = Math.ceil(event.target.scrollLeft / event.target.clientWidth) + indexLatest;
	
	      _this.ignoreNextScrollEvents = true;
	      // Reset the scroll position.
	      event.target.scrollLeft = 0;
	
	      if (_this.props.onChangeIndex && indexNew !== indexLatest) {
	        _this.props.onChangeIndex(indexNew, indexLatest);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	  // Added as an ads.
	
	
	  (0, _createClass3.default)(SwipeableViews, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _this2 = this;
	
	      return {
	        swipeableViews: {
	          slideUpdateHeight: function slideUpdateHeight() {
	            _this2.updateHeight();
	          }
	        }
	      };
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (false) {
	        (0, _reactSwipeableViewsCore.checkIndexBounds)(this.props);
	      }
	
	      this.setState({
	        indexCurrent: this.props.index,
	        indexLatest: this.props.index,
	        isDragging: false,
	        isFirstRender: true,
	        heightLatest: 0
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      // Subscribe to transition end events.
	      this.transitionListener = addEventListenerEnhanced(this.containerNode, _properties2.default.end, function () {
	        _this3.handleTransitionEnd();
	      });
	
	      // Block the thread to handle that event.
	      this.touchMoveListener = addEventListenerEnhanced(this.rootNode, 'touchmove', function (event) {
	        // Handling touch events is disabled.
	        if (_this3.props.disabled) {
	          return;
	        }
	        _this3.handleSwipeMove(event);
	      }, {
	        passive: false
	      });
	
	      /* eslint-disable react/no-did-mount-set-state */
	      this.setState({
	        isFirstRender: false
	      });
	      /* eslint-enable react/no-did-mount-set-state */
	
	      injectStyle();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var index = nextProps.index;
	
	
	      if (typeof index === 'number' && index !== this.props.index) {
	        if (false) {
	          (0, _reactSwipeableViewsCore.checkIndexBounds)(nextProps);
	        }
	
	        this.setState({
	          // If true, we are going to change the children. We shoudn't animate it.
	          displaySameSlide: (0, _reactSwipeableViewsCore.getDisplaySameSlide)(this.props, nextProps),
	          indexCurrent: index,
	          indexLatest: index
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (!this.props.animateTransitions && prevState.indexCurrent !== this.state.indexCurrent) {
	        this.handleTransitionEnd();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.transitionListener.remove();
	      this.touchMoveListener.remove();
	    }
	  }, {
	    key: 'handleTransitionEnd',
	    value: function handleTransitionEnd() {
	      if (!this.props.onTransitionEnd) {
	        return;
	      }
	
	      // Filters out when changing the children
	      if (this.state.displaySameSlide) {
	        return;
	      }
	
	      // The rest callback is triggered when swiping. It's just noise.
	      // We filter it out.
	      if (!this.state.isDragging) {
	        this.props.onTransitionEnd();
	      }
	    }
	  }, {
	    key: 'updateHeight',
	    value: function updateHeight() {
	      if (this.activeSlide !== null) {
	        var child = this.activeSlide.children[0];
	        if (child !== undefined && child.offsetHeight !== undefined && this.state.heightLatest !== child.offsetHeight) {
	          this.setState({
	            heightLatest: child.offsetHeight
	          });
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          animateHeight = _props.animateHeight,
	          animateTransitions = _props.animateTransitions,
	          axis = _props.axis,
	          children = _props.children,
	          containerStyleProp = _props.containerStyle,
	          disabled = _props.disabled,
	          enableMouseEvents = _props.enableMouseEvents,
	          hysteresis = _props.hysteresis,
	          ignoreNativeScroll = _props.ignoreNativeScroll,
	          index = _props.index,
	          onChangeIndex = _props.onChangeIndex,
	          onSwitching = _props.onSwitching,
	          onTransitionEnd = _props.onTransitionEnd,
	          resistance = _props.resistance,
	          slideStyleProp = _props.slideStyle,
	          slideClassName = _props.slideClassName,
	          springConfig = _props.springConfig,
	          style = _props.style,
	          threshold = _props.threshold,
	          other = (0, _objectWithoutProperties3.default)(_props, ['animateHeight', 'animateTransitions', 'axis', 'children', 'containerStyle', 'disabled', 'enableMouseEvents', 'hysteresis', 'ignoreNativeScroll', 'index', 'onChangeIndex', 'onSwitching', 'onTransitionEnd', 'resistance', 'slideStyle', 'slideClassName', 'springConfig', 'style', 'threshold']);
	      var _state = this.state,
	          displaySameSlide = _state.displaySameSlide,
	          heightLatest = _state.heightLatest,
	          indexCurrent = _state.indexCurrent,
	          isDragging = _state.isDragging,
	          isFirstRender = _state.isFirstRender;
	
	
	      var touchEvents = !disabled ? {
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd
	      } : {};
	
	      var mouseEvents = !disabled && enableMouseEvents ? {
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseMove: this.handleMouseMove
	      } : {};
	
	      // There is no point to animate if we are already providing a height.
	       false ? (0, _warning2.default)(!animateHeight || !containerStyleProp || !containerStyleProp.height && !containerStyleProp.maxHeight && !containerStyleProp.minHeight, 'react-swipeable-view: You are setting animateHeight to true but you are also providing a custom height.\nThe custom height has a higher priority than the animateHeight property.\nSo animateHeight is most likely having no effect at all.') : void 0;
	
	      var slideStyle = (0, _assign2.default)({}, styles.slide, slideStyleProp);
	
	      var transition = void 0;
	      var WebkitTransition = void 0;
	
	      if (isDragging || !animateTransitions || displaySameSlide) {
	        transition = 'all 0s ease 0s';
	        WebkitTransition = 'all 0s ease 0s';
	      } else {
	        transition = createTransition('transform', springConfig);
	        WebkitTransition = createTransition('-webkit-transform', springConfig);
	
	        if (heightLatest !== 0) {
	          var additionalTranstion = ', ' + createTransition('height', springConfig);
	          transition += additionalTranstion;
	          WebkitTransition += additionalTranstion;
	        }
	      }
	
	      var transform = axisProperties.transform[axis](indexCurrent * 100);
	      var containerStyle = {
	        WebkitTransform: transform,
	        transform: transform,
	        height: null,
	        WebkitFlexDirection: axisProperties.flexDirection[axis],
	        flexDirection: axisProperties.flexDirection[axis],
	        WebkitTransition: WebkitTransition,
	        transition: transition
	      };
	
	      if (animateHeight) {
	        containerStyle.height = heightLatest;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({
	          ref: function ref(node) {
	            _this4.rootNode = node;
	          },
	          style: (0, _assign2.default)({}, axisProperties.root[axis], style)
	        }, other, touchEvents, mouseEvents, {
	          onScroll: this.handleScroll
	        }),
	        _react2.default.createElement(
	          'div',
	          {
	            ref: function ref(node) {
	              _this4.containerNode = node;
	            },
	            style: (0, _assign2.default)({}, containerStyle, styles.container, containerStyleProp),
	            className: 'react-swipeable-view-container'
	          },
	          _react.Children.map(children, function (child, indexChild) {
	            if (isFirstRender && indexChild > 0) {
	              return null;
	            }
	
	             false ? (0, _warning2.default)((0, _react.isValidElement)(child), 'react-swipeable-view: one of the children provided is invalid: ' + child + '.\nWe are expecting a valid React Element') : void 0;
	
	            var ref = void 0;
	            var hidden = true;
	
	            if (indexChild === _this4.state.indexLatest) {
	              hidden = false;
	
	              if (animateHeight) {
	                ref = function ref(node) {
	                  _this4.activeSlide = node;
	                  _this4.updateHeight();
	                };
	                slideStyle.overflowY = 'hidden';
	              }
	            }
	
	            return _react2.default.createElement(
	              'div',
	              {
	                ref: ref,
	                style: slideStyle,
	                className: slideClassName,
	                'aria-hidden': hidden,
	                'data-swipeable': 'true'
	              },
	              child
	            );
	          })
	        )
	      );
	    }
	  }]);
	  return SwipeableViews;
	}(_react.Component);
	
	SwipeableViews.displayName = 'ReactSwipableView';
	SwipeableViews.defaultProps = {
	  animateHeight: false,
	  animateTransitions: true,
	  axis: 'x',
	  disabled: false,
	  enableMouseEvents: false,
	  hysteresis: 0.6,
	  ignoreNativeScroll: false,
	  index: 0,
	  threshold: 5,
	  springConfig: {
	    duration: '0.35s',
	    easeFunction: 'cubic-bezier(0.15, 0.3, 0.25, 1)',
	    delay: '0s'
	  },
	  resistance: false
	};
	SwipeableViews.childContextTypes = {
	  swipeableViews: _propTypes2.default.shape({
	    slideUpdateHeight: _propTypes2.default.func
	  })
	};
	 false ? SwipeableViews.propTypes = {
	  /**
	   * If `true`, the height of the container will be animated to match the current slide height.
	   * Animating another style property has a negative impact regarding performance.
	   */
	  animateHeight: _propTypes2.default.bool,
	  /**
	   * If `false`, changes to the index prop will not cause an animated transition.
	   */
	  animateTransitions: _propTypes2.default.bool,
	  /**
	   * The axis on which the slides will slide.
	   */
	  axis: _propTypes2.default.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),
	  /**
	   * Use this property to provide your slides.
	   */
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * This is the inlined style that will be applied
	   * to each slide container.
	   */
	  containerStyle: _propTypes2.default.object,
	  /**
	   * If `true`, it will disable touch events.
	   * This is useful when you want to prohibit the user from changing slides.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * If `true`, it will enable mouse events.
	   * This will allow the user to perform the relevant swipe actions with a mouse.
	   */
	  enableMouseEvents: _propTypes2.default.bool,
	  /**
	   * Configure hysteresis between slides. This value determines how far
	   * should user swipe to switch slide.
	   */
	  hysteresis: _propTypes2.default.number,
	  /**
	   * If `true`, it will ignore native scroll container.
	   * It can be used to filter out false positive that blocks the swipe.
	   */
	  ignoreNativeScroll: _propTypes2.default.bool,
	  /**
	   * This is the index of the slide to show.
	   * This is useful when you want to change the default slide shown.
	   * Or when you have tabs linked to each slide.
	   */
	  index: _propTypes2.default.number,
	  /**
	   * This is callback prop. It's call by the
	   * component when the shown slide change after a swipe made by the user.
	   * This is useful when you have tabs linked to each slide.
	   *
	   * @param {integer} index This is the current index of the slide.
	   * @param {integer} indexLatest This is the oldest index of the slide.
	   */
	  onChangeIndex: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onMouseDown: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onMouseLeave: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onMouseMove: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onMouseUp: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onScroll: _propTypes2.default.func,
	  /**
	   * This is callback prop. It's called by the
	   * component when the slide switching.
	   * This is useful when you want to implement something corresponding to the current slide position.
	   *
	   * @param {integer} index This is the current index of the slide.
	   * @param {string} type Can be either `move` or `end`.
	   */
	  onSwitching: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onTouchEnd: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onTouchMove: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * The callback that fires when the animation comes to a rest.
	   * This is useful to defer CPU intensive task.
	   */
	  onTransitionEnd: _propTypes2.default.func,
	  /**
	   * If `true`, it will add bounds effect on the edges.
	   */
	  resistance: _propTypes2.default.bool,
	  /**
	   * This is the className that will be applied
	   * on the slide component.
	   */
	  slideClassName: _propTypes2.default.string,
	  /**
	   * This is the inlined style that will be applied
	   * on the slide component.
	   */
	  slideStyle: _propTypes2.default.object,
	  /**
	   * This is the config used to create CSS transitions.
	   * This is useful to change the dynamic of the transition.
	   */
	  springConfig: _propTypes2.default.shape({
	    duration: _propTypes2.default.string,
	    easeFunction: _propTypes2.default.string,
	    delay: _propTypes2.default.string
	  }),
	  /**
	   * This is the inlined style that will be applied
	   * on the root component.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * This is the threshold used for detecting a quick swipe.
	   * If the computed speed is above this value, the index change.
	   */
	  threshold: _propTypes2.default.number
	} : void 0;
	exports.default = SwipeableViews;

/***/ }),

/***/ "./node_modules/react-swipeable-views/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SwipeableViews = __webpack_require__("./node_modules/react-swipeable-views/lib/SwipeableViews.js");
	
	var _SwipeableViews2 = _interopRequireDefault(_SwipeableViews);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SwipeableViews2.default; //  weak

/***/ }),

/***/ "./node_modules/react-transition-group/CSSTransitionGroup.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__("./node_modules/react-transition-group/TransitionGroup.js");
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransitionGroupChild = __webpack_require__("./node_modules/react-transition-group/CSSTransitionGroupChild.js");
	
	var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);
	
	var _PropTypes = __webpack_require__("./node_modules/react-transition-group/utils/PropTypes.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  transitionName: _PropTypes.nameShape.isRequired,
	
	  transitionAppear: _propTypes2.default.bool,
	  transitionEnter: _propTypes2.default.bool,
	  transitionLeave: _propTypes2.default.bool,
	  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
	  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
	  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
	};
	
	var defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	var CSSTransitionGroup = function (_React$Component) {
	  _inherits(CSSTransitionGroup, _React$Component);
	
	  function CSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // We need to provide this childFactory so that
	  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	  // leave while it is leaving.
	
	
	  CSSTransitionGroup.prototype.render = function render() {
	    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return CSSTransitionGroup;
	}(_react2.default.Component);
	
	CSSTransitionGroup.displayName = 'CSSTransitionGroup';
	
	
	CSSTransitionGroup.propTypes =  false ? propTypes : {};
	CSSTransitionGroup.defaultProps = defaultProps;
	
	exports.default = CSSTransitionGroup;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-transition-group/CSSTransitionGroupChild.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _addClass = __webpack_require__("./node_modules/dom-helpers/class/addClass.js");
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__("./node_modules/dom-helpers/class/removeClass.js");
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _requestAnimationFrame = __webpack_require__("./node_modules/dom-helpers/util/requestAnimationFrame.js");
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _properties = __webpack_require__("./node_modules/dom-helpers/transition/properties.js");
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _PropTypes = __webpack_require__("./node_modules/react-transition-group/utils/PropTypes.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var events = [];
	if (_properties.transitionEnd) events.push(_properties.transitionEnd);
	if (_properties.animationEnd) events.push(_properties.animationEnd);
	
	function addEndListener(node, listener) {
	  if (events.length) {
	    events.forEach(function (e) {
	      return node.addEventListener(e, listener, false);
	    });
	  } else {
	    setTimeout(listener, 0);
	  }
	
	  return function () {
	    if (!events.length) return;
	    events.forEach(function (e) {
	      return node.removeEventListener(e, listener, false);
	    });
	  };
	}
	
	var propTypes = {
	  children: _propTypes2.default.node,
	  name: _PropTypes.nameShape.isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: _propTypes2.default.bool,
	  enter: _propTypes2.default.bool,
	  leave: _propTypes2.default.bool,
	  appearTimeout: _propTypes2.default.number,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	
	var CSSTransitionGroupChild = function (_React$Component) {
	  _inherits(CSSTransitionGroupChild, _React$Component);
	
	  function CSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
	    var node = (0, _reactDom.findDOMNode)(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timer = null;
	    var removeListeners = void 0;
	
	    (0, _addClass2.default)(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // Clean-up the animation after the specified delay
	    var finish = function finish(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timer);
	      if (removeListeners) removeListeners();
	
	      (0, _removeClass2.default)(node, className);
	      (0, _removeClass2.default)(node, activeClassName);
	
	      if (removeListeners) removeListeners();
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    if (timeout) {
	      timer = setTimeout(finish, timeout);
	      this.transitionTimeouts.push(timer);
	    } else if (_properties.transitionEnd) {
	      removeListeners = addEndListener(node, finish);
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
	    var _this2 = this;
	
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.rafHandle) {
	      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
	        return _this2.flushClassNameAndNodeQueue();
	      });
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
	    if (!this.unmounted) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        // This is for to force a repaint,
	        // which is necessary in order to transition styles when adding a class name.
	        /* eslint-disable no-unused-expressions */
	        obj.node.scrollTop;
	        /* eslint-enable no-unused-expressions */
	        (0, _addClass2.default)(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.rafHandle = null;
	  };
	
	  CSSTransitionGroupChild.prototype.render = function render() {
	    var props = _extends({}, this.props);
	    delete props.name;
	    delete props.appear;
	    delete props.enter;
	    delete props.leave;
	    delete props.appearTimeout;
	    delete props.enterTimeout;
	    delete props.leaveTimeout;
	    delete props.children;
	    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
	  };
	
	  return CSSTransitionGroupChild;
	}(_react2.default.Component);
	
	CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';
	
	
	CSSTransitionGroupChild.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransitionGroupChild;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-transition-group/TransitionGroup.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__("./node_modules/chain-function/index.js");
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__("./node_modules/react-transition-group/utils/ChildMapping.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-transition-group/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _CSSTransitionGroup = __webpack_require__("./node_modules/react-transition-group/CSSTransitionGroup.js");
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _TransitionGroup = __webpack_require__("./node_modules/react-transition-group/TransitionGroup.js");
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  TransitionGroup: _TransitionGroup2.default,
	  CSSTransitionGroup: _CSSTransitionGroup2.default
	};

/***/ }),

/***/ "./node_modules/react-transition-group/utils/ChildMapping.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),

/***/ "./node_modules/react-transition-group/utils/PropTypes.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nameShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  leaveActive: _propTypes2.default.string,
	  appear: _propTypes2.default.string,
	  appearActive: _propTypes2.default.string
	})]);

/***/ }),

/***/ "./node_modules/redux/lib/applyMiddleware.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__("./node_modules/redux/lib/compose.js");
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),

/***/ "./node_modules/redux/lib/bindActionCreators.js":
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),

/***/ "./node_modules/redux/lib/combineReducers.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__("./node_modules/redux/lib/createStore.js");
	
	var _isPlainObject = __webpack_require__("./node_modules/lodash/isPlainObject.js");
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__("./node_modules/redux/lib/utils/warning.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),

/***/ "./node_modules/redux/lib/compose.js":
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),

/***/ "./node_modules/redux/lib/createStore.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__("./node_modules/lodash/isPlainObject.js");
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__("./node_modules/symbol-observable/index.js");
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),

/***/ "./node_modules/redux/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__("./node_modules/redux/lib/createStore.js");
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__("./node_modules/redux/lib/combineReducers.js");
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__("./node_modules/redux/lib/bindActionCreators.js");
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__("./node_modules/redux/lib/applyMiddleware.js");
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__("./node_modules/redux/lib/compose.js");
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__("./node_modules/redux/lib/utils/warning.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),

/***/ "./node_modules/redux/lib/utils/warning.js":
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),

/***/ "./node_modules/shallowequal/index.js":
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ "./node_modules/styled-jsx/dist/render.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _object = __webpack_require__("./node_modules/object.entries/index.js");
	
	var _object2 = _interopRequireDefault(_object);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var tags = {};
	var prevStyles = {};
	
	exports.default = typeof window === 'undefined' ? renderOnServer : renderOnClient;
	
	
	function renderOnServer() {}
	
	function renderOnClient(components) {
	  var styles = {};
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = components[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var c = _step.value;
	
	      styles[c.props.styleId] = c;
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  patch(diff(prevStyles, styles));
	
	  prevStyles = styles;
	}
	
	function diff(a, b) {
	  var added = (0, _object2.default)(b).filter(function (_ref) {
	    var _ref2 = _slicedToArray(_ref, 1),
	        k = _ref2[0];
	
	    return !hasOwnProperty.call(a, k);
	  });
	  var removed = (0, _object2.default)(a).filter(function (_ref3) {
	    var _ref4 = _slicedToArray(_ref3, 1),
	        k = _ref4[0];
	
	    return !hasOwnProperty.call(b, k);
	  });
	  return [added, removed];
	}
	
	var fromServer = {};
	
	function patch(_ref5) {
	  var _ref6 = _slicedToArray(_ref5, 2),
	      added = _ref6[0],
	      removed = _ref6[1];
	
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = added[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var _step2$value = _slicedToArray(_step2.value, 2),
	          id = _step2$value[0],
	          c = _step2$value[1];
	
	      // avoid duplicates from server-rendered markup
	      if (undefined === fromServer[id]) {
	        fromServer[id] = document.getElementById('__jsx-style-' + id);
	      }
	
	      tags[id] = fromServer[id] || makeStyleTag(c.props.css);
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	
	  var _iteratorNormalCompletion3 = true;
	  var _didIteratorError3 = false;
	  var _iteratorError3 = undefined;
	
	  try {
	    for (var _iterator3 = removed[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	      var _step3$value = _slicedToArray(_step3.value, 1),
	          id = _step3$value[0];
	
	      var t = tags[id];
	      delete tags[id];
	      t.parentNode.removeChild(t);
	      // avoid checking the DOM later on
	      fromServer[id] = null;
	    }
	  } catch (err) {
	    _didIteratorError3 = true;
	    _iteratorError3 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion3 && _iterator3.return) {
	        _iterator3.return();
	      }
	    } finally {
	      if (_didIteratorError3) {
	        throw _iteratorError3;
	      }
	    }
	  }
	}
	
	function makeStyleTag(str) {
	  // based on implementation by glamor
	  var tag = document.createElement('style');
	  tag.appendChild(document.createTextNode(str));
	
	  var head = document.head || document.getElementsByTagName('head')[0];
	  head.appendChild(tag);
	
	  return tag;
	}

/***/ }),

/***/ "./node_modules/styled-jsx/dist/style.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.flush = flush;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _render = __webpack_require__("./node_modules/styled-jsx/dist/render.js");
	
	var _render2 = _interopRequireDefault(_render);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var update = typeof window === 'undefined' ? doRender : updateOnClient;
	var components = [];
	var updatePromise = void 0;
	
	var _class = function (_Component) {
	  _inherits(_class, _Component);
	
	  function _class() {
	    _classCallCheck(this, _class);
	
	    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	  }
	
	  _createClass(_class, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      mount(this);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate() {
	      update();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      unmount(this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return _class;
	}(_react.Component);
	
	exports.default = _class;
	function flush() {
	  var ret = {};
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = components[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var _ref2 = _step.value;
	      var props = _ref2.props;
	
	      ret[props.styleId] = props.css;
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  components = [];
	
	  return ret;
	}
	
	function mount(component) {
	  components.push(component);
	  update();
	}
	
	function unmount(component) {
	  var i = components.indexOf(component);
	  if (i < 0) {
	    return;
	  }
	
	  components.splice(i, 1);
	  update();
	}
	
	function updateOnClient() {
	  // Debounce calls and only render once the latest promise resolves.
	  // rAF causes FOUC in Safari, setTimeout causes FOUC in Chrome, Promise#then()
	  // ensures micro task enqueuing of styles update before paint.
	  var promise = updatePromise = Promise.resolve().then(function () {
	    if (promise === updatePromise) {
	      updatePromise = null;
	      doRender();
	    }
	  });
	}
	
	function doRender() {
	  (0, _render2.default)(components);
	}

/***/ }),

/***/ "./node_modules/styled-jsx/style.js":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__("./node_modules/styled-jsx/dist/style.js")


/***/ }),

/***/ "./node_modules/symbol-observable/index.js":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__("./node_modules/symbol-observable/lib/index.js");


/***/ }),

/***/ "./node_modules/symbol-observable/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__("./node_modules/symbol-observable/lib/ponyfill.js");
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/symbol-observable/lib/ponyfill.js":
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),

/***/ "./node_modules/webpack/buildin/module.js":
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),

/***/ "./node_modules/youtube-embed-video/dist/youtube.js":
/***/ (function(module, exports, __webpack_require__) {

	module.exports=function(e){function t(r){if(o[r])return o[r].exports;var s=o[r]={exports:{},id:r,loaded:!1};return e[r].call(s.exports,s,s.exports,t),s.loaded=!0,s.exports}var o={};return t.m=e,t.c=o,t.p="",t(0)}([function(e,t,o){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function s(e){var t=u(e),o=i(e.width,e.height,e.size),r=o.width,s=o.height;return n.default.createElement("iframe",{width:r,height:s,src:t,frameBorder:"0",allowFullScreen:!0})}function u(e){var t=[];return e.enhancedPrivacy?t.push("https://www.youtube-nocookie.com/embed/"):t.push("https://www.youtube.com/embed/"),t.push(e.videoId),t.push(e.autoplay?"?autoplay=1":"?autoplay=0"),e.suggestions||t.push("&rel=0"),e.controls||t.push("&controls=0"),e.showInfo||t.push("&showinfo=0"),t.join("")}function i(e,t,o){return o&&h.has(o.toLowerCase())?h.get(o.toLowerCase()):{width:e,height:t}}Object.defineProperty(t,"__esModule",{value:!0});var a=o(1),n=r(a),h=new Map([["small",{width:560,height:315}],["medium",{width:640,height:360}],["large",{width:853,height:480}],["largest",{width:1280,height:720}]]);s.propTypes={videoId:n.default.PropTypes.string.isRequired,width:n.default.PropTypes.number,height:n.default.PropTypes.number,size:n.default.PropTypes.string,autoplay:n.default.PropTypes.bool,enhancedPrivacy:n.default.PropTypes.bool,suggestions:n.default.PropTypes.bool,controls:n.default.PropTypes.bool,showInfo:n.default.PropTypes.bool},s.defaultProps={width:560,height:315,size:"",autoplay:!1,enhancedPrivacy:!1,suggestions:!0,controls:!0,showInfo:!0},t.default=s},function(e,t){e.exports=__webpack_require__("./node_modules/react/react.js")}]);
	//# sourceMappingURL=youtube.js.map

/***/ }),

/***/ "./src/actions/ui.ts":
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.setSearchVisible = function (payload) {
	    return {
	        payload: payload,
	        type: 'set search visible'
	    };
	};
	exports.hideOverlay = function () {
	    return {
	        type: 'hide overlay'
	    };
	};
	exports.setOverviewVideoVisible = function (payload) {
	    return {
	        payload: payload,
	        type: 'set overview video visible'
	    };
	};

/***/ }),

/***/ "./src/assets/graphics/todos-preview.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/todos-preview.700d6eb0.png";

/***/ }),

/***/ "./src/assets/icons/check.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,Cjxzdmcgd2lkdGg9IjEycHgiIGhlaWdodD0iOXB4IiB2aWV3Qm94PSIwIDAgMTIgOSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNDQuMSAoNDE0NTUpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iVjMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CiAgICAgICAgPGcgaWQ9IkFydGJvYXJkLUNvcHktMTAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02MzkuMDAwMDAwLCAtMjY2NS4wMDAwMDApIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZT0iI0ZGRkZGRiI+CiAgICAgICAgICAgIDxnIGlkPSJHcm91cC00NSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjM1LjAwMDAwMCwgMjYwOC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC00MCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDQ3LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC04IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgNC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICAgICAgPHBvbHlsaW5lIGlkPSJQYWdlLTEiIHBvaW50cz0iMTQuMzc1IDcgNy4zNDM3NSAxMy41NjI1IDUgMTEuMjE4NzUiPjwvcG9seWxpbmU+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ "./src/assets/icons/dotnet-core.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dotnet-core.52d94469.png";

/***/ }),

/***/ "./src/assets/icons/hamburger.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "./src/assets/icons/play.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzdweCIgaGVpZ2h0PSIzN3B4IiB2aWV3Qm94PSIwIDAgMzcgMzciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+DQo8ZyBpZD0iVjMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIG9wYWNpdHk9IjAuMzAwMDAwMDEyIj4NCgk8ZyBpZD0iQXJ0Ym9hcmQtQ29weS0xMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTUzOC4wMDAwMDAsIC0zNjkuMDAwMDAwKSI+DQoJCTxnIGlkPSJHcm91cC0zOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTM5LjAwMDAwMCwgMzcwLjAwMDAwMCkiPg0KCQkJPGcgaWQ9Ikdyb3VwLTM4Ij4NCgkJCQk8Y2lyY2xlIGlkPSJPdmFsLTIiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIyIiBjeD0iMTcuNSIgY3k9IjE3LjUiIHI9IjE3LjUiPjwvY2lyY2xlPg0KCQkJCTxwb2x5Z29uIGlkPSJUcmlhbmdsZSIgZmlsbD0iIzAwMDAwMCIgcG9pbnRzPSIyNS42NjY2NjY3IDE3LjMzMzMzMzMgMTQgMjUuMzMzMzMzMyAxNCA5LjMzMzMzMzMzIj48L3BvbHlnb24+DQoJCQk8L2c+DQoJCTwvZz4NCgk8L2c+DQo8L2c+DQo8L3N2Zz4="

/***/ }),

/***/ "./src/assets/icons/semanticlink.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pgo8c3ZnIHdpZHRoPSI2MS45MzE1MTJtbSIgaGVpZ2h0PSI0OC41NDE4MTNtbSIKICAgICB2aWV3Qm94PSIwIDAgNjEuOTMxNTEyIDQ4LjU0MTgxMyIKICAgICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIKICAgICB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8Zz4KICAgICAgICA8ZWxsaXBzZQogICAgICAgICAgICAgICAgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2U6IzAwMDBlNTtzdHJva2Utd2lkdGg6Mi43O3N0cm9rZS1vcGFjaXR5OjEuMDAwMDAwIgogICAgICAgICAgICAgICAgdHJhbnNmb3JtPSJtYXRyaXgoMC45Njc3NzYsLTAuMjUsMC4yNSwwLjk3LC01LjIyMDM5Myw3Ljc0NzA5NikiCiAgICAgICAgICAgICAgICBjeD0iMjcuNjU5NjE5IgogICAgICAgICAgICAgICAgY3k9IjI0LjI3MDkxMCIKICAgICAgICAgICAgICAgIHJ4PSIyMi41Mjc1MjkiCiAgICAgICAgICAgICAgICByeT0iMTcuNzk0NDYyIgogICAgICAgIC8+CiAgICAgICAgPGVsbGlwc2UKICAgICAgICAgICAgICAgIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlOiMwMDAwZTU7c3Ryb2tlLXdpZHRoOjIuMztzdHJva2Utb3BhY2l0eToxLjAwMDAwMCIKICAgICAgICAgICAgICAgIHRyYW5zZm9ybT0ibWF0cml4KDAuOTY3Nzc2LC0wLjI1LDAuMjUsMC45NywtNy41Mjc3NDgsMTQuMykiCiAgICAgICAgICAgICAgICBjeD0iNTIuMTAzNzM3IgogICAgICAgICAgICAgICAgY3k9IjM2LjU2MTk5OSIKICAgICAgICAgICAgICAgIHJ4PSI3LjE1NTA1NyIKICAgICAgICAgICAgICAgIHJ5PSI1Ljk4MzI3MiIKICAgICAgICAvPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ "./src/assets/icons/twitter.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkViZW5lXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSIzM3B4IiBoZWlnaHQ9IjMxcHgiIHZpZXdCb3g9Ii04IDEwLjUgMzMgMzEiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgLTggMTAuNSAzMyAzMTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnR3aXR0ZXItbG9nbyB7IGZpbGw6IzFEQTFGMjsgfQo8L3N0eWxlPgo8cGF0aCBjbGFzcz0idHdpdHRlci1sb2dvIiBkPSJNMi43NSwzOC4zNmMxMS43LDAsMTguMS05LjUyLDE4LjEtMTcuNzdjMC0wLjI3LDAtMC41NC0wLjAyLTAuODFjMS4yNC0wLjg4LDIuMzItMS45OCwzLjE3LTMuMjMKCWMtMS4xNiwwLjUtMi4zOSwwLjg0LTMuNjUsMC45OGMxLjMzLTAuNzgsMi4zMi0yLjAxLDIuOC0zLjQ1Yy0xLjI1LDAuNzMtMi42MSwxLjI0LTQuMDQsMS41MmMtMi40MS0yLjUxLTYuNDQtMi42NC05LTAuMjcKCWMtMS42NSwxLjUzLTIuMzUsMy44LTEuODQsNS45N2MtNS4xMi0wLjI1LTkuODgtMi42Mi0xMy4xMS02LjUzYy0xLjY5LDIuODUtMC44Myw2LjUsMS45Nyw4LjM0Yy0xLjAxLTAuMDMtMi0wLjMtMi44OS0wLjc4djAuMDgKCWMwLDIuOTcsMi4xNCw1LjUzLDUuMSw2LjEyYy0wLjk0LDAuMjUtMS45MiwwLjI5LTIuODcsMC4xMWMwLjgzLDIuNTQsMy4yMiw0LjI5LDUuOTQsNC4zNGMtMi4yNSwxLjc0LTUuMDMsMi42OC03LjksMi42OAoJQy02LDM1LjY2LTYuNSwzNS42My03LDM1LjU3Qy00LjA5LDM3LjM5LTAuNzEsMzguMzYsMi43NSwzOC4zNiIvPgo8L3N2Zz4K"

/***/ }),

/***/ "./src/assets/icons/video.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkViZW5lXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzNiAzNyIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzYgMzc7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHBhdGggaWQ9IlhNTElEXzNfIiBkPSJNMC4wMiwyLjIzdjMyLjU0YzAsMS40NywxLjUyLDIuNDIsMi44MSwxLjc2bDMyLjA4LTE2LjI3YzEuNDMtMC43MywxLjQzLTIuOCwwLTMuNTNMMi44MywwLjQ3CglDMi41NCwwLjMyLDIuMjUsMC4yNSwxLjk2LDAuMjVDMC45NCwwLjI1LDAuMDIsMS4wOSwwLjAyLDIuMjN6Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "./src/assets/icons/vue.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTJweCIgaGVpZ2h0PSI0NXB4IiB2aWV3Qm94PSIwIDAgNTIgNDUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZyBpZD0iRG9jcy1MYW5kaW5nIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iSG9tZS0od2l0aC1hbGwtcGxheWdyb3VuZC1lbGVtZW50cykiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMDc5LjAwMDAwMCwgLTk1MS4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTI5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyODguMDAwMDAwLCA4NjkuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMTQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDc3MC4wMDAwMDAsIDU0LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC0yNSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSJQYWdlLTEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxLjAwMDAwMCwgMjguMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iRmlsbC0xIiBmaWxsPSIjNDFCODgzIiBwb2ludHM9IjMxLjk3OTkzOTEgNi4xMDg1OTcyOWUtMDUgMjUuOTk5OTM5MSAxMC40MjU0MDA1IDE5Ljg4OTkzOTEgNi4xMDg1OTcyOWUtMDUgLTYuMDkzNzQ5OTllLTA1IDYuMTA4NTk3MjllLTA1IDI1Ljk5OTkzOTEgNDQuOTU5MzM3MSA1MS45OTk5MzkxIDYuMTA4NTk3MjllLTA1Ij48L3BvbHlnb24+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iRmlsbC0yIiBmaWxsPSIjNDFCODgzIiBwb2ludHM9IjQxLjYwMDA4MTMgNi4xMDg1OTcyOWUtMDUgMjUuOTk5ODc4MSAyNi45NzU2MjY3IDEwLjI3MDA4MTIgNi4xMDg1OTcyOWUtMDUgOC4xMjVlLTA1IDYuMTA4NTk3MjllLTA1IDI1Ljk5OTg3ODEgNDQuOTU5MzM3MSA1MS45OTk4NzgxIDYuMTA4NTk3MjllLTA1Ij48L3BvbHlnb24+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iRmlsbC0zIiBmaWxsPSIjMzU0OTVFIiBwb2ludHM9IjMxLjk3OTkzOTEgNi4xMDg1OTcyOWUtMDUgMjUuOTk5OTM5MSAxMC40MjU0MDA1IDE5Ljg4OTkzOTEgNi4xMDg1OTcyOWUtMDUgMTAuMjY5OTM5MSA2LjEwODU5NzI5ZS0wNSAyNS45OTk5MzkxIDI3LjEwNTk0MzQgNDEuNjAwMTQyMiA2LjEwODU5NzI5ZS0wNSI+PC9wb2x5Z29uPgogICAgICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ "./src/components/App.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var Header_1 = __webpack_require__("./src/components/Header.tsx");
	var Overlay_1 = __webpack_require__("./src/components/Overlay.tsx");
	var Search_1 = __webpack_require__("./src/components/Search/Search.tsx");
	var MobileMenu_1 = __webpack_require__("./src/components/MobileMenu.tsx");
	var OverviewVideoModal_1 = __webpack_require__("./src/components/OverviewVideoModal.tsx");
	var Logo_1 = __webpack_require__("./src/components/Logo.tsx");
	__webpack_require__("./src/utils/polyfill.js");
	function App(_ref) {
	  var children = _ref.children,
	      history = _ref.history,
	      steps = _ref.steps,
	      location = _ref.location;
	
	  return React.createElement(
	    "div",
	    {
	      "data-jsx": 3032456826
	    },
	    React.createElement(_style2.default, {
	      styleId: 1739026277,
	      css: "\n        html,\n        body,\n        div,\n        span,\n        applet,\n        object,\n        iframe,\n        h1,\n        h2,\n        h3,\n        h4,\n        h5,\n        h6,\n        p,\n        blockquote,\n        pre,\n        a,\n        abbr,\n        acronym,\n        address,\n        big,\n        cite,\n        code,\n        del,\n        dfn,\n        em,\n        img,\n        ins,\n        kbd,\n        q,\n        s,\n        samp,\n        small,\n        strike,\n        strong,\n        sub,\n        sup,\n        tt,\n        var,\n        b,\n        u,\n        i,\n        center,\n        dl,\n        dt,\n        dd,\n        ol,\n        ul,\n        li,\n        fieldset,\n        form,\n        label,\n        legend,\n        table,\n        caption,\n        tbody,\n        tfoot,\n        thead,\n        tr,\n        th,\n        td,\n        article,\n        aside,\n        canvas,\n        details,\n        embed,\n        figure,\n        figcaption,\n        footer,\n        header,\n        hgroup,\n        menu,\n        nav,\n        output,\n        ruby,\n        section,\n        summary,\n        time,\n        mark,\n        audio,\n        video{\n          margin:0;\n          padding:0;\n          border:0;\n          font-size:100%;\n          vertical-align:baseline;\n        }\n        article,\n        aside,\n        details,\n        figcaption,\n        figure,\n        footer,\n        header,\n        hgroup,\n        menu,\n        nav,\n        section{\n          display:block;\n        }\n        body{\n          line-height:1;\n        }\n        ol, ul{\n          list-style:none;\n        }\n        blockquote, q{\n          quotes:none;\n        }\n        blockquote:before, blockquote:after, q:before, q:after{\n          content:'';\n          content:none;\n        }\n        table{\n          border-collapse:collapse;\n          border-spacing:0;\n        }\n        body, input, select, option, textarea{\n          font-family:'Open Sans', sans-serif;\n          -webkit-font-smoothing:antialiased;\n          -moz-osx-font-smoothing:grayscale;\n        }\n        input, select, options, textarea{\n          outline:none;\n        }\n        h2{\n          font-size:35px;\n        }\n        .btn{\n          background:linear-gradient(103deg, rgba(42, 126, 210, .8), rgba(42, 126, 210, 1));\n          background-color:rgba(42, 126, 210, 1);\n          background-position:0 0;\n          background-repeat:no-repeat;\n          border:solid 2px #rgba(42,126,210,1);\n          padding:17px 30px 19px;\n          border-radius:6px;\n          transition:background-position .25s ease, box-shadow .25s ease;\n        }\n        .btn.green{\n          background-color:rgba(39, 174, 96, 1);\n          background-image:linear-gradient(\n            101deg,\n            #33BC7F,\n            #27ae60\n          );\n          border:solid 2px #27ae60;\n        }\n        .btn.green:hover{\n          border:solid 2px #27ae60;\n        }\n        .btn:hover{\n          background-position:-300px;\n          box-shadow:0 1px 5px 0 rgba(0, 0, 0, .2);\n        }\n        .btn.passive{\n          background:white;\n          border-color:rgba(23, 42, 58, .30);\n        }\n        @media (max-width: 500px){\n          div div.btn{\n            padding:10px 16px !important;\n          }\n          h2{\n            font-size:32px !important;\n            text-align:left !important;\n          }\n          section{\n            padding-top:38px !important;\n          }\n        }\n        .f38,\nh1{\n          font-size:38px;\n}\n        .lhTitle,\nh1,\nh2,\n.btn{\n          line-height:1.3;\n}\n        .lhTitle,\nh1,\nh2,\n.btn{\n          line-height:1.3;\n}\n        .f20,\nsection p,\n.btn.small{\n          font-size:20px;\n}\n        .darkBlue50,\nsection p{\n          color:rgba(23, 42, 58, .5);\n}\n        .lhCopy,\nsection p,\na{\n          line-height:1.5;\n}\n        .noUnderline,\na{\n          text-decoration:none;\n}\n        .lhCopy,\nsection p,\na{\n          line-height:1.5;\n}\n        .pt96,\nsection{\n          padding-top:96px;\n}\n        .tc,\nsection h2{\n          text-align:center;\n}\n        .white,\n.btn,\n.btn.green{\n          color:#fff;\n}\n        .f25,\n.btn{\n          font-size:25px;\n}\n        .fw6,\n.btn,\n.btn.small{\n          font-weight:600;\n}\n        .dib,\n.btn{\n          display:inline-block;\n}\n        .lhTitle,\nh1,\nh2,\n.btn{\n          line-height:1.3;\n}\n        .pointer:hover,\n.btn:hover{\n          cursor:pointer;\n}\n        .white,\n.btn,\n.btn.green{\n          color:#fff;\n}\n        .ba,\n.btn.passive{\n          border-style:solid;\n          border-width:1px;\n}\n        .bw2,\n.btn.passive{\n          border-width:2px;\n}\n        .blue,\n.btn.passive{\n          color:#2a7ed2;\n}\n        .f20,\nsection p,\n.btn.small{\n          font-size:20px;\n}\n        .fw6,\n.btn,\n.btn.small{\n          font-weight:600;\n}\n        .pv16,\n.btn.small{\n          padding-top:16px;\n          padding-bottom:16px;\n}\n        .ph20,\n.btn.small{\n          padding-left:20px;\n          padding-right:20px;\n}\n      "
	    }),
	    React.createElement(_style2.default, {
	      styleId: 148561658,
	      css: ".content[data-jsx=\"3032456826\"]{padding-top:68px;}.mobile-logo[data-jsx=\"3032456826\"]{z-index:10150;}@media (max-width: 1050px){div.mobile-logo[data-jsx=\"3032456826\"]{display:block;}}.fixed,\n.mobile-logo[data-jsx=\"3032456826\"]{position:fixed;}.top0,\n.mobile-logo[data-jsx=\"3032456826\"]{top:0;}.left0,\n.mobile-logo[data-jsx=\"3032456826\"]{left:0;}.dn,\n.mobile-logo[data-jsx=\"3032456826\"]{display:none;}"
	    }),
	    React.createElement(Overlay_1.default, null),
	    React.createElement(OverviewVideoModal_1.default, null),
	    React.createElement(Search_1.default, { history: history, location: location }),
	    React.createElement(MobileMenu_1.default, { steps: steps, location: location }),
	    React.createElement(Header_1.default, { steps: steps, location: location }),
	    React.createElement(
	      "div",
	      { className: "mobile-logo", "data-jsx": 3032456826
	      },
	      React.createElement(Logo_1.default, null)
	    ),
	    React.createElement(
	      "div",
	      { className: "content", "data-jsx": 3032456826
	      },
	      children
	    )
	  );
	}
	exports.default = App;

/***/ }),

/***/ "./src/components/Checkmark.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var cn = __webpack_require__("./node_modules/classnames/index.js");
	function Checkmark(_ref) {
	  var _ref$checked = _ref.checked,
	      checked = _ref$checked === undefined ? true : _ref$checked,
	      _ref$crossed = _ref.crossed,
	      crossed = _ref$crossed === undefined ? false : _ref$crossed;
	
	  return React.createElement(
	    "div",
	    { className: cn('checkmark', { checked: checked, crossed: crossed }), "data-jsx": 2859601940
	    },
	    React.createElement(_style2.default, {
	      styleId: 2859601940,
	      css: ".checkmark[data-jsx=\"2859601940\"]{height:20px;width:20px;}.checkmark.crossed[data-jsx=\"2859601940\"]{left:-2px;width:24px;height:24px;}@media (max-width: 500px){div.checkmark[data-jsx=\"2859601940\"]{-ms-flex:0 0 auto;-webkit-box-flex:0;flex:0 0 auto;}}.br100,\n.checkmark[data-jsx=\"2859601940\"]{border-radius:100%;}.white,\n.checkmark[data-jsx=\"2859601940\"]{color:#fff;}.flex,\n.checkmark[data-jsx=\"2859601940\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.itemsCenter,\n.checkmark[data-jsx=\"2859601940\"]{-webkit-box-align:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;}.justifyCenter,\n.checkmark[data-jsx=\"2859601940\"]{-ms-flex-pack:center;-webkit-box-pack:center;justify-content:center;}.ba,\n.checkmark[data-jsx=\"2859601940\"]{border-style:solid;border-width:1px;}.bBlack30,\n.checkmark[data-jsx=\"2859601940\"]{border-color:rgba(0, 0, 0, .3);}.bw2,\n.checkmark[data-jsx=\"2859601940\"]{border-width:2px;}.relative,\n.checkmark[data-jsx=\"2859601940\"]{position:relative;}.bbox,\n.checkmark[data-jsx=\"2859601940\"]{box-sizing:border-box;}.bgBlue,\n.checkmark.checked[data-jsx=\"2859601940\"]{background-color:#2a7ed2;}.bw0,\n.checkmark.checked[data-jsx=\"2859601940\"]{border-width:0;}.bBlack20,\n.checkmark.crossed[data-jsx=\"2859601940\"]{border-color:rgba(0, 0, 0, .2);}.black20,\n.cross[data-jsx=\"2859601940\"]{color:rgba(0, 0, 0, .2);}.fw7,\n.cross[data-jsx=\"2859601940\"]{font-weight:700;}.f20,\n.cross[data-jsx=\"2859601940\"]{font-size:20px;}"
	    }),
	    checked && React.createElement("img", { src: __webpack_require__("./src/assets/icons/check.svg"), alt: "", "data-jsx": 2859601940
	    }),
	    crossed && React.createElement(
	      "div",
	      { className: "cross", "data-jsx": 2859601940
	      },
	      "\xD7"
	    )
	  );
	}
	exports.default = Checkmark;

/***/ }),

/***/ "./src/components/CustomHelmet.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var react_helmet_1 = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	function CustomHelmet(_ref) {
	    var title = _ref.title,
	        description = _ref.description,
	        overrideDescription = _ref.overrideDescription;
	
	    return React.createElement(react_helmet_1.Helmet, { title: title, meta: [{ name: 'description', content: overrideDescription || title }, { property: 'og:type', content: 'article' }, { property: 'og:title', content: title }, { property: 'og:description', content: description }, { name: 'twitter:card', content: 'summary_large_image' }, { name: 'twitter:title', content: title }, { name: 'twitter:description', content: description }] });
	}
	exports.default = CustomHelmet;

/***/ }),

/***/ "./src/components/Duration.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var cn = __webpack_require__("./node_modules/classnames/index.js");
	var gatsby_link_1 = __webpack_require__("./node_modules/gatsby-link/index.js");
	function Duration(_ref) {
	  var duration = _ref.duration,
	      total = _ref.total,
	      dark = _ref.dark,
	      className = _ref.className,
	      link = _ref.link;
	
	  var component = React.createElement(
	    "div",
	    { className: cn('time', className, { dark: dark }), "data-jsx": 287658195
	    },
	    React.createElement(_style2.default, {
	      styleId: 287658195,
	      css: ".time[data-jsx=\"287658195\"]{font-size:15px;}.time[data-jsx=\"287658195\"] img[data-jsx=\"287658195\"]{width:15px;height:15px;}.time.first[data-jsx=\"287658195\"]{top:-3px;}.time.dark[data-jsx=\"287658195\"] img[data-jsx=\"287658195\"]{filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"table\" tableValues=\"1 0\" /><feFuncG type=\"table\" tableValues=\"1 0\" /><feFuncB type=\"table\" tableValues=\"1 0\" /></feComponentTransfer></filter></svg>#filter');-webkit-filter:invert(100%);filter:invert(100%);}@media (max-width: 500px){div.time[data-jsx=\"287658195\"]{display:none;}}.ttu,\n.time[data-jsx=\"287658195\"]{text-transform:uppercase;}.black30,\n.time[data-jsx=\"287658195\"]{color:rgba(0, 0, 0, .3);}.ml10,\n.time[data-jsx=\"287658195\"]{margin-left:10px;}.itemsCenter,\n.time[data-jsx=\"287658195\"]{-webkit-box-align:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;}.flex,\n.time[data-jsx=\"287658195\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.fw6,\n.time[data-jsx=\"287658195\"]{font-weight:600;}.relative,\n.time[data-jsx=\"287658195\"]{position:relative;}.flexFixed,\n.time[data-jsx=\"287658195\"]{-ms-flex:0 0 auto;-webkit-box-flex:0;flex:0 0 auto;}.white30,\n.time.dark[data-jsx=\"287658195\"]{color:hsla(0, 0%, 100%, .3);}.ml6,\n.time[data-jsx=\"287658195\"] span[data-jsx=\"287658195\"]{margin-left:6px;}"
	    }),
	    React.createElement("img", { src: __webpack_require__("./src/assets/icons/play.svg"), alt: "", "data-jsx": 287658195
	    }),
	    React.createElement(
	      "span",
	      {
	        "data-jsx": 287658195
	      },
	      duration,
	      " MIN ",
	      total ? 'TOTAL' : ''
	    )
	  );
	  if (link) {
	    return React.createElement(
	      gatsby_link_1.default,
	      { to: link + '?autoplay' },
	      component
	    );
	  } else {
	    return component;
	  }
	}
	exports.default = Duration;

/***/ }),

/***/ "./src/components/Header.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var Nav_1 = __webpack_require__("./src/components/Nav.tsx");
	var Logo_1 = __webpack_require__("./src/components/Logo.tsx");
	function Header(_ref) {
	  var steps = _ref.steps,
	      location = _ref.location;
	
	  return React.createElement(
	    "div",
	    { className: "header", "data-jsx": 677676485
	    },
	    React.createElement(_style2.default, {
	      styleId: 677676485,
	      css: ".header[data-jsx=\"677676485\"]{z-index:1000;-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);}@media (min-width: 1051px){div.header-logo[data-jsx=\"677676485\"]{opacity:1;}}.flex,\n.header[data-jsx=\"677676485\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.bb,\n.header[data-jsx=\"677676485\"]{border-bottom-style:solid;border-bottom-width:1px;}.bDarkBlue10,\n.header[data-jsx=\"677676485\"]{border-color:rgba(23, 42, 58, .1);}.bw2,\n.header[data-jsx=\"677676485\"]{border-width:2px;}.justifyBetween,\n.header[data-jsx=\"677676485\"]{-ms-flex-pack:justify;-webkit-box-pack:justify;justify-content:space-between;}.fixed,\n.header[data-jsx=\"677676485\"]{position:fixed;}.left0,\n.header[data-jsx=\"677676485\"]{left:0;}.right0,\n.header[data-jsx=\"677676485\"]{right:0;}.top0,\n.header[data-jsx=\"677676485\"]{top:0;}.bgWhite,\n.header[data-jsx=\"677676485\"]{background-color:#fff;}.o0,\n.header-logo[data-jsx=\"677676485\"]{opacity:0;}"
	    }),
	    React.createElement(
	      "div",
	      { className: "header-logo", "data-jsx": 677676485
	      },
	      React.createElement(Logo_1.default, null)
	    ),
	    React.createElement(Nav_1.default, { steps: steps, location: location })
	  );
	}
	exports.default = Header;

/***/ }),

/***/ "./src/components/Logo.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var gatsby_link_1 = __webpack_require__("./node_modules/gatsby-link/index.js");
	function Logo() {
	  return React.createElement(
	    "div",
	    { className: "logo-wrapper", "data-jsx": 3934051051
	    },
	    React.createElement(_style2.default, {
	      styleId: 3934051051,
	      css: ".logo[data-jsx=\"3934051051\"]{z-index:10102;font-size:17px;}img[data-jsx=\"3934051051\"]{width:40px;height:35px;}.flex,\n.logo[data-jsx=\"3934051051\"],\n.logo-wrapper[data-jsx=\"3934051051\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.ttu,\n.logo[data-jsx=\"3934051051\"]{text-transform:uppercase;}.fw6,\n.logo[data-jsx=\"3934051051\"]{font-weight:600;}.itemsCenter,\n.logo[data-jsx=\"3934051051\"],\n.logo-wrapper[data-jsx=\"3934051051\"]{-webkit-box-align:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;}.blue,\n.logo[data-jsx=\"3934051051\"]{color:#2a7ed2;}.mr10,\n.logo[data-jsx=\"3934051051\"] img[data-jsx=\"3934051051\"]{margin-right:10px;}.flexFixed,\n.logo[data-jsx=\"3934051051\"] span[data-jsx=\"3934051051\"]{-ms-flex:0 0 auto;-webkit-box-flex:0;flex:0 0 auto;}.flex,\n.logo[data-jsx=\"3934051051\"],\n.logo-wrapper[data-jsx=\"3934051051\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.pa16,\n.logo-wrapper[data-jsx=\"3934051051\"]{padding:16px;}.itemsCenter,\n.logo[data-jsx=\"3934051051\"],\n.logo-wrapper[data-jsx=\"3934051051\"]{-webkit-box-align:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;}"
	    }),
	    React.createElement(
	      gatsby_link_1.default,
	      { to: "/" },
	      React.createElement(
	        "div",
	        { className: "logo", "data-jsx": 3934051051
	        },
	        React.createElement("img", { src: __webpack_require__("./src/assets/icons/semanticlink.svg"), alt: "", "data-jsx": 3934051051
	        }),
	        React.createElement(
	          "span",
	          {
	            "data-jsx": 3934051051
	          },
	          "How to Hypermedia"
	        )
	      )
	    )
	  );
	}
	exports.default = Logo;

/***/ }),

/***/ "./src/components/MobileMenu.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var Icon_1 = __webpack_require__("./node_modules/graphcool-styles/dist/components/Icon/Icon.js");
	var cn = __webpack_require__("./node_modules/classnames/index.js");
	var Sidebar_1 = __webpack_require__("./src/components/Tutorials/Sidebar.tsx");
	
	var MobileMenu = function (_React$Component) {
	  _inherits(MobileMenu, _React$Component);
	
	  function MobileMenu(props) {
	    _classCallCheck(this, MobileMenu);
	
	    var _this = _possibleConstructorReturn(this, (MobileMenu.__proto__ || Object.getPrototypeOf(MobileMenu)).call(this, props));
	
	    _this.toggleMenu = function () {
	      _this.setState(function (state) {
	        return { menuOpen: !state.menuOpen };
	      });
	    };
	    _this.state = {
	      menuOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(MobileMenu, [{
	    key: "render",
	    value: function render() {
	      var menuOpen = this.state.menuOpen;
	      var _props = this.props,
	          steps = _props.steps,
	          location = _props.location;
	
	      if (location.pathname === '/') {
	        return null;
	      }
	      return React.createElement(
	        "div",
	        { className: "mobile-menu", "data-jsx": 260509116
	        },
	        React.createElement(_style2.default, {
	          styleId: 260509116,
	          css: ".mobile-menu[data-jsx=\"260509116\"]{z-index:10200;}.hamburger[data-jsx=\"260509116\"]{padding:16px;padding-top:18px;}.menu-overlay[data-jsx=\"260509116\"]{pointer-events:none;background-color:#F5F5F5;transition:opacity .25s ease-in-out;}.menu-overlay.visible[data-jsx=\"260509116\"]{pointer-events:all;}.oval[data-jsx=\"260509116\"]{background-color:rgba(0, 0, 0, .03);top:-790px;right:-290px;width:481px;height:909px;-webkit-transform:rotate(-9deg);transform:rotate(-9deg);}@media (min-width: 1051px){.mobile-menu[data-jsx=\"260509116\"]{display:none;}}.mobile-menu[data-jsx=\"260509116\"] .sidebar{height:100vh;width:100vw;padding-right:25px;}.fixed,\n.mobile-menu[data-jsx=\"260509116\"],\n.menu-overlay[data-jsx=\"260509116\"]{position:fixed;}.right0,\n.mobile-menu[data-jsx=\"260509116\"],\n.menu-overlay[data-jsx=\"260509116\"],\n.close[data-jsx=\"260509116\"]{right:0;}.top0,\n.mobile-menu[data-jsx=\"260509116\"],\n.menu-overlay[data-jsx=\"260509116\"],\n.close[data-jsx=\"260509116\"]{top:0;}.bgWhite,\n.hamburger[data-jsx=\"260509116\"]{background-color:#fff;}.pointer:hover,\n.hamburger[data-jsx=\"260509116\"]:hover,\n.oval[data-jsx=\"260509116\"]:hover{cursor:pointer;}.fixed,\n.mobile-menu[data-jsx=\"260509116\"],\n.menu-overlay[data-jsx=\"260509116\"]{position:fixed;}.top0,\n.mobile-menu[data-jsx=\"260509116\"],\n.menu-overlay[data-jsx=\"260509116\"],\n.close[data-jsx=\"260509116\"]{top:0;}.left0,\n.menu-overlay[data-jsx=\"260509116\"]{left:0;}.right0,\n.mobile-menu[data-jsx=\"260509116\"],\n.menu-overlay[data-jsx=\"260509116\"],\n.close[data-jsx=\"260509116\"]{right:0;}.bottom0,\n.menu-overlay[data-jsx=\"260509116\"]{bottom:0;}.o0,\n.menu-overlay[data-jsx=\"260509116\"]{opacity:0;}.o100,\n.menu-overlay.visible[data-jsx=\"260509116\"]{opacity:1;}.flex,\n.menu-overlay[data-jsx=\"260509116\"] .sidebar-container{display:-ms-flexbox;display:-webkit-box;display:flex;}.brPill,\n.oval[data-jsx=\"260509116\"]{border-radius:9999px;}.absolute,\n.oval[data-jsx=\"260509116\"],\n.close[data-jsx=\"260509116\"]{position:absolute;}.z2,\n.oval[data-jsx=\"260509116\"],\n.close[data-jsx=\"260509116\"]{z-index:2;}.pointer:hover,\n.hamburger[data-jsx=\"260509116\"]:hover,\n.oval[data-jsx=\"260509116\"]:hover{cursor:pointer;}.absolute,\n.oval[data-jsx=\"260509116\"],\n.close[data-jsx=\"260509116\"]{position:absolute;}.top0,\n.mobile-menu[data-jsx=\"260509116\"],\n.menu-overlay[data-jsx=\"260509116\"],\n.close[data-jsx=\"260509116\"]{top:0;}.right0,\n.mobile-menu[data-jsx=\"260509116\"],\n.menu-overlay[data-jsx=\"260509116\"],\n.close[data-jsx=\"260509116\"]{right:0;}.pa25,\n.close[data-jsx=\"260509116\"]{padding:25px;}.z2,\n.oval[data-jsx=\"260509116\"],\n.close[data-jsx=\"260509116\"]{z-index:2;}"
	        }),
	        React.createElement(
	          "div",
	          { className: "hamburger", onClick: this.toggleMenu, "data-jsx": 260509116
	          },
	          React.createElement(Icon_1.default, { src: __webpack_require__("./src/assets/icons/hamburger.svg"), width: 7, height: 33 })
	        ),
	        React.createElement(
	          "div",
	          { className: cn('menu-overlay', { visible: menuOpen }), "data-jsx": 260509116
	          },
	          React.createElement(Sidebar_1.default, { steps: steps, location: location, onClickLink: this.toggleMenu }),
	          React.createElement("div", { className: "oval", onClick: this.toggleMenu, "data-jsx": 260509116
	          }),
	          React.createElement(
	            "div",
	            { className: "close", onClick: this.toggleMenu, "data-jsx": 260509116
	            },
	            React.createElement(Icon_1.default, { src: __webpack_require__("./node_modules/graphcool-styles/icons/stroke/cross.svg"), width: 15, height: 15, color: '#B2B2B2', stroke: true, strokeWidth: 6 })
	          )
	        )
	      );
	    }
	  }]);
	
	  return MobileMenu;
	}(React.Component);
	
	exports.default = MobileMenu;

/***/ }),

/***/ "./src/components/Nav.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var Icon_1 = __webpack_require__("./node_modules/graphcool-styles/dist/components/Icon/Icon.js");
	var graphcool_styles_1 = __webpack_require__("./node_modules/graphcool-styles/dist/build.js");
	var tutorials_1 = __webpack_require__("./src/utils/tutorials.ts");
	var Stack_1 = __webpack_require__("./src/components/Steps/Stack.tsx");
	
	var Nav = function (_React$Component) {
	  _inherits(Nav, _React$Component);
	
	  function Nav(props) {
	    _classCallCheck(this, Nav);
	
	    var _this = _possibleConstructorReturn(this, (Nav.__proto__ || Object.getPrototypeOf(Nav)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Nav, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          steps = _props.steps,
	          location = _props.location;
	
	      var frontendTutorials = tutorials_1.getFrontendTutorials(steps);
	      var backendTutorials = tutorials_1.getBackendTutorials(steps);
	      return React.createElement(
	        "div",
	        { className: "right", "data-jsx": 3308391659
	        },
	        React.createElement(_style2.default, {
	          styleId: 3308391659,
	          css: ".element[data-jsx=\"3308391659\"]{transition:opacity ease-in-out 0.25s;}.element[data-jsx=\"3308391659\"]:hover .dropdown{pointer-events:all;}@media (max-width: 1050px){div.right[data-jsx=\"3308391659\"]{display:none;}}.flex,\n.right[data-jsx=\"3308391659\"],\n.element[data-jsx=\"3308391659\"],\n.element.github[data-jsx=\"3308391659\"],\n.graphql[data-jsx=\"3308391659\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.f14,\n.element[data-jsx=\"3308391659\"],\n.triangle[data-jsx=\"3308391659\"]{font-size:14px;}.ph25,\n.element[data-jsx=\"3308391659\"],\n.element.github[data-jsx=\"3308391659\"]{padding-left:25px;padding-right:25px;}.darkBlue60,\n.element[data-jsx=\"3308391659\"]{color:rgba(23, 42, 58, .6);}.pointer:hover,\n.element[data-jsx=\"3308391659\"]:hover{cursor:pointer;}.itemsCenter,\n.element[data-jsx=\"3308391659\"],\n.element.github[data-jsx=\"3308391659\"]{-webkit-box-align:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;}.flex,\n.right[data-jsx=\"3308391659\"],\n.element[data-jsx=\"3308391659\"],\n.element.github[data-jsx=\"3308391659\"],\n.graphql[data-jsx=\"3308391659\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.relative,\n.element[data-jsx=\"3308391659\"]{position:relative;}.darkBlue,\n.element[data-jsx=\"3308391659\"]:hover{color:#172a3a;}.o100,\n.element[data-jsx=\"3308391659\"]:hover .dropdown{opacity:1;}.o0,\n.element[data-jsx=\"3308391659\"]:hover:active .dropdown{opacity:0;}.f14,\n.element[data-jsx=\"3308391659\"],\n.triangle[data-jsx=\"3308391659\"]{font-size:14px;}.ml6,\n.triangle[data-jsx=\"3308391659\"]{margin-left:6px;}.ph25,\n.element[data-jsx=\"3308391659\"],\n.element.github[data-jsx=\"3308391659\"]{padding-left:25px;padding-right:25px;}.flex,\n.right[data-jsx=\"3308391659\"],\n.element[data-jsx=\"3308391659\"],\n.element.github[data-jsx=\"3308391659\"],\n.graphql[data-jsx=\"3308391659\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.itemsCenter,\n.element[data-jsx=\"3308391659\"],\n.element.github[data-jsx=\"3308391659\"]{-webkit-box-align:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;}.pv0,\n.element.github[data-jsx=\"3308391659\"]{padding-top:0;padding-bottom:0;}.flex,\n.right[data-jsx=\"3308391659\"],\n.element[data-jsx=\"3308391659\"],\n.element.github[data-jsx=\"3308391659\"],\n.graphql[data-jsx=\"3308391659\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}"
	        }),
	        React.createElement(
	          "div",
	          { className: "element", "data-jsx": 3308391659
	          },
	          React.createElement(
	            "span",
	            {
	              "data-jsx": 3308391659
	            },
	            "Hypermedia"
	          ),
	          React.createElement(
	            "span",
	            { className: "triangle", "data-jsx": 3308391659
	            },
	            "\u25BE"
	          ),
	          React.createElement(
	            Dropdown,
	            null,
	            React.createElement(
	              "div",
	              { className: "graphql", "data-jsx": 3308391659
	              },
	              React.createElement(Stack_1.default, { name: "Fundamentals", steps: steps.basics, location: location }),
	              React.createElement(Stack_1.default, { name: "Advanced", steps: steps.advanced, location: location })
	            )
	          )
	        ),
	        React.createElement(
	          "div",
	          { className: "element", "data-jsx": 3308391659
	          },
	          React.createElement(
	            "span",
	            {
	              "data-jsx": 3308391659
	            },
	            "Client"
	          ),
	          React.createElement(
	            "span",
	            { className: "triangle", "data-jsx": 3308391659
	            },
	            "\u25BE"
	          ),
	          React.createElement(
	            Dropdown,
	            null,
	            React.createElement(Stack_1.default, { name: "All Client Tutorials", steps: frontendTutorials, location: location, showLines: false })
	          )
	        ),
	        React.createElement(
	          "div",
	          { className: "element", "data-jsx": 3308391659
	          },
	          React.createElement(
	            "span",
	            {
	              "data-jsx": 3308391659
	            },
	            "Api"
	          ),
	          React.createElement(
	            "span",
	            { className: "triangle", "data-jsx": 3308391659
	            },
	            "\u25BE"
	          ),
	          React.createElement(
	            Dropdown,
	            null,
	            React.createElement(Stack_1.default, { name: "All Api Tutorials", steps: backendTutorials, location: location, showLines: false })
	          )
	        ),
	        React.createElement(
	          "a",
	          { className: "element github", href: "https://github.com/semanticlink/howtohypermedia", target: "_blank", "data-jsx": 3308391659
	          },
	          React.createElement(Icon_1.default, { src: __webpack_require__("./node_modules/graphcool-styles/icons/fill/github.svg"), color: graphcool_styles_1.$v.gray30, width: 32, height: 32 })
	        )
	      );
	    }
	  }]);
	
	  return Nav;
	}(React.Component);
	
	exports.default = Nav;
	function Dropdown(_ref) {
	  var children = _ref.children;
	
	  return React.createElement(
	    "div",
	    { className: "dropdown", "data-jsx": 1586564003
	    },
	    React.createElement(_style2.default, {
	      styleId: 1586564003,
	      css: ".dropdown[data-jsx=\"1586564003\"]{transition:opacity ease-in-out 0.1s;pointer-events:none;right:0;top:67px;}.big-triangle[data-jsx=\"1586564003\"]{right:48px;top:-16px;width:0;height:0;border-style:solid;border-width:0 13px 16px 13px;border-color:transparent transparent #E5E5E5 transparent;}.small-triangle[data-jsx=\"1586564003\"]{right:51px;top:-13px;width:0;height:0;border-style:solid;border-width:0 10px 12.5px 10px;border-color:transparent transparent #ffffff transparent;}.absolute,\n.dropdown[data-jsx=\"1586564003\"],\n.big-triangle[data-jsx=\"1586564003\"],\n.small-triangle[data-jsx=\"1586564003\"]{position:absolute;}.o0,\n.dropdown[data-jsx=\"1586564003\"]{opacity:0;}.z999,\n.dropdown[data-jsx=\"1586564003\"]{z-index:999;}.absolute,\n.dropdown[data-jsx=\"1586564003\"],\n.big-triangle[data-jsx=\"1586564003\"],\n.small-triangle[data-jsx=\"1586564003\"]{position:absolute;}.absolute,\n.dropdown[data-jsx=\"1586564003\"],\n.big-triangle[data-jsx=\"1586564003\"],\n.small-triangle[data-jsx=\"1586564003\"]{position:absolute;}.relative,\n.content[data-jsx=\"1586564003\"]{position:relative;}.bgWhite,\n.content[data-jsx=\"1586564003\"]{background-color:#fff;}.pa38,\n.content[data-jsx=\"1586564003\"]{padding:38px;}.ba,\n.content[data-jsx=\"1586564003\"]{border-style:solid;border-width:1px;}.bw2,\n.content[data-jsx=\"1586564003\"]{border-width:2px;}.br2,\n.content[data-jsx=\"1586564003\"]{border-radius:2px;}.bBlack10,\n.content[data-jsx=\"1586564003\"]{border-color:rgba(0, 0, 0, .1);}"
	    }),
	    React.createElement(
	      "div",
	      { className: "content", "data-jsx": 1586564003
	      },
	      React.createElement("div", { className: "big-triangle", "data-jsx": 1586564003
	      }),
	      React.createElement("div", { className: "small-triangle", "data-jsx": 1586564003
	      }),
	      children
	    )
	  );
	}

/***/ }),

/***/ "./src/components/NewsletterSignup.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var cn = __webpack_require__("./node_modules/classnames/index.js");
	
	var NewsletterSignup = function (_React$Component) {
	  _inherits(NewsletterSignup, _React$Component);
	
	  function NewsletterSignup(props) {
	    _classCallCheck(this, NewsletterSignup);
	
	    var _this = _possibleConstructorReturn(this, (NewsletterSignup.__proto__ || Object.getPrototypeOf(NewsletterSignup)).call(this, props));
	
	    _this.onChangeEmail = function (e) {
	      _this.setState({ email: e.target.value });
	    };
	    _this.onKeyDown = function (e) {
	      if (e.keyCode === 13) {
	        _this.submit();
	      }
	    };
	    _this.submit = function () {
	      if (_this.emailValid()) {
	        _this.setState({ sending: true }, function () {
	          var email = _this.state.email;
	          var tutorial = _this.props.tutorial;
	
	          var mutation = "\n          mutation signup($email: String!, $tutorial: String!) {\n            createSignup(email: $email tutorial: $tutorial) {\n              id\n            }\n          }\n        ";
	          var variables = {
	            email: email,
	            tutorial: tutorial
	          };
	          fetch('https://api.graph.cool/simple/v1/cj4pjmqj541d501696t6bgh08', {
	            body: JSON.stringify({ query: mutation, variables: variables }),
	            headers: {
	              'Content-Type': 'application/json'
	            },
	            method: 'post'
	          }).then(function (res) {
	            return res.json();
	          }).then(function () {
	            _this.setState({ sending: false, sent: true });
	          });
	        });
	      }
	    };
	    _this.state = {
	      email: '',
	      sending: false,
	      sent: false
	    };
	    return _this;
	  }
	
	  _createClass(NewsletterSignup, [{
	    key: "renderButton",
	    value: function renderButton() {
	      var invalid = !this.emailValid();
	      return React.createElement(
	        "button",
	        { className: cn({ invalid: invalid }), onClick: this.submit, "data-jsx": 3850082883
	        },
	        React.createElement(_style2.default, {
	          styleId: 3850082883,
	          css: "button[data-jsx=\"3850082883\"]{border:none;}button.invalid[data-jsx=\"3850082883\"]{cursor:not-allowed;}@media (max-width: 480px){button[data-jsx=\"3850082883\"]{width:100%;}button[data-jsx=\"3850082883\"]{padding-top:16px !important;padding-bottom:16px !important;}}.bgBlue,\nbutton[data-jsx=\"3850082883\"]{background-color:#2a7ed2;}.white,\nbutton[data-jsx=\"3850082883\"]{color:#fff;}.br2,\nbutton[data-jsx=\"3850082883\"]{border-radius:2px;}.flexFixed,\nbutton[data-jsx=\"3850082883\"]{-ms-flex:0 0 auto;-webkit-box-flex:0;flex:0 0 auto;}.f16,\nbutton[data-jsx=\"3850082883\"]{font-size:16px;}.fw6,\nbutton[data-jsx=\"3850082883\"]{font-weight:600;}.pv10,\nbutton[data-jsx=\"3850082883\"]{padding-top:10px;padding-bottom:10px;}.ph16,\nbutton[data-jsx=\"3850082883\"]{padding-left:16px;padding-right:16px;}.pointer:hover,\nbutton[data-jsx=\"3850082883\"]:hover{cursor:pointer;}.ttu,\nbutton[data-jsx=\"3850082883\"]{text-transform:uppercase;}.buttonShadow,\nbutton[data-jsx=\"3850082883\"]{box-shadow:0 1px 3px 0 rgba(0, 0, 0, .2);}"
	        }),
	        "Stay Tuned"
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var light = this.props.light;
	      var _state = this.state,
	          sending = _state.sending,
	          sent = _state.sent;
	
	      if (sent) {
	        return React.createElement(
	          "p",
	          { className: cn({ light: light }), "data-jsx": 350694255
	          },
	          React.createElement(_style2.default, {
	            styleId: 350694255,
	            css: ".tc,\np[data-jsx=\"350694255\"] {text-align: center\n}.white,\np.light[data-jsx=\"350694255\"] {color: #fff\n}"
	          }),
	          "Thanks for signing up. We will inform you as soon as the tutorial is ready!"
	        );
	      }
	      if (sending) {
	        return React.createElement(
	          "p",
	          { className: cn({ light: light }), "data-jsx": 2456066055
	          },
	          React.createElement(_style2.default, {
	            styleId: 2456066055,
	            css: ".white,\np[data-jsx=\"2456066055\"] {color: #fff\n}.tc,\np[data-jsx=\"2456066055\"] {text-align: center\n}.darkBlue80,\np.light[data-jsx=\"2456066055\"] {color: rgba(23, 42, 58, .8)\n}"
	          }),
	          "Signing up..."
	        );
	      }
	      return React.createElement(
	        "div",
	        {
	          "data-jsx": 619436089
	        },
	        React.createElement(_style2.default, {
	          styleId: 619436089,
	          css: ".newsletter-signup[data-jsx=\"619436089\"]{max-width:512px;}input[data-jsx=\"619436089\"]{border:none;background:none;}@media (max-width: 580px){div[data-jsx=\"619436089\"] p[data-jsx=\"619436089\"]{padding-left:25px;padding-right:25px;}div[data-jsx=\"619436089\"] input[data-jsx=\"619436089\"]{padding:10px;}div[data-jsx=\"619436089\"] input[data-jsx=\"619436089\"]{margin-bottom:10px;}div.newsletter-signup[data-jsx=\"619436089\"]{display:block;}}.bgWhite04,\n.newsletter-signup[data-jsx=\"619436089\"]{background-color:hsla(0, 0%, 100%, .04);}.br2,\n.newsletter-signup[data-jsx=\"619436089\"]{border-radius:2px;}.pa10,\n.newsletter-signup[data-jsx=\"619436089\"]{padding:10px;}.flex,\n.newsletter-signup[data-jsx=\"619436089\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.center,\n.newsletter-signup[data-jsx=\"619436089\"]{margin-right:auto;margin-left:auto;}.f20,\ninput[data-jsx=\"619436089\"]{font-size:20px;}.w100,\ninput[data-jsx=\"619436089\"]{width:100%;}.pl10,\ninput[data-jsx=\"619436089\"]{padding-left:10px;}.white80,\ninput[data-jsx=\"619436089\"],\np[data-jsx=\"619436089\"]{color:hsla(0, 0%, 100%, .8);}.bgDarkBlue10,\n.newsletter-signup.light[data-jsx=\"619436089\"]{background-color:rgba(23, 42, 58, .1);}.darkBlue80,\n.newsletter-signup.light[data-jsx=\"619436089\"] input[data-jsx=\"619436089\"]{color:rgba(23, 42, 58, .8);}.tc,\np[data-jsx=\"619436089\"]{text-align:center;}.mb16,\np[data-jsx=\"619436089\"]{margin-bottom:16px;}.white80,\ninput[data-jsx=\"619436089\"],\np[data-jsx=\"619436089\"]{color:hsla(0, 0%, 100%, .8);}.lhCopy,\np[data-jsx=\"619436089\"]{line-height:1.5;}"
	        }),
	        React.createElement(
	          "p",
	          {
	            "data-jsx": 619436089
	          },
	          "To get notified when this tutorial is available, sign up here"
	        ),
	        React.createElement(
	          "div",
	          { className: cn('newsletter-signup', { light: light }), "data-jsx": 619436089
	          },
	          React.createElement("input", { type: "text", placeholder: "Just type your Email", onChange: this.onChangeEmail, onKeyDown: this.onKeyDown, "data-jsx": 619436089
	          }),
	          this.renderButton()
	        )
	      );
	    }
	  }, {
	    key: "emailValid",
	    value: function emailValid() {
	      var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	      return regex.test(this.state.email);
	    }
	  }]);
	
	  return NewsletterSignup;
	}(React.Component);
	
	exports.default = NewsletterSignup;

/***/ }),

/***/ "./src/components/Overlay.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var react_redux_1 = __webpack_require__("./node_modules/react-redux/lib/index.js");
	var cn = __webpack_require__("./node_modules/classnames/index.js");
	var ui_1 = __webpack_require__("./src/actions/ui.ts");
	
	var Overlay = function (_React$Component) {
	    _inherits(Overlay, _React$Component);
	
	    function Overlay(props) {
	        _classCallCheck(this, Overlay);
	
	        var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props));
	
	        _this.handleClick = function () {
	            _this.props.hideOverlay();
	        };
	        _this.state = {
	            transition: false
	        };
	        return _this;
	    }
	
	    _createClass(Overlay, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            setTimeout(function () {
	                _this2.setState({ transition: true });
	            }, 1000);
	        }
	    }, {
	        key: "shouldComponentUpdate",
	        value: function shouldComponentUpdate(nextProps) {
	            return this.props.visible !== nextProps.visible;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var visible = this.props.visible;
	            var transition = this.state.transition;
	
	            return React.createElement(
	                "div",
	                { className: cn('overlay', { visible: visible, transition: transition }), onClick: this.handleClick, "data-jsx": 333858458
	                },
	                React.createElement(_style2.default, {
	                    styleId: 333858458,
	                    css: ".overlay[data-jsx=\"333858458\"]{pointer-events:none;z-index:10000;}.overlay.transition[data-jsx=\"333858458\"]{transition:opacity .25s ease-in-out;}.overlay.visible[data-jsx=\"333858458\"]{pointer-events:all;}.fixed,\n.overlay[data-jsx=\"333858458\"]{position:fixed;}.top0,\n.overlay[data-jsx=\"333858458\"]{top:0;}.left0,\n.overlay[data-jsx=\"333858458\"]{left:0;}.right0,\n.overlay[data-jsx=\"333858458\"]{right:0;}.bottom0,\n.overlay[data-jsx=\"333858458\"]{bottom:0;}.bgWhite80,\n.overlay[data-jsx=\"333858458\"]{background-color:hsla(0, 0%, 100%, .8);}.o0,\n.overlay[data-jsx=\"333858458\"]{opacity:0;}.o100,\n.overlay.visible[data-jsx=\"333858458\"]{opacity:1;}"
	                })
	            );
	        }
	    }]);
	
	    return Overlay;
	}(React.Component);
	
	exports.default = react_redux_1.connect(function (state) {
	    return { visible: state.ui.overlayVisible };
	}, {
	    hideOverlay: ui_1.hideOverlay
	})(Overlay);

/***/ }),

/***/ "./src/components/OverviewVideoModal.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var react_redux_1 = __webpack_require__("./node_modules/react-redux/lib/index.js");
	var cn = __webpack_require__("./node_modules/classnames/index.js");
	var youtube_embed_video_1 = __webpack_require__("./node_modules/youtube-embed-video/dist/youtube.js");
	
	var OverviewVideoModal = function (_React$Component) {
	  _inherits(OverviewVideoModal, _React$Component);
	
	  function OverviewVideoModal(props) {
	    _classCallCheck(this, OverviewVideoModal);
	
	    var _this = _possibleConstructorReturn(this, (OverviewVideoModal.__proto__ || Object.getPrototypeOf(OverviewVideoModal)).call(this, props));
	
	    _this.state = {
	      transition: false
	    };
	    return _this;
	  }
	
	  _createClass(OverviewVideoModal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        _this2.setState({ transition: true });
	      }, 1000);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var visible = this.props.visible;
	      var transition = this.state.transition;
	
	      return React.createElement(
	        "div",
	        { className: cn('overview-video-modal', { visible: visible, transition: transition }), "data-jsx": 2416041235
	        },
	        React.createElement(_style2.default, {
	          styleId: 2416041235,
	          css: ".overview-video-modal[data-jsx=\"2416041235\"]{top:50%;left:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);width:924px;max-width:100vw;z-index:10011;pointer-events:none;}.overview-video-modal.transition[data-jsx=\"2416041235\"]{transition:opacity ease-in-out 0.25s;transition-delay:0.3s;}.overview-video-modal.visible[data-jsx=\"2416041235\"]{pointer-events:all;transition-delay:0;}.video-wrap[data-jsx=\"2416041235\"]{max-width:920px;}.video[data-jsx=\"2416041235\"]{height:0;padding-top:0;padding-bottom:56.25%;}.fixed,\n.overview-video-modal[data-jsx=\"2416041235\"]{position:fixed;}.bgWhite,\n.overview-video-modal[data-jsx=\"2416041235\"]{background-color:#fff;}.o0,\n.overview-video-modal[data-jsx=\"2416041235\"]{opacity:0;}.o100,\n.overview-video-modal.visible[data-jsx=\"2416041235\"]{opacity:1;}.center,\n.video-wrap[data-jsx=\"2416041235\"]{margin-right:auto;margin-left:auto;}.relative,\n.video[data-jsx=\"2416041235\"]{position:relative;}.absolute,\n.video[data-jsx=\"2416041235\"] iframe{position:absolute;}.top0,\n.video[data-jsx=\"2416041235\"] iframe{top:0;}.left0,\n.video[data-jsx=\"2416041235\"] iframe{left:0;}.right0,\n.video[data-jsx=\"2416041235\"] iframe{right:0;}.bottom0,\n.video[data-jsx=\"2416041235\"] iframe{bottom:0;}.w100,\n.video[data-jsx=\"2416041235\"] iframe{width:100%;}.h100,\n.video[data-jsx=\"2416041235\"] iframe{height:100%;}"
	        }),
	        React.createElement(
	          "div",
	          { className: "video-wrap", "data-jsx": 2416041235
	          },
	          React.createElement(
	            "div",
	            { className: "video", "data-jsx": 2416041235
	            },
	            React.createElement(youtube_embed_video_1.default, { videoId: "gdoRAPW7Abc", suggestions: false, autoplay: visible, controls: true })
	          )
	        )
	      );
	    }
	  }]);
	
	  return OverviewVideoModal;
	}(React.Component);
	
	exports.default = react_redux_1.connect(function (state) {
	  return { visible: state.ui.overviewVideoVisible };
	})(OverviewVideoModal);

/***/ }),

/***/ "./src/components/Search/GroupBadge.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var getStackName_1 = __webpack_require__("./src/utils/getStackName.ts");
	var graphcool_styles_1 = __webpack_require__("./node_modules/graphcool-styles/dist/build.js");
	var colors = {
	  advanced: 'rgba(0,0,0,.7)',
	  basics: '#EB1796',
	  graphcool: graphcool_styles_1.$v.green,
	  graphene: '#db594c',
	  'graphql-elixir': '#4e2a8e',
	  'graphql-ruby': '#a5152a',
	  'react-apollo': '#00A89A',
	  'react-relay': '#F96600'
	};
	function GroupBadge(_ref) {
	  var group = _ref.group;
	
	  var stackName = getStackName_1.getStackName(group);
	  return React.createElement(
	    "div",
	    { className: "group-badge", style: { color: colors[group], borderColor: colors[group] }, "data-jsx": 2634741711
	    },
	    React.createElement(_style2.default, {
	      styleId: 2634741711,
	      css: ".group-badge[data-jsx=\"2634741711\"]{font-size:10px;padding:3px 7px;}\n.ttu,\n.group-badge[data-jsx=\"2634741711\"]{text-transform:uppercase;}\n.br2,\n.group-badge[data-jsx=\"2634741711\"]{border-radius:2px;}\n.ba,\n.group-badge[data-jsx=\"2634741711\"]{border-style:solid;border-width:1px;}\n.dib,\n.group-badge[data-jsx=\"2634741711\"]{display:inline-block;}\n.ml10,\n.group-badge[data-jsx=\"2634741711\"]{margin-left:10px;}\n.relative,\n.group-badge[data-jsx=\"2634741711\"]{position:relative;}"
	    }),
	    stackName
	  );
	}
	exports.default = GroupBadge;

/***/ }),

/***/ "./src/components/Search/Results.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var cn = __webpack_require__("./node_modules/classnames/index.js");
	var react_redux_1 = __webpack_require__("./node_modules/react-redux/lib/index.js");
	var Icon_1 = __webpack_require__("./node_modules/graphcool-styles/dist/components/Icon/Icon.js");
	var ui_1 = __webpack_require__("./src/actions/ui.ts");
	var gatsby_link_1 = __webpack_require__("./node_modules/gatsby-link/index.js");
	var GroupBadge_1 = __webpack_require__("./src/components/Search/GroupBadge.tsx");
	var graphql_1 = __webpack_require__("./src/utils/graphql.ts");
	var graphcool_styles_1 = __webpack_require__("./node_modules/graphcool-styles/dist/build.js");
	
	var Results = function (_React$Component) {
	    _inherits(Results, _React$Component);
	
	    function Results() {
	        _classCallCheck(this, Results);
	
	        var _this = _possibleConstructorReturn(this, (Results.__proto__ || Object.getPrototypeOf(Results)).apply(this, arguments));
	
	        _this.resultRefs = {};
	        _this.setRef = function (index, ref) {
	            if (ref) {
	                _this.resultRefs[index] = ref;
	            }
	        };
	        _this.handleKeyDown = function (e) {
	            if (!_this.props.visible) {
	                return;
	            }
	            if (e.keyCode === 27) {
	                _this.props.onClose();
	            }
	            if (e.keyCode === 13 && !e.metaKey) {
	                _this.props.gotoSelectedItem();
	                return;
	            }
	            if (e.keyCode === 38) {
	                var selectedIndex = _this.props.selectedIndex - 1;
	                if (selectedIndex < 0) {
	                    return;
	                }
	                _this.props.onSelectIndex(selectedIndex);
	                _this.scrollToIndex(selectedIndex);
	                return;
	            }
	            if (e.keyCode === 40) {
	                var _selectedIndex = _this.props.selectedIndex + 1;
	                if (_selectedIndex > _this.props.results.length - 1) {
	                    return;
	                }
	                _this.props.onSelectIndex(_selectedIndex);
	                _this.scrollToIndex(_selectedIndex);
	                return;
	            }
	        };
	        _this.handleLinkClick = function () {
	            _this.props.setSearchVisible(false);
	        };
	        return _this;
	    }
	
	    _createClass(Results, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            document.addEventListener('keydown', this.handleKeyDown);
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            document.removeEventListener('keydown', this.handleKeyDown);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                results = _props.results,
	                selectedIndex = _props.selectedIndex,
	                onSelectIndex = _props.onSelectIndex,
	                visible = _props.visible;
	
	            return React.createElement(
	                "div",
	                { className: cn('search-results', { visible: visible }), "data-jsx": 2245191572
	                },
	                React.createElement(_style2.default, {
	                    styleId: 2245191572,
	                    css: ".search-results[data-jsx=\"2245191572\"]{margin-top:-60px;padding-top:67px;padding-bottom:10px;box-shadow:0 1px 5px 0 rgba(0, 0, 0, .07),              0 7px 17px 0 rgba(0, 0, 0, .1);background:white;transition:opacity .25s ease-in-out;pointer-events:none;border-bottom-left-radius:2px;border-bottom-right-radius:2px;}.results[data-jsx=\"2245191572\"]{max-height:calc(100vh - 92px);}.search-results.visible[data-jsx=\"2245191572\"]{pointer-events:all;}.result[data-jsx=\"2245191572\"]{padding:10px 15px 8px 44px;margin-bottom:10px;}.result.selected[data-jsx=\"2245191572\"]{background-color:rgba(224, 0, 130, .04);}.result.selected[data-jsx=\"2245191572\"] i{left:20px;margin-top:6px;}.result[data-jsx=\"2245191572\"] a{display:inline-block;font-weight:500;color:rgba(42, 126, 210, 1);font-size:15px;margin-right:5px;margin-bottom:5px;}.result[data-jsx=\"2245191572\"] a span[data-jsx=\"2245191572\"]{text-decoration:underline;}.result[data-jsx=\"2245191572\"] p[data-jsx=\"2245191572\"]{font-size:13px;line-height:20px;color:#4c555a;overflow:hidden;padding:0;margin:0;max-height:40px;}.result[data-jsx=\"2245191572\"] em{color:rgb(195, 10, 118);font-style:normal;}.absolute,\n.search-results[data-jsx=\"2245191572\"],\n.result.selected[data-jsx=\"2245191572\"] i{position:absolute;}.o0,\n.search-results[data-jsx=\"2245191572\"]{opacity:0;}.overflowAuto,\n.results[data-jsx=\"2245191572\"]{overflow:auto;}.o100,\n.search-results.visible[data-jsx=\"2245191572\"]{opacity:1;}.relative,\n.result[data-jsx=\"2245191572\"]{position:relative;}.absolute,\n.search-results[data-jsx=\"2245191572\"],\n.result.selected[data-jsx=\"2245191572\"] i{position:absolute;}.fw7,\n.result[data-jsx=\"2245191572\"] em{font-weight:700;}"
	                }),
	                React.createElement(
	                    "div",
	                    { className: "results", "data-jsx": 2245191572
	                    },
	                    results.map(function (result, index) {
	                        return React.createElement(
	                            "div",
	                            { className: cn('result', { selected: index === selectedIndex }), onClick: onSelectIndex.bind(null, index), ref: _this2.setRef.bind(_this2, index), "data-jsx": 2245191572
	                            },
	                            index === selectedIndex && React.createElement(Icon_1.default, { src: __webpack_require__("./node_modules/graphcool-styles/icons/stroke/arrowRight.svg"), color: graphcool_styles_1.$v.blue, stroke: true, strokeWidth: 4, width: 10, height: 10 }),
	                            React.createElement(
	                                gatsby_link_1.default,
	                                { to: result.link, onClick: _this2.handleLinkClick },
	                                React.createElement("span", { dangerouslySetInnerHTML: { __html: result.title }, "data-jsx": 2245191572
	                                }),
	                                React.createElement(GroupBadge_1.default, { group: graphql_1.extractGroup(result.link) })
	                            ),
	                            React.createElement(
	                                "p",
	                                {
	                                    "data-jsx": 2245191572
	                                },
	                                result.description
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }, {
	        key: "scrollToIndex",
	        value: function scrollToIndex(i) {
	            if (this.resultRefs[i]) {
	                this.resultRefs[i].scrollIntoViewIfNeeded(false);
	            }
	        }
	    }]);
	
	    return Results;
	}(React.Component);
	
	exports.default = react_redux_1.connect(function (state) {
	    return { visible: state.ui.searchVisible };
	}, {
	    setSearchVisible: ui_1.setSearchVisible
	})(Results);

/***/ }),

/***/ "./src/components/Search/Search.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var throttle = __webpack_require__("./node_modules/lodash/throttle.js");
	var algolia = __webpack_require__("./node_modules/algoliasearch/src/browser/builds/algoliasearch.js");
	var SearchInput_1 = __webpack_require__("./src/components/Search/SearchInput.tsx");
	var react_redux_1 = __webpack_require__("./node_modules/react-redux/lib/index.js");
	var ui_1 = __webpack_require__("./src/actions/ui.ts");
	var Results_1 = __webpack_require__("./src/components/Search/Results.tsx");
	var cn = __webpack_require__("./node_modules/classnames/index.js");
	
	var Search = function (_React$Component) {
	    _inherits(Search, _React$Component);
	
	    function Search(props) {
	        _classCallCheck(this, Search);
	
	        var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));
	
	        _this.search = throttle(function (q) {
	            _this.index.search({
	                attributesToHighlight: ['title'],
	                hitsPerPage: 10,
	                query: q
	            }, function (err, data) {
	                if (err) {} else {
	                    _this.setState({
	                        results: data.hits.map(function (hit) {
	                            return {
	                                description: hit.body,
	                                link: hit.objectID,
	                                title: hit._highlightResult.title.value
	                            };
	                        })
	                    });
	                }
	            });
	        }, 500, {
	            trailing: true
	        });
	        _this.handleClose = function () {
	            _this.props.setSearchVisible(false);
	        };
	        _this.handleSelectIndex = function (selectedIndex) {
	            if (selectedIndex < 0 || selectedIndex > _this.state.results.length - 1) {
	                return;
	            }
	            _this.setState(function (state) {
	                return _extends({}, state, { selectedIndex: selectedIndex });
	            });
	        };
	        _this.handleGotoSelectedItem = function () {
	            var _this$state = _this.state,
	                selectedIndex = _this$state.selectedIndex,
	                results = _this$state.results;
	
	            _this.props.history.push(results[selectedIndex].link);
	            _this.props.setSearchVisible(false);
	        };
	        _this.handleFocus = function (e) {
	            _this.setState(function (state) {
	                return _extends({}, state, { focused: true });
	            });
	            if (_this.state.query.length > 0) {
	                _this.props.setSearchVisible(true);
	            }
	        };
	        _this.handleBlur = function (e) {
	            _this.setState(function (state) {
	                return _extends({}, state, { focused: false });
	            });
	            if (window && window.innerWidth < 1050 && _this.state.query.length === 0) {
	                _this.props.setSearchVisible(false);
	            }
	        };
	        _this.handleChange = function (value) {
	            _this.setState(function (state) {
	                return _extends({}, state, { query: value });
	            });
	            if (value.length > 0) {
	                _this.props.setSearchVisible(true);
	            } else {
	                _this.props.setSearchVisible(false);
	            }
	            _this.search(value);
	        };
	        _this.client = algolia('X0QXFM9JVE', 'bc5ffd98742de2961e4852c29ccc0483');
	        _this.index = _this.client.initIndex('howtohypermedia');
	        _this.state = {
	            focused: false,
	            query: '',
	            results: [],
	            selectedIndex: 0
	        };
	        return _this;
	    }
	
	    _createClass(Search, [{
	        key: "render",
	        value: function render() {
	            var focused = this.state.focused;
	
	            return React.createElement(
	                "div",
	                { className: cn('search', { visible: focused }), "data-jsx": 4106422765
	                },
	                React.createElement(_style2.default, {
	                    styleId: 4106422765,
	                    css: ".search[data-jsx=\"4106422765\"]{top:9px;left:235px;z-index:10010;width:calc(100% - 235px - 456px);}.search.visible[data-jsx=\"4106422765\"]{z-index:10180;}@media (max-width: 1050px){div.search[data-jsx=\"4106422765\"]{left:0;width:100%;}}.fixed,\n.search[data-jsx=\"4106422765\"]{position:fixed;}"
	                }),
	                React.createElement(SearchInput_1.default, { focused: this.state.focused, query: this.state.query, onChange: this.handleChange, onFocus: this.handleFocus, onBlur: this.handleBlur, onClose: this.handleClose, location: this.props.location, numResults: this.state.results.length }),
	                React.createElement(Results_1.default, { results: this.state.results, selectedIndex: this.state.selectedIndex, onSelectIndex: this.handleSelectIndex, gotoSelectedItem: this.handleGotoSelectedItem, onClose: this.handleClose })
	            );
	        }
	    }]);
	
	    return Search;
	}(React.Component);
	
	exports.default = react_redux_1.connect(null, {
	    setSearchVisible: ui_1.setSearchVisible
	})(Search);

/***/ }),

/***/ "./src/components/Search/SearchInput.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var Icon_1 = __webpack_require__("./node_modules/graphcool-styles/dist/components/Icon/Icon.js");
	var graphcool_styles_1 = __webpack_require__("./node_modules/graphcool-styles/dist/build.js");
	var cn = __webpack_require__("./node_modules/classnames/index.js");
	
	var SearchInput = function (_React$Component) {
	  _inherits(SearchInput, _React$Component);
	
	  function SearchInput() {
	    _classCallCheck(this, SearchInput);
	
	    var _this = _possibleConstructorReturn(this, (SearchInput.__proto__ || Object.getPrototypeOf(SearchInput)).apply(this, arguments));
	
	    _this.handleChange = function (e) {
	      _this.props.onChange(e.target.value);
	    };
	    return _this;
	  }
	
	  _createClass(SearchInput, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          onFocus = _props.onFocus,
	          onBlur = _props.onBlur,
	          query = _props.query,
	          focused = _props.focused,
	          onClose = _props.onClose,
	          location = _props.location,
	          numResults = _props.numResults;
	
	      var tutorial = location.pathname !== '/';
	      return React.createElement(
	        "div",
	        { className: cn('search-input', { focused: focused, tutorial: tutorial }), "data-jsx": 3108361442
	        },
	        React.createElement(_style2.default, {
	          styleId: 3108361442,
	          css: ".search-input[data-jsx=\"3108361442\"]{transition:-webkit-transform ease-in-out 0.15s;transition:transform ease-in-out 0.15s;transition:transform ease-in-out 0.15s, -webkit-transform ease-in-out 0.15s;}.search-after[data-jsx=\"3108361442\"]{top:18px;}.search-text[data-jsx=\"3108361442\"]{visibility:hidden;}.no-results[data-jsx=\"3108361442\"]{pointer-events:none;}input[data-jsx=\"3108361442\"]{background:none;border:none;}@media (min-width: 1200px){input[data-jsx=\"3108361442\"]{min-width:300px;}}.icon[data-jsx=\"3108361442\"]{left:16px;top:17px;}@media (max-width: 1050px){.search-input[data-jsx=\"3108361442\"]{-webkit-transform:translateX(calc(100vw - 44px));transform:translateX(calc(100vw - 44px));background:white;}.search-input.tutorial[data-jsx=\"3108361442\"]{-webkit-transform:translateX(calc(100vw - 74px));transform:translateX(calc(100vw - 74px));}.search-input.focused[data-jsx=\"3108361442\"]{-webkit-transform:translateX(10px);transform:translateX(10px);}div.icon[data-jsx=\"3108361442\"]{left:10px;}div.close[data-jsx=\"3108361442\"]{position:absolute;}div.close[data-jsx=\"3108361442\"]{display:block;}div.close[data-jsx=\"3108361442\"]{padding:16px;}div.close[data-jsx=\"3108361442\"]{z-index:2;}div.close[data-jsx=\"3108361442\"]{right:9px;top:2px;}}.z2,\n.search-input[data-jsx=\"3108361442\"]{z-index:2;}.relative,\n.search-input[data-jsx=\"3108361442\"],\n.input[data-jsx=\"3108361442\"],\ninput[data-jsx=\"3108361442\"]{position:relative;}.relative,\n.search-input[data-jsx=\"3108361442\"],\n.input[data-jsx=\"3108361442\"],\ninput[data-jsx=\"3108361442\"]{position:relative;}.flex,\n.input[data-jsx=\"3108361442\"],\nlabel[data-jsx=\"3108361442\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.itemsCenter,\n.input[data-jsx=\"3108361442\"],\nlabel[data-jsx=\"3108361442\"]{-webkit-box-align:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;}.left0,\n.search-after[data-jsx=\"3108361442\"]{left:0;}.absolute,\n.search-after[data-jsx=\"3108361442\"],\n.icon[data-jsx=\"3108361442\"]{position:absolute;}.f14,\n.search-text[data-jsx=\"3108361442\"],\n.no-results[data-jsx=\"3108361442\"],\ninput[data-jsx=\"3108361442\"]{font-size:14px;}.dib,\n.search-text[data-jsx=\"3108361442\"],\n.no-results[data-jsx=\"3108361442\"]{display:inline-block;}.pl38,\n.search-text[data-jsx=\"3108361442\"],\ninput[data-jsx=\"3108361442\"]{padding-left:38px;}.black30,\n.no-results[data-jsx=\"3108361442\"]{color:rgba(0, 0, 0, .3);}.ml16,\n.no-results[data-jsx=\"3108361442\"]{margin-left:16px;}.dib,\n.search-text[data-jsx=\"3108361442\"],\n.no-results[data-jsx=\"3108361442\"]{display:inline-block;}.f14,\n.search-text[data-jsx=\"3108361442\"],\n.no-results[data-jsx=\"3108361442\"],\ninput[data-jsx=\"3108361442\"]{font-size:14px;}.f14,\n.search-text[data-jsx=\"3108361442\"],\n.no-results[data-jsx=\"3108361442\"],\ninput[data-jsx=\"3108361442\"]{font-size:14px;}.black80,\ninput[data-jsx=\"3108361442\"]{color:rgba(0, 0, 0, .8);}.ml6,\ninput[data-jsx=\"3108361442\"]{margin-left:6px;}.pl38,\n.search-text[data-jsx=\"3108361442\"],\ninput[data-jsx=\"3108361442\"]{padding-left:38px;}.pv16,\ninput[data-jsx=\"3108361442\"]{padding-top:16px;padding-bottom:16px;}.pr25,\ninput[data-jsx=\"3108361442\"]{padding-right:25px;}.relative,\n.search-input[data-jsx=\"3108361442\"],\n.input[data-jsx=\"3108361442\"],\ninput[data-jsx=\"3108361442\"]{position:relative;}.z1,\ninput[data-jsx=\"3108361442\"]{z-index:1;}.flex,\n.input[data-jsx=\"3108361442\"],\nlabel[data-jsx=\"3108361442\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.itemsCenter,\n.input[data-jsx=\"3108361442\"],\nlabel[data-jsx=\"3108361442\"]{-webkit-box-align:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;}.pa10,\nlabel[data-jsx=\"3108361442\"]{padding:10px;}.black40,\ninput[data-jsx=\"3108361442\"]::-webkit-input-placeholder{color:rgba(0, 0, 0, .4);}.black40,\ninput[data-jsx=\"3108361442\"]:-ms-input-placeholder{color:rgba(0, 0, 0, .4);}.black40,\ninput[data-jsx=\"3108361442\"]::placeholder{color:rgba(0, 0, 0, .4);}.absolute,\n.search-after[data-jsx=\"3108361442\"],\n.icon[data-jsx=\"3108361442\"]{position:absolute;}.dn,\n.close[data-jsx=\"3108361442\"]{display:none;}"
	        }),
	        React.createElement(
	          "div",
	          { className: "input", "data-jsx": 3108361442
	          },
	          React.createElement(
	            "div",
	            { className: "icon", "data-jsx": 3108361442
	            },
	            React.createElement(Icon_1.default, { src: __webpack_require__("./node_modules/graphcool-styles/icons/stroke/search.svg"), stroke: true, strokeWidth: 4, width: 20, height: 20, color: graphcool_styles_1.$v.gray30 })
	          ),
	          React.createElement("input", { type: "text", name: "search", placeholder: "Search tutorials...", value: query, onChange: this.handleChange, onFocus: onFocus, onBlur: onBlur, "data-jsx": 3108361442
	          }),
	          query.length > 0 && numResults === 0 && React.createElement(
	            "div",
	            { className: "search-after", "data-jsx": 3108361442
	            },
	            React.createElement(
	              "span",
	              { className: "search-text", "data-jsx": 3108361442
	              },
	              query
	            ),
	            React.createElement(
	              "span",
	              { className: "no-results", "data-jsx": 3108361442
	              },
	              "\u2014 No Results"
	            )
	          )
	        ),
	        React.createElement(
	          "div",
	          { className: "close", onClick: onClose, "data-jsx": 3108361442
	          },
	          React.createElement(Icon_1.default, { src: __webpack_require__("./node_modules/graphcool-styles/icons/stroke/cross.svg"), width: 15, height: 15, color: '#B2B2B2', stroke: true, strokeWidth: 6 })
	        )
	      );
	    }
	  }]);
	
	  return SearchInput;
	}(React.Component);
	
	exports.default = SearchInput;

/***/ }),

/***/ "./src/components/StackChooser.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var withWidth_1 = __webpack_require__("./src/components/home/withWidth.tsx");
	var cn = __webpack_require__("./node_modules/classnames/index.js");
	var Icon_1 = __webpack_require__("./node_modules/graphcool-styles/dist/components/Icon/Icon.js");
	var react_swipeable_views_1 = __webpack_require__("./node_modules/react-swipeable-views/lib/index.js");
	
	var StackChooser = function (_React$Component) {
	    _inherits(StackChooser, _React$Component);
	
	    function StackChooser() {
	        _classCallCheck(this, StackChooser);
	
	        var _this = _possibleConstructorReturn(this, (StackChooser.__proto__ || Object.getPrototypeOf(StackChooser)).apply(this, arguments));
	
	        _this.handleMouseDown = function () {
	            _this.mouseMoved = false;
	        };
	        _this.handleDrag = function (e) {
	            _this.mouseMoved = true;
	        };
	        _this.handleMouseUp = function (i) {
	            if (!_this.mouseMoved) {
	                _this.props.onChangeSelectedIndex(i);
	                if (i === _this.props.selectedIndex && typeof _this.props.onClickCurrentStack === 'function') {
	                    _this.props.onClickCurrentStack();
	                }
	            }
	            _this.mouseMoved = false;
	        };
	        _this.handleKeydown = function (e) {
	            if (typeof HTMLInputElement !== 'undefined' && e.target instanceof HTMLInputElement) {
	                return;
	            }
	            if (e.keyCode === 37) {
	                _this.props.onChangeSelectedIndex(_this.props.selectedIndex - 1);
	            } else if (e.keyCode === 39) {
	                _this.props.onChangeSelectedIndex(_this.props.selectedIndex + 1);
	            }
	        };
	        return _this;
	    }
	
	    _createClass(StackChooser, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            document.addEventListener('keydown', this.handleKeydown);
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            document.removeEventListener('keydown', this.handleKeydown);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                stacks = _props.stacks,
	                selectedIndex = _props.selectedIndex,
	                onChangeSelectedIndex = _props.onChangeSelectedIndex,
	                markdownFiles = _props.markdownFiles,
	                _props$showSelectedBo = _props.showSelectedBorder,
	                showSelectedBorder = _props$showSelectedBo === undefined ? false : _props$showSelectedBo;
	
	            var tutorials = stacks.map(function (tutorial) {
	                return _extends({}, tutorial, {
	                    steps: markdownFiles[tutorial.key]
	                });
	            });
	            return React.createElement(
	                "div",
	                { className: "stack-chooser", "data-jsx": 130301251
	                },
	                React.createElement(_style2.default, {
	                    styleId: 130301251,
	                    css: ".stacks-content[data-jsx=\"130301251\"]{left:4px;max-width:200px;height:180px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}div[data-jsx=\"130301251\"] .stacks{transition:-webkit-transform 0.2s ease-out;transition:transform 0.2s ease-out;transition:transform 0.2s ease-out, -webkit-transform 0.2s ease-out;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}.stacks-item[data-jsx=\"130301251\"]{transition:all 0.1s ease-out;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:140px;}.stacks-item[data-jsx=\"130301251\"]:not(.active){margin-top:36px;}.stacks-item[data-jsx=\"130301251\"] i,.stacks-item[data-jsx=\"130301251\"] img[data-jsx=\"130301251\"]{filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0\" /><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"2\" /><feFuncG type=\"linear\" slope=\"2\" /><feFuncB type=\"linear\" slope=\"2\" /></feComponentTransfer></filter></svg>#filter');-webkit-filter:grayscale(100%) brightness(200%);filter:grayscale(100%) brightness(200%);}.stacks-item[data-jsx=\"130301251\"] img[data-jsx=\"130301251\"]{max-width:128px;}.stacks-item.active[data-jsx=\"130301251\"]{-webkit-transform:scale(1.2);transform:scale(1.2);}.stacks-item.active.showSelectedBorder[data-jsx=\"130301251\"]{border-color:rgb(229, 229, 229);border-radius:6px;}.stacks-item.active[data-jsx=\"130301251\"] i,.stacks-item.active[data-jsx=\"130301251\"] img[data-jsx=\"130301251\"]{filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0\" /></filter></svg>#filter');-webkit-filter:grayscale(0%);filter:grayscale(0%);}.logos[data-jsx=\"130301251\"] i + i,.logos[data-jsx=\"130301251\"] i + img,.logos[data-jsx=\"130301251\"] img + i{margin-left:10px !important;}.beginners-choice[data-jsx=\"130301251\"]{color:#459BF2;}img[data-jsx=\"130301251\"]{width:auto !important;height:50px;margin-left:0 !important;}.coming-soon[data-jsx=\"130301251\"]{color:rgba(42, 126, 210, 1);border-color:rgba(42, 126, 210, 1);font-size:10px;padding:3px 7px;}.overflowHidden,\n.stack-chooser[data-jsx=\"130301251\"]{overflow:hidden;}.flex,\n.stacks-content[data-jsx=\"130301251\"],\ndiv[data-jsx=\"130301251\"] .stacks,\n.logos[data-jsx=\"130301251\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.center,\n.stacks-content[data-jsx=\"130301251\"],\n.stacks-item[data-jsx=\"130301251\"]{margin-right:auto;margin-left:auto;}.relative,\n.stacks-content[data-jsx=\"130301251\"],\n.coming-soon[data-jsx=\"130301251\"]{position:relative;}.flex,\n.stacks-content[data-jsx=\"130301251\"],\ndiv[data-jsx=\"130301251\"] .stacks,\n.logos[data-jsx=\"130301251\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.tc,\n.stacks-item[data-jsx=\"130301251\"],\n.beginners-choice[data-jsx=\"130301251\"]{text-align:center;}.pointer:hover,\n.stacks-item[data-jsx=\"130301251\"]:hover{cursor:pointer;}.center,\n.stacks-content[data-jsx=\"130301251\"],\n.stacks-item[data-jsx=\"130301251\"]{margin-right:auto;margin-left:auto;}.mt25,\n.stacks-item[data-jsx=\"130301251\"]{margin-top:25px;}.o30,\n.stacks-item[data-jsx=\"130301251\"] i,\n.stacks-item[data-jsx=\"130301251\"] img[data-jsx=\"130301251\"]{opacity:.3;}.mv0,\n.stacks-item[data-jsx=\"130301251\"] img[data-jsx=\"130301251\"],\n.logos[data-jsx=\"130301251\"] i + i,\n.logos[data-jsx=\"130301251\"] i + img,\n.logos[data-jsx=\"130301251\"] img + i{margin-top:0;margin-bottom:0;}.mt10,\n.stacks-item[data-jsx=\"130301251\"] p[data-jsx=\"130301251\"],\n.beginners-choice[data-jsx=\"130301251\"],\n.coming-soon[data-jsx=\"130301251\"]{margin-top:10px;}.o40,\n.stacks-item[data-jsx=\"130301251\"] p[data-jsx=\"130301251\"]{opacity:.4;}.f14,\n.stacks-item[data-jsx=\"130301251\"] p[data-jsx=\"130301251\"]{font-size:14px;}.fw6,\n.stacks-item[data-jsx=\"130301251\"] p[data-jsx=\"130301251\"],\n.beginners-choice[data-jsx=\"130301251\"],\n.coming-soon[data-jsx=\"130301251\"]{font-weight:600;}.pv16,\n.stacks-item.active[data-jsx=\"130301251\"]{padding-top:16px;padding-bottom:16px;}.ba,\n.stacks-item.active.showSelectedBorder[data-jsx=\"130301251\"],\n.coming-soon[data-jsx=\"130301251\"]{border-style:solid;border-width:1px;}.bw2,\n.stacks-item.active.showSelectedBorder[data-jsx=\"130301251\"]{border-width:2px;}.o100,\n.stacks-item.active[data-jsx=\"130301251\"] i,\n.stacks-item.active[data-jsx=\"130301251\"] img[data-jsx=\"130301251\"],\n.stacks-item.active[data-jsx=\"130301251\"] p[data-jsx=\"130301251\"]{opacity:1;}.o100,\n.stacks-item.active[data-jsx=\"130301251\"] i,\n.stacks-item.active[data-jsx=\"130301251\"] img[data-jsx=\"130301251\"],\n.stacks-item.active[data-jsx=\"130301251\"] p[data-jsx=\"130301251\"]{opacity:1;}.flex,\n.stacks-content[data-jsx=\"130301251\"],\ndiv[data-jsx=\"130301251\"] .stacks,\n.logos[data-jsx=\"130301251\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.justifyCenter,\n.logos[data-jsx=\"130301251\"]{-ms-flex-pack:center;-webkit-box-pack:center;justify-content:center;}.mv0,\n.stacks-item[data-jsx=\"130301251\"] img[data-jsx=\"130301251\"],\n.logos[data-jsx=\"130301251\"] i + i,\n.logos[data-jsx=\"130301251\"] i + img,\n.logos[data-jsx=\"130301251\"] img + i{margin-top:0;margin-bottom:0;}.f10,\n.beginners-choice[data-jsx=\"130301251\"]{font-size:10px;}.fw6,\n.stacks-item[data-jsx=\"130301251\"] p[data-jsx=\"130301251\"],\n.beginners-choice[data-jsx=\"130301251\"],\n.coming-soon[data-jsx=\"130301251\"]{font-weight:600;}.ttu,\n.beginners-choice[data-jsx=\"130301251\"],\n.coming-soon[data-jsx=\"130301251\"]{text-transform:uppercase;}.tc,\n.stacks-item[data-jsx=\"130301251\"],\n.beginners-choice[data-jsx=\"130301251\"]{text-align:center;}.mt10,\n.stacks-item[data-jsx=\"130301251\"] p[data-jsx=\"130301251\"],\n.beginners-choice[data-jsx=\"130301251\"],\n.coming-soon[data-jsx=\"130301251\"]{margin-top:10px;}.tracked,\n.beginners-choice[data-jsx=\"130301251\"]{letter-spacing:1px;}.ttu,\n.beginners-choice[data-jsx=\"130301251\"],\n.coming-soon[data-jsx=\"130301251\"]{text-transform:uppercase;}.br2,\n.coming-soon[data-jsx=\"130301251\"]{border-radius:2px;}.ba,\n.stacks-item.active.showSelectedBorder[data-jsx=\"130301251\"],\n.coming-soon[data-jsx=\"130301251\"]{border-style:solid;border-width:1px;}.dib,\n.coming-soon[data-jsx=\"130301251\"]{display:inline-block;}.relative,\n.stacks-content[data-jsx=\"130301251\"],\n.coming-soon[data-jsx=\"130301251\"]{position:relative;}.fw6,\n.stacks-item[data-jsx=\"130301251\"] p[data-jsx=\"130301251\"],\n.beginners-choice[data-jsx=\"130301251\"],\n.coming-soon[data-jsx=\"130301251\"]{font-weight:600;}.mt10,\n.stacks-item[data-jsx=\"130301251\"] p[data-jsx=\"130301251\"],\n.beginners-choice[data-jsx=\"130301251\"],\n.coming-soon[data-jsx=\"130301251\"]{margin-top:10px;}"
	                }),
	                React.createElement(
	                    "div",
	                    { className: "stacks-content", "data-jsx": 130301251
	                    },
	                    React.createElement(
	                        react_swipeable_views_1.default,
	                        { enableMouseEvents: true, style: {
	                                overflow: 'visible',
	                                width: 190
	                            }, slideStyle: {
	                                height: 200
	                            }, index: selectedIndex, onChangeIndex: onChangeSelectedIndex },
	                        tutorials.map(function (tutorial, index) {
	                            return React.createElement(
	                                "div",
	                                { className: cn('stacks-item', {
	                                        active: selectedIndex === index,
	                                        showSelectedBorder: showSelectedBorder
	                                    }), onMouseDown: _this2.handleMouseDown, onDrag: _this2.handleDrag, onMouseUp: _this2.handleMouseUp.bind(_this2, index), key: index, "data-jsx": 130301251
	                                },
	                                React.createElement(
	                                    "div",
	                                    { className: "logos", "data-jsx": 130301251
	                                    },
	                                    tutorial.images[0].endsWith('.png') || tutorial.images[0].endsWith('.svg') ? React.createElement("img", { src: tutorial.images[0], alt: "", className: cn(tutorial.key + "-1", {
	                                            darken: tutorial.darkenGreyLogo
	                                        }), "data-jsx": 130301251
	                                    }) : React.createElement(Icon_1.default, { src: tutorial.images[0], width: 50, height: 50, color: tutorial.color1 || 'black', className: cn(tutorial.key + "-1", {
	                                            lighten: tutorial.lightenLogo
	                                        }) }),
	                                    tutorial.images[1] && React.createElement(Icon_1.default, { src: tutorial.images[1], width: 50, height: 50, color: tutorial.color2 || 'black', className: cn(tutorial.key + "-2", {
	                                            lighten: tutorial.lightenLogo
	                                        }) })
	                                ),
	                                React.createElement(
	                                    "p",
	                                    {
	                                        "data-jsx": 130301251
	                                    },
	                                    tutorial.title
	                                ),
	                                tutorial.comingSoon && React.createElement(
	                                    "div",
	                                    { className: "coming-soon", "data-jsx": 130301251
	                                    },
	                                    "Coming Soon"
	                                ),
	                                tutorial.beginnersChoice && React.createElement(
	                                    "div",
	                                    { className: "beginners-choice", "data-jsx": 130301251
	                                    },
	                                    "Beginners's Choice"
	                                )
	                            );
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return StackChooser;
	}(React.Component);
	
	exports.default = withWidth_1.default()(StackChooser);

/***/ }),

/***/ "./src/components/Steps/ChooseTutorialStep.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var gatsby_link_1 = __webpack_require__("./node_modules/gatsby-link/index.js");
	var cn = __webpack_require__("./node_modules/classnames/index.js");
	function ChooseTutorialStep(_ref) {
	  var active = _ref.active,
	      onClick = _ref.onClick;
	
	  return React.createElement(
	    "div",
	    { className: cn('choose-tutorial-step', { active: active }), "data-jsx": 2823304925
	    },
	    active && React.createElement("div", { className: "before-fade", "data-jsx": 2823304925
	    }),
	    React.createElement(_style2.default, {
	      styleId: 2823304925,
	      css: ".choose-tutorial-step[data-jsx=\"2823304925\"] .before-fade[data-jsx=\"2823304925\"]{content:\"\";background:linear-gradient(            to bottom,            rgba(196, 196, 196, 1),            rgba(224, 0, 130, 1)          );height:100px;width:2px;left:-2px;top:-50px;}.choose-tutorial-step[data-jsx=\"2823304925\"]:after{content:\"\";background:linear-gradient(            to bottom,            rgba(245, 245, 245, 0),            rgba(245, 245, 245, 1)          );height:100px;width:2px;left:-2px;}.choose-tutorial-step.active[data-jsx=\"2823304925\"],.choose-tutorial-step.active[data-jsx=\"2823304925\"] span[data-jsx=\"2823304925\"]:before{border-color:rgba(42, 126, 210, 1);}span[data-jsx=\"2823304925\"]:before{background:#f5f5f5;content:'';left:-7px;margin-top:7px;width:8px;height:8px;}.bl,\n.choose-tutorial-step[data-jsx=\"2823304925\"]{border-left-style:solid;border-left-width:1px;}.bBlack20,\n.choose-tutorial-step[data-jsx=\"2823304925\"],\nspan[data-jsx=\"2823304925\"]:before{border-color:rgba(0, 0, 0, .2);}.pb38,\n.choose-tutorial-step[data-jsx=\"2823304925\"]{padding-bottom:38px;}.pl25,\n.choose-tutorial-step[data-jsx=\"2823304925\"]{padding-left:25px;}.relative,\n.choose-tutorial-step[data-jsx=\"2823304925\"]{position:relative;}.bw2,\n.choose-tutorial-step[data-jsx=\"2823304925\"],\nspan[data-jsx=\"2823304925\"]:before{border-width:2px;}.absolute,\n.choose-tutorial-step[data-jsx=\"2823304925\"] .before-fade[data-jsx=\"2823304925\"],\n.choose-tutorial-step[data-jsx=\"2823304925\"]:after,\nspan[data-jsx=\"2823304925\"]:before{position:absolute;}.bottom0,\n.choose-tutorial-step[data-jsx=\"2823304925\"] .before-fade[data-jsx=\"2823304925\"],\n.choose-tutorial-step[data-jsx=\"2823304925\"]:after{bottom:0;}.absolute,\n.choose-tutorial-step[data-jsx=\"2823304925\"] .before-fade[data-jsx=\"2823304925\"],\n.choose-tutorial-step[data-jsx=\"2823304925\"]:after,\nspan[data-jsx=\"2823304925\"]:before{position:absolute;}.bottom0,\n.choose-tutorial-step[data-jsx=\"2823304925\"] .before-fade[data-jsx=\"2823304925\"],\n.choose-tutorial-step[data-jsx=\"2823304925\"]:after{bottom:0;}.black80,\nspan[data-jsx=\"2823304925\"]{color:rgba(0, 0, 0, .8);}.bBlack20,\n.choose-tutorial-step[data-jsx=\"2823304925\"],\nspan[data-jsx=\"2823304925\"]:before{border-color:rgba(0, 0, 0, .2);}.absolute,\n.choose-tutorial-step[data-jsx=\"2823304925\"] .before-fade[data-jsx=\"2823304925\"],\n.choose-tutorial-step[data-jsx=\"2823304925\"]:after,\nspan[data-jsx=\"2823304925\"]:before{position:absolute;}.ba,\nspan[data-jsx=\"2823304925\"]:before{border-style:solid;border-width:1px;}.bw2,\n.choose-tutorial-step[data-jsx=\"2823304925\"],\nspan[data-jsx=\"2823304925\"]:before{border-width:2px;}.br100,\nspan[data-jsx=\"2823304925\"]:before{border-radius:100%;}.black30,\nh3[data-jsx=\"2823304925\"],\np[data-jsx=\"2823304925\"]{color:rgba(0, 0, 0, .3);}.f14,\nh3[data-jsx=\"2823304925\"],\np[data-jsx=\"2823304925\"]{font-size:14px;}.ttu,\nh3[data-jsx=\"2823304925\"]{text-transform:uppercase;}.fw6,\nh3[data-jsx=\"2823304925\"]{font-weight:600;}.mb25,\nh3[data-jsx=\"2823304925\"]{margin-bottom:25px;}.f14,\nh3[data-jsx=\"2823304925\"],\np[data-jsx=\"2823304925\"]{font-size:14px;}.black30,\nh3[data-jsx=\"2823304925\"],\np[data-jsx=\"2823304925\"]{color:rgba(0, 0, 0, .3);}.lhCopy,\np[data-jsx=\"2823304925\"]{line-height:1.5;}.mt25,\np[data-jsx=\"2823304925\"]{margin-top:25px;}"
	    }),
	    React.createElement(
	      gatsby_link_1.default,
	      { to: "/choose/", onClick: onClick },
	      React.createElement(
	        "h3",
	        {
	          "data-jsx": 2823304925
	        },
	        "Practical Tutorial"
	      ),
	      React.createElement(
	        "span",
	        {
	          "data-jsx": 2823304925
	        },
	        "Choosing the right tutorial"
	      ),
	      React.createElement(
	        "p",
	        {
	          "data-jsx": 2823304925
	        },
	        "We have tutorials prepared covering all major API and client technologies you can use to build hypermedia applications such as Vue, ASP.NET Core and many more."
	      )
	    )
	  );
	}
	exports.default = ChooseTutorialStep;

/***/ }),

/***/ "./src/components/Steps/DottedListItem.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var cn = __webpack_require__("./node_modules/classnames/index.js");
	var react_redux_1 = __webpack_require__("./node_modules/react-redux/lib/index.js");
	var quiz_1 = __webpack_require__("./src/reducers/quiz.ts");
	var Checkmark_1 = __webpack_require__("./src/components/Checkmark.tsx");
	var Icon_1 = __webpack_require__("./node_modules/graphcool-styles/dist/components/Icon/Icon.js");
	var graphcool_styles_1 = __webpack_require__("./node_modules/graphcool-styles/dist/build.js");
	var DottedListItem = function DottedListItem(_ref) {
	  var children = _ref.children,
	      light = _ref.light,
	      first = _ref.first,
	      small = _ref.small,
	      active = _ref.active,
	      highlightFirst = _ref.highlightFirst,
	      _ref$showLine = _ref.showLine,
	      showLine = _ref$showLine === undefined ? true : _ref$showLine,
	      last = _ref.last,
	      skipped = _ref.skipped,
	      answeredCorrectly = _ref.answeredCorrectly;
	
	  var done = skipped || answeredCorrectly;
	  return React.createElement(
	    "div",
	    { className: cn('dotted-list-item', {
	        active: active,
	        done: done,
	        first: first,
	        highlightFirst: highlightFirst,
	        last: last,
	        light: light,
	        showLine: showLine,
	        small: small
	      }), "data-jsx": 378797913
	    },
	    React.createElement(_style2.default, {
	      styleId: 378797913,
	      css: ".dotted-list-item[data-jsx=\"378797913\"]:not(.done)::before{background:rgba(224, 0, 130, 0);content:'';left:-7px;margin-top:3px;width:8px;height:8px;transition:border-color .15s ease-in-out;}.dotted-list-item[data-jsx=\"378797913\"]{transition:color .15s ease-in-out;}.dotted-list-item[data-jsx=\"378797913\"]:not(.done):hover{color:rgba(42, 126, 210, 1) !important;}.dotted-list-item[data-jsx=\"378797913\"]:not(.done):hover::before{border-color:rgba(42, 126, 210, 1);margin-top:-2px !important;left:-13px;width:20px;height:20px;}.play[data-jsx=\"378797913\"]{visibility:hidden;pointer-events:none;transition:opacity .25s ease-in-out;left:-5px;margin-top:5px;}.dotted-list-item[data-jsx=\"378797913\"]:not(.done):hover .play[data-jsx=\"378797913\"]{visibility:visible;pointer-events:all;transition:none;}div.dotted-list-item[data-jsx=\"378797913\"]:not(.done).first:hover::before{margin-top:-4px !important;}.dotted-list-item[data-jsx=\"378797913\"]:not(.done).first:hover .play[data-jsx=\"378797913\"]{margin-top:3px;}.dotted-list-item[data-jsx=\"378797913\"]:not(.done).first.small:hover::before{margin-top:-4px !important;}.dotted-list-item[data-jsx=\"378797913\"]:not(.done).first.small:hover .play[data-jsx=\"378797913\"]{margin-top:3px;}.dotted-list-item[data-jsx=\"378797913\"]:not(.done).last.small:hover::before{bottom:-5px;}.dotted-list-item[data-jsx=\"378797913\"]:not(.done).last.small .play[data-jsx=\"378797913\"]{bottom:2px;}.checkmark[data-jsx=\"378797913\"]{left:-11px;margin-top:-1px;}.dotted-list-item.light.first[data-jsx=\"378797913\"]:not(.small)::before,.dotted-list-item.active[data-jsx=\"378797913\"]::before{border-color:rgba(42, 126, 210, 1) !important;}.dotted-list-item.light.first[data-jsx=\"378797913\"]::before{margin-top:0 !important;}.dotted-list-item.light.first.small[data-jsx=\"378797913\"]::before{margin-top:0 !important;}.dotted-list-item.light.first.small[data-jsx=\"378797913\"]::before{margin-top:14px;}.dotted-list-item.first[data-jsx=\"378797913\"]{padding-top:0 !important;}.first[data-jsx=\"378797913\"] .checkmark[data-jsx=\"378797913\"]{margin-top:-5px;}.last[data-jsx=\"378797913\"] .checkmark[data-jsx=\"378797913\"]{bottom:0;}.dotted-list-item.first.light.highlightFirst[data-jsx=\"378797913\"]::after,.dotted-list-item.first.light.done[data-jsx=\"378797913\"]::after{content:'';height:38px;margin-top:-18px;left:-2px;background-image:linear-gradient(            to top,            rgba(225, 225, 225, .0),            rgba(42, 126, 210, 1)          );width:2px;}.dotted-list-item.first.highlightFirst.small[data-jsx=\"378797913\"]::after,.dotted-list-item.first.done.small[data-jsx=\"378797913\"]::after{height:30px;margin-top:-9px;}.dotted-list-item.last[data-jsx=\"378797913\"]::before{margin-top:auto;bottom:0;}.dotted-list-item.last[data-jsx=\"378797913\"]{padding-bottom:0 !important;}.dotted-list-item.small[data-jsx=\"378797913\"]::before{margin-top:2px;}div.dotted-list-item.light[data-jsx=\"378797913\"]::before,.dotted-list-item.light[data-jsx=\"378797913\"]{border-color:rgba(0, 0, 0, .2);}.dotted-list-item.small.last[data-jsx=\"378797913\"]{padding-top:0;}.dotted-list-item[data-jsx=\"378797913\"]:not(.light).first{padding-top:18px !important;}.dotted-list-item.first.light[data-jsx=\"378797913\"]:not(.small) .list-item{top:-8px;}.dotted-list-item.first.light[data-jsx=\"378797913\"]:not(.small).done .list-item{top:-9px;}.dotted-list-item.small[data-jsx=\"378797913\"] .list-item{top:-4px;}.dotted-list-item.small.first[data-jsx=\"378797913\"] .list-item{top:-6px;}.dotted-list-item.small.last[data-jsx=\"378797913\"] .list-item{top:5px;}.dotted-list-item.small.last.done[data-jsx=\"378797913\"] .list-item{top:2px;}.dotted-list-item[data-jsx=\"378797913\"]:not(.small) .list-item{top:-5px;}.done[data-jsx=\"378797913\"]:not(.active) .title{color:rgba(42, 126, 210, 1) !important;}.dotted-list-item[data-jsx=\"378797913\"]:not(.first) .before-glow[data-jsx=\"378797913\"]{height:100%;top:-23px;left:-2px;background-image:linear-gradient(            to top,            rgba(42, 126, 210, 1) 20%,            rgba(225, 225, 225, .0)          );width:2px;}.dotted-list-item[data-jsx=\"378797913\"]:not(.first).small .before-glow[data-jsx=\"378797913\"]{height:100%;top:-21px;}.dotted-list-item.last.small[data-jsx=\"378797913\"] .before-glow[data-jsx=\"378797913\"]{height:100%;top:-12px;}.dotted-list-item[data-jsx=\"378797913\"] .after-glow[data-jsx=\"378797913\"]{height:100%;left:-2px;top:33px;background-image:linear-gradient(            to top,            rgba(225, 225, 225, .0),            rgba(42, 126, 210, 1) 80%          );width:2px;}.dotted-list-item.small.first[data-jsx=\"378797913\"] .after-glow[data-jsx=\"378797913\"]{height:calc(100% - 10px);top:12px;}.dotted-list-item.small[data-jsx=\"378797913\"] .after-glow[data-jsx=\"378797913\"]{height:calc(100% - 10px);top:50%;}.bWhite20,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.done)::before,\n.dotted-list-item[data-jsx=\"378797913\"]{border-color:hsla(0, 0%, 100%, .2);}.absolute,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.done)::before,\n.play[data-jsx=\"378797913\"],\n.checkmark[data-jsx=\"378797913\"],\n.dotted-list-item.first.light.highlightFirst[data-jsx=\"378797913\"]::after,\n.dotted-list-item.first.light.done[data-jsx=\"378797913\"]::after,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.first) .before-glow[data-jsx=\"378797913\"],\n.dotted-list-item[data-jsx=\"378797913\"] .after-glow[data-jsx=\"378797913\"]{position:absolute;}.bgDarkBlue,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.done)::before{background-color:#172a3a;}.ba,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.done)::before{border-style:solid;border-width:1px;}.bw2,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.done)::before,\n.dotted-list-item.showLine[data-jsx=\"378797913\"]{border-width:2px;}.br100,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.done)::before{border-radius:100%;}.z2,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.done)::before,\n.checkmark[data-jsx=\"378797913\"]{z-index:2;}.o0,\n.play[data-jsx=\"378797913\"]{opacity:0;}.absolute,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.done)::before,\n.play[data-jsx=\"378797913\"],\n.checkmark[data-jsx=\"378797913\"],\n.dotted-list-item.first.light.highlightFirst[data-jsx=\"378797913\"]::after,\n.dotted-list-item.first.light.done[data-jsx=\"378797913\"]::after,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.first) .before-glow[data-jsx=\"378797913\"],\n.dotted-list-item[data-jsx=\"378797913\"] .after-glow[data-jsx=\"378797913\"]{position:absolute;}.z3,\n.play[data-jsx=\"378797913\"]{z-index:3;}.o100,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.done):hover .play[data-jsx=\"378797913\"]{opacity:1;}.absolute,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.done)::before,\n.play[data-jsx=\"378797913\"],\n.checkmark[data-jsx=\"378797913\"],\n.dotted-list-item.first.light.highlightFirst[data-jsx=\"378797913\"]::after,\n.dotted-list-item.first.light.done[data-jsx=\"378797913\"]::after,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.first) .before-glow[data-jsx=\"378797913\"],\n.dotted-list-item[data-jsx=\"378797913\"] .after-glow[data-jsx=\"378797913\"]{position:absolute;}.z2,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.done)::before,\n.checkmark[data-jsx=\"378797913\"]{z-index:2;}.blue,\n.dotted-list-item.first.light[data-jsx=\"378797913\"]:not(.small) .list-item{color:#2a7ed2;}.db,\n.dotted-list-item.first.light.highlightFirst[data-jsx=\"378797913\"]::after,\n.dotted-list-item.first.light.done[data-jsx=\"378797913\"]::after,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.first) .before-glow[data-jsx=\"378797913\"],\n.dotted-list-item[data-jsx=\"378797913\"] .after-glow[data-jsx=\"378797913\"]{display:block;}.absolute,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.done)::before,\n.play[data-jsx=\"378797913\"],\n.checkmark[data-jsx=\"378797913\"],\n.dotted-list-item.first.light.highlightFirst[data-jsx=\"378797913\"]::after,\n.dotted-list-item.first.light.done[data-jsx=\"378797913\"]::after,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.first) .before-glow[data-jsx=\"378797913\"],\n.dotted-list-item[data-jsx=\"378797913\"] .after-glow[data-jsx=\"378797913\"]{position:absolute;}.bgWhite,\n.dotted-list-item.light[data-jsx=\"378797913\"]::before{background-color:#fff;}.pv16,\n.dotted-list-item[data-jsx=\"378797913\"]{padding-top:16px;padding-bottom:16px;}.f20,\n.dotted-list-item[data-jsx=\"378797913\"]{font-size:20px;}.pl38,\n.dotted-list-item[data-jsx=\"378797913\"]{padding-left:38px;}.relative,\n.dotted-list-item[data-jsx=\"378797913\"],\n.dotted-list-item.light[data-jsx=\"378797913\"] a,\n.dotted-list-item[data-jsx=\"378797913\"] .list-item{position:relative;}.bWhite20,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.done)::before,\n.dotted-list-item[data-jsx=\"378797913\"]{border-color:hsla(0, 0%, 100%, .2);}.bl,\n.dotted-list-item.showLine[data-jsx=\"378797913\"]{border-left-style:solid;border-left-width:1px;}.bw2,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.done)::before,\n.dotted-list-item.showLine[data-jsx=\"378797913\"]{border-width:2px;}.f16,\n.dotted-list-item.small[data-jsx=\"378797913\"]{font-size:16px;}.pv12,\n.dotted-list-item.small[data-jsx=\"378797913\"]{padding-top:12px;padding-bottom:12px;}.pl25,\n.dotted-list-item.small[data-jsx=\"378797913\"]{padding-left:25px;}.black80,\n.dotted-list-item.light[data-jsx=\"378797913\"] a{color:rgba(0, 0, 0, .8);}.relative,\n.dotted-list-item[data-jsx=\"378797913\"],\n.dotted-list-item.light[data-jsx=\"378797913\"] a,\n.dotted-list-item[data-jsx=\"378797913\"] .list-item{position:relative;}.relative,\n.dotted-list-item[data-jsx=\"378797913\"],\n.dotted-list-item.light[data-jsx=\"378797913\"] a,\n.dotted-list-item[data-jsx=\"378797913\"] .list-item{position:relative;}.white,\n.dotted-list-item[data-jsx=\"378797913\"] a{color:#fff;}.noUnderline,\n.dotted-list-item[data-jsx=\"378797913\"] a{text-decoration:none;}.db,\n.dotted-list-item.first.light.highlightFirst[data-jsx=\"378797913\"]::after,\n.dotted-list-item.first.light.done[data-jsx=\"378797913\"]::after,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.first) .before-glow[data-jsx=\"378797913\"],\n.dotted-list-item[data-jsx=\"378797913\"] .after-glow[data-jsx=\"378797913\"]{display:block;}.absolute,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.done)::before,\n.play[data-jsx=\"378797913\"],\n.checkmark[data-jsx=\"378797913\"],\n.dotted-list-item.first.light.highlightFirst[data-jsx=\"378797913\"]::after,\n.dotted-list-item.first.light.done[data-jsx=\"378797913\"]::after,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.first) .before-glow[data-jsx=\"378797913\"],\n.dotted-list-item[data-jsx=\"378797913\"] .after-glow[data-jsx=\"378797913\"]{position:absolute;}.db,\n.dotted-list-item.first.light.highlightFirst[data-jsx=\"378797913\"]::after,\n.dotted-list-item.first.light.done[data-jsx=\"378797913\"]::after,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.first) .before-glow[data-jsx=\"378797913\"],\n.dotted-list-item[data-jsx=\"378797913\"] .after-glow[data-jsx=\"378797913\"]{display:block;}.absolute,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.done)::before,\n.play[data-jsx=\"378797913\"],\n.checkmark[data-jsx=\"378797913\"],\n.dotted-list-item.first.light.highlightFirst[data-jsx=\"378797913\"]::after,\n.dotted-list-item.first.light.done[data-jsx=\"378797913\"]::after,\n.dotted-list-item[data-jsx=\"378797913\"]:not(.first) .before-glow[data-jsx=\"378797913\"],\n.dotted-list-item[data-jsx=\"378797913\"] .after-glow[data-jsx=\"378797913\"]{position:absolute;}.dn,\ndiv.dotted-list-item[data-jsx=\"378797913\"]:not(.small).first .after-glow[data-jsx=\"378797913\"]{display:none;}"
	    }),
	    React.createElement(
	      "div",
	      { className: "play", "data-jsx": 378797913
	      },
	      React.createElement(Icon_1.default, { src: __webpack_require__("./src/assets/icons/video.svg"), width: 10, height: 10, color: graphcool_styles_1.$v.blue })
	    ),
	    done && React.createElement(
	      "div",
	      { className: "checkmark", "data-jsx": 378797913
	      },
	      React.createElement(Checkmark_1.default, { checked: true })
	    ),
	    showLine && (done || active) && React.createElement("div", { className: "before-glow", "data-jsx": 378797913
	    }),
	    children,
	    showLine && (done || active) && !last && React.createElement("div", { className: "after-glow", "data-jsx": 378797913
	    })
	  );
	};
	exports.default = react_redux_1.connect(function (_ref2, props) {
	  var quiz = _ref2.quiz;
	
	  return quiz.quizReactions[props.path] || quiz_1.defaultReaction;
	})(DottedListItem);

/***/ }),

/***/ "./src/components/Steps/OptionalDottedListItem.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var cn = __webpack_require__("./node_modules/classnames/index.js");
	var quiz_1 = __webpack_require__("./src/reducers/quiz.ts");
	var react_redux_1 = __webpack_require__("./node_modules/react-redux/lib/index.js");
	var Checkmark_1 = __webpack_require__("./src/components/Checkmark.tsx");
	var Icon_1 = __webpack_require__("./node_modules/graphcool-styles/dist/components/Icon/Icon.js");
	var graphcool_styles_1 = __webpack_require__("./node_modules/graphcool-styles/dist/build.js");
	var OptionalDottedListItem = function OptionalDottedListItem(_ref) {
	  var children = _ref.children,
	      small = _ref.small,
	      active = _ref.active,
	      skipped = _ref.skipped,
	      answeredCorrectly = _ref.answeredCorrectly;
	
	  var done = skipped || answeredCorrectly;
	  return React.createElement(
	    "div",
	    { className: cn('optional-dotted-list-item', { small: small, active: active, done: done }), "data-jsx": 4161471927
	    },
	    React.createElement(_style2.default, {
	      styleId: 4161471927,
	      css: ".optional-dotted-list-item[data-jsx=\"4161471927\"]:not(.done)::before{content:'';left:-9px;margin-top:9px;width:8px;height:8px;transition:border-color .15s ease-in-out;}div.optional-dotted-list-item.active[data-jsx=\"4161471927\"]::before{border-color:rgba(42, 126, 210, 1);}.optional-dotted-list-item[data-jsx=\"4161471927\"]{left:0px;transition:color .15s ease-in-out;}.optional-dotted-list-item.small[data-jsx=\"4161471927\"]{padding-left:20px;}.optional-dotted-list-item.small[data-jsx=\"4161471927\"] .list-item{top:-3px;}div.optional-dotted-list-item.small[data-jsx=\"4161471927\"]::before{margin-top:3px;}.done[data-jsx=\"4161471927\"]:not(.active) span{color:rgba(23, 42, 58, .40) !important;}.checkmark[data-jsx=\"4161471927\"]{left:-13px;margin-top:-1px;}.optional-dotted-list-item[data-jsx=\"4161471927\"]:not(.small) .checkmark[data-jsx=\"4161471927\"]{margin-top:4px;}.optional-dotted-list-item[data-jsx=\"4161471927\"]:not(.done):hover::before{border-color:rgba(42, 126, 210, 1);margin-top:4px !important;left:-13px;width:20px;height:20px;}.optional-dotted-list-item.small[data-jsx=\"4161471927\"]:not(.done):hover::before{border-color:rgba(42, 126, 210, 1);margin-top:-2px !important;left:-13px;width:20px;height:20px;}.optional-dotted-list-item[data-jsx=\"4161471927\"] span{transition:color .15s ease-in-out;}.optional-dotted-list-item[data-jsx=\"4161471927\"]:hover span{color:rgba(42, 126, 210, 1) !important;}.small[data-jsx=\"4161471927\"] .play[data-jsx=\"4161471927\"]{margin-top:5px;}.play[data-jsx=\"4161471927\"]{visibility:hidden;pointer-events:none;transition:opacity .25s ease-in-out;left:-5px;margin-top:11px;}.optional-dotted-list-item[data-jsx=\"4161471927\"]:not(.done):hover .play[data-jsx=\"4161471927\"]{visibility:visible;pointer-events:all;transition:none;}.bBlack20,\n.optional-dotted-list-item[data-jsx=\"4161471927\"]:not(.done)::before{border-color:rgba(0, 0, 0, .2);}.bgWhite,\n.optional-dotted-list-item[data-jsx=\"4161471927\"]:not(.done)::before{background-color:#fff;}.absolute,\n.optional-dotted-list-item[data-jsx=\"4161471927\"]:not(.done)::before,\n.checkmark[data-jsx=\"4161471927\"],\n.play[data-jsx=\"4161471927\"]{position:absolute;}.ba,\n.optional-dotted-list-item[data-jsx=\"4161471927\"]:not(.done)::before{border-style:solid;border-width:1px;}.bw2,\n.optional-dotted-list-item[data-jsx=\"4161471927\"]:not(.done)::before{border-width:2px;}.br100,\n.optional-dotted-list-item[data-jsx=\"4161471927\"]:not(.done)::before{border-radius:100%;}.pv16,\n.optional-dotted-list-item[data-jsx=\"4161471927\"]{padding-top:16px;padding-bottom:16px;}.f20,\n.optional-dotted-list-item[data-jsx=\"4161471927\"]{font-size:20px;}.pl38,\n.optional-dotted-list-item[data-jsx=\"4161471927\"]{padding-left:38px;}.relative,\n.optional-dotted-list-item[data-jsx=\"4161471927\"],\n.optional-dotted-list-item.small[data-jsx=\"4161471927\"] .list-item{position:relative;}.pv12,\n.optional-dotted-list-item.small[data-jsx=\"4161471927\"]{padding-top:12px;padding-bottom:12px;}.black80,\n.optional-dotted-list-item.small[data-jsx=\"4161471927\"] span,\n.optional-dotted-list-item[data-jsx=\"4161471927\"] span{color:rgba(0, 0, 0, .8);}.f16,\n.optional-dotted-list-item.small[data-jsx=\"4161471927\"] span{font-size:16px;}.relative,\n.optional-dotted-list-item[data-jsx=\"4161471927\"],\n.optional-dotted-list-item.small[data-jsx=\"4161471927\"] .list-item{position:relative;}.black80,\n.optional-dotted-list-item.small[data-jsx=\"4161471927\"] span,\n.optional-dotted-list-item[data-jsx=\"4161471927\"] span{color:rgba(0, 0, 0, .8);}.blue,\ndiv.optional-dotted-list-item.active[data-jsx=\"4161471927\"] span{color:#2a7ed2;}.absolute,\n.optional-dotted-list-item[data-jsx=\"4161471927\"]:not(.done)::before,\n.checkmark[data-jsx=\"4161471927\"],\n.play[data-jsx=\"4161471927\"]{position:absolute;}.z2,\n.checkmark[data-jsx=\"4161471927\"]{z-index:2;}.o0,\n.play[data-jsx=\"4161471927\"]{opacity:0;}.absolute,\n.optional-dotted-list-item[data-jsx=\"4161471927\"]:not(.done)::before,\n.checkmark[data-jsx=\"4161471927\"],\n.play[data-jsx=\"4161471927\"]{position:absolute;}.z3,\n.play[data-jsx=\"4161471927\"]{z-index:3;}.o100,\n.optional-dotted-list-item[data-jsx=\"4161471927\"]:not(.done):hover .play[data-jsx=\"4161471927\"]{opacity:1;}"
	    }),
	    React.createElement(
	      "div",
	      { className: "play", "data-jsx": 4161471927
	      },
	      React.createElement(Icon_1.default, { src: __webpack_require__("./src/assets/icons/video.svg"), width: 10, height: 10, color: graphcool_styles_1.$v.blue })
	    ),
	    done && React.createElement(
	      "div",
	      { className: "checkmark", "data-jsx": 4161471927
	      },
	      React.createElement(Checkmark_1.default, { checked: true })
	    ),
	    children
	  );
	};
	exports.default = react_redux_1.connect(function (_ref2, props) {
	  var quiz = _ref2.quiz;
	
	  return quiz.quizReactions[props.path] || quiz_1.defaultReaction;
	})(OptionalDottedListItem);

/***/ }),

/***/ "./src/components/Steps/OptionalSteps.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var gatsby_link_1 = __webpack_require__("./node_modules/gatsby-link/index.js");
	var OptionalDottedListItem_1 = __webpack_require__("./src/components/Steps/OptionalDottedListItem.tsx");
	var Icon_1 = __webpack_require__("./node_modules/graphcool-styles/dist/components/Icon/Icon.js");
	var Duration_1 = __webpack_require__("./src/components/Duration.tsx");
	var cn = __webpack_require__("./node_modules/classnames/index.js");
	var graphql_1 = __webpack_require__("./src/utils/graphql.ts");
	var react_transition_group_1 = __webpack_require__("./node_modules/react-transition-group/index.js");
	
	var OptionalSteps = function (_React$Component) {
	  _inherits(OptionalSteps, _React$Component);
	
	  function OptionalSteps(props) {
	    _classCallCheck(this, OptionalSteps);
	
	    var _this = _possibleConstructorReturn(this, (OptionalSteps.__proto__ || Object.getPrototypeOf(OptionalSteps)).call(this, props));
	
	    _this.toggleCollapse = function () {
	      _this.setState(function (state) {
	        return { collapsed: !state.collapsed };
	      }, _this.tweenN);
	    };
	    var group = graphql_1.extractGroup(props.location.pathname);
	    var count = group === 'advanced' ? props.steps.length : 2;
	    _this.state = {
	      collapsed: true,
	      group: group,
	      n: _this.getN(count)
	    };
	    return _this;
	  }
	
	  _createClass(OptionalSteps, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.location.key !== this.props.location.key) {
	        var group = graphql_1.extractGroup(nextProps.location.pathname);
	        var isAdvanced = group === 'advanced';
	        var count = isAdvanced ? nextProps.steps.length : 2;
	        this.setState(function (state) {
	          return _extends({}, state, { group: group, n: _this2.getN(count), collapsed: !isAdvanced });
	        });
	      }
	    }
	  }, {
	    key: "getN",
	    value: function getN(count) {
	      if (this.props.small) {
	        return count * 36 + 16;
	      }
	      return count * 52 + 16;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          steps = _props.steps,
	          small = _props.small,
	          mainPink = _props.mainPink,
	          onClickLink = _props.onClickLink;
	      var _state = this.state,
	          collapsed = _state.collapsed,
	          n = _state.n,
	          group = _state.group;
	
	      var reallyCollapsed = collapsed && group !== 'advanced';
	      var visibleSteps = reallyCollapsed ? steps.slice(0, 2) : steps;
	      var showDuration = typeof this.props.showDuration !== 'undefined' ? this.props.showDuration : true;
	      return React.createElement(
	        "div",
	        { className: cn('optional-steps', { small: small, mainPink: mainPink }), "data-jsx": 3392699359
	        },
	        React.createElement(_style2.default, {
	          styleId: 841592754,
	          css: ".optional-steps.mainPink[data-jsx=\"3392699359\"]::before{content:\"\";left:-2px;width:2px;}.time[data-jsx=\"3392699359\"]{font-size:15px;}.time[data-jsx=\"3392699359\"] img[data-jsx=\"3392699359\"]{width:15px;height:15px;}.time.first[data-jsx=\"3392699359\"]{top:-3px;}.steps-svg-class[data-jsx=\"3392699359\"]{fill:none;stroke:#ccc;stroke-width:2;stroke-linecap:square;stroke-miterlimit:10;stroke-dasharray:10, 10;}.small[data-jsx=\"3392699359\"] .more[data-jsx=\"3392699359\"] span[data-jsx=\"3392699359\"]{margin-left:-12px;}.plus[data-jsx=\"3392699359\"]{left:-19px;width:28px;height:28px;}.line[data-jsx=\"3392699359\"]{left:-2px;}.flex,\n.optional-steps[data-jsx=\"3392699359\"],\n.list-item[data-jsx=\"3392699359\"],\n.time[data-jsx=\"3392699359\"],\n.more[data-jsx=\"3392699359\"],\n.plus[data-jsx=\"3392699359\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.bl,\n.optional-steps[data-jsx=\"3392699359\"]{border-left-style:solid;border-left-width:1px;}.bw2,\n.optional-steps[data-jsx=\"3392699359\"],\n.plus[data-jsx=\"3392699359\"]{border-width:2px;}.bBlack20,\n.optional-steps[data-jsx=\"3392699359\"],\n.plus[data-jsx=\"3392699359\"]{border-color:rgba(0, 0, 0, .2);}.pb25,\n.optional-steps[data-jsx=\"3392699359\"]{padding-bottom:25px;}.relative,\n.optional-steps[data-jsx=\"3392699359\"],\n.time[data-jsx=\"3392699359\"],\n.plus[data-jsx=\"3392699359\"],\n.line[data-jsx=\"3392699359\"]{position:relative;}.bbox,\n.optional-steps[data-jsx=\"3392699359\"]{box-sizing:border-box;}.absolute,\n.optional-steps.mainPink[data-jsx=\"3392699359\"]::before{position:absolute;}.top0,\n.optional-steps.mainPink[data-jsx=\"3392699359\"]::before{top:0;}.bottom0,\n.optional-steps.mainPink[data-jsx=\"3392699359\"]::before{bottom:0;}.bgBlue,\n.optional-steps.mainPink[data-jsx=\"3392699359\"]::before{background-color:#2a7ed2;}.z2,\n.optional-steps.mainPink[data-jsx=\"3392699359\"]::before{z-index:2;}.black30,\np[data-jsx=\"3392699359\"],\n.time[data-jsx=\"3392699359\"],\n.more[data-jsx=\"3392699359\"] span[data-jsx=\"3392699359\"]{color:rgba(0, 0, 0, .3);}.itemsCenter,\n.list-item[data-jsx=\"3392699359\"],\n.time[data-jsx=\"3392699359\"],\n.more[data-jsx=\"3392699359\"],\n.plus[data-jsx=\"3392699359\"]{-webkit-box-align:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;}.flex,\n.optional-steps[data-jsx=\"3392699359\"],\n.list-item[data-jsx=\"3392699359\"],\n.time[data-jsx=\"3392699359\"],\n.more[data-jsx=\"3392699359\"],\n.plus[data-jsx=\"3392699359\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.ttu,\n.time[data-jsx=\"3392699359\"]{text-transform:uppercase;}.black30,\np[data-jsx=\"3392699359\"],\n.time[data-jsx=\"3392699359\"],\n.more[data-jsx=\"3392699359\"] span[data-jsx=\"3392699359\"]{color:rgba(0, 0, 0, .3);}.ml10,\n.time[data-jsx=\"3392699359\"]{margin-left:10px;}.itemsCenter,\n.list-item[data-jsx=\"3392699359\"],\n.time[data-jsx=\"3392699359\"],\n.more[data-jsx=\"3392699359\"],\n.plus[data-jsx=\"3392699359\"]{-webkit-box-align:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;}.flex,\n.optional-steps[data-jsx=\"3392699359\"],\n.list-item[data-jsx=\"3392699359\"],\n.time[data-jsx=\"3392699359\"],\n.more[data-jsx=\"3392699359\"],\n.plus[data-jsx=\"3392699359\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.fw6,\n.time[data-jsx=\"3392699359\"]{font-weight:600;}.relative,\n.optional-steps[data-jsx=\"3392699359\"],\n.time[data-jsx=\"3392699359\"],\n.plus[data-jsx=\"3392699359\"],\n.line[data-jsx=\"3392699359\"]{position:relative;}.ml6,\n.time[data-jsx=\"3392699359\"] span[data-jsx=\"3392699359\"]{margin-left:6px;}.mt60,\n.steps[data-jsx=\"3392699359\"]{margin-top:60px;}.flex,\n.optional-steps[data-jsx=\"3392699359\"],\n.list-item[data-jsx=\"3392699359\"],\n.time[data-jsx=\"3392699359\"],\n.more[data-jsx=\"3392699359\"],\n.plus[data-jsx=\"3392699359\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.itemsCenter,\n.list-item[data-jsx=\"3392699359\"],\n.time[data-jsx=\"3392699359\"],\n.more[data-jsx=\"3392699359\"],\n.plus[data-jsx=\"3392699359\"]{-webkit-box-align:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;}.mt12,\n.more[data-jsx=\"3392699359\"]{margin-top:12px;}.pointer:hover,\n.more[data-jsx=\"3392699359\"]:hover{cursor:pointer;}.f20,\n.more[data-jsx=\"3392699359\"] span[data-jsx=\"3392699359\"]{font-size:20px;}.black30,\np[data-jsx=\"3392699359\"],\n.time[data-jsx=\"3392699359\"],\n.more[data-jsx=\"3392699359\"] span[data-jsx=\"3392699359\"]{color:rgba(0, 0, 0, .3);}.ml4,\n.more[data-jsx=\"3392699359\"] span[data-jsx=\"3392699359\"]{margin-left:4px;}.f16,\n.small[data-jsx=\"3392699359\"] .more[data-jsx=\"3392699359\"] span[data-jsx=\"3392699359\"]{font-size:16px;}.bBlack20,\n.optional-steps[data-jsx=\"3392699359\"],\n.plus[data-jsx=\"3392699359\"]{border-color:rgba(0, 0, 0, .2);}.ba,\n.plus[data-jsx=\"3392699359\"]{border-style:solid;border-width:1px;}.br100,\n.plus[data-jsx=\"3392699359\"]{border-radius:100%;}.flex,\n.optional-steps[data-jsx=\"3392699359\"],\n.list-item[data-jsx=\"3392699359\"],\n.time[data-jsx=\"3392699359\"],\n.more[data-jsx=\"3392699359\"],\n.plus[data-jsx=\"3392699359\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.itemsCenter,\n.list-item[data-jsx=\"3392699359\"],\n.time[data-jsx=\"3392699359\"],\n.more[data-jsx=\"3392699359\"],\n.plus[data-jsx=\"3392699359\"]{-webkit-box-align:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;}.justifyCenter,\n.plus[data-jsx=\"3392699359\"]{-ms-flex-pack:center;-webkit-box-pack:center;justify-content:center;}.bw2,\n.optional-steps[data-jsx=\"3392699359\"],\n.plus[data-jsx=\"3392699359\"]{border-width:2px;}.bgWhite,\n.plus[data-jsx=\"3392699359\"]{background-color:#fff;}.relative,\n.optional-steps[data-jsx=\"3392699359\"],\n.time[data-jsx=\"3392699359\"],\n.plus[data-jsx=\"3392699359\"],\n.line[data-jsx=\"3392699359\"]{position:relative;}.relative,\n.optional-steps[data-jsx=\"3392699359\"],\n.time[data-jsx=\"3392699359\"],\n.plus[data-jsx=\"3392699359\"],\n.line[data-jsx=\"3392699359\"]{position:relative;}"
	        }),
	        React.createElement(_style2.default, {
	          styleId: 3689561608,
	          css: "\n          .optional-enter{\n            opacity:0.01;\n          }\n          .optional-enter.optional-enter-active{\n            opacity:1;\n            transition:opacity 400ms ease-in;\n            transition-delay:100ms;\n          }\n          .optional-leave{\n            opacity:1;\n          }\n          .optional-leave.optional-leave-active{\n            opacity:0.01;\n            transition:opacity 300ms ease-in;\n          }\n        "
	        }),
	        React.createElement(
	          "div",
	          { className: "line", "data-jsx": 3392699359
	          },
	          React.createElement(
	            "svg",
	            { width: "32px", height: n + 196 + "px", viewBox: "0 0 32 " + (n + 196), "data-jsx": 3392699359
	            },
	            React.createElement("path", { className: "steps-svg-class", d: "M1," + (n + 195) + "c0-48.98,30-48.98,30-97c0-32.01,0-" + n + ",0-" + n + "C31,49.98,1,49.98,1,1", "data-jsx": 3392699359
	            })
	          )
	        ),
	        React.createElement(
	          "div",
	          { className: "steps", "data-jsx": 3392699359
	          },
	          React.createElement(
	            react_transition_group_1.CSSTransitionGroup,
	            { transitionName: "optional", transitionEnterTimeout: 500, transitionLeaveTimeout: 300, transitionAppear: true },
	            visibleSteps.map(function (step) {
	              return React.createElement(
	                gatsby_link_1.default,
	                { to: step.link, onClick: onClickLink },
	                React.createElement(
	                  OptionalDottedListItem_1.default,
	                  { key: step.title, small: _this3.props.small, active: step.link === _this3.props.location.pathname, path: step.link },
	                  React.createElement(
	                    "div",
	                    { className: "list-item", "data-jsx": 3392699359
	                    },
	                    React.createElement(
	                      "span",
	                      {
	                        "data-jsx": 3392699359
	                      },
	                      step.title
	                    ),
	                    showDuration && step.duration && React.createElement(Duration_1.default, { duration: step.duration })
	                  )
	                )
	              );
	            })
	          ),
	          reallyCollapsed && React.createElement(
	            "div",
	            { className: "more", onClick: this.toggleCollapse, "data-jsx": 3392699359
	            },
	            React.createElement(
	              "div",
	              { className: "plus", "data-jsx": 3392699359
	              },
	              React.createElement(Icon_1.default, { src: __webpack_require__("./node_modules/graphcool-styles/icons/stroke/addFull.svg"), color: '#ccc', stroke: true, strokeWidth: 8, width: 16, height: 16 })
	            ),
	            React.createElement(
	              "span",
	              {
	                "data-jsx": 3392699359
	              },
	              "+",
	              steps.length - 2,
	              " more chapters"
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "tweenN",
	    value: function tweenN() {
	      var _this4 = this;
	
	      var count = this.props.steps.length;
	      var animate = function animate() {
	        if (_this4.state.n < _this4.getN(count)) {
	          _this4.setState(function (state) {
	            return { n: state.n + 15 };
	          });
	          requestAnimationFrame(animate);
	        }
	      };
	      animate();
	    }
	  }]);
	
	  return OptionalSteps;
	}(React.Component);
	
	exports.default = OptionalSteps;

/***/ }),

/***/ "./src/components/Steps/Stack.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var Steps_1 = __webpack_require__("./src/components/Steps/Steps.tsx");
	function Stack(_ref) {
	  var name = _ref.name,
	      steps = _ref.steps,
	      location = _ref.location,
	      _ref$showLines = _ref.showLines,
	      showLines = _ref$showLines === undefined ? true : _ref$showLines;
	
	  return React.createElement(
	    "div",
	    { className: "stack", "data-jsx": 3234595779
	    },
	    React.createElement(_style2.default, {
	      styleId: 3234595779,
	      css: ".stack[data-jsx=\"3234595779\"]{min-width:180px;max-width:200px;}h3[data-jsx=\"3234595779\"]{left:-4px;margin-bottom:32px;}.ml38,\n.stack[data-jsx=\"3234595779\"] + .stack[data-jsx=\"3234595779\"]{margin-left:38px;}.f14,\nh3[data-jsx=\"3234595779\"]{font-size:14px;}.fw6,\nh3[data-jsx=\"3234595779\"]{font-weight:600;}.black30,\nh3[data-jsx=\"3234595779\"]{color:rgba(0, 0, 0, .3);}.ttu,\nh3[data-jsx=\"3234595779\"]{text-transform:uppercase;}.tracked,\nh3[data-jsx=\"3234595779\"]{letter-spacing:1px;}.nowrap,\nh3[data-jsx=\"3234595779\"]{white-space:nowrap;}.relative,\nh3[data-jsx=\"3234595779\"]{position:relative;}"
	    }),
	    React.createElement(
	      "h3",
	      {
	        "data-jsx": 3234595779
	      },
	      name
	    ),
	    React.createElement(Steps_1.default, { steps: steps, small: true, location: location, showDuration: false, showLines: showLines })
	  );
	}
	exports.default = Stack;

/***/ }),

/***/ "./src/components/Steps/Steps.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var DottedListItem_1 = __webpack_require__("./src/components/Steps/DottedListItem.tsx");
	var Duration_1 = __webpack_require__("./src/components/Duration.tsx");
	var gatsby_link_1 = __webpack_require__("./node_modules/gatsby-link/index.js");
	var cn = __webpack_require__("./node_modules/classnames/index.js");
	function Steps(_ref) {
	  var steps = _ref.steps,
	      small = _ref.small,
	      _ref$showDuration = _ref.showDuration,
	      showDuration = _ref$showDuration === undefined ? true : _ref$showDuration,
	      location = _ref.location,
	      _ref$highlightFirst = _ref.highlightFirst,
	      highlightFirst = _ref$highlightFirst === undefined ? false : _ref$highlightFirst,
	      _ref$showLines = _ref.showLines,
	      showLines = _ref$showLines === undefined ? true : _ref$showLines,
	      _ref$showLast = _ref.showLast,
	      showLast = _ref$showLast === undefined ? true : _ref$showLast,
	      _ref$stepsActive = _ref.stepsActive,
	      stepsActive = _ref$stepsActive === undefined ? false : _ref$stepsActive,
	      onClickLink = _ref.onClickLink,
	      _ref$pinkBorder = _ref.pinkBorder,
	      pinkBorder = _ref$pinkBorder === undefined ? false : _ref$pinkBorder,
	      _ref$dark = _ref.dark,
	      dark = _ref$dark === undefined ? false : _ref$dark;
	
	  return React.createElement(
	    "div",
	    { className: cn('steps', { pinkBorder: pinkBorder }), "data-jsx": 2768323214
	    },
	    React.createElement(_style2.default, {
	      styleId: 2768323214,
	      css: ".steps.pinkBorder[data-jsx=\"2768323214\"] .dotted-list-item{border-left-color:rgba(42, 126, 210, 1);}.first-duration-up{top:-3px;}.active[data-jsx=\"2768323214\"] .title{color:rgba(42, 126, 210, 1) !important;}.itemsCenter,\n.list-item[data-jsx=\"2768323214\"]{-webkit-box-align:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;}.flex,\n.list-item[data-jsx=\"2768323214\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.relative,\n.first-duration-up,\ndiv[data-jsx=\"2768323214\"] a{position:relative;}.black80,\ndiv[data-jsx=\"2768323214\"] a{color:rgba(0, 0, 0, .8);}.db,\ndiv[data-jsx=\"2768323214\"] a{display:block;}.relative,\n.first-duration-up,\ndiv[data-jsx=\"2768323214\"] a{position:relative;}.z2,\ndiv[data-jsx=\"2768323214\"] a{z-index:2;}"
	    }),
	    (steps || []).map(function (step, index) {
	      var duration = null;
	      if (showDuration && step.duration && step.duration > 0) {
	        duration = React.createElement(Duration_1.default, { duration: step.duration || 0, link: step.link, dark: dark });
	      }
	      return React.createElement(
	        gatsby_link_1.default,
	        { to: step.link, onClick: onClickLink },
	        React.createElement(
	          DottedListItem_1.default,
	          { key: step.title, light: !dark, first: index === 0 && steps.length > 1, last: showLast ? index === steps.length - 1 : false, small: small, active: step.link === location.pathname || stepsActive, highlightFirst: highlightFirst, showLine: showLines, path: step.link },
	          React.createElement(
	            "div",
	            { className: cn('list-item', {
	                active: step.link === location.pathname
	              }), "data-jsx": 2768323214
	            },
	            React.createElement(
	              "span",
	              { className: "title", "data-jsx": 2768323214
	              },
	              step.title
	            ),
	            duration
	          )
	        )
	      );
	    })
	  );
	}
	exports.default = Steps;

/***/ }),

/***/ "./src/components/Steps/Theory.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	function Theory() {
	  return React.createElement(
	    "div",
	    { className: "theory", "data-jsx": 4294394104
	    },
	    React.createElement(_style2.default, {
	      styleId: 4294394104,
	      css: ".pl16,\n.theory[data-jsx=\"4294394104\"] {padding-left: 16px\n}.mb38,\n.theory[data-jsx=\"4294394104\"] {margin-bottom: 38px\n}.ml10,\n.theory[data-jsx=\"4294394104\"] {margin-left: 10px\n}.black30,\nspan[data-jsx=\"4294394104\"] {color: rgba(0, 0, 0, .3)\n}.f14,\nspan[data-jsx=\"4294394104\"] {font-size: 14px\n}.ttu,\nspan[data-jsx=\"4294394104\"] {text-transform: uppercase\n}.fw6,\nspan[data-jsx=\"4294394104\"] {font-weight: 600\n}"
	    }),
	    React.createElement(
	      "span",
	      {
	        "data-jsx": 4294394104
	      },
	      "Hypermedia Fundamentals"
	    )
	  );
	}
	exports.default = Theory;

/***/ }),

/***/ "./src/components/Steps/TutorialTitleStep.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var cn = __webpack_require__("./node_modules/classnames/index.js");
	function TutorialTitleStep(_ref) {
	  var title = _ref.title,
	      pinkLine = _ref.pinkLine;
	
	  return React.createElement(
	    "div",
	    { className: cn('tutorial-title-step', { pinkLine: pinkLine }), "data-jsx": 2203349284
	    },
	    React.createElement(_style2.default, {
	      styleId: 2203349284,
	      css: ".tutorial-title-step.pinkLine[data-jsx=\"2203349284\"]{border-color:rgba(42, 126, 210, 1);}.bl,\n.tutorial-title-step[data-jsx=\"2203349284\"]{border-left-style:solid;border-left-width:1px;}.bBlack20,\n.tutorial-title-step[data-jsx=\"2203349284\"]{border-color:rgba(0, 0, 0, .2);}.pb25,\n.tutorial-title-step[data-jsx=\"2203349284\"]{padding-bottom:25px;}.pl25,\n.tutorial-title-step[data-jsx=\"2203349284\"]{padding-left:25px;}.relative,\n.tutorial-title-step[data-jsx=\"2203349284\"]{position:relative;}.bw2,\n.tutorial-title-step[data-jsx=\"2203349284\"]{border-width:2px;}.black30,\nh3[data-jsx=\"2203349284\"]{color:rgba(0, 0, 0, .3);}.f14,\nh3[data-jsx=\"2203349284\"]{font-size:14px;}.ttu,\nh3[data-jsx=\"2203349284\"]{text-transform:uppercase;}.fw6,\nh3[data-jsx=\"2203349284\"]{font-weight:600;}.mb25,\nh3[data-jsx=\"2203349284\"]{margin-bottom:25px;}.tracked,\nh3[data-jsx=\"2203349284\"]{letter-spacing:1px;}"
	    }),
	    React.createElement(
	      "h3",
	      {
	        "data-jsx": 2203349284
	      },
	      title,
	      " Tutorial"
	    )
	  );
	}
	exports.default = TutorialTitleStep;

/***/ }),

/***/ "./src/components/Tutorials/Sidebar.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var OptionalSteps_1 = __webpack_require__("./src/components/Steps/OptionalSteps.tsx");
	var Steps_1 = __webpack_require__("./src/components/Steps/Steps.tsx");
	var ChooseTutorialStep_1 = __webpack_require__("./src/components/Steps/ChooseTutorialStep.tsx");
	var Theory_1 = __webpack_require__("./src/components/Steps/Theory.tsx");
	var graphql_1 = __webpack_require__("./src/utils/graphql.ts");
	var TutorialTitleStep_1 = __webpack_require__("./src/components/Steps/TutorialTitleStep.tsx");
	var stacks_1 = __webpack_require__("./src/data/stacks.ts");
	
	var Sidebar = function (_React$Component) {
	  _inherits(Sidebar, _React$Component);
	
	  function Sidebar() {
	    _classCallCheck(this, Sidebar);
	
	    var _this = _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).apply(this, arguments));
	
	    _this.setRef = function (ref) {
	      _this.ref = ref;
	    };
	    return _this;
	  }
	
	  _createClass(Sidebar, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.scrollDown();
	    }
	  }, {
	    key: "scrollDown",
	    value: function scrollDown() {
	      if (this.ref) {
	        var post = this.props.post;
	
	        var group = post ? graphql_1.extractGroup(post.fields.slug) : 'basics';
	        if (!['basics', 'advanced'].includes(group)) {
	          this.ref.scrollTop = this.ref.scrollHeight;
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          post = _props.post,
	          steps = _props.steps,
	          location = _props.location;
	
	      var group = post ? graphql_1.extractGroup(post.fields.slug) : 'basics';
	      var selectedSteps = steps[group];
	      var tutorialTitle = null;
	      var stack = stacks_1.default.find(function (s) {
	        return s.key === group;
	      });
	      if (stack) {
	        tutorialTitle = stack.title;
	      }
	      if (group === '') {
	        selectedSteps = selectedSteps.filter(function (step) {
	          return step.link === location.pathname;
	        });
	      }
	      var isChapter = ['basics', 'advanced'].includes(group);
	      var isChooseTutorial = location.pathname.includes('/choose');
	      var showChoose = isChapter || isChooseTutorial;
	      return React.createElement(
	        "div",
	        { className: "sidebar-container", "data-jsx": 124570129
	        },
	        React.createElement(_style2.default, {
	          styleId: 124570129,
	          css: ".sidebar[data-jsx=\"124570129\"]{background-color:rgb(245, 245, 245);padding-left:21px;height:calc(100vh - 68px);width:300px;overflow-y:scroll;-webkit-overflow-scrolling:touch;}.sidebar-container[data-jsx=\"124570129\"]::before{left:1px;content:\"\";background:linear-gradient(              to bottom,              rgb(245, 245, 245) 30%,              rgba(245, 245, 245, 0)            );height:38px;}.sidebar[data-jsx=\"124570129\"] .plus{background-color:rgb(245, 245, 245);}@media (max-width: 1050px){.sidebar-container[data-jsx=\"124570129\"]{display:none;}}.relative,\n.sidebar-container[data-jsx=\"124570129\"],\n.sidebar[data-jsx=\"124570129\"]{position:relative;}.z0,\n.sidebar-container[data-jsx=\"124570129\"]{z-index:0;}.flexFixed,\n.sidebar[data-jsx=\"124570129\"]{-ms-flex:0 0 auto;-webkit-box-flex:0;flex:0 0 auto;}.pt38,\n.sidebar[data-jsx=\"124570129\"]{padding-top:38px;}.bbox,\n.sidebar[data-jsx=\"124570129\"]{box-sizing:border-box;}.relative,\n.sidebar-container[data-jsx=\"124570129\"],\n.sidebar[data-jsx=\"124570129\"]{position:relative;}.bl,\n.sidebar[data-jsx=\"124570129\"]{border-left-style:solid;border-left-width:1px;}.bBlack10,\n.sidebar[data-jsx=\"124570129\"]{border-color:rgba(0, 0, 0, .1);}.absolute,\n.sidebar-container[data-jsx=\"124570129\"]::before{position:absolute;}.top0,\n.sidebar-container[data-jsx=\"124570129\"]::before{top:0;}.right0,\n.sidebar-container[data-jsx=\"124570129\"]::before{right:0;}.z3,\n.sidebar-container[data-jsx=\"124570129\"]::before{z-index:3;}.pb96,\n.steps-list[data-jsx=\"124570129\"]{padding-bottom:96px;}"
	        }),
	        React.createElement(
	          "div",
	          { className: "sidebar", ref: this.setRef, "data-jsx": 124570129
	          },
	          React.createElement(
	            "div",
	            { className: "steps-list fade-before", "data-jsx": 124570129
	            },
	            React.createElement(Theory_1.default, null),
	            React.createElement(Steps_1.default, { steps: steps.basics, small: true, showDuration: false, location: location, highlightFirst: false, showLast: false, onClickLink: this.props.onClickLink, pinkBorder: !isChapter }),
	            React.createElement(OptionalSteps_1.default, { location: location, steps: steps.advanced, small: true, showDuration: false, mainPink: !isChapter, onClickLink: this.props.onClickLink }),
	            showChoose ? React.createElement(ChooseTutorialStep_1.default, { active: isChooseTutorial, onClick: this.props.onClickLink }) : React.createElement(
	              "div",
	              {
	                "data-jsx": 124570129
	              },
	              tutorialTitle && React.createElement(TutorialTitleStep_1.default, { title: tutorialTitle, pinkLine: !isChapter }),
	              React.createElement(Steps_1.default, { steps: selectedSteps, small: true, showDuration: false, location: location, onClickLink: this.props.onClickLink })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Sidebar;
	}(React.Component);
	
	exports.default = Sidebar;

/***/ }),

/***/ "./src/components/home/Chooser.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var gatsby_link_1 = __webpack_require__("./node_modules/gatsby-link/index.js");
	var cn = __webpack_require__("./node_modules/classnames/index.js");
	var DottedListItem_1 = __webpack_require__("./src/components/Steps/DottedListItem.tsx");
	var LeftColumn_1 = __webpack_require__("./src/components/home/LeftColumn.tsx");
	var stacks_1 = __webpack_require__("./src/data/stacks.ts");
	var StackChooser_1 = __webpack_require__("./src/components/StackChooser.tsx");
	var react_swipeable_views_1 = __webpack_require__("./node_modules/react-swipeable-views/lib/index.js");
	var react_transition_group_1 = __webpack_require__("./node_modules/react-transition-group/index.js");
	var Duration_1 = __webpack_require__("./src/components/Duration.tsx");
	var NewsletterSignup_1 = __webpack_require__("./src/components/NewsletterSignup.tsx");
	var getTotalDuration_1 = __webpack_require__("./src/utils/getTotalDuration.ts");
	var Steps_1 = __webpack_require__("./src/components/Steps/Steps.tsx");
	exports.FRONTEND_TUTORIALS_COUNT = stacks_1.default.filter(function (tutorial) {
	  return tutorial.type === 'frontend';
	}).length - 1;
	var CATEGORIES = ['Frontend', 'Backend'];
	var FRONTEND_INDEX = 0;
	var BACKEND_INDEX = 1;
	
	var Chooser = function (_React$Component) {
	  _inherits(Chooser, _React$Component);
	
	  function Chooser() {
	    _classCallCheck(this, Chooser);
	
	    var _this = _possibleConstructorReturn(this, (Chooser.__proto__ || Object.getPrototypeOf(Chooser)).apply(this, arguments));
	
	    _this.state = {
	      selectedCategoryIndex: BACKEND_INDEX,
	      selectedIndex: exports.FRONTEND_TUTORIALS_COUNT + 1
	    };
	    _this.selectStack = function (index) {
	      if (index < 0 || index > Object.keys(_this.props.mds).length) {
	        return;
	      }
	      var selectedCategoryIndex = index > 5 ? 1 : 0;
	      _this.setState({ selectedIndex: index, selectedCategoryIndex: selectedCategoryIndex });
	    };
	    _this.handleClickCurrentStack = function () {
	      var mds = _this.props.mds;
	      var selectedIndex = _this.state.selectedIndex;
	
	      var tutorials = stacks_1.default.map(function (tutorial) {
	        return _extends({}, tutorial, {
	          steps: mds[tutorial.key]
	        });
	      });
	      var selected = tutorials[selectedIndex];
	      if (!selected.comingSoon) {
	        var introChapter = selected.steps[0];
	        _this.props.history.push(introChapter.link);
	      }
	    };
	    _this.handleChangeSelectedCategoryIndex = function (index) {
	      _this.setState(function (state) {
	        var selectedIndex = 0;
	        if (index === FRONTEND_INDEX) {
	          selectedIndex = exports.FRONTEND_TUTORIALS_COUNT;
	        }
	        if (index === BACKEND_INDEX) {
	          selectedIndex = exports.FRONTEND_TUTORIALS_COUNT + 1;
	        }
	        return _extends({}, state, { selectedCategoryIndex: index, selectedIndex: selectedIndex });
	      });
	    };
	    return _this;
	  }
	
	  _createClass(Chooser, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          mds = _props.mds,
	          light = _props.light;
	      var _state = this.state,
	          selectedIndex = _state.selectedIndex,
	          selectedCategoryIndex = _state.selectedCategoryIndex;
	
	      var tutorials = stacks_1.default.map(function (tutorial) {
	        return _extends({}, tutorial, {
	          steps: mds[tutorial.key]
	        });
	      });
	      var selected = tutorials[selectedIndex];
	      var selectedDuration = getTotalDuration_1.getTotalDuration(selected.steps);
	      return React.createElement(
	        "div",
	        { className: cn('steps-container', { light: light }), "data-jsx": 3877546898
	        },
	        React.createElement(_style2.default, {
	          styleId: 7091661,
	          css: ".steps-content[data-jsx=\"3877546898\"] .steps-description{margin-top:48px;}.steps-list[data-jsx=\"3877546898\"]::after{content:'';display:block;height:48px;background-image:linear-gradient(              to bottom,              rgba(225, 225, 225, .2),              #172a3a            );width:2px;}div[data-jsx=\"3877546898\"] h3.first-h3[data-jsx=\"3877546898\"]{margin-top:60px;}.mobile-line-bend[data-jsx=\"3877546898\"],.mobile-line-bend-bottom[data-jsx=\"3877546898\"]{display:none;}.fade-before-element[data-jsx=\"3877546898\"]{content:'';height:48px;background-image:linear-gradient(              to top,              rgba(225, 225, 225, .2),              #172a3a            );width:2px;}.steps-list-top[data-jsx=\"3877546898\"] .dotted-list-item:not(.light).first{padding-top:60px !important;}@media (max-width: 500px){div.fade-before-element[data-jsx=\"3877546898\"]{display:none;}h3.first-h3[data-jsx=\"3877546898\"]{display:none;}.steps-content[data-jsx=\"3877546898\"]{padding:0 30px;}.steps-content[data-jsx=\"3877546898\"] .left-column{display:none;}div.steps-list[data-jsx=\"3877546898\"]{width:100%;}.bottom-chooser[data-jsx=\"3877546898\"],\n.mobile-line-bend[data-jsx=\"3877546898\"],\n.mobile-line-bend-bottom[data-jsx=\"3877546898\"]{position:relative;}.bottom-chooser[data-jsx=\"3877546898\"]{padding-top:48px;}.steps-list-top[data-jsx=\"3877546898\"]::after{content:'';display:block;height:48px;width:48px;background:none;border-left:2px solid rgba(225, 225, 225, .2);border-bottom:2px solid rgba(225, 225, 225, .2);border-bottom-left-radius:500px;}.steps-list-top[data-jsx=\"3877546898\"]::before{content:'';position:absolute;width:calc(50% - 99px);bottom:0;left:50px;height:2px;background:rgba(225, 225, 225, .2);}.bottom-chooser[data-jsx=\"3877546898\"]::after{content:'';top:-2px;left:30px;position:absolute;display:block;height:48px;width:48px;background:none;border-top:2px solid rgba(225, 225, 225, .2);border-left:2px solid rgba(225, 225, 225, .2);border-top-left-radius:500px;}.bottom-chooser[data-jsx=\"3877546898\"]::before{content:'';position:absolute;width:calc(50% - 128px);top:-2px;left:80px;height:2px;background:rgba(225, 225, 225, .2);}.mobile-line-bend[data-jsx=\"3877546898\"],\n.mobile-line-bend-bottom[data-jsx=\"3877546898\"]{display:block;}.mobile-line-bend[data-jsx=\"3877546898\"],\n.mobile-line-bend-bottom[data-jsx=\"3877546898\"]{margin-right:auto;margin-left:auto;}.mobile-line-bend[data-jsx=\"3877546898\"]{height:48px;width:48px;border-right:2px solid rgba(225, 225, 225, .2);border-top:2px solid rgba(225, 225, 225, .2);border-top-right-radius:500px;left:-24px;top:-2px;}.mobile-line-bend[data-jsx=\"3877546898\"]:after,\n.mobile-line-bend-bottom[data-jsx=\"3877546898\"]:after{position:absolute;}.mobile-line-bend[data-jsx=\"3877546898\"]:after,\n.mobile-line-bend-bottom[data-jsx=\"3877546898\"]:after{bottom:0;}.mobile-line-bend[data-jsx=\"3877546898\"]:after,\n.mobile-line-bend-bottom[data-jsx=\"3877546898\"]:after{left:0;}.mobile-line-bend[data-jsx=\"3877546898\"]:after{content:\"\";right:-2px;height:48px;background:linear-gradient(                to bottom,                rgba(23, 42, 58, 0),                rgba(23, 42, 58, 1)              );}.mobile-line-bend-bottom[data-jsx=\"3877546898\"]{height:48px;width:48px;border-right:2px solid rgba(225, 225, 225, .2);border-bottom:2px solid rgba(225, 225, 225, .2);border-bottom-right-radius:500px;left:-23px;top:0px;}.mobile-line-bend-bottom[data-jsx=\"3877546898\"]:after{content:\"\";right:-2px;height:48px;background:linear-gradient(                to top,                rgba(23, 42, 58, 0),                rgba(23, 42, 58, 1)              );}}.steps-container[data-jsx=\"3877546898\"] .stacks-item:not(.active) .graphql-elixir-1{filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0\" /><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"15\" /><feFuncG type=\"linear\" slope=\"15\" /><feFuncB type=\"linear\" slope=\"15\" /></feComponentTransfer></filter></svg>#filter');-webkit-filter:grayscale(100%) brightness(1500%) !important;filter:grayscale(100%) brightness(1500%) !important;}.steps-container[data-jsx=\"3877546898\"] .stacks-item.active .graphql-elixir-1{filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"4.5\" /><feFuncG type=\"linear\" slope=\"4.5\" /><feFuncB type=\"linear\" slope=\"4.5\" /></feComponentTransfer></filter></svg>#filter');-webkit-filter:brightness(450%) !important;filter:brightness(450%) !important;}.steps-container[data-jsx=\"3877546898\"] .stacks-item:not(.active) .graphql-elixir-2,.steps-container[data-jsx=\"3877546898\"] .stacks-item:not(.active) .graphql-ruby-2{filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0\" /><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"10\" /><feFuncG type=\"linear\" slope=\"10\" /><feFuncB type=\"linear\" slope=\"10\" /></feComponentTransfer></filter></svg>#filter');-webkit-filter:grayscale(100%) brightness(1000%) !important;filter:grayscale(100%) brightness(1000%) !important;}.steps-container[data-jsx=\"3877546898\"] .stacks-item.active .graphql-elixir-2,.steps-container[data-jsx=\"3877546898\"] .stacks-item.active .graphql-ruby-2{filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"1.8\" /><feFuncG type=\"linear\" slope=\"1.8\" /><feFuncB type=\"linear\" slope=\"1.8\" /></feComponentTransfer></filter></svg>#filter');-webkit-filter:brightness(180%) !important;filter:brightness(180%) !important;}.white,\ndiv.steps-container[data-jsx=\"3877546898\"],\np[data-jsx=\"3877546898\"],\n.steps-container[data-jsx=\"3877546898\"] .dotted-list-item{color:#fff;}.bgDarkBlue,\ndiv.steps-container[data-jsx=\"3877546898\"]{background-color:#172a3a;}.pb60,\ndiv.steps-container[data-jsx=\"3877546898\"]{padding-bottom:60px;}.flex,\n.steps-content[data-jsx=\"3877546898\"],\n.list-item[data-jsx=\"3877546898\"],\n.category-chooser[data-jsx=\"3877546898\"],\n.center-container[data-jsx=\"3877546898\"],\n.link[data-jsx=\"3877546898\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.w50,\n.steps-list[data-jsx=\"3877546898\"]{width:50%;}.relative,\n.steps-list[data-jsx=\"3877546898\"]{position:relative;}.white,\ndiv.steps-container[data-jsx=\"3877546898\"],\np[data-jsx=\"3877546898\"],\n.steps-container[data-jsx=\"3877546898\"] .dotted-list-item{color:#fff;}.fw6,\nh3[data-jsx=\"3877546898\"],\n.category[data-jsx=\"3877546898\"]{font-weight:600;}.white30,\n.steps-container[data-jsx=\"3877546898\"] .steps-description p[data-jsx=\"3877546898\"],\n.category[data-jsx=\"3877546898\"]{color:hsla(0, 0%, 100%, .3);}.mt16,\n.duration[data-jsx=\"3877546898\"],\n.category-chooser[data-jsx=\"3877546898\"]{margin-top:16px;}.mr38,\n.duration[data-jsx=\"3877546898\"]{margin-right:38px;}.db,\n.fade-before-element[data-jsx=\"3877546898\"]{display:block;}.flex,\n.steps-content[data-jsx=\"3877546898\"],\n.list-item[data-jsx=\"3877546898\"],\n.category-chooser[data-jsx=\"3877546898\"],\n.center-container[data-jsx=\"3877546898\"],\n.link[data-jsx=\"3877546898\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.itemsCenter,\n.list-item[data-jsx=\"3877546898\"],\n.link[data-jsx=\"3877546898\"]{-webkit-box-align:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;}.white,\ndiv.steps-container[data-jsx=\"3877546898\"],\np[data-jsx=\"3877546898\"],\n.steps-container[data-jsx=\"3877546898\"] .dotted-list-item{color:#fff;}.pb96,\n.coming-soon[data-jsx=\"3877546898\"]{padding-bottom:96px;}.pt38,\n.coming-soon[data-jsx=\"3877546898\"]{padding-top:38px;}.white70,\n.coming-soon[data-jsx=\"3877546898\"] p[data-jsx=\"3877546898\"],\n.category.active[data-jsx=\"3877546898\"]{color:hsla(0, 0%, 100%, .7);}.mb16,\n.coming-soon[data-jsx=\"3877546898\"] p[data-jsx=\"3877546898\"]{margin-bottom:16px;}.flex,\n.steps-content[data-jsx=\"3877546898\"],\n.list-item[data-jsx=\"3877546898\"],\n.category-chooser[data-jsx=\"3877546898\"],\n.center-container[data-jsx=\"3877546898\"],\n.link[data-jsx=\"3877546898\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.justifyCenter,\n.category-chooser[data-jsx=\"3877546898\"],\n.center-container[data-jsx=\"3877546898\"]{-ms-flex-pack:center;-webkit-box-pack:center;justify-content:center;}.mt16,\n.duration[data-jsx=\"3877546898\"],\n.category-chooser[data-jsx=\"3877546898\"]{margin-top:16px;}.f14,\n.category[data-jsx=\"3877546898\"]{font-size:14px;}.fw6,\nh3[data-jsx=\"3877546898\"],\n.category[data-jsx=\"3877546898\"]{font-weight:600;}.white30,\n.steps-container[data-jsx=\"3877546898\"] .steps-description p[data-jsx=\"3877546898\"],\n.category[data-jsx=\"3877546898\"]{color:hsla(0, 0%, 100%, .3);}.ttu,\n.category[data-jsx=\"3877546898\"]{text-transform:uppercase;}.pointer:hover,\n.category[data-jsx=\"3877546898\"]:hover{cursor:pointer;}.tc,\n.category[data-jsx=\"3877546898\"]{text-align:center;}.white70,\n.coming-soon[data-jsx=\"3877546898\"] p[data-jsx=\"3877546898\"],\n.category.active[data-jsx=\"3877546898\"]{color:hsla(0, 0%, 100%, .7);}.flex,\n.steps-content[data-jsx=\"3877546898\"],\n.list-item[data-jsx=\"3877546898\"],\n.category-chooser[data-jsx=\"3877546898\"],\n.center-container[data-jsx=\"3877546898\"],\n.link[data-jsx=\"3877546898\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.justifyCenter,\n.category-chooser[data-jsx=\"3877546898\"],\n.center-container[data-jsx=\"3877546898\"]{-ms-flex-pack:center;-webkit-box-pack:center;justify-content:center;}.flex,\n.steps-content[data-jsx=\"3877546898\"],\n.list-item[data-jsx=\"3877546898\"],\n.category-chooser[data-jsx=\"3877546898\"],\n.center-container[data-jsx=\"3877546898\"],\n.link[data-jsx=\"3877546898\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.itemsCenter,\n.list-item[data-jsx=\"3877546898\"],\n.link[data-jsx=\"3877546898\"]{-webkit-box-align:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;}"
	        }),
	        React.createElement(_style2.default, {
	          styleId: 649312762,
	          css: "\n          .chooser-enter{\n            opacity:0.01;\n          }\n          .chooser-enter.chooser-enter-active{\n            opacity:1;\n            transition:opacity 500ms ease-in;\n          }\n          .chooser-leave{\n            opacity:1;\n          }\n          .chooser-leave.chooser-leave-active{\n            opacity:0.01;\n            transition:opacity 300ms ease-in;\n          }\n        "
	        }),
	        React.createElement(
	          "div",
	          { className: "steps-content", "data-jsx": 3877546898
	          },
	          React.createElement(
	            LeftColumn_1.default,
	            null,
	            React.createElement(
	              "h3",
	              { className: "first-h3", "data-jsx": 3877546898
	              },
	              "Hands-on tutorials"
	            )
	          ),
	          React.createElement(
	            "div",
	            { className: "steps-list steps-list-top", "data-jsx": 3877546898
	            },
	            React.createElement(
	              DottedListItem_1.default,
	              { first: true, path: '/tutorials/choose' },
	              React.createElement(
	                "div",
	                { className: "list-item", "data-jsx": 3877546898
	                },
	                React.createElement(
	                  gatsby_link_1.default,
	                  { to: '/choose/' },
	                  React.createElement(
	                    "span",
	                    {
	                      "data-jsx": 3877546898
	                    },
	                    "Choose your favorite technology"
	                  )
	                )
	              )
	            )
	          )
	        ),
	        React.createElement("div", { className: "mobile-line-bend", "data-jsx": 3877546898
	        }),
	        React.createElement(
	          "div",
	          { className: "category-chooser", "data-jsx": 3877546898
	          },
	          React.createElement(
	            react_swipeable_views_1.default,
	            { enableMouseEvents: true, style: {
	                overflow: 'visible',
	                width: 90
	              }, slideStyle: {
	                overflow: 'hidden'
	              }, index: selectedCategoryIndex, onChangeIndex: this.handleChangeSelectedCategoryIndex },
	            CATEGORIES.map(function (cat, index) {
	              return React.createElement(
	                "div",
	                { className: cn('category', {
	                    active: index === selectedCategoryIndex
	                  }), onClick: _this2.handleChangeSelectedCategoryIndex.bind(_this2, index), "data-jsx": 3877546898
	                },
	                cat
	              );
	            })
	          )
	        ),
	        React.createElement(StackChooser_1.default, { stacks: stacks_1.default, selectedIndex: this.state.selectedIndex, onChangeSelectedIndex: this.selectStack, markdownFiles: mds, onClickCurrentStack: this.handleClickCurrentStack }),
	        React.createElement(
	          react_transition_group_1.CSSTransitionGroup,
	          { transitionName: "chooser", transitionEnterTimeout: 500, transitionLeaveTimeout: 300 },
	          !selected.comingSoon && React.createElement("div", { className: "mobile-line-bend-bottom", key: selected.key + 'bend2', "data-jsx": 3877546898
	          }),
	          !selected.comingSoon ? React.createElement(
	            "div",
	            { className: "bottom-chooser", key: 'crazy-' + selected.key, "data-jsx": 3877546898
	            },
	            React.createElement(
	              "div",
	              { className: "steps-content", "data-jsx": 3877546898
	              },
	              React.createElement(
	                LeftColumn_1.default,
	                { className: "steps-description" },
	                React.createElement(
	                  "h3",
	                  {
	                    "data-jsx": 3877546898
	                  },
	                  selected.content.title
	                ),
	                selectedDuration > 0 && React.createElement(
	                  "div",
	                  { className: "duration", "data-jsx": 3877546898
	                  },
	                  React.createElement(Duration_1.default, { duration: selectedDuration, total: true, dark: true })
	                ),
	                React.createElement(
	                  "p",
	                  {
	                    "data-jsx": 3877546898
	                  },
	                  selected.content.description
	                )
	              ),
	              React.createElement(
	                "div",
	                { className: "steps-list", "data-jsx": 3877546898
	                },
	                selected && React.createElement("div", { className: "fade-before-element", key: selected.key, "data-jsx": 3877546898
	                }),
	                React.createElement(Steps_1.default, { steps: selected.steps, location: this.props.location, dark: true, showLast: false })
	              )
	            )
	          ) : React.createElement(
	            "div",
	            { className: "center-container", "data-jsx": 3877546898
	            },
	            React.createElement(
	              "div",
	              { className: "coming-soon", "data-jsx": 3877546898
	              },
	              React.createElement(NewsletterSignup_1.default, { tutorial: selected.key })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Chooser;
	}(React.Component);
	
	exports.default = Chooser;

/***/ }),

/***/ "./src/components/home/ContentOverview.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var tutorials_1 = __webpack_require__("./src/utils/tutorials.ts");
	var Stack_1 = __webpack_require__("./src/components/Steps/Stack.tsx");
	function ContentOverview(_ref) {
	  var location = _ref.location,
	      steps = _ref.steps;
	
	  var frontendTutorials = tutorials_1.getFrontendTutorials(steps);
	  var backendTutorials = tutorials_1.getBackendTutorials(steps);
	  return React.createElement(
	    "section",
	    {
	      "data-jsx": 3563740197
	    },
	    React.createElement(_style2.default, {
	      styleId: 3563740197,
	      css: "section[data-jsx=\"3563740197\"]{background-color:#fafafa;}.content-overview[data-jsx=\"3563740197\"]{max-width:1280px;}.all-tutorials[data-jsx=\"3563740197\"] .stack + .stack{margin-left:0 !important;}@media (max-width: 500px){section[data-jsx=\"3563740197\"]{display:none;}}.pt0,\nsection[data-jsx=\"3563740197\"]{padding-top:0;}.center,\n.content-overview[data-jsx=\"3563740197\"]{margin-right:auto;margin-left:auto;}.tc,\np[data-jsx=\"3563740197\"]{text-align:center;}.mt38,\np[data-jsx=\"3563740197\"],\n.advanced[data-jsx=\"3563740197\"],\n.all-tutorials[data-jsx=\"3563740197\"] .stack + .stack{margin-top:38px;}.bb,\n.bordered[data-jsx=\"3563740197\"]{border-bottom-style:solid;border-bottom-width:1px;}.bt,\n.bordered[data-jsx=\"3563740197\"]{border-top-style:solid;border-top-width:1px;}.bBlack10,\n.bordered[data-jsx=\"3563740197\"],\n.left[data-jsx=\"3563740197\"]{border-color:rgba(0, 0, 0, .1);}.bw2,\n.bordered[data-jsx=\"3563740197\"],\n.left[data-jsx=\"3563740197\"]{border-width:2px;}.flex,\n.bordered[data-jsx=\"3563740197\"],\n.overview[data-jsx=\"3563740197\"],\n.right[data-jsx=\"3563740197\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.mt60,\n.bordered[data-jsx=\"3563740197\"]{margin-top:60px;}.flex,\n.bordered[data-jsx=\"3563740197\"],\n.overview[data-jsx=\"3563740197\"],\n.right[data-jsx=\"3563740197\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.pa38,\n.block[data-jsx=\"3563740197\"]{padding:38px;}.bBlack10,\n.bordered[data-jsx=\"3563740197\"],\n.left[data-jsx=\"3563740197\"]{border-color:rgba(0, 0, 0, .1);}.br,\n.left[data-jsx=\"3563740197\"]{border-right-style:solid;border-right-width:1px;}.bw2,\n.bordered[data-jsx=\"3563740197\"],\n.left[data-jsx=\"3563740197\"]{border-width:2px;}.flexFixed,\n.left[data-jsx=\"3563740197\"]{-ms-flex:0 0 auto;-webkit-box-flex:0;flex:0 0 auto;}.flex1,\n.flexAuto,\n.right[data-jsx=\"3563740197\"]{min-width:0;min-height:0;}.flexAuto,\n.right[data-jsx=\"3563740197\"]{-ms-flex:1 1 auto;-webkit-box-flex:1;flex:1 1 auto;}.flex,\n.bordered[data-jsx=\"3563740197\"],\n.overview[data-jsx=\"3563740197\"],\n.right[data-jsx=\"3563740197\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.mt38,\np[data-jsx=\"3563740197\"],\n.advanced[data-jsx=\"3563740197\"],\n.all-tutorials[data-jsx=\"3563740197\"] .stack + .stack{margin-top:38px;}.pt10,\n.advanced[data-jsx=\"3563740197\"],\n.all-tutorials[data-jsx=\"3563740197\"] .stack + .stack{padding-top:10px;}.ml38,\n.all-tutorials[data-jsx=\"3563740197\"]{margin-left:38px;}.mt38,\np[data-jsx=\"3563740197\"],\n.advanced[data-jsx=\"3563740197\"],\n.all-tutorials[data-jsx=\"3563740197\"] .stack + .stack{margin-top:38px;}.pt10,\n.advanced[data-jsx=\"3563740197\"],\n.all-tutorials[data-jsx=\"3563740197\"] .stack + .stack{padding-top:10px;}"
	    }),
	    React.createElement(
	      "div",
	      { className: "content-overview", "data-jsx": 3563740197
	      },
	      React.createElement(
	        "h2",
	        {
	          "data-jsx": 3563740197
	        },
	        "Content Overview"
	      ),
	      React.createElement(
	        "p",
	        {
	          "data-jsx": 3563740197
	        },
	        "Here is an overview of all the tutorials and their contents that you find on this site. ",
	        ' '
	      )
	    ),
	    React.createElement(
	      "div",
	      { className: "bordered", "data-jsx": 3563740197
	      },
	      React.createElement(
	        "div",
	        { className: "content-overview", "data-jsx": 3563740197
	        },
	        React.createElement(
	          "div",
	          { className: "overview", "data-jsx": 3563740197
	          },
	          React.createElement(
	            "div",
	            { className: "block left", "data-jsx": 3563740197
	            },
	            React.createElement(Stack_1.default, { name: "Fundamentals", steps: steps.basics, location: location }),
	            React.createElement(
	              "div",
	              { className: "advanced", "data-jsx": 3563740197
	              },
	              React.createElement(Stack_1.default, { name: "Advanced", steps: steps.advanced, location: location })
	            )
	          ),
	          React.createElement(
	            "div",
	            { className: "block right", "data-jsx": 3563740197
	            },
	            React.createElement(Stack_1.default, { name: "AspNetCore (API)", steps: steps['aspnetcore-dynamodb'], location: location }),
	            React.createElement(Stack_1.default, { name: "Vue (todo)", steps: steps['vue-todo-app'], location: location }),
	            React.createElement(Stack_1.default, { name: "Vue (Api)", steps: steps['vue-api-browser'], location: location }),
	            React.createElement(
	              "div",
	              { className: "all-tutorials", "data-jsx": 3563740197
	              },
	              React.createElement(Stack_1.default, { name: "All Frontend Tutorials", steps: frontendTutorials, location: location, showLines: false }),
	              React.createElement(Stack_1.default, { name: "All Backend Tutorials", steps: backendTutorials, location: location, showLines: false })
	            )
	          )
	        )
	      )
	    )
	  );
	}
	exports.default = ContentOverview;

/***/ }),

/***/ "./src/components/home/Footer.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var Icon_1 = __webpack_require__("./node_modules/graphcool-styles/dist/components/Icon/Icon.js");
	var graphcool_styles_1 = __webpack_require__("./node_modules/graphcool-styles/dist/build.js");
	function Footer() {
	  return React.createElement(
	    "div",
	    { className: "footer", "data-jsx": 2877560336
	    },
	    React.createElement(_style2.default, {
	      styleId: 2877560336,
	      css: ".footer[data-jsx=\"2877560336\"]{background-color:rgba(0, 0, 0, .03);padding-left:30px;padding-right:30px;line-height:1.5;}img[data-jsx=\"2877560336\"]{height:28px;width:auto;}.tc,\n.footer[data-jsx=\"2877560336\"]{text-align:center;}.pv38,\n.footer[data-jsx=\"2877560336\"]{padding-top:38px;padding-bottom:38px;}.black40,\n.footer[data-jsx=\"2877560336\"],\na[data-jsx=\"2877560336\"]{color:rgba(0, 0, 0, .4);}.relative,\n.footer[data-jsx=\"2877560336\"]{position:relative;}.z2,\n.footer[data-jsx=\"2877560336\"]{z-index:2;}.red,\n.love[data-jsx=\"2877560336\"]{color:#f25c54;}.flex,\n.logos[data-jsx=\"2877560336\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.justifyCenter,\n.logos[data-jsx=\"2877560336\"]{-ms-flex-pack:center;-webkit-box-pack:center;justify-content:center;}.mt25,\n.logos[data-jsx=\"2877560336\"]{margin-top:25px;}.ml16,\n.logos[data-jsx=\"2877560336\"] * + *{margin-left:16px;}.black40,\n.footer[data-jsx=\"2877560336\"],\na[data-jsx=\"2877560336\"]{color:rgba(0, 0, 0, .4);}.underline,\na[data-jsx=\"2877560336\"]:hover{text-decoration:underline;}"
	    }),
	    React.createElement(
	      "span",
	      {
	        "data-jsx": 2877560336
	      },
	      "Made by",
	      " ",
	      " Semantic Link Project ",
	      React.createElement("br", {
	        "data-jsx": 2877560336
	      }),
	      "(big thanks to tutorial format by ",
	      React.createElement(
	        "a",
	        { href: "https://www.prisma.io", target: "_blank", "data-jsx": 2877560336
	        },
	        "Prisma"
	      ),
	      ")"
	    ),
	    React.createElement(
	      "div",
	      { className: "logos", "data-jsx": 2877560336
	      },
	      React.createElement(
	        "a",
	        { href: "https://twitter.com/semantic_link", target: "_blank", "data-jsx": 2877560336
	        },
	        React.createElement("img", { src: __webpack_require__("./src/assets/icons/twitter.svg"), alt: "", "data-jsx": 2877560336
	        })
	      ),
	      React.createElement(
	        "a",
	        { href: "https://github.com/semanticlink/", target: "_blank", "data-jsx": 2877560336
	        },
	        React.createElement(Icon_1.default, { src: __webpack_require__("./node_modules/graphcool-styles/icons/fill/github.svg"), color: graphcool_styles_1.$v.black, width: 28, height: 28 })
	      )
	    )
	  );
	}
	exports.default = Footer;

/***/ }),

/***/ "./src/components/home/Intro.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var IntroSteps_1 = __webpack_require__("./src/components/home/IntroSteps.tsx");
	var gatsby_link_1 = __webpack_require__("./node_modules/gatsby-link/index.js");
	var react_redux_1 = __webpack_require__("./node_modules/react-redux/lib/index.js");
	var ui_1 = __webpack_require__("./src/actions/ui.ts");
	var react_particles_js_1 = __webpack_require__("./node_modules/react-particles-js/lib/particles.js");
	
	var Intro = function (_React$Component) {
	  _inherits(Intro, _React$Component);
	
	  function Intro() {
	    _classCallCheck(this, Intro);
	
	    return _possibleConstructorReturn(this, (Intro.__proto__ || Object.getPrototypeOf(Intro)).apply(this, arguments));
	  }
	
	  _createClass(Intro, [{
	    key: "render",
	    value: function render() {
	      return React.createElement(
	        "section",
	        { className: "intro", "data-jsx": 1304959149
	        },
	        React.createElement(
	          "div",
	          { className: "particles", "data-jsx": 1304959149
	          },
	          React.createElement(react_particles_js_1.default, { style: { maxWidth: "100%" }, width: "" + (typeof window !== "undefined" && window.innerWidth || 1000), height: "466", params: {
	              particles: {
	                number: { value: 20, density: { enable: !0, value_area: 800 } },
	                color: { value: "#ffc0e5" },
	                shape: {
	                  type: "circle",
	                  stroke: { width: 4, color: "#fdd7ed" },
	                  polygon: { nb_sides: 5 }
	                },
	                opacity: { value: .2, random: !1, anim: { enable: !1, speed: 1, opacity_min: .6, sync: !1 } },
	                size: { value: 1, random: !0, anim: { enable: !1, speed: 40, size_min: .1, sync: !1 } },
	                line_linked: { enable: !0, distance: 150, color: "#ffc0e5", opacity: .3, width: 1 },
	                move: {
	                  enable: !0,
	                  speed: 1,
	                  direction: "none",
	                  random: !1,
	                  straight: !1,
	                  out_mode: "out",
	                  attract: { enable: !1, rotateX: 600, rotateY: 1200 }
	                }
	              },
	              interactivity: {
	                detect_on: "canvas",
	                events: {
	                  onhover: { enable: !1, mode: "repulse" },
	                  onclick: { enable: !0, mode: "push" },
	                  resize: !0
	                },
	                modes: {
	                  grab: { distance: 400, line_linked: { opacity: 1 } },
	                  bubble: { distance: 400, size: 40, duration: 2, opacity: 8, speed: 3 },
	                  repulse: { distance: 200 },
	                  push: { particles_nb: 4 },
	                  remove: { particles_nb: 2 }
	                }
	              }
	            } })
	        ),
	        React.createElement(_style2.default, {
	          styleId: 1304959149,
	          css: "h1[data-jsx=\"1304959149\"]{font-size:54px;}p[data-jsx=\"1304959149\"]{max-width:800px;}.watch-overview[data-jsx=\"1304959149\"]{transition:color .15s ease-in-out;}.watch-overview[data-jsx=\"1304959149\"] img[data-jsx=\"1304959149\"]{transition:-webkit-filter .15s ease-in-out;transition:filter .15s ease-in-out;transition:filter .15s ease-in-out, -webkit-filter .15s ease-in-out;}.watch-overview[data-jsx=\"1304959149\"] svg > g{transition:opacity .15s ease-in-out;}.watch-overview[data-jsx=\"1304959149\"]:hover svg > g{opacity:0.6;}@media (max-width: 500px){.intro[data-jsx=\"1304959149\"]{padding:30px 30px 0;}h1[data-jsx=\"1304959149\"]{font-size:32px;text-align:left !important;}p[data-jsx=\"1304959149\"]{text-align:left !important;}.center-container[data-jsx=\"1304959149\"]{-webkit-box-pack:start !important;-ms-flex-pack:start !important;justify-content:flex-start !important;}.btn[data-jsx=\"1304959149\"]{font-size:20px;}}.relative,\n.rest[data-jsx=\"1304959149\"],\nsection[data-jsx=\"1304959149\"]{position:relative;}.z2,\n.rest[data-jsx=\"1304959149\"]{z-index:2;}.relative,\n.rest[data-jsx=\"1304959149\"],\nsection[data-jsx=\"1304959149\"]{position:relative;}.tc,\nh1[data-jsx=\"1304959149\"],\np[data-jsx=\"1304959149\"]{text-align:center;}.mt25,\np[data-jsx=\"1304959149\"],\n.watch-overview[data-jsx=\"1304959149\"],\n.btn-container[data-jsx=\"1304959149\"]{margin-top:25px;}.center,\np[data-jsx=\"1304959149\"]{margin-right:auto;margin-left:auto;}.tc,\nh1[data-jsx=\"1304959149\"],\np[data-jsx=\"1304959149\"]{text-align:center;}.black40,\n.watch-overview[data-jsx=\"1304959149\"]{color:rgba(0, 0, 0, .4);}.f16,\n.watch-overview[data-jsx=\"1304959149\"]{font-size:16px;}.fw6,\n.watch-overview[data-jsx=\"1304959149\"]{font-weight:600;}.mt25,\np[data-jsx=\"1304959149\"],\n.watch-overview[data-jsx=\"1304959149\"],\n.btn-container[data-jsx=\"1304959149\"]{margin-top:25px;}.pa16,\n.watch-overview[data-jsx=\"1304959149\"]{padding:16px;}.ttu,\n.watch-overview[data-jsx=\"1304959149\"]{text-transform:uppercase;}.flex,\n.watch-overview[data-jsx=\"1304959149\"],\n.center-container[data-jsx=\"1304959149\"],\n.particles[data-jsx=\"1304959149\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.itemsCenter,\n.watch-overview[data-jsx=\"1304959149\"]{-webkit-box-align:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;}.pointer:hover,\n.watch-overview[data-jsx=\"1304959149\"]:hover{cursor:pointer;}.black60,\n.watch-overview[data-jsx=\"1304959149\"]:hover{color:rgba(0, 0, 0, .6);}.ml16,\n.watch-overview[data-jsx=\"1304959149\"] span[data-jsx=\"1304959149\"]{margin-left:16px;}.flex,\n.watch-overview[data-jsx=\"1304959149\"],\n.center-container[data-jsx=\"1304959149\"],\n.particles[data-jsx=\"1304959149\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.justifyCenter,\n.center-container[data-jsx=\"1304959149\"]{-ms-flex-pack:center;-webkit-box-pack:center;justify-content:center;}.absolute,\n.particles[data-jsx=\"1304959149\"]{position:absolute;}.left0,\n.particles[data-jsx=\"1304959149\"]{left:0;}.top0,\n.particles[data-jsx=\"1304959149\"]{top:0;}.right0,\n.particles[data-jsx=\"1304959149\"]{right:0;}.bottom0,\n.particles[data-jsx=\"1304959149\"]{bottom:0;}.flex,\n.watch-overview[data-jsx=\"1304959149\"],\n.center-container[data-jsx=\"1304959149\"],\n.particles[data-jsx=\"1304959149\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.mt25,\np[data-jsx=\"1304959149\"],\n.watch-overview[data-jsx=\"1304959149\"],\n.btn-container[data-jsx=\"1304959149\"]{margin-top:25px;}"
	        }),
	        React.createElement(
	          "div",
	          { className: "rest", "data-jsx": 1304959149
	          },
	          React.createElement(
	            "h1",
	            {
	              "data-jsx": 1304959149
	            },
	            "Hypermedia for the dedicated"
	          ),
	          React.createElement(
	            "p",
	            {
	              "data-jsx": 1304959149
	            },
	            "The free and open-source tutorials (based around a simple a ",
	            React.createElement(
	              "i",
	              {
	                "data-jsx": 1304959149
	              },
	              "todo"
	            ),
	            " app) to learn all around creating and consuming hypermedia APIs."
	          ),
	          React.createElement(
	            "p",
	            {
	              "data-jsx": 1304959149
	            },
	            React.createElement(
	              "i",
	              {
	                "data-jsx": 1304959149
	              },
	              "Less talk, more code"
	            ),
	            ": the tutorials walk you through full working examples of the ",
	            React.createElement(
	              "b",
	              {
	                "data-jsx": 1304959149
	              },
	              "API"
	            ),
	            " and the ",
	            React.createElement(
	              "b",
	              {
	                "data-jsx": 1304959149
	              },
	              "client"
	            ),
	            "."
	          ),
	          React.createElement(
	            "div",
	            { className: "center-container btn-container", "data-jsx": 1304959149
	            },
	            React.createElement(
	              gatsby_link_1.default,
	              { to: "/basics/0-introduction/" },
	              React.createElement(
	                "div",
	                { className: "btn", "data-jsx": 1304959149
	                },
	                "Start with Introduction"
	              )
	            )
	          ),
	          React.createElement(IntroSteps_1.default, { steps: this.props.steps, location: this.props.location })
	        )
	      );
	    }
	  }]);
	
	  return Intro;
	}(React.Component);
	
	exports.default = react_redux_1.connect(null, { setOverviewVideoVisible: ui_1.setOverviewVideoVisible })(Intro);

/***/ }),

/***/ "./src/components/home/IntroSteps.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var LeftColumn_1 = __webpack_require__("./src/components/home/LeftColumn.tsx");
	var OptionalSteps_1 = __webpack_require__("./src/components/Steps/OptionalSteps.tsx");
	var Duration_1 = __webpack_require__("./src/components/Duration.tsx");
	var Steps_1 = __webpack_require__("./src/components/Steps/Steps.tsx");
	var getTotalDuration_1 = __webpack_require__("./src/utils/getTotalDuration.ts");
	function IntroSteps(_ref) {
	  var steps = _ref.steps,
	      location = _ref.location;
	
	  var basicsDuration = getTotalDuration_1.getTotalDuration(steps.basics);
	  return React.createElement(
	    "div",
	    { className: "intro-steps", "data-jsx": 950315840
	    },
	    React.createElement(_style2.default, {
	      styleId: 950315840,
	      css: ".basic-graphql[data-jsx=\"950315840\"]{top:-3px;}.advanced-graphql[data-jsx=\"950315840\"]{margin-top:196px;}@media (max-width: 500px){.steps-content[data-jsx=\"950315840\"] .steps-description{display:none;}div.steps-list[data-jsx=\"950315840\"]{width:100%;}}.mt38,\n.intro-steps[data-jsx=\"950315840\"]{margin-top:38px;}.pt10,\n.intro-steps[data-jsx=\"950315840\"]{padding-top:10px;}.flex,\n.steps-content[data-jsx=\"950315840\"],\n.duration[data-jsx=\"950315840\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.mt0,\n.steps-content[data-jsx=\"950315840\"] .steps-description h3[data-jsx=\"950315840\"]{margin-top:0;}.relative,\n.basic-graphql[data-jsx=\"950315840\"]{position:relative;}.w50,\n.steps-list[data-jsx=\"950315840\"]{width:50%;}.black30,\np[data-jsx=\"950315840\"]{color:rgba(0, 0, 0, .3);}.justifyEnd,\n.steps-content[data-jsx=\"950315840\"] .steps-description .time[data-jsx=\"950315840\"],\n.duration[data-jsx=\"950315840\"]{-ms-flex-pack:end;-webkit-box-pack:end;justify-content:flex-end;}.pr38,\n.steps-content[data-jsx=\"950315840\"] .steps-description .time[data-jsx=\"950315840\"]{padding-right:38px;}.mt16,\n.steps-content[data-jsx=\"950315840\"] .steps-description .time[data-jsx=\"950315840\"],\n.duration[data-jsx=\"950315840\"]{margin-top:16px;}.mt16,\n.steps-content[data-jsx=\"950315840\"] .steps-description .time[data-jsx=\"950315840\"],\n.duration[data-jsx=\"950315840\"]{margin-top:16px;}.mr38,\n.duration[data-jsx=\"950315840\"]{margin-right:38px;}.flex,\n.steps-content[data-jsx=\"950315840\"],\n.duration[data-jsx=\"950315840\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.justifyEnd,\n.steps-content[data-jsx=\"950315840\"] .steps-description .time[data-jsx=\"950315840\"],\n.duration[data-jsx=\"950315840\"]{-ms-flex-pack:end;-webkit-box-pack:end;justify-content:flex-end;}.fw6,\nh3[data-jsx=\"950315840\"]{font-weight:600;}"
	    }),
	    React.createElement(
	      "div",
	      { className: "steps-content", "data-jsx": 950315840
	      },
	      React.createElement(
	        LeftColumn_1.default,
	        { className: "steps-description", light: true },
	        React.createElement(
	          "div",
	          { className: "basic-graphql", "data-jsx": 950315840
	          },
	          React.createElement(
	            "h3",
	            {
	              "data-jsx": 950315840
	            },
	            "Hypermedia Fundamentals"
	          ),
	          React.createElement(
	            "div",
	            { className: "duration", "data-jsx": 950315840
	            },
	            React.createElement(Duration_1.default, { duration: basicsDuration, total: true })
	          ),
	          React.createElement(
	            "p",
	            {
	              "data-jsx": 950315840
	            },
	            "In the first chapter, you\u2019ll learn about the core concepts in how we design a hypermedia system. ",
	            ' '
	          )
	        ),
	        React.createElement(
	          "div",
	          { className: "advanced-graphql", "data-jsx": 950315840
	          },
	          React.createElement(
	            "h3",
	            {
	              "data-jsx": 950315840
	            },
	            "Advanced concepts"
	          ),
	          React.createElement(
	            "p",
	            {
	              "data-jsx": 950315840
	            },
	            "Read this chapter to get a broader understanding of the hypermedia ecosystem that is used throughout all the client and API tutorials."
	          )
	        )
	      ),
	      React.createElement(
	        "div",
	        { className: "steps-list fade-before", "data-jsx": 950315840
	        },
	        React.createElement(Steps_1.default, { steps: steps.basics, location: location, highlightFirst: true, showLast: false }),
	        React.createElement(OptionalSteps_1.default, { steps: steps.advanced, location: location })
	      )
	    )
	  );
	}
	exports.default = IntroSteps;

/***/ }),

/***/ "./src/components/home/LeftColumn.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var classNames = __webpack_require__("./node_modules/classnames/index.js");
	var LeftColumn = function LeftColumn(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      light = _ref.light;
	
	  return React.createElement(
	    "div",
	    { className: classNames('left-column', className, { light: light }), "data-jsx": 1516893200
	    },
	    React.createElement(_style2.default, {
	      styleId: 1516893200,
	      css: ".left-column[data-jsx=\"1516893200\"] p{max-width:320px;}.w50,\n.left-column[data-jsx=\"1516893200\"]{width:50%;}.tr,\n.left-column[data-jsx=\"1516893200\"]{text-align:right;}.white50,\n.left-column[data-jsx=\"1516893200\"]{color:hsla(0, 0%, 100%, .5);}.flex,\n.left-column[data-jsx=\"1516893200\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.itemsEnd,\n.left-column[data-jsx=\"1516893200\"]{-webkit-box-align:end;-ms-flex-align:end;-ms-grid-row-align:flex-end;align-items:flex-end;}.flexColumn,\n.left-column[data-jsx=\"1516893200\"]{-ms-flex-direction:column;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;}.black30,\n.left-column.light[data-jsx=\"1516893200\"]{color:rgba(0, 0, 0, .3);}.f20,\n.left-column[data-jsx=\"1516893200\"] h3{font-size:20px;}.mt16,\n.left-column[data-jsx=\"1516893200\"] h3,\n.left-column[data-jsx=\"1516893200\"] p{margin-top:16px;}.pr38,\n.left-column[data-jsx=\"1516893200\"] h3,\n.left-column[data-jsx=\"1516893200\"] p{padding-right:38px;}.f16,\n.left-column[data-jsx=\"1516893200\"] p{font-size:16px;}.mt16,\n.left-column[data-jsx=\"1516893200\"] h3,\n.left-column[data-jsx=\"1516893200\"] p{margin-top:16px;}.lhCopy,\n.left-column[data-jsx=\"1516893200\"] p{line-height:1.5;}.pr38,\n.left-column[data-jsx=\"1516893200\"] h3,\n.left-column[data-jsx=\"1516893200\"] p{padding-right:38px;}"
	    }),
	    children
	  );
	};
	exports.default = LeftColumn;

/***/ }),

/***/ "./src/components/home/WhatWeBuild.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _style = __webpack_require__("./node_modules/styled-jsx/style.js");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var Checkmark_1 = __webpack_require__("./src/components/Checkmark.tsx");
	function WhatWeBuild() {
	  return React.createElement(
	    "section",
	    null,
	    React.createElement(
	      "div",
	      { className: "what-we-build", "data-jsx": 960053870
	      },
	      React.createElement(_style2.default, {
	        styleId: 960053870,
	        css: ".what-we-build[data-jsx=\"960053870\"]{max-width:960px;}.preview[data-jsx=\"960053870\"] img[data-jsx=\"960053870\"]{height:370px;width:auto;}@media (max-width: 500px){.what-we-build[data-jsx=\"960053870\"]{position:relative;}.what-we-build[data-jsx=\"960053870\"]{padding:0 30px;}.what-we-build[data-jsx=\"960053870\"]:after{content:\"\";position:absolute;bottom:0;left:0;right:0;height:100px;background:linear-gradient(to top, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))            }p.c[data-jsx=\"960053870\"]{text-align:left!important;}div.preview[data-jsx=\"960053870\"],\ndiv.preview[data-jsx=\"960053870\"] img[data-jsx=\"960053870\"]{margin-top:38px;}div.preview[data-jsx=\"960053870\"]{-moz-flex-direction:column-reverse;-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse;}div.preview[data-jsx=\"960053870\"] img[data-jsx=\"960053870\"]{width:100%;height:auto;}}.center,\n.what-we-build[data-jsx=\"960053870\"]{margin-right:auto;margin-left:auto;}.tc,\np.c[data-jsx=\"960053870\"]{text-align:center;}.mt38,\np.c[data-jsx=\"960053870\"]{margin-top:38px;}.flex,\n.preview[data-jsx=\"960053870\"],\n.point[data-jsx=\"960053870\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.justifyBetween,\n.preview[data-jsx=\"960053870\"]{-ms-flex-pack:justify;-webkit-box-pack:justify;justify-content:space-between;}.itemsCenter,\n.preview[data-jsx=\"960053870\"],\n.point[data-jsx=\"960053870\"]{-webkit-box-align:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;}.mt96,\n.preview[data-jsx=\"960053870\"]{margin-top:96px;}.flex,\n.preview[data-jsx=\"960053870\"],\n.point[data-jsx=\"960053870\"]{display:-ms-flexbox;display:-webkit-box;display:flex;}.itemsCenter,\n.preview[data-jsx=\"960053870\"],\n.point[data-jsx=\"960053870\"]{-webkit-box-align:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;}.mt20,\n.point[data-jsx=\"960053870\"]{margin-top:20px;}.mt0,\n.point[data-jsx=\"960053870\"]:first-child{margin-top:0;}.ml16,\n.point[data-jsx=\"960053870\"] p[data-jsx=\"960053870\"]{margin-left:16px;}"
	      }),
	      React.createElement(
	        "h2",
	        {
	          "data-jsx": 960053870
	        },
	        "What you'll build: A hypermedia todo app"
	      ),
	      React.createElement(
	        "p",
	        { className: "c", "data-jsx": 960053870
	        },
	        "Work through the key aspects of constructing or consuming a fully-tenanted hypermedia-based todo app with one of the detailed step-by-step tutorials. Use the programming language and framework of your choice!"
	      ),
	      React.createElement(
	        "div",
	        { className: "preview", "data-jsx": 960053870
	        },
	        React.createElement("img", { src: __webpack_require__("./src/assets/graphics/todos-preview.png"), alt: "", "data-jsx": 960053870
	        }),
	        React.createElement(
	          "div",
	          { className: "points", "data-jsx": 960053870
	          },
	          React.createElement(
	            "div",
	            { className: "point", "data-jsx": 960053870
	            },
	            React.createElement(Checkmark_1.default, null),
	            React.createElement(
	              "p",
	              {
	                "data-jsx": 960053870
	              },
	              "Practices to implement a hypermedia API"
	            )
	          ),
	          React.createElement(
	            "div",
	            { className: "point", "data-jsx": 960053870
	            },
	            React.createElement(Checkmark_1.default, null),
	            React.createElement(
	              "p",
	              {
	                "data-jsx": 960053870
	              },
	              "Detailed code walk through & explanations"
	            )
	          ),
	          React.createElement(
	            "div",
	            { className: "point", "data-jsx": 960053870
	            },
	            React.createElement(Checkmark_1.default, null),
	            React.createElement(
	              "p",
	              {
	                "data-jsx": 960053870
	              },
	              "From scratch to production"
	            )
	          )
	        )
	      )
	    )
	  );
	}
	exports.default = WhatWeBuild;

/***/ }),

/***/ "./src/components/home/withWidth.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	function withWidth() {
	    return function (Component) {
	        var WithWidth = function (_React$Component) {
	            _inherits(WithWidth, _React$Component);
	
	            function WithWidth(props) {
	                _classCallCheck(this, WithWidth);
	
	                var _this = _possibleConstructorReturn(this, (WithWidth.__proto__ || Object.getPrototypeOf(WithWidth)).call(this, props));
	
	                _this.updateWindowDimensions = function () {
	                    var innerWidth = typeof window !== 'undefined' ? window.innerWidth : 800;
	                    _this.setState({ width: innerWidth });
	                };
	                var innerWidth = typeof window !== 'undefined' ? window.innerWidth : 800;
	                _this.state = {
	                    width: innerWidth
	                };
	                return _this;
	            }
	
	            _createClass(WithWidth, [{
	                key: "componentDidMount",
	                value: function componentDidMount() {
	                    this.updateWindowDimensions();
	                    if (typeof window !== 'undefined') {
	                        window.addEventListener('resize', this.updateWindowDimensions);
	                    }
	                }
	            }, {
	                key: "componentWillUnmount",
	                value: function componentWillUnmount() {
	                    if (typeof window !== 'undefined') {
	                        window.removeEventListener('resize', this.updateWindowDimensions);
	                    }
	                }
	            }, {
	                key: "render",
	                value: function render() {
	                    var width = this.state.width;
	
	                    return React.createElement(Component, _extends({}, this.props, { width: width }));
	                }
	            }]);
	
	            return WithWidth;
	        }(React.Component);
	
	        return WithWidth;
	    };
	}
	exports.default = withWidth;

/***/ }),

/***/ "./src/data/stacks.ts":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var data = [{
	    title: "Vue todo API browser",
	    type: "frontend",
	    key: "vue-api-browser",
	    images: [__webpack_require__("./src/assets/icons/vue.svg")],
	    content: {
	        title: "Vue + API browser",
	        description: "Learn how to browse a hypermedia API with a general purpose client build in Vue"
	    },
	    authorName: "semantic link project",
	    comingSoon: false
	}, {
	    title: "Vue todo app",
	    type: "frontend",
	    key: "vue-todo-app",
	    images: [__webpack_require__("./src/assets/icons/vue.svg")],
	    content: {
	        title: "Vue + todo",
	        description: "Learn how to use Vue to create a todo app that consumes a hypermedia-based todo API"
	    },
	    authorName: "semantic link project",
	    comingSoon: false
	}, {
	    title: "ASP.NET Core todo API",
	    type: "backend",
	    key: "aspnetcore-todo-api",
	    images: [__webpack_require__("./src/assets/icons/dotnet-core.png")],
	    content: {
	        title: "AspNetCore + todo API",
	        description: "Learn to build the todo hypermedia API with AspNetCore"
	    },
	    authorName: "semantic link project",
	    comingSoon: false
	}];
	exports.default = data;

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/todd/src/howtohypermedia/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\"]}!./node_modules/ts-loader/index.js?{\"compilerOptions\":{\"target\":\"esnext\",\"removeComments\":true,\"emitDecoratorMetadata\":true,\"experimentalDecorators\":true,\"jsx\":\"preserve\",\"sourceMap\":true,\"strictNullChecks\":true,\"lib\":[\"es7\",\"dom\"],\"allowJs\":true,\"noUnusedLocals\":true,\"types\":[\"@types/node\"]},\"logLevel\":\"warn\",\"exclude\":[\"node_modules\",\"dist\",\".cache\"]}!./src/pages/index.tsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__("./node_modules/react/react.js");
	var Chooser_1 = __webpack_require__("./src/components/home/Chooser.tsx");
	var Intro_1 = __webpack_require__("./src/components/home/Intro.tsx");
	var App_1 = __webpack_require__("./src/components/App.tsx");
	var graphql_1 = __webpack_require__("./src/utils/graphql.ts");
	var WhatWeBuild_1 = __webpack_require__("./src/components/home/WhatWeBuild.tsx");
	var ContentOverview_1 = __webpack_require__("./src/components/home/ContentOverview.tsx");
	var Footer_1 = __webpack_require__("./src/components/home/Footer.tsx");
	var CustomHelmet_1 = __webpack_require__("./src/components/CustomHelmet.tsx");
	exports.default = function (props) {
	  var steps = graphql_1.extractSteps(props.data.mds);
	  var title = "How to Hypermedia - A tutorial for the dedicated";
	  var overrideDescription = "Hypermedia tutorial covering basics and advanced concepts in different languages across API and client implementations.";
	  var description = "Hypermedia tutorial covering all basics and advanced concepts.";
	  return React.createElement(
	    App_1.default,
	    { history: props.history, steps: steps, location: props.location },
	    React.createElement(CustomHelmet_1.default, { title: title, description: description, overrideDescription: overrideDescription }),
	    React.createElement(Intro_1.default, { steps: steps, location: props.location }),
	    React.createElement(Chooser_1.default, { mds: steps, location: props.location, history: props.history }),
	    React.createElement(WhatWeBuild_1.default, null),
	    React.createElement(ContentOverview_1.default, { location: props.location, steps: steps }),
	    React.createElement(Footer_1.default, null)
	  );
	};
	exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ "./src/reducers/quiz.ts":
/***/ (function(module, exports) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.defaultQuizState = {
	    quizReactions: {},
	    rememberSkipped: false
	};
	exports.defaultReaction = {
	    answerIndeces: [],
	    answeredCorrectly: false,
	    skipped: false
	};
	function quizReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : exports.defaultQuizState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case 'remember skipped':
	            return _extends({}, state, {
	                rememberSkipped: action.payload
	            });
	        case 'answer correctly':
	            return updateReaction(state, action.path, { answeredCorrectly: true });
	        case 'add answer':
	            var currentReaction = action.path ? state.quizReactions[action.path] || exports.defaultReaction : exports.defaultReaction;
	            return updateReaction(state, action.path, {
	                answerIndeces: (currentReaction.answerIndeces || []).concat(action.payload)
	            });
	        case 'skip':
	            return updateReaction(state, action.path, { skipped: true });
	        case 'set reaction':
	            return updateReaction(state, action.path, action.payload);
	    }
	    return state;
	}
	exports.default = quizReducer;
	function updateReaction(state, path, newReaction) {
	    if (!path) {
	        throw new Error('path is missing');
	    }
	    var oldReaction = state.quizReactions[path] || exports.defaultReaction;
	    return _extends({}, state, {
	        quizReactions: _extends({}, state.quizReactions, _defineProperty({}, path, _extends({}, oldReaction, newReaction)))
	    });
	}

/***/ }),

/***/ "./src/utils/getStackName.ts":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var stacks_1 = __webpack_require__("./src/data/stacks.ts");
	var localMap = {
	    advanced: 'Advanced',
	    basics: 'Basics'
	};
	function getStackName(group) {
	    if (localMap[group]) {
	        return localMap[group];
	    }
	    var stack = stacks_1.default.find(function (s) {
	        return s.key === group;
	    });
	    if (stack) {
	        return stack.title;
	    }
	    return null;
	}
	exports.getStackName = getStackName;

/***/ }),

/***/ "./src/utils/getTotalDuration.ts":
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	function getTotalDuration(steps) {
	    if (!steps) {
	        return 0;
	    }
	    return steps.reduce(function (acc, curr) {
	        return acc + (curr.duration || 0);
	    }, 0);
	}
	exports.getTotalDuration = getTotalDuration;

/***/ }),

/***/ "./src/utils/graphql.ts":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var groupBy = __webpack_require__("./node_modules/lodash/groupBy.js");
	var sortBy = __webpack_require__("./node_modules/lodash/sortBy.js");
	function extractSteps(mds) {
	    var tutorials = mds.edges.map(function (edge) {
	        return edge.node;
	    }).filter(function (n) {
	        return n.frontmatter.title.length > 0;
	    }).map(function (chapter) {
	        return {
	            description: chapter.frontmatter.description,
	            duration: chapter.frontmatter.duration,
	            link: chapter.fields.slug,
	            title: chapter.frontmatter.title
	        };
	    });
	    var grouped = groupBy(tutorials, function (md) {
	        return extractGroup(md.link);
	    });
	    return Object.keys(grouped).reduce(function (acc, curr) {
	        var steps = grouped[curr];
	        return _extends({}, acc, _defineProperty({}, curr, sortBy(steps, function (step) {
	            var splittedLink = step.link.split('/');
	            var leadingNumber = '0';
	            if (splittedLink.length > 2) {
	                leadingNumber = splittedLink[2].split('-')[0];
	            }
	            return parseInt(leadingNumber, 10);
	        })));
	    }, {});
	}
	exports.extractSteps = extractSteps;
	function extractGroup(slug) {
	    var splittedSlug = slug.split('/');
	    if (splittedSlug.length > 1) {
	        return splittedSlug[1];
	    }
	    if (slug.includes('/choose')) {
	        return 'choose';
	    }
	    return '';
	}
	exports.extractGroup = extractGroup;

/***/ }),

/***/ "./src/utils/polyfill.js":
/***/ (function(module, exports) {

	'use strict';
	
	if (typeof Element !== 'undefined' && !Element.prototype.scrollIntoViewIfNeeded) {
	  Element.prototype.scrollIntoViewIfNeeded = function (centerIfNeeded) {
	    centerIfNeeded = arguments.length === 0 ? true : !!centerIfNeeded;
	
	    var parent = this.parentNode,
	        parentComputedStyle = window.getComputedStyle(parent, null),
	        parentBorderTopWidth = parseInt(parentComputedStyle.getPropertyValue('border-top-width')),
	        parentBorderLeftWidth = parseInt(parentComputedStyle.getPropertyValue('border-left-width')),
	        overTop = this.offsetTop - parent.offsetTop < parent.scrollTop,
	        overBottom = this.offsetTop - parent.offsetTop + this.clientHeight - parentBorderTopWidth > parent.scrollTop + parent.clientHeight,
	        overLeft = this.offsetLeft - parent.offsetLeft < parent.scrollLeft,
	        overRight = this.offsetLeft - parent.offsetLeft + this.clientWidth - parentBorderLeftWidth > parent.scrollLeft + parent.clientWidth,
	        alignWithTop = overTop && !overBottom;
	
	    if ((overTop || overBottom) && centerIfNeeded) {
	      parent.scrollTop = this.offsetTop - parent.offsetTop - parent.clientHeight / 2 - parentBorderTopWidth + this.clientHeight / 2;
	    }
	
	    if ((overLeft || overRight) && centerIfNeeded) {
	      parent.scrollLeft = this.offsetLeft - parent.offsetLeft - parent.clientWidth / 2 - parentBorderLeftWidth + this.clientWidth / 2;
	    }
	
	    if ((overTop || overBottom || overLeft || overRight) && !centerIfNeeded) {
	      this.scrollIntoView(alignWithTop);
	    }
	  };
	}

/***/ }),

/***/ "./src/utils/tutorials.ts":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var stacks_1 = __webpack_require__("./src/data/stacks.ts");
	function getFrontendTutorials(steps) {
	    return stacks_1.default.filter(function (t) {
	        return t.type === 'frontend' && !t.comingSoon;
	    }).map(function (stack) {
	        var tutorialSteps = steps[stack.key];
	        return _extends({}, tutorialSteps[0], {
	            title: stack.title
	        });
	    });
	}
	exports.getFrontendTutorials = getFrontendTutorials;
	function getBackendTutorials(steps) {
	    return stacks_1.default.filter(function (t) {
	        return t.type === 'backend' && !t.comingSoon;
	    }).map(function (stack) {
	        var tutorialSteps = steps[stack.key];
	        return _extends({}, tutorialSteps[0], {
	            title: stack.title
	        });
	    });
	}
	exports.getBackendTutorials = getBackendTutorials;

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-pages-index-tsx-30196665fde03dae6db3.js